/* ⚠️ DO NOT EDIT THIS FILE MANUALLY
 *
 * This file is generated by
 * lib/py_nitrex_plant_manager/scripts/export_translations_to_frontend.py
 * And uses the original NPM translation files as inputs.
 */
export default {
  resourceId: {
    1: 'Zadajte hodnotu',
    2: 'OK',
    3: 'Zrušiť',
    4: 'Názov súboru',
    5: 'Zmazať',
    6: 'Zavrieť',
    7: 'Obnoviť',
    8: 'Vymazať',
    9: 'Nedá sa otvoriť súbor',
    10: 'Vstupného poľa',
    11: 'Nový',
    12: 'História',
    13: 'Otvoriť',
    14: 'Uložiť',
    15: 'Výjazd',
    16: 'Chcete uložiť zmeny?',
    17: 'Áno',
    18: 'Nie',
    19: 'Súbor',
    20: 'Alarm',
    21: 'Robiť Kópie',
    22: 'Upraviť',
    23: 'Vyberte',
    24: 'Používateľ',
    25: 'Default',
    26: 'Kópia',
    27: 'Presunúť',
    28: 'Uložiť ako predvolené',
    29: 'Ste si istí?',
    30: 'nie je k dispozícii',
    31: 'Vložiť',
    32: 'Plán',
    33: 'Teraz',
    34: 'Poslať',
    35: 'Aktualizácia úspešná',
    36: 'Aktualizácia zlyhala',
    37: 'Komentár',
    38: 'Zobraziť',
    39: 'Denník',
    40: 'Konfigurovať',
    41: 'Ignorovať',
    42: 'Odstrániť',
    43: 'Upozornenie',
    44: 'Potvrďte',
    45: 'Zmenšenie',
    46: 'Popis',
    47: 'Proces',
    48: 'Nepodarilo sa otvoriť súbor Pomocníka.',
    49: 'Dátum',
    50: 'Druh',
    51: 'Rozšírenie',
    52: 'Zrútiť sa',
    53: 'Číslo chyby',
    54: '< kontaktujte Nitrex >',
    55: 'Zavrite aplikáciu?',
    56: 'Je nasledujúci súbor chýba alebo je poškodený: ',
    57: 'Nie je k dispozícii pre túto verziu systému Windows.',
    58: 'Operácia úspešne ukončená.',
    59: 'Operácia ukončená neúspešne. Pozri [system.err] súbor pre viac informácií.',
    60: 'Sa vyskytla neočakávaná chyba.',
    61: 'Niektoré súbory chýbajú.',
    62: 'Panel stavu',
    63: 'Aplikácia ukončená',
    64: 'Súbor úspešne uložený',
    65: 'Súbor nebol uložený',
    66: 'Disky',
    67: 'Výber',
    68: 'Potrat',
    69: 'Denník Interval',
    70: 'Sekúnd',
    71: 'Vonku',
    72: 'Uzavreté',
    73: 'Typ súboru',
    74: 'Pozrite sa do',
    75: 'Späť',
    76: 'Nadradený adresár',
    77: 'Zobrazenie zoznamu',
    78: 'Podrobnejšie zobrazenie',
    79: 'Veľkosť',
    80: 'Typ',
    81: 'Modifikovaný',
    82: 'HH:MM:SS MM-DD',
    83: 'Vám môže byť neprihlásili do vzdialenej jednotky.',
    84: 'Nemožno získať prístup k tomuto systému.',
    85: 'Inštalácia aktualizácie',
    86: ':',
    87: 'Zobrazenie všetkých',
    88: 'Kľúč zabezpečenia vrátila chybu',
    89: 'Kľúč nebol nájdený',
    90: 'Prenájom Dátum uplynul',
    91: 'Dátum bol stanovený späť',
    92: 'Predchádzajúci',
    93: 'Ďalšie',
    94: 'Jednotka inžinierstvo',
    95: 'Skupina EÚ',
    96: 'Rozbaliť všetko',
    97: 'Zbaliť všetko',
    98: 'Graf',
    99: '#',
    100: 'Používateľ prihlásiť',
    101: 'Uplynutý čas',
    102: 'Uložené',
    103: 'Žiaden',
    104: 'Dno',
    105: 'Právo',
    106: 'Licencia',
    107: 'Licencia bola stanovená',
    108: 'Licenčný kód',
    109: 'Žiadosť kód',
    110: 'Neplatné licencie',
    111: 'Táto licencia už bol nastavený',
    112: 'Chyba pri obnovení záložného súboru',
    113: 'Kontakt UPC',
    114: 'Používate demo verziu tohto softvéru',
    115: 'Firmware verzia',
    116: 'Poradové číslo',
    117: 'Čakajte prosím...',
    118: 'Watchdog nepodarilo reštartovať radič',
    119: 'Neplatný súbor',
    120: 'Chýbajúci súbor',
    121: 'Obchod objednávky',
    122: 'Načítať čísla',
    123: 'Časť čísla',
    124: 'Uložiť ako',
    125: 'Vymazať?',
    126: 'Configuration is saved. Please restart the application in order for changes to take effect.',
    127: 'Append',
    128: 'Save As',
    129: 'Insert',
    130: 'Prepočítať',
    131: 'Fungujúci',
    132: 'Nie Fungujúci',
    133: 'Pozri Podrobnosti',
    134: 'Rastlina poplachový stav',
    135: 'Stav poplachového systému',
    136: 'Systém',
    137: 'Zobrazenie rastlinné',
    138: 'Pokúša nadviazať spojenie.',
    139: 'Chyba ovládača',
    140: 'Pravda',
    141: 'Falošné',
    142: 'Day',
    143: 'Month',
    144: 'Year',
    145: 'Hour',
    146: 'Minute',
    147: 'Second',
    148: 'Yes All',
    149: 'Chart Comment',
    150: 'Part Count',
    151: 'Error',
    152: 'Add',
    153: 'Profile/Die',
    154: 'Die Count',
    155: 'Profile',
    156: 'Customer Code',
    157: 'Invalid Format',
    158: 'Update in progress.',
    159: 'Please reboot the controller.',
    160: 'Reset Font',
    161: 'Set Language',
    162: 'Font Size',
    163: 'Large Font',
    164: 'Medium Font',
    165: 'Small Font',
    166: 'Help',
    167: 'Start',
    168: 'Stop',
    169: 'Template',
    170: 'Update',
    171: 'Tools',
    172: 'Calculate',
    173: 'Calculation',
    174: 'Lot number(s)',
    175: 'Please insert USB stick',
    176: 'Operator',
    177: 'Function not supported',
    178: 'Nothing to display',
    179: 'File too big',
    199: 'Reading',
    200: 'Do you want to proceed?',
    201: 'IIoT',
    202: 'Select Recipe',
    203: 'Select Log Path',
    204: 'Interactive Plot',
    205: 'Show Model',
    206: 'Time Series',
    207: 'Predictive/Actual Comparison',
    208: 'Model Results Evaluation',
    209: 'Correlation Plot',
    512: 'Vytvoriť užívateľa...',
    513: 'Vyložiť',
    514: 'Niektoré skupiny odstráni patril prihlásený používateľ, zmeny sa prejavia pri ďalšom prihlásení. ',
    515: 'Odstránenie používateľa zo systému',
    516: 'Odstrániť skupinu od užívateľa',
    518: 'Upraviť skupinu...',
    519: 'Užívateľ Manager ',
    520: 'Zmeniť používateľa...',
    521: 'Kopírovanie vybratého používateľa',
    522: 'Klon užívateľa...',
    523: 'Vytvoriť skupinu...',
    524: 'Odstrániť skupinu',
    525: 'Klon skupiny...',
    526: 'Názov skupiny: ',
    527: 'Skupiny',
    528: 'Priradiť skupiny používateľov...',
    529: 'Užívateľov',
    530: 'Prístup',
    531: 'Vstavané skupiny',
    532: 'Telesne',
    533: 'Celé meno: ',
    534: 'Užívateľské meno: ',
    535: 'Heslo: ',
    536: 'Popis/kontrol: ',
    537: 'Nie je vidieť',
    538: 'Zoznam',
    540: 'Užívateľ Manager ',
    541: 'Nastaviť všetkým prístup',
    542: 'Nastaviť všetkým zdravotným postihnutím',
    543: 'Nastaviť všetkým nie je viditeľný',
    544: 'Nastaviť všetkým najnižší prístup',
    546: 'Neplatné meno používateľa alebo heslo',
    547: 'Neplatný Popis',
    549: 'Neplatné celé meno',
    550: 'Chyba pri čítaní alebo zápise do súboru: ',
    551: 'Neplatný formát súboru',
    557: 'Jazyk: ',
    558: 'Vyberte jazyk',
    560: 'Prihlásiť sa',
    561: 'Užívateľské meno',
    562: 'Heslo',
    563: 'Neplatné meno používateľa alebo heslo, prosím skúste to znova',
    565: 'Užívateľ: ',
    575: 'Upozornenie: vaše prihlásenie relácie uplynie menej než 20 sekúnd. ',
    576: 'Pokračovať',
    577: 'Užívateľské meno už v prevádzke.',
    579: 'Odhlásiť',
    580: 'Vyberte priečinok obsahujúci súbory, ktoré majú byť obnovené.',
    582: 'Zálohovanie',
    583: 'Obnovovanie',
    585: 'Nitrex užívateľ',
    588: 'Snažím sa prihlásiť, čakajte prosím...',
    598: 'Tieto zdieľané adresár systému nemôžu byť umiestnené: ',
    599: 'Tieto kontroly počítača nie je prístupné: ',
    600: 'Prístup bol odmietnutý pri pokuse o prístup tieto zdieľaný adresár: ',
    602: 'Nie je možné vytvoriť predvolený užívateľa.',
    604: 'Čítanie a zápis operácia zlyhala. Zmeny neboli uložené.',
    606: 'Zoznam skupín',
    607: 'Počkajte, kým som naplniť zoznam...',
    608: 'Systémy',
    614: 'Názov skupiny je neplatný',
    615: 'Už existuje skupina',
    621: 'Overenie používateľa',
    622: 'Vyberte adresár, kde budú uložené súbory".',
    629: 'Chcete uložiť zmeny?',
    632: 'Neplatné povolenie',
    633: 'Chyba pri načítaní súboru používateľa.',
    634: 'Používateľ už prihlásený.',
    635: 'Nenašiel názov systému pre systém umiestnený na: ',
    636: 'Súbor sa nenašiel: ',
    637: 'Nemožno odstrániť používateľa, ktorý je aktuálne prihlásený.',
    638: 'Nepodarilo sa odstrániť skupín od užívateľa, ktorý je aktuálne prihlásený.',
    639: 'Užívateľ Manager Stand Alone - konfigurátor',
    640: 'Vyberte priečinok, kde je umiestnený súbor <QUsers.Dat> ',
    641: '',
    642: 'Oneskorenie (sec)',
    643: 'Musíte vybrať riadok',
    901: 'Hlavné Regulácia Teploty',
    902: 'Kúrenie rampa kontrolu',
    903: 'Regulácia teploty v pásme',
    904: 'Reguláciu tlaku',
    905: 'KN Ovládanie - Prietok',
    906: 'KN Ovládanie - atmosféra',
    907: 'KC Ovládanie - Prietok',
    908: 'KC Ovládanie - atmosféra',
    909: 'W % kontrola',
    910: 'Post-Oxidation Ovládanie',
    911: 'Chladiaci rampe riadenia',
    912: 'Ovládanie disociácia - Prietok',
    913: 'Oddelenie kontroly - atmosféru',
    914: 'Regulátor s externou žiadanej hodnoty',
    931: 'Prehriatie ochrany',
    932: 'Pracovný pretlak ochrany',
    933: 'Pod tlakom ochrany',
    934: 'Chladiacej vody Ovládanie',
    935: 'Reguláciu s ON/OFF ventil tlaku',
    936: 'Teplo stopové Ovládanie',
    937: 'Zapĺňať Ovládanie',
    1024: 'Process Status Changed',
    1025: 'Existuje',
    1026: 'Nahradiť',
    1027: 'Pece',
    1028: 'Odhadovaný čas',
    1030: 'Proces kód',
    1031: 'Žiadane hodnoty',
    1032: 'Atmosféra',
    1033: 'Výstupy',
    1034: 'Etapa',
    1035: 'Koniec stav',
    1036: 'Čas',
    1037: 'Názov štádia',
    1039: 'Proces Tvorca',
    1040: 'Nastaviť',
    1041: 'Min',
    1042: 'Max',
    1043: 'TOK',
    1044: 'Nitridačná šablóny',
    1045: 'Zoznam procesov',
    1046: 'Odstrániť fázy',
    1047: 'Pridať fázu',
    1048: 'Vložiť fázu',
    1049: 'Spáchať fáze',
    1050: 'Zemný plyn',
    1051: 'Hodnota mimo rozsahu',
    1052: 'Celková atmosféra-mali rovnaký 100% > nie',
    1053: 'Neplatná hodnota pre potenciál',
    1054: 'Neplatná hodnota disociačnej',
    1055: 'Náhradné',
    1066: 'Komory',
    1067: 'Nesprávna komora',
    1068: 'Komory nie sú v správnom poradí.',
    1069: 'Chýbajúce informácie. Všetky komory musí byť nastavená.',
    1079: 'Konfigurácia',
    1080: 'Zadajte názov',
    1086: 'Fáze vložený!',
    1087: 'Etape upravené!',
    1088: 'Štádiu pridáva',
    1089: 'Zadajte kód procesu',
    1090: 'Zadajte popis procesu (maximálne 30 znakov)',
    1091: 'Nemožno uložiť bez kód procesu!',
    1092: 'Nemožno uložiť bez popisu!',
    1093: 'Žiadne etapy! Použite Delete proces',
    1094: 'Chyba v konfiguračnom súbore',
    1095: 'Uložiť proces',
    1096: 'Zavrieť Process',
    1101: 'Proces nebol uložený',
    1102: 'Proces uložené',
    1103: 'Odhadované proces čas',
    1104: 'Žiadne zmeny uložiť',
    1105: 'Chyba s vákuové Setpoint',
    1106: 'Výpočet ATM',
    1107: 'Dvakrát kliknite na položku zmeniť názov',
    1108: 'Odhadované pece atmosféra',
    1109: 'Vytvorenie zostavy',
    1110: 'Pece',
    1111: 'Koniec procesu',
    1112: 'Nemôžu obsahovať kód procesu / \\\\ * alebo? ',
    1113: 'Proces Tvorca',
    1114: 'Otvorte proces',
    1115: 'Staviteľ proces aktuálne otvorené pre',
    1116: 'Iba jedno sieťové pripojenie povolené za pece',
    1117: 'Nemožno otvoriť súbor procesu',
    1118: 'Proces môže byť otvorená iný používateľ',
    1119: 'Uložiť ako: (maximálne 12 znakov) ',
    1120: 'Proces uložené',
    1121: 'Pece',
    1123: 'PEC T',
    1124: 'Špeciálne procesy',
    1125: 'Šablóny',
    1126: 'Núdzové postupy',
    1129: 'Zaťaženie procesu',
    1130: 'Upraviť proces',
    1131: 'Nemôžete upravovať fáz, ktoré už nastali. Načítaní prvej fáze k dispozícii.',
    1132: 'Fáze pokročila od načítania. Obnovte proces.',
    1133: 'Nie je aktuálne spustený proces.',
    1134: 'Musia byť v pohotovostnom režime načítať proces',
    1135: 'Chyba čítania/zápisu súborov',
    1136: 'Chyba pri načítaní súboru',
    1137: 'Chyba úpravu procesu - žiadne zmeny boli uložené',
    1138: 'Neexistuje žiadny proces spustený',
    1139: 'Procesu: ',
    1140: 'Plánovaný čas začatia procesu',
    1141: 'Nie je vybratý',
    1142: 'Začať okamžite',
    1143: 'Triediť šablóny',
    1144: 'Žiadny proces nahrá',
    1145: 'Načítať zo súboru',
    1146: 'Uložiť súbor',
    1147: 'Neplatný dočasný súbor',
    1148: 'Dočasný súbor nahradiť?',
    1149: 'Uložiť alebo obnoviť prácu',
    1150: 'Odstrániť dočasné súbory',
    1151: 'Zadajte názov súboru (bez prípony)',
    1152: 'Dočasný súbor',
    1153: 'Názov súboru nemôže obsahovať',
    1154: 'Žiadne etapy definované - pridať alebo najprv uložiť javisko ',
    1155: 'Zadajte názov súboru - práca neuloží',
    1156: 'Fáze dopustil',
    1157: 'Nástroje',
    1158: 'Gama Epsilon Graph',
    1159: 'Generovať zostavu',
    1160: 'Aktualizovať proces zmeny?',
    1161: 'Nemáte povolenie upravovať osobitné recipies. Chceli by ste zmeniť prácu recept miesto?',
    1168: 'Nie je dostatok údajov na výpočet atmosféra',
    1169: 'Je nám ľúto, táto operácia sa nedá vykonať',
    1170: 'Proces nemá žiadne platné etapy! ',
    1171: 'Len jeden otvorený proces povolené',
    1172: 'Kliknite na tlačidlo Zmeniť kód procesu (úspory kódom nový proces vytvorí nový proces, alebo kópiu existujúceho procesu) ',
    1173: 'Neplatný fázy boli nájdené a odstránené. Čiastočné proces bude naložené.',
    1174: 'Nie je možné vložiť novú etapu do aktuálneho štádia.',
    1175: 'Nemôžete odstrániť aktuálnu fázu.',
    1176: 'Nemôžete odstrániť blok keď zahŕňa súčasnej fáze.',
    1182: 'Zaťaženie procesu',
    1183: 'Nie je pripojený',
    1184: 'Odoslanie súboru sa vyskytla chyba',
    1185: 'Spustenie procesu',
    1186: 'Musí byť v pohotovostného režimu na začať proces',
    1187: 'Žiadny proces spustený',
    1188: 'Prerušenie procesu',
    1189: 'Pokračovať v procese',
    1190: 'Proces upravený',
    1191: 'Graf atmosféra',
    1192: 'Etapa procesu',
    1193: 'Koncentrácia plynov',
    1194: 'Číslo nie je platné',
    1195: 'Proces nebol nájdený - odstránenie z indexu',
    1196: 'Zálohovanie',
    1197: 'Kopírovať operácia bola dokončená',
    1199: 'Kód',
    1200: 'Proces upravuje iný používateľ',
    1202: 'Potvrdiť',
    1203: 'Kopírovanie zlyhalo',
    1204: 'Aktualizácia knižnice',
    1205: 'nie je platný čas.',
    1206: 'nie je platné číslo.',
    1207: 'nie je platný atmosféru hodnotu.',
    1208: 'Nitrex chránené proces',
    1209: 'Overiť ako čiastočné proces',
    1210: 'Oneskorenia (v sekundách) - digitálne výstupy',
    1211: 'Digitálne ovládanie',
    1212: 'Rovnocennosť',
    1213: 'Analógové vstupy',
    1214: 'Digitálnych vstupov',
    1215: 'Analógové výstupy',
    1216: 'N2 ',
    1217: 'NH3 ',
    1218: 'DNH3 ',
    1219: 'VZDUCHU',
    1220: 'CO2 ',
    1221: 'ENDO',
    1222: 'H2O',
    1223: 'CO',
    1224: 'Proces existuje - nahradiť?',
    1225: 'Súbor existuje - nahradiť?',
    1226: 'Núdzové',
    1227: 'Prevod',
    1228: 'Aktuálny recept',
    1229: 'Analógové ovládanie',
    1230: 'Modifikovaný proces poslal do riadiaceho počítača.',
    1231: 'Pridanie bloku',
    1232: 'Vložiť blok',
    1233: 'Odstrániť blok',
    1234: 'Blok',
    1235: 'Nový blok',
    1236: 'Otvorte blok',
    1237: 'Odstrániť blok',
    1238: 'Uložiť blok',
    1239: 'Zavrieť blok',
    1240: 'Nový proces',
    1241: 'Otvorte proces',
    1242: 'Odstrániť procesu',
    1243: 'Názov bloku',
    1244: 'Nemožno uložiť bez bloku meno',
    1245: 'Blok uložené',
    1246: 'Odstrániť bloky',
    1247: 'Otvorte blok',
    1248: 'Bloku bolo pridané.',
    1249: 'Blok bol vložený.',
    1250: 'Nie vhodné blok.',
    1251: 'Chyba úprava blok - žiadne zmeny boli uložené',
    1252: 'Bloky musia mať aspoň dvoch etapách.',
    1253: 'Blok verzia',
    1254: 'Chyba v skupinovej fáze',
    1255: 'Pomocou objemu pece pre toky',
    1256: 'Pred vybratý Modfication',
    1257: 'Po vybratú úpravu',
    1258: 'Nastaviť bod',
    1259: 'Hodnota',
    1260: 'Jednotka',
    1261: 'Povoliť radiče',
    1262: 'This process may not be modified remotely.',
    1263: 'Block has been deleted.',
    1264: 'Set Alarm Limits',
    1265: 'Always',
    1266: 'Error - High warning must be less than high alarm',
    1267: 'Error - Low warning must be less than low alarm',
    1268: 'Warning Offsets',
    1269: 'Alarm Offsets',
    1270: 'Alarm Delay (sec)',
    1271: 'In-charge value',
    1272: 'On-charge value',
    1273: 'Upper Limit Use %',
    1274: 'Lower Limit Use %',
    1275: 'High',
    1276: 'Low',
    1277: '% of Setpoint',
    1278: 'Default',
    1279: 'Reference Value',
    1290: 'Digital Outputs',
    1291: 'Status',
    1301: 'H2',
    1302: 'CH4',
    1303: 'C3H8',
    1304: 'N2O',
    1305: 'CH3OH',
    1306: 'C2H2',
    1307: 'C2H6',
    1308: 'Spare Gas1',
    1536: 'Zobraziť denník',
    1537: 'Jasné body',
    1538: 'Vyberte všetky správy a alarmy',
    1539: 'Maximálne číslo denníka bodov je',
    1540: 'Neplatný súbor denníka!',
    1541: 'Banka',
    1543: 'Alarmy uznal',
    1544: 'REŠTART POČÍTAČA PO',
    1545: 'MINÚT',
    1546: 'Časť',
    1547: 'Naložené v',
    1548: 'Pec',
    1549: 'Vyložený z',
    1550: 'Fáza zmeny',
    1551: 'Celkové použitie',
    1553: 'ALARM SYSTÉM',
    1554: 'Vymazať všetky body',
    1555: 'Zadajte predvolené nastavenia miesta',
    1567: 'Nie je vybraté žiadne zobrazenie. Otvorenie súboru alebo vyberte zobrazenie pre aktuálny súbor',
    1568: 'Žiadny platný súbor denníka načítané. Vyberte otvoriť.',
    1569: 'Log súbor údržbu',
    1570: 'Mazanie súborov...',
    1571: 'Kopírovanie súborov...',
    1572: 'Premiestňovanie súborov...',
    1573: 'nie je platný súbor denníka - tento súbor sa nespracuje. ',
    1574: 'Nie je platné číslo denníka adresár. Operácia ukončená.',
    1575: 'Nemôžete premiestniť ani odstrániť aktuálny súbor denníka. Tento súbor sa nespracuje',
    1576: 'Nemôže graf bodov s rôznych technických jednotiek - výber',
    1577: 'Zobrazenie grafu',
    1578: 'Práca Štart',
    1579: 'Úloha číslo',
    1580: 'Proces kód',
    1581: 'Interval (v sekundách)',
    1583: 'Systém',
    1584: 'Zahŕňajú históriu?',
    1585: 'Aktuálne',
    1586: 'Kumulatívne',
    1587: 'Proces pokračuje',
    1588: 'Proces bol prerušený',
    1589: '(Zadajte hodnotu 0 pre úplný denník)',
    1590: 'Neboli vybraté žiadne body. Kliknite na \\"Modify\\" vyberte body. ',
    1591: '(Vyberte predvolený zoznam automaticky načítať bodov.)',
    1592: 'Proces upravený',
    1593: 'Export Log súbory',
    1594: 'Uložiť ako súbor HTML',
    1595: 'Vytvorený súbor',
    1596: 'Uložiť ako textový súbor s oddeľovačmi',
    1597: 'Prejdite na vybratú stranu',
    1598: 'Export',
    1599: 'Excel.exe sa nedá nájsť',
    1600: 'Ak máte nainštalovaný program Excel môže otvoriť exportovaný súbor ',
    1601: 'Exportovaný súbor musí mať príponu',
    1602: 'Pracovný čas',
    1603: 'Čas nahromadené úlohy',
    1604: 'Nie je nainštalovaná žiadna tlačiareň. Predvolená tlačiareň a skúste to znova.',
    1605: 'Náklady na prácu',
    1606: 'Kontrolovaný',
    1607: 'Zastaviť proces',
    1608: 'Používať uplynulého času',
    1609: 'Select Points',
    1610: 'Select Points and Axis',
    1611: 'Interval (Minutes)',
    1612: 'Point Description',
    1613: 'Toggle-View',
    1614: 'Toggle to select the view',
    1615: 'Printing-View',
    1616: 'Free-View',
    1617: 'Export to CSV',
    1618: 'Export to HTML',
    1619: 'Data corruption has been detected in this file.',
    1620: '*** CORRUPTION DETECTED ***',
    2048: ' Chýbajúce IO konfiguráciu.',
    2049: ' Chýbajúce Konfigurácia systému.',
    2050: 'Fatálna chyba - nedá načítať.',
    2051: ' Chýbajúce proces inštalačný súbor.',
    2052: ' Chýba zoznam procesov.',
    2053: 'Chyba pri čítaní set-up proces',
    2054: 'Proces nemá žiadne platné etapy',
    2055: 'Neplatný znak v štádiu argument',
    2056: 'Neplatná etapa žiadanej hodnoty',
    2057: 'Fáze má žiadny platný počet argumentov',
    2058: 'Set-up proces má žiadny platný fáze sekvenciu',
    2059: 'UROBIŤ set-up obsahuje neplatný znak. ',
    2060: 'UROBIŤ set-up obsahuje odkaz na zariadenie, ktoré neexistuje ',
    2061: 'Chyba v robiť set-up-príliš veľa argumentov',
    2062: 'Chýbajúci objem pece',
    2063: 'Chýba tepelného gradientu',
    2064: 'Chladenie sklon chýba',
    2065: 'Vákuové / zapĺňať Gradient chýba ',
    2066: 'Pomerom plyn nie je medzi 0 a 100 ',
    2067: 'Fáze set-up používa plyn, ktorý neexistuje',
    2068: 'Súčet všetkých plynov nie je rovný 100 %',
    2069: 'MIN atmosféra je príliš vysoká',
    2070: 'MAX atmosféra je príliš nízka',
    2071: 'Koniec podmienka neexistuje',
    2072: 'Nie je vhodné koncom podmienka pre túto fázu',
    2073: 'Nastaviť bod je mimo rozsah',
    2074: 'Chýbajúca hodnota času fáze',
    2075: 'Chýbajúce fáze čas nastaviť bod',
    2076: 'Teplota v peci nie je nakonfigurovaný',
    2077: 'Chýbajúca hodnota na konci teplota',
    2078: 'Chýbajúce bod nastavenia teploty',
    2079: 'V poplatku nie je nakonfigurovaná teplota',
    2080: 'Bod nastavenia teploty chýba na poplatku',
    2081: 'V poplatku nie je nakonfigurovaná teplota',
    2082: 'Bod nastavenia teploty chýba v poplatku',
    2083: 'Nie je nakonfigurovaný vákuové čítanie',
    2084: 'Chýba vákuové žiadanou',
    2085: 'Tlak čítanie nie je nakonfigurovaná',
    2086: 'Chýbajúce bod nastavenia tlaku',
    2087: 'Nie je nakonfigurovaný MFC čítanie',
    2088: 'Chýbajúce MFC set point',
    2089: 'Chýbajúce disociácia set point',
    2090: 'Nesprávne Kn set point',
    2091: 'Nesprávne disociácia set point',
    2092: 'Dvojzmyselné údaje',
    2093: 'Nastavená teplota príliš nízka, MIN = ',
    2094: 'Nastavená teplota príliš vysoká, MAX = ',
    2095: 'Teplota na konci fázy príliš vysoká, MAX = ',
    2096: 'Teplota na konci fázy príliš nízko, MIN = ',
    2097: 'Vákuový set bod príliš vysoká, MAX = ',
    2098: 'Vákuový set bod príliš nízka, MIN = ',
    2099: 'Tlak bod nastavenia príliš vysoká, MAX = ',
    2100: 'Tlak bod nastavenia príliš nízka, MIN = ',
    2101: 'Tlak je príliš nízky na konci práce, MIN = ',
    2102: 'Tlak je príliš vysoká, aby ukončiť prácu, MAX = ',
    2103: 'Teplota je príliš vysoká, aby ukončiť prácu, MAX = ',
    2104: 'Obsah čpavok je príliš vysoká, aby ukončiť prácu, MAX = ',
    2105: 'Obsah vodíka príliš vysoká na konci cyklu, MAX = ',
    2106: 'Air obsah privysoké zoznámiť H2, MAX = ',
    2107: 'Chýbajúce fázy počiatočné tok',
    2108: 'Chýbajúce fáze minimálny prietok',
    2109: 'Chýbajúce fáze maximálny prietok',
    2110: 'Fázy toku príliš vysoká, MAX = ',
    2111: 'Fázy toku príliš nízka, MIN = ',
    2112: 'Minimálny prietok príliš vysoká, MAX = ',
    2113: 'Minimálny prietok príliš nízka, MIN = ',
    2114: 'Maximálny prietok príliš vysoká, MAX = ',
    2115: 'Maximálny prietok príliš nízka, MIN = ',
    2116: 'Minimálny prietok nie je nižší ako maximálny prietok',
    2117: 'Bod nastavenia toku nie je povolená pre túto fázu',
    2118: 'Kúrenie nie je povolená pre túto fázu',
    2119: 'Nemôže tak, vákuum a tlak nastavili bodov',
    2120: 'IO bod neexistuje',
    2121: 'Neúplná Inštalácia vlastné DIs',
    2122: 'Meškanie dlhšie ako trvanie etapy',
    2123: 'Teplota na konci fázy príliš vysoká, MAX zaťaženie = ',
    2124: 'Zaťaženie teplota až do konca fázy príliš nízko, MIN = ',
    2125: 'Zaťaženie teplota až do konca fázy príliš vysoká, MAX = ',
    2126: 'Zaťaženie teplota až do konca fázy príliš nízko, MIN = ',
    2127: 'Obsah vzduch príliš vysoká na konci etapy, MAX = ',
    2128: 'Etapa argument-',
    2129: 'Bod nastavenia teploty',
    2130: 'Tlak bod nastavenia',
    2131: 'Vákuový žiadanej hodnoty',
    2132: 'Koniec stav',
    2133: 'Fázy času',
    2134: 'Fázy toku',
    2135: 'Prietoku minimálne fáze',
    2136: 'Maximálnej fáze prietok',
    2137: 'Fáze atmosféra',
    2138: 'Minimálne fáze atmosféra',
    2139: 'Maximálnej fáze atmosféra',
    2140: 'Potenciál bodu',
    2141: 'Disociácia žiadanej hodnoty',
    2142: 'Etapa končí teplota',
    2143: 'Kúrenie svahu nastavená hodnota',
    2144: 'Sekvencia',
    2145: 'Fáza opis',
    2146: 'Nastavenie zariadenia',
    2147: 'Na starosti teplotu nastaviť hodnotu',
    2148: 'V-Charge teplota nastavená hodnota',
    2149: 'Vlastné DI koniec stav',
    2150: 'Vlastné AI koniec stav',
    2151: 'Analógový výstup nastavenia',
    2152: 'Kúrenie by mali byť stanovené',
    2153: 'Zap-Vyp regulátory nastavenia',
    2154: 'Chladenie svahu nastavená hodnota',
    2155: 'Teplota diferenciálnu nastavená hodnota',
    2160: 'Proces Set-up chyba!',
    2161: 'Fáza postupnosti-',
    2162: 'Etapa Argument-',
    2163: 'Nie rozpoznateľné fáze argument',
    2164: 'Neznáma chyba',
    2165: 'Analógový výstup z nastavenia neexistuje',
    2166: 'Neplatný výstup nastavenia',
    2167: 'Chýba analógové bod: teplotný rozdiel ',
    2168: 'Chýbajúca hodnota pre teplotný rozdiel',
    2169: 'Vyberte tento výstup vo všetkých fázach: ',
    2170: 'Digitálne výstupy sú vzájomne vylučujú (na základe recept): ',
    2171: 'Niektoré plyny nemôžu použiť súčasne vo fáze',
    2172: 'Vlastné DI',
    2173: 'Vlastné AI',
    2174: 'Min. prietok',
    2175: 'Max prietok',
    2176: 'Zátky by mali byť uzavreté Kúrenie',
    2177: 'Zátky by mali byť otvorené',
    2178: 'Pre ventilátor možno vybrať len jednu rýchlosť',
    2179: 'Tlak príliš vysoká pre konvekčné ventilátor. MAX = ',
    2180: 'Tlak príliš nízka pre konvekčné ventilátor. MIN = ',
    2181: 'Teplota príliš vysoká pre konvekčné ventilátor. MAX = ',
    2182: 'Tlak príliš vysoká pre ventilátor. MAX = ',
    2183: 'Tlak príliš nízka pre ventilátor. MIN = ',
    2184: 'Chladenie vody ventil na výmenník tepla má byť otvorený',
    2185: 'Ventil má byť uzavretá',
    2186: 'Plynový ventil má byť uzavretá',
    2187: 'Vákuové ventil má byť uzavretá',
    2188: 'Vákuové ventil musí byť otvorený',
    2189: 'Nemôžete mať vákuum a plynový ventil otvoriť',
    2190: 'Nesprávne použitie vykurovanie/chladenie rampa',
    2191: 'Nemôžete rozdeliť recept',
    2192: 'Hodnoty pre ovládače, ktoré zdieľajú vstup musí byť rovnaký',
    2193: 'Nemôže povoliť viac než jeden radič s zdieľaný výstup',
    2194: 'Fáze inštalácie obsahuje ovládače, ktoré neexistujú',
    2195: 'Inlet gas mixture is not safe',
    2196: 'Not safe to introduce AIR/N2O',
    2200: 'Recept nesúhlasí komora indexu. ',
    2201: '',
    2202: '',
    2203: 'Set Flow is too high for some gas ratios. Will be lowered automatically, if needed.',
    2204: 'Set Flow value that covers the whole ratio range = ',
    2205: 'Set Flow is too low for some gas ratios. Will be increased automatically, if needed.',
    2206: 'Min Flow value that covers the whole ratio range = ',
    2207: 'Max Flow value that covers the whole ratio range = ',
    2208: 'Min Flow is too low for some gas ratios. Will be increased automatically, if needed.',
    2209: 'Max Flow is too high for some gas ratios. Will be lowered automatically, if needed.',
    2210: 'Min Flow is too high for some gas ratios. Will be lowered automatically, if needed.',
    2211: 'Max Flow is too low for some gas ratios. Will be increased automatically, if needed.',
    2561: 'Proces Tvorca: otvorené konanie ',
    2562: 'Užívateľ Manager ',
    2563: 'Proces Tvorca: uložiť proces ',
    2564: 'Proces Tvorca: upraviť šablóny ',
    2565: 'Zaťaženie práce',
    2566: 'Proces Tvorca: upravovať počet etáp v procese ',
    2567: 'Zobraziť záznamy',
    2568: 'Zobraziť grafy',
    2569: 'Proces Tvorca: Vytvárať proces správy ',
    2570: 'Proces Tvorca: Prístup k súborom ',
    2571: 'Proces Tvorca: Zmeniť fáze koniec podmienku ',
    2572: 'Proces Tvorca: Zmena času fáze ',
    2573: 'Proces Tvorca: Zmeniť bod nastavenia teploty ',
    2574: 'Proces Tvorca: Zmena tlaku nastaviť bod ',
    2575: 'Proces Tvorca: Zmena vákuový žiadanej hodnoty ',
    2576: 'Proces Tvorca: Zmeniť Kúrenie svahu žiadanej hodnoty ',
    2577: 'Proces Tvorca: Zmeniť potenciál bodu ',
    2578: 'Proces Tvorca: Zmena disociačných nastaviť bod ',
    2579: 'Proces Tvorca: Zmena fáze toky ',
    2580: 'Proces Tvorca: Zmena fáze atmosféra ',
    2581: 'Proces Tvorca: Upraviť výstupné nastavenia ',
    2582: 'Proces Tvorca: Potvrdiť fáze ',
    2583: 'Proces Tvorca: Zmeniť kód procesu ',
    2584: 'Proces Tvorca: Zmeniť opis procesu ',
    2585: 'Proces Tvorca: Vytvoriť nový proces ',
    2586: 'Matematický Model',
    2587: 'Proces Tvorca: Proces Tvorca nástroje ',
    2588: 'Upraviť súčasný proces',
    2589: 'Spustenie procesu',
    2590: 'Prerušenie procesu',
    2591: 'Pokračovať v procese',
    2592: 'Režim údržby',
    2593: 'Kalibrácia snímačov',
    2594: 'Uplatňovať kompenzácií',
    2595: 'Pridať komentáre',
    2596: 'Proces Tvorca',
    2597: 'Export Log súbory',
    2598: 'Pravidelné čistenie protokolov',
    2599: 'Ukončite aplikáciu',
    2600: 'Zálohy konfiguračných súborov',
    2601: 'Obnoviť konfiguračné súbory',
    2602: 'Aktualizácia systému',
    2603: 'Koniec práce',
    2604: 'Uznať alarmy',
    2605: 'Zobraziť Detail na obrazovke',
    2606: 'Proces Tvorca: zálohovať súbory knižnice proces ',
    2607: 'Proces Tvorca: obnoviť proces inštalačné súbory ',
    2608: 'Proces Tvorca: odstrániť proces inštalačné súbory z knižnice ',
    2609: 'Používanie monitora: zobrazenie ',
    2610: 'Používanie monitora: Vymazať údaje ',
    2611: 'Používanie monitora: Zmena ceny ',
    2612: 'Kontrolovať prácu',
    2613: 'Proces Tvorca: upraviť zoznam procesov rovnocennosť ',
    2614: 'Zobrazenie obrazovky pece',
    2615: 'Reštartujte Turbo chladenie',
    2616: 'Predhrejte otvorené pece',
    2617: 'Plánovač úloh údržby: zobrazenie ',
    2618: 'Plánovač úloh údržby: Konfigurovať ',
    2619: 'Plánovač úloh údržby: urobiť údržbu ',
    2620: 'Vedomie správu varovania',
    2621: 'Správca prístup matice',
    2622: 'Dotazy programu prístup matice',
    2623: 'Nakládku a vykládku zomrie',
    2624: 'Prepnúť komorou moc',
    2625: 'Prepínanie pohotovostnom typov',
    2626: 'Proces Tvorca: Zmena Log Interval ',
    2627: 'Proces Tvorca: Zobraziť chránené procesov ',
    2628: 'Zmazať tabuľu',
    2629: 'Proces staviteľ: Vytvorte bloky',
    2630: 'Restart Application',
    2631: 'Proces Tvorca: Pridať/odstrániť bloky v procese',
    3552: 'Nitridom',
    3553: 'Vnútro',
    3554: 'Vákuové',
    3555: 'Zomrie',
    3556: 'Neznámy',
    3557: 'Načítanie reálnom čase graf, čakajte prosím...',
    3584: 'Zoznam všetkých matice.',
    3585: 'Zoznam špecifických zomrieť.',
    3586: 'Zoznam všetkých skupín.',
    3587: 'Zoznam všetkých zomrie spracovaných.',
    3588: 'Zoznam všetkých zomrie spracovaných v určitom rozsahu dátumu.',
    3589: 'Zoznam špecifických zomrieť spracované do určitého rozsahu dátumov.',
    3616: 'Transakcia',
    3617: 'Pracovných nastaviť dočasné',
    3618: 'Dátum a čas',
    3632: 'Matice kód',
    3633: 'Celkový čas (min)',
    3634: 'Nad čas (min)',
    3635: 'Celkového cyklu',
    3636: 'Skupina',
    3637: 'Vypršala',
    3638: 'Od dátumu',
    3639: 'K dnešnému dňu',
    3642: 'Namočte teplota',
    3643: 'Min. namočiť (min)',
    3644: 'Max máčať (min)',
    3645: 'Neboli nájdené žiadne záznamy',
    3646: 'Vyhľadávanie parametrov',
    3647: 'Zoznam otázky',
    3648: 'Pri spustení systému',
    3649: 'Chyba v konfigurácii IO. Skontrolujte, či iopoint.cfg.',
    3650: 'Začína',
    3651: 'Nie je možné otvoriť',
    3652: 'Chyba #',
    3653: 'Aktuálneho štádia',
    3654: 'je väčší ako celkový počet etáp',
    3655: 'Chyba generovanie proces z konfiguračného súboru',
    3656: 'Etapa číslo',
    3657: 'Chyba pohotovostného režimu: Process Manager nie je možné otvoriť ',
    3658: 'Chyba pohotovostného režimu: štádium vrátil hodnotu NULL proces vytvárania ',
    3659: 'Kontaktovať Nitrex',
    3660: 'Spustenie núdzového proces.',
    3661: 'Spustenie systému zlyhala. Mohol vytvárať proces.',
    3662: 'Jedná sa o Nitrex chránených proces. Nemáte prístup upraviť alebo zmazať.',
    3663: 'Niektoré Nitrex chránené procesy boli vybrané. Boli odstránené z výberu.',
    3664: 'Zmenil sa stav procesu. Zmeny boli aborted.',
    3665: 'Aplikácia bude teraz ukončená',
    3666: 'Obnovenie',
    3667: 'Automatická',
    3668: 'Pec nie zatvorené',
    3669: 'Neplatný typ núdzové',
    3670: 'Práca Štart nie je povolená',
    3776: 'Kalibrácia',
    3777: 'Aktuálne počíta',
    3778: 'Úroveň',
    3779: 'Počíta',
    3780: 'Kalibrovať',
    3781: 'Kompenzuje',
    3782: 'Nastaviť',
    3783: 'Práca',
    3784: 'Hotovo',
    3785: 'Nepodarilo sa načítať súbor kalibračných - žiadne kalibračné údaje',
    3786: 'Naposledy kalibrovaný: ',
    3787: '****',
    3788: 'Chyba pri kalibrácii súbor',
    3789: 'Nesprávny počet argumentov',
    3790: 'Nepodarilo sa načítať nové údaje. Pokúša sa vrátiť na predchádzajúce hodnoty.',
    3791: 'Hodnota mimo povoleného rozsahu.',
    3792: 'Musí byť medzi',
    3793: 'nie je platné číslo',
    3794: 'Kalibrované počty nie sú v poradí',
    3795: 'Overenie kalibrácie',
    3796: 'Konečné počty nie sú v poradí',
    3797: 'Či kompenzácie kalibrácie je správna',
    3799: 'Nepodarilo sa vrátiť na predchádzajúce hodnoty. Obnoviť pôvodný súbor: ',
    3800: 'Pôvodné hodnoty naložený znova.',
    3801: 'Prajete si pokračovať?',
    3802: 'Kalibračné údaje bol aktualizovaný.',
    3803: 'Generovať zostavu',
    3804: 'Kalibrácia správa',
    3805: 'Odsadenie presahuje nízkej medze',
    3806: 'Odsadenie presiahne horné hranice',
    3807: 'Kalibrácia prebieha. Nemôžete zmeniť režim.',
    3808: 'Correction Offset',
    3809: 'Modification Offset',
    3810: 'Sensor Error',
    3904: 'NORMÁLNE',
    3905: 'UPOZORNENIE',
    3906: 'NÍZKE UPOZORNENIE',
    3907: 'VYSOKÁ VAROVANIA',
    3908: 'ALARM',
    3909: 'NÍZKE ALARM',
    3910: 'VYSOKÁ ALARM',
    3911: 'NÚDZOVÉ',
    3912: 'NÍZKY STAV NÚDZE',
    3913: 'VYSOKO NÚDZOVÉ',
    3914: 'ŽIADNA ODPOVEĎ',
    3915: 'NÚDZE (NIE REAKCIA)',
    3916: 'NORMÁLNE - bolo upozornenie',
    3917: 'NORMÁLNE - bol poplach',
    3918: 'NÍZKE upozornenie - bol poplach',
    3919: 'VYSOKÁ upozornenie - bol poplach',
    3920: 'Alarmy uznal',
    3921: '?NEZNÁMY ALARM?',
    3922: '-',
    3923: '-',
    3924: '-',
    3925: '-',
    3926: '-',
    3927: 'Hodnota: ',
    3928: 'AUTOMATICKÁ',
    3929: '?',
    3936: 'História poplachu',
    3938: 'Poplach typu',
    3939: 'Hodnota vyhlásené',
    3940: 'Čas vyhlásenia',
    3941: 'Chyba!',
    3942: 'Súbor denníka sa nedá čítať',
    3943: 'Súbor denníka je prázdne',
    3944: 'Nemožno nájsť súbor denníka',
    3945: 'Č poplach',
    3947: 'Aktuálne',
    3948: 'Dejiny: ',
    3949: 'Naposledy obnovené: ',
    3950: 'Pohotovostný režim',
    3968: 'Zaťaženie práce',
    3971: 'Zrušiť plán',
    3976: 'Vybratý proces',
    3977: 'Začiatok úlohy',
    3978: 'Zákazník',
    3980: 'Zaťažené: ',
    3981: 'Inšpektor: ',
    3982: 'Častí: ',
    3983: 'Proces knižnica nie je k dispozícii',
    3985: 'Chyba pri kopírovaní súborov procesu!',
    3986: 'Nepodarilo sa uložiť informácie o prácu!',
    3987: 'Nemôžem nájsť načítaného procesu!',
    3988: 'Naozaj chcete zrušiť prácu?',
    3989: 'Naozaj chcete zrušiť? Zmeny sa zahodia.',
    3990: 'Plánovaný proces: ',
    3991: 'Naložené procesu: ',
    3992: 'Príliš veľa času, ktorý uplynul! Program zrušiť.',
    3993: 'Príliš veľa času uplynulo!',
    3994: 'Ste si istí, že chcete spustiť proces',
    3995: 'Neexistuje žiadny proces nahrá',
    3996: 'Rozvrh čas uplynul: ',
    3997: 'Nedá prístup k informáciám o prácu!',
    3998: 'Práce musia byť schválení pred je možné spustiť.',
    4000: 'Kontrola konca prácu',
    4001: 'Žiadne inšpektor podpísal',
    4002: 'Posledné zamestnanie nie kontrolovať!',
    4003: 'Chyba zápisu do súboru',
    4004: 'Súbor sa nenašiel: ',
    4005: 'Príliš veľa chýb! Vzdať!',
    4006: 'Sa pokúsi uložiť súbor',
    4007: 'Naozaj chcete zrušiť pláne?',
    4008: 'Žiadny plán',
    4009: 'Inšpektor nebol rozpoznaný.',
    4010: 'Naplánovaná úloha zrušené kvôli spustenie úlohy.',
    4011: 'Naplánovaná úloha zrušená z dôvodu údržby.',
    4012: 'Naplánovaná úloha odložené kvôli údržbe.',
    4013: 'Aktuálny čas v systéme',
    4014: 'Chyba pri získavaní pracovných zaťažení informácie!',
    4015: 'Chyba pri nastavovaní pracovných zaťažení informácie!',
    4016: 'Špecifická hmotnosť',
    4017: '-',
    4018: '-',
    4019: '-',
    4020: 'Nie je možné kopírovať súbor denníka',
    4021: '-',
    4022: '-',
    4023: '-',
    4024: '-',
    4025: '-',
    4026: '-',
    4027: '-',
    4028: 'Zadajte časti údajov pred výberom proces.',
    4029: 'Nepodarilo sa načítať súbor DNC: ',
    4030: 'Oader DNC Nenakonfigurované!',
    4031: 'Nemôže nájsť cestu: ',
    4033: '-',
    4034: '-',
    4035: 'Naozaj chcete uložiť tento komentár na nasledovný súbor?: ',
    4036: 'Zrušiť komentár?',
    4037: 'Chyba zápisu do súboru',
    4038: 'Jasné komentár?',
    4039: 'The scheduled start has been cancelled.',
    4096: 'Elektriny',
    4097: 'Čpavok',
    4098: 'Disociované čpavok',
    4099: 'Dusíka',
    4100: 'Oxid uhličitý',
    4101: 'Endo plyn',
    4102: 'Plynu CO',
    4103: 'Recept úpravy',
    4104: 'Tam boli žiadne zmeny zaviazala.',
    4105: 'Upravené v kroku',
    4106: 'H2',
    4107: 'Methane CH4',
    4108: 'Propane C3H8',
    4109: 'Nitrous N2O',
    4110: 'Methanol CH3OH',
    4111: 'Acetylene C2H2',
    4112: 'Ethane C2H6',
    4113: 'Em N2',
    4114: 'N2O',
    4197: 'Cost',
    4198: 'Consumable',
    4582: 'Systém: ',
    4583: 'Komora: ',
    4584: 'Úloha: ',
    4585: 'Zobraziť dnešný údajov',
    4586: 'Dnešné celkových nákladov: ',
    4587: 'Dnes to stálo: ',
    4588: 'Dnešné využitie: ',
    4589: 'Chyba v totalizer protokole.',
    4590: 'Pri ukladaní údajov sa vyskytla chyba! Bez zmeny.',
    4591: 'Žiadne zmeny. Neuloží.',
    4592: 'Chyba pri načítavaní údajov!',
    4593: 'Chyba pri vstupe na',
    4594: 'Cena Changer',
    4595: 'Nenakonfigurované',
    4596: 'Nič vybrané',
    4597: 'Zmena ceny',
    4598: 'Zobraziť prácu údajov',
    4599: 'Zobraziť nahromadené údaje',
    4600: 'Vymazať údaje pre nasledujúce položky?: ',
    4601: 'Celkový súhrnný nákladov: ',
    4602: 'Nahromadené náklady: ',
    4603: 'Nahromadené využitie: ',
    4604: 'Celkové náklady práce: ',
    4605: 'Pracovné náklady: ',
    4606: 'Pracovné využitie: ',
    4607: 'Použitie monitora',
    4608: 'Dostatok diskového priestoru.',
    4609: 'Disku je málo miesta!',
    4610: 'Na disku je veľmi nízky!',
    4611: 'Program je teraz schopný získať prístup k súboru denníka procesu.',
    4612: 'Problémy so zápisom na spracovanie log súbor!',
    4613: 'Nemohol zapisovať do súboru denníka procesu! Dáta stratené!',
    4614: 'Program teraz môžete zaznamenať zmeny procesu.',
    4615: '-',
    4616: '!Program je SCHOPNÁ zaznamenávať zmeny spracovať!',
    4617: '-',
    4618: '-',
    4619: '-',
    4620: '-',
    4621: '-',
    4622: '-',
    4623: 'Upozornenie!',
    4624: 'Miesto na disku',
    4625: '-',
    4626: 'Disku je málo miesta!',
    4627: 'Na disku je veľmi nízky! ',
    4628: 'Denník procesu',
    4629: '-',
    4630: 'Nedá sa zapisovať do denníka procesu!',
    4631: 'DÁTA STRATENÉ Z PROCESU PRIHLÁSIŤ!',
    4632: 'Proces pamäte',
    4633: '-',
    4634: '-',
    4635: 'Program je schopný zaznamenať zmeny spracovať.',
    4636: 'Chart Recorder',
    4672: 'výrobný príkaz',
    4673: 'Časť číslo',
    4674: 'Množ.',
    4675: 'Musí byť v pohotovosti na zaťaženie práce',
    4676: '-',
    4677: '-',
    4678: '-',
    4679: '-',
    4680: 'Minimálne: ',
    4681: 'Zadajte číslo objednávky: ',
    4682: 'Vyberte objednávku',
    4683: 'Nový objednávka',
    4684: 'Odstrániť objednávku',
    4685: 'Celkové množstvo: ',
    4686: 'Poradie už naložené!',
    4687: 'Príkaz nebol nájdený!',
    4688: '-',
    4689: '-',
    4690: 'Naozaj chcete odstrániť tieto príkazy?: ',
    4691: 'Nič odstrániť.',
    4692: 'Duplicitná objednávka.',
    4693: 'SAP adresár nie je nakonfigurovaný.',
    4694: 'Nepodarilo sa načítať súbor: ',
    4695: '-',
    4696: 'Tieto polia nie sú platné: ',
    4697: '-',
    4698: '-',
    4699: 'Zabezpečenia Override',
    4700: 'Prepísať množstvové obmedzenie',
    4701: 'Naozaj chcete vymazať security prepíše?',
    4702: 'Naozaj chcete uvoľniť tento proces?',
    4703: '-',
    4704: 'Zaťaženie od SAP',
    4705: 'Dostupné príkazy',
    4706: 'Vybrané objednávky',
    4707: '-',
    4709: 'Minimálne množstvo nedosiahol.',
    4710: 'Konfliktné procesy.',
    4711: '-',
    4712: '-',
    4713: '-',
    4714: '-',
    4715: '-',
    4716: '-',
    4717: '-',
    4718: '-',
    4719: '-',
    4720: 'Prepísať prácu požiadavky',
    4721: 'Stanoviť minimálne množstvo',
    4722: 'Naozaj chcete zmeniť minimálne množstvo požiadavka?',
    4723: 'Táto zmena ovplyvní všetky budúce robotu.',
    4724: 'NEPODARILO SA ULOŽIŤ ZMENY!',
    4725: 'Minimálne množstvo zmenil na: ',
    4726: 'Minimálne množstvo hodnota musí byť celé kladné číslo.',
    4727: '-',
    4728: '-',
    4729: '-',
    4730: '-',
    4731: '-',
    4732: '-',
    4733: '-',
    4734: '-',
    4735: '-',
    4736: 'Plánovač úloh údržby',
    4737: 'Pridať položku',
    4738: 'Nakonfigurovať položku',
    4739: 'Interval pripomenutie údržby (dni): ',
    4740: 'Spustiť nový denník',
    4741: 'Naozaj chcete spustiť nový protokol údržby?',
    4742: 'Zaťaženie aktívneho denníka',
    4743: 'Vyberte denník',
    4744: '-',
    4745: 'Vyberte položku',
    4746: '-',
    4747: '-',
    4748: 'Úloha: ',
    4749: 'Nemožno uložiť, pretože nastavenia sú neplatné!',
    4750: 'Žiadne zmeny uložte!',
    4751: '-',
    4752: 'Obnovenie položky pri kalibrované',
    4753: 'Naozaj chcete zmeniť plán údržby pre túto položku?',
    4754: 'Naozaj chcete odstrániť túto položku z údržby plánovača?',
    4755: '-',
    4756: '-',
    4757: '-',
    4758: '-',
    4759: '-',
    4760: 'Použitie',
    4761: 'Čas',
    4762: 'Pracovné miesta',
    4763: 'Vypršala',
    4764: '-',
    4765: '-',
    4766: '-',
    4767: '-',
    4768: 'Pripomenutie údržby',
    4769: 'Údržba je vyžadovaná pre nasledovné položky: ',
    4770: 'Údržba vykonávaná',
    4864: 'Údržba Log',
    4865: 'Max pracovných miest: ',
    4866: 'Max použitie: ',
    4867: 'Max čas: ',
    4868: 'pracovné miesta',
    4869: 'dni',
    4870: '-',
    4871: '-',
    4872: 'VŠETKY',
    4873: '-',
    4874: '-',
    4875: 'VYPRŠALA',
    4876: 'KOMENTÁR',
    4877: 'Konfigurácia sa zmenila.',
    4878: 'ÚDRŽBA vykonávaná.',
    4879: 'ODSTRÁNENÉ: položka bola odstránená z harmonogramu. ',
    4880: 'Položky',
    4881: 'Položky uplynula.',
    4882: 'Položka neuplynuli.',
    4883: 'Práca skončila',
    4884: 'Využitie vypršala',
    4885: 'Uplynul časový limit',
    4886: 'Práce pred uplynutím: ',
    4887: 'Pracovných miest od vypršania: ',
    4888: 'Využitie pred uplynutím: ',
    4889: 'Využitie od vypršania: ',
    4890: 'Čas pred uplynutím: ',
    4891: 'Doby platnosti: ',
    4892: '-',
    4893: '*** POŠKODENÝ LINE *** ',
    4894: 'Kalibrácia vykonáva.',
    4895: 'Položka sa obnoví pri kalibrované',
    4896: '**************',
    4897: 'POPIS ÚLOHY',
    4898: '-',
    4899: '-',
    4900: '-',
    4901: '-',
    4902: '-',
    4903: '-',
    4904: '-',
    4905: '-',
    4906: '-',
    4907: '-',
    4908: '-',
    4909: '-',
    4910: '-',
    4911: '-',
    4912: '-',
    4913: '-',
    4914: '-',
    4915: '-',
    4916: '-',
    4917: 'ODSADENIE vykonáva.',
    4918: 'Operácia neúplné!',
    4919: 'IGNOROVAŤ: používateľa ignorovať údržba pripomenutie. ',
    4920: 'Používateľ začal nový súbor denníka.',
    4921: '-',
    4922: '-',
    4923: '-',
    4924: '-',
    4925: '-',
    4926: '-',
    4927: '-',
    4992: 'Vyberte krivky',
    4993: 'Pero šírky',
    4994: 'Pero štýl',
    4995: 'Symbol štýl',
    4996: 'Farba čiary',
    4997: 'Symbol farby',
    4998: 'Plátno farby',
    4999: 'Perá',
    5000: 'Uložiť PDF',
    5001: 'Uložiť vo farbe',
    5002: 'Uložiť biele plátno',
    5003: 'Chyba! Pozemok vzal príliš veľa času a bola zrušená.',
    5004: 'Chyba pri ukladaní graf pero konfigurácia!',
    32767: 'Počítač strážneho psa povolený',
    32768: 'Pomôcť',
    32769: 'Obsah',
    32770: 'O... ',
    32771: 'Communication Timeout',
    32772: 'Nedá sa načítať profily používateľov. Kontaktovať Nitrex.',
    32773: 'Počítač zlyhal strážneho psa.',
    32774: 'Chyba konfigurácie. Aplikácia nebude pracovať správne.',
    32775: 'Systém nadol',
    32776: 'Minút',
    32777: 'Export Log súbory',
    32778: 'Pravidelné čistenie protokolov',
    32781: 'Proces Tvorca',
    32782: 'Pomôcka',
    32783: 'Zálohovanie Config',
    32784: 'Alarmy',
    32785: 'Podrobnejšie zobrazenie',
    32786: 'Naložiť',
    32787: 'Upraviť',
    32788: 'Štart',
    32789: 'Prerušiť',
    32790: 'Pokračovať',
    32791: 'Grafické zobrazenie',
    32792: 'RT Chart',
    32793: 'Použite markerov krok',
    32794: 'Obnoviť Config',
    32795: 'Aktualizácia systému',
    32796: 'Kalibrácia',
    32797: 'Kompenzuje',
    32798: 'Proces upravený',
    32799: 'Proces modifikácie zlyhala',
    32800: 'Chyba v systéme konfiguračného súboru',
    32801: 'Chyba v konfigurácii IO! Chyba v súbore: ',
    32802: 'Pre Podrobnosti pozri súbor',
    32803: 'Chyba pri vytváraní paket vstupno – výstupné objekty',
    32804: 'Kalibrácia povolené len v režime údržby',
    32805: 'Nemôžete vykonať túto operáciu v tejto dobe',
    32806: 'Dostal',
    32807: 'Zložka',
    32808: 'Proces začal',
    32809: 'Proces prerušený',
    32810: 'Musí byť v pohotovosti na zaťaženie/rozvrh proces',
    32811: 'Žiadny proces spustený',
    32812: 'Nemáte povolenie na úpravu tohto procesu',
    32813: 'Musí byť v pohotovosti na spustenie procesu',
    32814: 'Už naplánovaných',
    32815: 'Proces vzdialene prerušená',
    32816: 'Pokus o prerušenie procesu zlyhal!',
    32817: 'Chyba začiatok práce',
    32818: 'Naozaj chcete zastaviť túto prácu?',
    32819: 'Nemôžete zastaviť túto úlohu teraz!',
    32820: 'Naozaj chcete zrušiť tento proces?',
    32821: 'Neexistuje žiadny proces spustený',
    32822: 'Naozaj chcete pokračovať v procese?',
    32823: 'Nie je v núdzové režime',
    32824: 'V tomto režime sa nedá spustiť údržbu',
    32825: 'Nemožno pokračovať/prerušiť',
    32826: 'Systémová chyba',
    32827: 'Panel chyba',
    32828: 'Resetovanie',
    32829: 'Panel',
    32830: 'Chyba',
    32831: 'Proces upravený vzdialene',
    32832: 'Vzdialenej pokus upraviť proces zlyhal',
    32833: 'Proces pokračuje vzdialene od',
    32834: 'Vzdialenej pokus obnoviť proces zlyhal',
    32835: 'Proces sa ZASTAVIL vzdialene',
    32836: 'Oneskorenie medzi dvoma po sebe idúcich pracovných miest nie uplynula ',
    32837: 'Zadaná úloha nie v komore.',
    32838: 'Proces sa zastavil',
    32839: 'Error with chart recorder!',
    32840: 'Missing information for batch!',
    32841: 'The configuration is missing the Model Number or the Serial Number of the furnace!',
    33581: 'There is already a comment saved at this time:',
    33582: 'Are you sure you want to replace it?',
    33583: 'Nedá sa vytvoriť lokálna kópia. Spracovanie pôvodný súbor',
    33584: 'Log súbor údržbu',
    33585: 'Chyba pri kopírovaní',
    33586: 'Operácia bola ukončená',
    33587: 'Skontrolujte, či cieľový disk',
    33588: 'Chyba pri odstraňovaní súboru',
    33589: 'Možno napísať chránených alebo neprístupné',
    33590: ' Nie je platný súbor denníka - tento súbor sa nespracuje. ',
    33591: ' Nie je platné číslo denníka adresár - operácia bola ukončená',
    33592: 'Nemôžete premiestniť ani odstrániť aktuálny súbor denníka-tento súbor sa nespracuje. ',
    33593: 'Mazanie súborov...',
    33594: 'Kopírovanie súborov...',
    33595: 'Premiestňovanie súborov...',
    33596: 'Chyba pri kopírovaní súboru, zariadenie môže napísať chránených alebo neprístupné',
    33597: 'Zdrojový súbor sa nedá otvoriť',
    33598: 'Cieľový súbor sa nedá vytvoriť',
    33599: 'Kopírovanie súboru vyskytli chyby',
    33600: 'Automatický režim',
    33601: 'Režim údržby',
    33602: 'Režim',
    33603: 'Stop',
    33604: 'Reštartujte Turbo Cool',
    33605: 'Reštartujte Turbo?',
    33606: 'Predhrejte otvorené pece',
    33607: 'Nie je možné spustiť - pec by mala byť otvorená ',
    33608: 'Nitplanner',
    33609: 'Potvrdiť, že správa',
    33610: 'Konfigurácia chyba pri vytváraní súboru plyny-viď Ctrl.Err',
    33611: 'Nemožno reštartovať Turbo Cool',
    33612: 'Pozastavený Turbo Cool',
    33613: 'Turbo Cool disabled',
    33614: 'Chyba v procese inštalácie',
    33615: 'Závažná chyba pod kontrolou.',
    33616: 'Fatálna chyba, nedá spustiť úlohu. Prosím, kontaktujte Nitrex Metal Inc.',
    33617: 'Táto úloha nemôže byť obnovená',
    33618: 'Chyba vo kontrola nastavenia - pozri kláves CTRL.EHM súbor',
    33619: 'Zálohy konfiguračných súborov',
    33620: 'Chyba v regulačnej slučke',
    33621: 'Pec termočlánok nahradiť aux. TC1 ',
    33622: 'Pec termočlánok nahradiť aux. TC2 ',
    33623: 'Hlavné termočlánok vymenil späť',
    33624: 'Nemožno spustiť difúznej pumpy',
    33625: 'Test netesnosti pece prešiel - NETESNOSTI = ',
    33626: 'Zlyhal Test netesnosti pec - NETESNOSTI = ',
    33627: 'Kúrenie nie je dovolené - prerušiť prácu vyžaduje',
    33628: 'Kontrola chýb späť - späť do normálneho',
    33629: 'Chyba konfigurácie - všetky plyny sú zakázané ',
    33630: 'Chyba konfigurácie - niektoré analyzátory sú zakázané ',
    33631: 'Chyba konfigurácie - všetky analyzátory sú zakázané ',
    33632: 'Chyba konfigurácie - niektoré analógové regulátory sú zakázané ',
    33633: 'Chyba konfigurácie - niektoré On/Off radiče sú zakázané',
    33634: 'Chladný pohotovosti',
    33635: 'Horúci pohotovosti',
    33636: 'Turbo chladenie reštartu: ',
    33637: 'Turbo chladenie reštartovať vzdialený používateľ: ',
    33638: 'Prácu začali vzdialeným používateľom: ',
    33639: 'Práca pokračovala vzdialeným používateľom: ',
    33640: 'Naozaj chcete Predhriať otvorené pec? ',
    33641: 'Predhrejte otvorené pec začal: ',
    33642: 'Predhrejte otvorené pec začal vzdialeným používateľom: ',
    33643: 'Zaťažené prácu: ',
    33644: 'Prácu naložené vzdialeným používateľom: ',
    33645: 'Režim údržby je nechránené. Naozaj chcete pokračovať? ',
    33646: 'Režim údržby začal: ',
    33647: 'Režim údržby začal vzdialeným používateľom: ',
    33648: 'Ospravedlňujeme sa, ale nemáte povolenie na vykonanie tejto operácie',
    33649: 'Kalibrácia/Offset požiada: ',
    33650: 'Kalibrácia/Offset požiada vzdialený používateľ: ',
    33651: 'Komory',
    33652: 'Predchádzajúci komory',
    33653: 'Ďalšie komory',
    33654: 'Podmienky nie sú splnené do konca tejto úlohy',
    33655: 'Nie sú splnené podmienky pre prenos zaťaženia',
    33656: 'Pohotovostnom typ prešiel na pohotovostnom ÚSPORNOM',
    33657: 'Vzdialený používateľ prešiel pohotovostnom typu HOT pohotovostného',
    33658: 'Pohotovostnom typ chladné režime pohotovosti',
    33659: 'Vzdialený používateľ prešiel pohotovostnom typ studenej pohotovostného',
    33660: 'Ďalšie práce povolené v',
    33661: 'Hlavné GUI',
    33662: 'Chcete začať Purge?',
    33663: 'Vyloženie prácu: ',
    33664: 'Prácu vyložiť vzdialený používateľ: ',
    33665: 'Vybrať horúce pohotovostnom recept',
    33666: 'Nemožno získať čítanie z: ',
    33667: 'Downloading file:',
    33668: 'File transfer error',
    33669: 'File transfer connection refused',
    33670: 'File transfer remote host closed',
    33671: 'File transfer host not found',
    33672: 'File transfer timeout',
    33673: 'File transfer operation cancelled',
    33674: 'File transfer content access denied',
    33675: 'File transfer content not found',
    33676: 'File transfer authentication required',
    33677: 'File transfer content conflict',
    33678: 'File transfer content gone',
    33679: 'File transfer internal server error',
    33680: 'File transfer unknown network error',
    33681: 'Restart Controller',
    33682: 'Are you sure you want to restart the controller now?',
    33683: 'Cannot find recipe for this part',
    33684: 'Job loaded by inspector',
    33685: 'This verification code is incorrect.',
    33686: 'Part number not found in file.',
    33687: 'Part has already been loaded.',
    33691: 'Recipients',
    33692: 'Recipient',
    33693: 'Company SMTP setup',
    33694: 'E-mail ',
    33695: 'Event',
    33696: 'Emergency',
    33697: 'Job Aborted',
    33698: 'Job Started',
    33699: 'Job Finished',
    33700: 'System Alarm',
    33701: 'I/O Alarm',
    33702: 'Cannot Write LOG file',
    33703: 'Cannot write process memory file',
    33704: 'Low Disk Space',
    33705: 'System Clock not Set',
    33706: 'Add Recipient',
    33707: 'Remove Recipient',
    33708: 'Clone Recipient',
    33709: 'Add Event',
    33710: 'Clear All Events',
    33711: 'Enable All Events',
    33712: 'Clear Event',
    33713: 'Mobile Connection',
    33714: 'Job Status Event',
    33715: 'All Events',
    33716: 'None',
    33717: 'I/O Type',
    33718: 'SMS Text',
    33719: 'Job Resumed',
    33720: 'ERROR',
    33721: 'Save Failed. At least one of e-mail addresses has to be entered',
    33722: 'Save Failed. Missing SMTP configuration.',
    33723: 'Save Failed. Missing notification events configuration.',
    33724: 'COMMON SMTP',
    33725: 'USER SMTP',
    33726: 'SMTP User Name',
    33727: 'SMTP User Password',
    33728: 'Host Name',
    33729: 'Port Number',
    33730: 'SSL Required',
    33731: 'Are you sure you want to discard the changes?',
    33732: 'Are you sure you want to clear all notifications, for all systems? Changes apply to selected user only',
    33733: 'Are you sure you want to enable all existing notifications for all systems? Changes apply to selected user only',
    33734: 'Recipient already exists. Please select anothe name',
    33735: 'Recipient name requires at least one character',
    33736: 'Recipient Name',
    33737: 'Select a chamber',
    33738: 'No I/O alarms available for the selected system',
    33739: 'Save Failed.',
    33740: 'Saved Successfully.',
    33741: 'Mobile Connection Setting',
    33742: 'Port Number for Mobile Connection (default 443)',
    33743: 'Max. Number of Mobile Connections',
    33744: 'Are you sure you want to delete the recipient?',
    33745: 'Delete all connections?',
    33746: 'Save changes?',
    33747: 'Mirroring',
    33748: 'Path',
    33749: 'Interval (hours)',
    33750: 'Mirroring Configuration',
    33751: 'Invalid interval value',
    33752: 'Configuration',
    33753: 'Mirror all',
    33754: 'There are no systems configured',
    33755: 'There are no systems available',
    33756: 'No systems have been selected',
    33757: 'No systems have mirroring enabled',
    33758: 'Select folder',
    33759: 'The path does not exist or is currently not accessible. Continue and save anyways?',
    33760: "Service enabled ('yes' or 'no')",
    33761: 'Protocol',
    33762: 'MQTT Connection',
    33763: 'SSL/TLS Version',
    33764: 'Private Key File',
    33765: 'Private Key Password',
    33766: 'Keystore File',
    33767: 'Enable Server Certificate Authentication',
    33768: 'Verify Certificates',
    33769: 'Any SSL/TLS',
    33770: 'Server Supports Retained Messages',
    33771: 'Max Payload Size (bytes)',
    33772: 'Max Readings Interval (seconds)',
    33773: 'Enable Auto Export',
    33774: 'Export All Logs',
    33775: 'You need to specify the path for exporting log files',
    33776: 'Export Log Files is disabled automatically when mirroring is disabled',
    33777: 'Log File Access',
    33778: 'Process Memory Access',
    33779: 'Low Disk Space',
    33780: 'System Clock Not Set',
    33781: 'Export Log Files is disabled',
    33782: 'Client ID',
    33783: 'Enable MQTT',
    33784: 'The following required fields are empty',
    33785: 'This Client ID may or may not be accepted by a server.',
    33786: "MQTT servers are required only to accept Client IDs of 1 to 23 characters, with each character one of '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.",
    33787: 'View MQTT status',
    33788: 'View Mobile status',
    33789: 'Database Configuration',
    33790: 'Logging Configuration',
    33800: 'Job Started',
    33801: 'Job Resumed',
    33802: 'Emergency Process Started',
    33803: 'Job Finished',
    33804: 'Job Aborted',
    33805: 'Notifications',
    33820: 'Connected to mobile back end server.',
    33821: 'Disconnected from mobile back end server.',
    33822: 'Connection error with mobile back end server:',
    33850: 'DASHBOARD',
    33851: 'PLANT CONNECTIONS',
    33852: 'ABOUT',
    33853: 'STATUS',
    33854: 'ALARMS',
    33855: 'System ID',
    33856: 'View Alarms',
    33857: 'View Status',
    33858: 'CHART',
    33859: 'RECIPE',
    33860: 'PLANT SELECT',
    33861: 'Refresh',
    33862: 'View Recipe',
    33871: 'Plant Connection Added',
    33872: 'Plant Connection Removed',
    33873: 'DEMO-MODE',
    33874: 'View Chart',
    33875: 'SELECT PLANT',
    33880: 'Trying to connect...',
    33881: 'Logon accepted',
    33882: 'Logon rejected',
    33883: 'Too many users',
    33884: 'Failed to connect',
    33920: 'Matice Predhrejte pec',
    33922: 'Watchdog stav',
    33925: 'Oznámenie',
    33926: 'Zomrie',
    33927: 'Zomrieť Manager',
    33928: 'Dotazy',
    33930: 'Nemožno spustiť nástroj Pack je naložený',
    33936: 'Banka',
    33937: 'Rúra',
    33938: 'Príručka',
    33939: 'Záťaž',
    33940: 'Kontrola',
    33941: 'Teploty pece',
    33942: 'Nízky prietok',
    33943: 'Vysoký prietok',
    33944: 'Výkon',
    33945: 'Teplota Setpoint',
    33946: 'Dvere pece Status',
    33947: 'Nie je platná hodnota!',
    33948: 'Hodnota mimo rozsahu! Musí byť medzi',
    33949: 'Ovládací Panel Status',
    33950: 'Zapnúť',
    33951: 'Vypnúť',
    33952: 'Pohotovostný režim',
    33953: 'Výkon Zapnuté',
    33954: 'Vypnutie',
    33955: 'N2 vysokou prietok',
    33956: 'N2 nízky prietok',
    33957: 'Nemôžem zapnúť moc - úloha naplánovaná!',
    33958: 'Nemožno vypnúť napájanie - zomrie naložené!',
    33959: 'Nemôžete prepnúť režim - zomrie naložené!',
    33960: 'Uplynulý čas: ',
    33961: 'Zostávajúci čas: ',
    34000: 'Nahrá',
    34001: 'Kúrenie',
    34002: 'Namáčanie',
    34003: 'Pripravené',
    34004: 'Over-Soaked',
    34005: 'Chyba!',
    34006: 'Náhradné',
    34007: 'Náhradné',
    34008: 'Náhradné',
    34009: 'Náhradné',
    34016: 'Matice',
    34017: 'Neplatné údaje',
    34018: 'Neplatný čas',
    34019: 'Chyba čítania súboru zotavenie zomrieť!',
    34048: 'Vyložiť',
    34049: 'Úlohy naplánované pre',
    34050: 'Pridať matice',
    34051: 'Rúra: ',
    34052: 'Bank: ',
    34053: 'Dvere umožniť, čakanie na dvere otvoriť...',
    34054: 'Dvere umožniť, čakanie na dvere zavrieť...',
    34055: 'Min. čas: ',
    34056: 'Max. Čas: ',
    34057: 'Nastaviť Teplotu: ',
    34058: 'Zomrieť kód: ',
    34059: 'Odstrániť matice',
    34060: 'Neplatné údaje',
    34061: 'Nepodarilo sa pridať studenej zomrie s horúcou zomrie',
    34062: 'Nepodarilo sa odstrániť aktívne matice',
    34063: 'Nové zomrieť',
    34064: 'Matice stav: ',
    34065: 'Prekročili ste maximálnu povolenú zomrie má byť naložený',
    34066: 'Zoznam zomrie',
    34067: 'Namočte teplotu',
    34068: 'Min.Soak čas (min)',
    34069: 'Max.Soak čas (min)',
    34070: 'Zomrie',
    34071: 'Skupina',
    34073: 'Matice nebol nájdený',
    34074: 'Pokúšate sa pridať umrieť, že je už liečený',
    34075: 'Nemožno pridať zomrie s rozličnou teplotou.',
    34076: 'Teplotný rozsah: ',
    34077: 'Pec nastavená teplota',
    34078: 'Matice s rôzne stanovené teploty bude naložené, musíte zadať rovnaké teplota pre všetky zomrie.',
    34079: 'Neplatný teplota.',
    34080: 'Nie je možné vykonať požadovanú operáciu, kým sú načítané zomrie.',
    34081: 'Aktuálne nastavená teplota.',
    34082: 'Operácia zrušené, čakanie na dvere zavrieť...',
    34083: 'Rýchle vyhľadávanie: ',
    34084: 'Matice pridané',
    34085: 'Matice už pridané',
    34086: 'Skupiny',
    34087: 'Vymazať',
    34088: 'Od dátum (dd/mm/rrrr): ',
    34089: 'Dátum (dd/mm/rrrr): ',
    34090: 'Vymazáva sa úspešne dokončila',
    34091: 'Neplatný dátum',
    34092: 'Neplatný rozsah údajov',
    34093: 'Nedá sa načítať zomrie s rôznymi minimálna doba.',
    34094: 'Momentálne upravujete alebo pridanie nových údajov, údaje sa neuložia. Pokračovať?',
    34095: 'Niektoré databázové súbory chýbajú alebo adresár údajov už existuje, aplikácia bude pokračovať bez podpory databázy.',
    34096: 'Prvý záznam',
    34097: 'Predchádzajúci rekord',
    34098: 'Ďalší záznam',
    34099: 'Posledný záznam',
    34100: 'Vložiť záznam',
    34101: 'Odstránenie záznamu',
    34102: 'Úprava záznamu',
    34103: 'Uložiť záznam',
    34104: 'Zrušiť záznam',
    34105: 'Obnovenie záznamu',
    34112: 'Neaktívne',
    34113: 'Vyskytla sa neočakávaná chyba, žiadosť sa teraz ukonΦφ.',
    34114: 'Duplicitný záznam',
    34115: 'Vymazať?',
    34116: 'Sa nedá odstrániť, táto skupina je odkazom Ostatné zomrie',
    34117: 'Tam je neplatný vstup v poli s označením: ',
    34118: 'Nie je možné upraviť alebo odstrániť matice že je naložený.',
    34119: 'Vyžaduje sa názov skupiny',
    34120: 'Popis je potrebné',
    34121: 'Matice kód je potrebné',
    34122: 'Minimálny čas je mimo rozsahu. Nasledujúci rozsah hodnôt sú povolené: ',
    34123: 'Maximálny čas je mimo rozsahu. Nasledujúci rozsah hodnôt sú povolené: ',
    34124: 'Nastavenie teploty je mimo rozsahu. Nasledujúci rozsah hodnôt sú povolené: ',
    34125: 'NOT Ready',
    32126: 'Ready Die',
    32127: 'Oversoaked Die',
    32128: 'Scheduled',
    32129: 'Query Results',
    32130: 'Press ENTER when the die is selected',
    32131: 'Pause',
    32132: 'Reschedule Pause',
    32133: 'System paused until ',
    32134: 'Are you sure you want to pause the system ?',
    32135: 'Set resume time',
    32136: 'Set job start',
    32137: 'Pause the system',
    32138: 'System paused',
    35000: 'Nastaviť IP adresu',
    35001: 'Časový limit [MS]',
    35002: 'Intervale [MS]',
    35003: 'Adresy IP sa zmenila',
    35004: 'Naozaj chcete vymazať vybraté položky?',
    35005: 'Pridať Slave',
    35006: 'Odstrániť Slave',
    35007: 'Slave #',
    35008: 'Adresa IP hostiteľa',
    35009: 'Kanál #',
    35010: 'Je obmedzený na prihlásenie údajov',
    40000: 'Termočlánok zóny 1 ',
    40001: 'Termočlánok zóny 1 (dole)',
    40002: 'Termočlánok zóny 2 ',
    40003: 'Termočlánok zóny 2 ',
    40004: 'Termočlánok zóny 3 ',
    40005: 'Termočlánok zóna 3 ',
    40006: 'Termočlánok zóny 4 ',
    40007: 'Termočlánok zóny 4 ',
    40008: 'Termočlánok zóny 5 ',
    40009: 'Termočlánok zóny 5 ',
    40010: 'Termočlánok zóny 6 ',
    40011: 'Termočlánok zóny 6 ',
    40012: 'Termočlánok zóny 7 ',
    40013: 'Termočlánok zóny 7 ',
    40014: 'Termočlánok zóny 8 ',
    40015: 'Termočlánok zóny 8 ',
    40016: 'Hlavné Termočlánok',
    40017: 'Termočlánok interiéru Main',
    40018: 'Aux Termočlánok 1 ',
    40019: 'Aux termočlánok interiér 1 ',
    40020: 'Aux Termočlánok 2 ',
    40021: 'Interiér termočlánok AUX 2 ',
    40022: 'Pri načítaní Termočlánok',
    40023: 'Na zaťaženie termočlánok',
    40024: 'Na zaťaženie 2 ',
    40025: 'Na zaťaženie termočlánok 2 ',
    40026: 'Na zaťaženie 3 ',
    40027: 'Na zaťaženie termočlánok 3 ',
    40028: 'Zaťaženie Termočlánok',
    40029: 'V termočlánku zaťaženia',
    40030: 'Zaťaženie 2 ',
    40031: 'V termočlánku zaťaženie 2 ',
    40032: 'Zaťaženie 3 ',
    40033: 'V termočlánku zaťaženie 3 ',
    40034: 'Tlak pece',
    40035: 'Pec tlak',
    40036: 'Talk2 ',
    40037: 'Diferenciálny tlak 2. ',
    40038: 'ABS. Tlak',
    40039: 'Absolútny tlak snímača Main',
    40040: 'ABS. Tlak2 ',
    40041: 'Vákuové tlakovým snímačom 2. ',
    40042: 'N2 prietok',
    40043: 'MFC1A dusíka',
    40044: 'N2 prietok-B',
    40045: 'MFC1B dusíka',
    40046: 'Tok N2-C',
    40047: 'MFC1C dusíka',
    40048: 'N2 prietok-D',
    40049: 'MFC1D dusíka',
    40050: 'NH3 prietok',
    40051: 'MFC2A čpavok',
    40052: 'NH3 prietok-B',
    40053: 'MFC2B čpavok',
    40054: 'NH3 prietok-C',
    40055: 'MFC2C čpavok',
    40056: 'NH3 prietok-D',
    40057: 'MFC2D čpavok',
    40058: 'dNH3 tok',
    40059: 'MFC3A oddeliť čpavok',
    40060: 'dNH3 tok-B',
    40061: 'MFC3B oddeliť čpavok',
    40062: 'dNH3 tok-C',
    40063: 'MFC3C oddeliť čpavok',
    40064: 'dNH3 tok-D',
    40065: 'MFC3D oddeliť čpavok',
    40066: 'CO2 prietok',
    40067: 'MFC4A CO2 ',
    40068: 'CO2 prietok-B',
    40069: 'MFC4B CO2 ',
    40070: 'CO2 prietok-C',
    40071: 'MFC4C CO2 ',
    40072: 'CO2 prietok-D',
    40073: 'MFC4D CO2 ',
    40074: 'Prúdenie vzduchu',
    40075: 'MFC5A ovzdušie',
    40076: 'Air prietok-B',
    40077: 'MFC5B ovzdušie',
    40078: 'Air prietok-C',
    40079: 'MFC5C ovzdušie',
    40080: 'Air prietok-D',
    40081: 'MFC5D ovzdušie',
    40082: 'Endo prietok',
    40083: 'MFC6A Endo',
    40084: 'Tok endo-B ',
    40085: 'MFC6B Endo',
    40086: 'Tok endo-C ',
    40087: 'MFC6C Endo',
    40088: 'Tok endo-D ',
    40089: 'MFC6D Endo',
    40090: 'H2O prietok',
    40091: 'MFC7A voda',
    40092: 'H2O prietok-B',
    40093: 'MFC7B voda',
    40094: 'H2O prietok-C',
    40095: 'MFC7C voda',
    40096: 'H2O prietok-D',
    40097: 'MFC7D voda',
    40098: 'CO prietok',
    40099: 'MFC CO prietok',
    40100: 'MFC CO-B',
    40101: 'B tok CO',
    40102: 'MFC CO-C',
    40103: 'CO tok C',
    40104: 'MFC CO-D',
    40105: 'CO tok D',
    40106: 'Disociácia',
    40107: 'Disociácia pece',
    40108: 'H2 Analyzer',
    40109: 'H2 Analyzer',
    40110: 'CO analyzátor',
    40111: 'CO analyzátor',
    40112: 'Analyzátor CO2',
    40113: 'Analyzátor CO2',
    40114: 'O2 sonda',
    40115: 'Kyslík sonda mV',
    40116: 'Th. Balance',
    40117: 'Thermo rovnováhu snímač',
    40118: 'Teplo Sledovanie zóna 1 ',
    40119: 'Teplo sledovanie Termočlánok 1 ',
    40120: 'Teplo Sledovanie zóny 2 ',
    40121: 'Teplo sledovanie Termočlánok 2 ',
    40122: 'Teplo Sledovanie zóna 3 ',
    40123: 'Teplo sledovanie Termočlánok 3 ',
    40124: 'Teplo Sledovanie zóna 4 ',
    40125: 'Teplo sledovanie Termočlánok 4 ',
    40126: 'Odber vzoriek prietok',
    40127: 'Prietok vzorky',
    40128: 'Celkový prietok',
    40129: 'Celkový prietok',
    40130: 'N2 pece ',
    40131: 'N2 atmosféra pece ',
    40132: 'Pec NH3 ',
    40133: 'NH3 atmosféra pece ',
    40134: 'Pec dNH3 ',
    40135: 'Pec atmosféru dNH3 ',
    40136: 'Pec CO2 ',
    40137: 'Pec atmosfére CO2 ',
    40138: 'Pec vzduchu',
    40139: 'Pec atmosfére vzduch',
    40140: 'Endo pece',
    40141: 'Pec atmosféru ENDO',
    40142: 'Pec H2O',
    40143: 'H2O atmosféra pece',
    40144: 'Pec CO',
    40145: 'Pec atmosfére plynu CO',
    40146: 'Prívod N2 ',
    40147: 'Prívod atmosféru N2 ',
    40148: 'Prívod NH3 ',
    40149: 'Prívod atmosféru NH3 ',
    40150: 'Prívod dNH3 ',
    40151: 'Prívod atmosféru dNH3 ',
    40152: 'Prívod CO2 ',
    40153: 'Prívod atmosféru CO',
    40154: 'Prívod vzduchu',
    40155: 'Atmosféra nasávaného vzduchu',
    40156: 'Prívod Endo',
    40157: 'Prívod atmosféru ENDO',
    40158: 'Prívod H2O',
    40159: 'Prívod plynu atmosféru 7 ',
    40160: 'Prívod CO',
    40161: 'Prívod atmosféru CO',
    40162: 'NH3 snímač',
    40163: 'Snímač úniku čpavok 1 ',
    40164: 'NH3 Senzor 2 ',
    40165: 'Snímač úniku čpavok 2 ',
    40166: 'Chladenie rampa',
    40167: 'Ramping v chladenie',
    40168: 'Kúrenie rampa',
    40169: 'Ramping v vykurovanie',
    40170: 'nie. Stupne',
    40171: 'Počet etáp',
    40172: 'KN',
    40173: 'Nitridačná potenciál',
    40174: 'Kn2 ',
    40175: 'Nitridačná potenciál 2 ',
    40176: 'KC',
    40177: 'Uhlíka potenciál',
    40178: 'Ko',
    40179: 'Kyslík potenciál',
    40180: 'Fázy času',
    40181: 'Fázy času',
    40182: 'Vymazané objem',
    40183: 'Prívod plynu objem - fáze',
    40184: 'Neutraliz.Termočlánok',
    40185: 'Neutralizačné termočlánok',
    40186: 'IO Bus',
    40187: 'Vstup/výstup zbernice stav',
    40188: 'Čas úlohy',
    40189: 'Čas odhadovaných úlohy',
    40190: 'Núdzové',
    40191: 'Núdzového stavu kód',
    40192: 'Diff.teplota',
    40193: 'Budík Offset peci teploty',
    40194: 'Koniec teplota',
    40195: 'Teplota konca fázy',
    40196: 'Stlačením pece',
    40197: 'Tlak pece',
    40198: 'Max St. Time',
    40199: 'Čas maximálnej fázy',
    40200: 'VAC čerpanie',
    40201: 'Vákuové na čerpací systém',
    40202: 'Plášť teplota',
    40203: 'Plášť peci teploty',
    40204: 'Dvere teplota',
    40205: 'Peci teploty dvere',
    40206: 'I1 ',
    40207: 'Kúrenie aktuálne 1 ',
    40208: 'I2 [A] ',
    40209: 'Kúrenie aktuálne 2 ',
    40210: 'I3 [A] ',
    40211: 'Kúrenie aktuálne 3 ',
    40212: 'N2 Rosa',
    40213: 'Dusík rosný bod',
    40214: 'Olej teplota',
    40215: 'Teplota oleja difúzie čerpadlo',
    40216: 'Náhradné',
    40217: 'Náhradné',
    40218: 'H2 test',
    40219: 'H2 senzora 3 ',
    40220: 'Teplota Vzorkovanie',
    40221: 'Odber vzoriek toku teploty',
    40222: 'Em.N2 tok',
    40223: 'Núdzové dusíka prietok',
    40224: 'Náhradné',
    40225: 'Náhradné',
    40226: 'Vysoká vyplachovania',
    40227: 'Vysoká očistiť prúdom dusíka',
    40228: 'Nízke vyplachovania',
    40229: 'Dusík Low očistiť tok',
    40230: 'Q.Tlak',
    40231: 'Tlak v kalenia komory',
    40232: 'Teplota vody',
    40233: 'Kalením teplota vody',
    40234: 'NF',
    40235: 'Nitridačná faktor',
    40236: 'Stlačte rampa',
    40237: 'Tlakový Gradient',
    40238: 'Vac.Ramp',
    40239: 'Vákuové Gradient',
    40240: 'Napájanie 1 ',
    40241: 'Zapnutie zóna 1 (dole)',
    40242: 'Napájanie 2 ',
    40243: 'Zapnutie zóny 2 ',
    40244: 'Napájanie 3 ',
    40245: 'Zapnutie zóna 3 ',
    40246: 'Napájanie 4 ',
    40247: 'Zapnutie zóna 4 ',
    40248: 'Výkon 5 ',
    40249: 'Výkon v pásme 5 ',
    40250: 'Výkon 6 ',
    40251: 'Výkon v pásme 6 ',
    40252: 'Výkon 7 ',
    40253: 'Zapnutie zóny 7 ',
    40254: 'Výkon 8 ',
    40255: 'Zapnutie zóna 8 ',
    40256: 'N2 žiadaná',
    40257: 'MFC1A dusík žiadaná',
    40258: 'N2-B žiadaná',
    40259: 'MFC1B dusík žiadaná',
    40260: 'N2-C žiadaná',
    40261: 'MFC1C dusík žiadaná',
    40262: 'N2-D žiadaná',
    40263: 'MFC1D dusík žiadaná',
    40264: 'NH3 žiadaná',
    40265: 'MFC2A čpavok žiadaná',
    40266: 'NH3-B žiadaná',
    40267: 'MFC2B čpavok žiadaná',
    40268: 'NH3-C žiadaná',
    40269: 'MFC2C čpavok žiadaná',
    40270: 'NH3-D žiadaná',
    40271: 'MFC2D čpavok žiadaná',
    40272: 'dNH3 žiadaná',
    40273: 'MFC3A oddeliť čpavok žiadaná',
    40274: 'dNH3-B žiadaná',
    40275: 'MFC3B oddeliť čpavok žiadaná',
    40276: 'dNH3-C žiadaná',
    40277: 'MFC3C oddeliť čpavok žiadaná',
    40278: 'dNH3-D žiadaná',
    40279: 'MFC3D oddeliť čpavok žiadaná',
    40280: 'CO2 žiadaná',
    40281: 'MFC4A CO2 žiadaná',
    40282: 'CO2-B žiadaná',
    40283: 'MFC4B CO2 žiadaná',
    40284: 'CO2-C žiadaná',
    40285: 'MFC4C CO2 žiadaná',
    40286: 'CO2-D žiadaná',
    40287: 'MFC4D CO2 žiadaná',
    40288: 'Vzduchu žiadaná',
    40289: 'MFC5A prietok vzduchu žiadaná',
    40290: 'Vzduch-B žiadaná',
    40291: 'MFC5B prietok vzduchu žiadaná',
    40292: 'Vzduchu žiadaná',
    40293: 'MFC5C prietok vzduchu žiadaná',
    40294: 'Vzduchu žiadaná',
    40295: 'MFC5D prietok vzduchu žiadaná',
    40296: 'Endo žiadaná',
    40297: 'MFC6A Endo žiadaná',
    40298: 'Endo-B žiadaná',
    40299: 'MFC6B Endo žiadaná',
    40300: 'Endo-C žiadaná',
    40301: 'MFC6C Endo žiadaná',
    40302: 'Endo-D žiadaná',
    40303: 'MFC6D Endo žiadaná',
    40304: 'H2O žiadaná',
    40305: 'MFC7A vody žiadaná',
    40306: 'H2O-B žiadaná',
    40307: 'MFC7B vody žiadaná',
    40308: 'H2O žiadaná',
    40309: 'MFC7C vody žiadaná',
    40310: 'H2O-D žiadaná',
    40311: 'MFC7D vody žiadaná',
    40312: 'CO žiadaná',
    40313: 'MFC CO žiadaná',
    40314: 'CO-B žiadaná',
    40315: 'MFC CO-B žiadaná',
    40316: 'CO-C žiadaná',
    40317: 'MFC CO-C žiadaná',
    40318: 'CO-D žiadaná',
    40319: 'MFC CO-D žiadaná',
    40320: 'Výfukových plynov',
    40321: 'Výfukový ventil',
    40322: 'Náhradné',
    40323: 'Náhradné',
    40324: 'Ventilátora',
    40325: 'Plynové dúchadlo rýchlosti',
    40326: 'Teplota žiadaná',
    40327: 'Teplota žiadaná radič',
    40328: 'Zdieľané',
    40329: 'Zdieľanie: ',
    40330: 'Stav',
    40331: 'Kód stavu vybavenia',
    40332: 'Náhradné',
    40333: 'Náhradné',
    40334: 'Prehriatiu teplota',
    40335: 'Prehriatiu teplota',
    40336: 'Celkový prietok',
    40337: 'Celkový tok výstupu (potenciálne ctrl)',
    40338: 'ATM. KnCtrl',
    40339: 'Nastaviť atmosféru (Kn ctrl)',
    40340: 'Atm.NH3 ',
    40341: 'Nastaviť atmosféru NH3 ',
    40342: 'ATM. dNH3 ',
    40343: 'Nastaviť atmosféru dNH3 ',
    40344: 'ATM. CO',
    40345: 'Nastaviť atmosféru CO',
    40346: 'ATM. Air',
    40347: 'Nastaviť atmosféru vzduchu',
    40348: 'ATM. ENDO',
    40349: 'Nastaviť atmosféru ENDO',
    40350: 'ATM. plynu 7 ',
    40351: 'Nastaviť atmosféru plynu 7 ',
    40352: 'ATM. CO',
    40353: 'Nastaviť atmosféru CO',
    40354: 'Náhradné',
    40355: 'Náhradné',
    40356: 'Žiadaná teplota',
    40357: 'Teplota žiadaná radič',
    40358: 'Žiadaná cirkulačný ventilátor',
    40359: 'Interiér turbíny rýchlosti',
    40360: 'Turbo ventil',
    40361: 'Turbo Cool ventil',
    40362: 'Filtre obišli',
    40363: 'Filtre obišiel',
    40364: 'Prefiltruje tlak',
    40365: 'Diferenciálneho tlaku na filtri',
    40366: 'Proces vstrekovania',
    40367: 'SS vybratý proces vstrekovania',
    40368: 'Výfukové filtre',
    40369: 'Filter výfukových povolené',
    40370: 'Reg. proces',
    40371: 'Pravidelné vybratý proces',
    40372: 'HLAVNÉ Výfukové',
    40373: 'HLAVNÉ výfukových povolené',
    40440: 'Veko',
    40441: 'Kryt pece Status',
    40442: 'Výkon',
    40443: 'Zlyhanie napájania',
    40444: 'H2O prietok',
    40445: 'Chladiaca voda prepínač',
    40446: 'Neutralizačné',
    40447: 'Neutralizačné Status',
    40448: 'Fáza',
    40449: 'Fázu monitorovania',
    40450: 'Prepínač 1 ',
    40451: 'Uzavretej prepínač 1 Master',
    40452: 'Prepnúť 2 ',
    40453: 'Uzavretej prepnúť 2 ',
    40454: 'Pohode ventilátora',
    40455: 'Chladiaci ventilátor snímač rýchlosti',
    40456: 'Cirkulačný ventilátor',
    40457: 'Cirkulujúcej ventilátora snímač rýchlosti',
    40458: 'Turbo Motor',
    40459: 'Turbo chladenie motora snímač rýchlosti',
    40460: 'Vákuové pumpy',
    40461: 'Vákuová pumpa snímač rýchlosti',
    40462: 'Motory',
    40463: 'Motor(s) preťaženie Alarm',
    40464: 'Turbo v OPEN',
    40465: 'Turbo ventil OPEN - výmenník tepla',
    40466: 'SCR O/H',
    40467: 'SCR prehriať stav',
    40468: 'Obísť Turbo',
    40469: 'Turbo obtokový ventil',
    40470: 'Tlakový spínač',
    40471: 'Tlakový spínač',
    40472: 'Turbo tlak',
    40473: 'Turbo tlak',
    40474: 'NH3 snímač',
    40475: 'Čpavok senzor 1 ',
    40476: 'NH3 senzor 2 ',
    40477: 'Čpavok senzor 2 ',
    40478: 'Turbo v zatvorené',
    40479: 'Turbo ventil uzavretý - výmenník tepla',
    40480: 'Turbo, OTVORTE',
    40481: 'Turbo ventil OPEN - z tepelného výmenníka',
    40482: 'Turbo, zatvorené',
    40483: 'Turbo ventil uzavretý - z tepelného výmenníka',
    40484: 'Vzduchu BF Open',
    40485: 'Ovzdušia zapĺňať ventil otvorený',
    40486: 'AirBF uzavreté',
    40487: 'Vzduchu zapĺňať ventil uzavretý',
    40488: 'E-STOP',
    40489: 'Núdzové zastavenie',
    40490: 'Pec pretlak spínač',
    40491: 'Pec pretlak spínač',
    40492: 'Celkový čas',
    40493: 'Celková Práca Time',
    40494: 'Pec O/H ',
    40495: 'Pec Prehriatie',
    40496: 'Chladič stlačením',
    40497: 'Tlak chladiacej kvapaliny',
    40498: 'TEN HORE',
    40499: 'Výmenník tepla do stavu',
    40500: 'TEN DOLE',
    40501: 'Výmenník tepla dole Status',
    40502: 'CW-obchvat',
    40503: 'Chladenie vody obchvat',
    40504: 'Q1 CW-obchvat',
    40505: 'Chladenie vody obchvatu v FC komory',
    40506: 'Spustenie úlohy',
    40507: 'Práca Štart požaduje',
    40508: 'Zaťaženie v Q1 ',
    40509: 'Zaťaženie colling komory',
    40510: 'D1 OTVORENÉ',
    40511: 'Chladiace komory otvorené',
    40512: 'D1 UZAVRETÁ',
    40513: 'Chladiace komory uzavreté',
    40514: 'Reťazca v Q1 ',
    40515: 'Dopravného reťazca v Q1 ',
    40516: 'Závora zaťaženia',
    40517: 'Reverzibilné závora zaťaženia',
    40518: 'Uvoľniť západku',
    40519: 'Reverzibilné závora vyložiť',
    40520: 'Zaťaženie v Q3 ',
    40521: 'Zaťaženie v Q3 ',
    40522: 'D2/D3 OPEN',
    40523: 'Dvere D2/D3 OPEN',
    40524: 'D2/D3 ZATVORENÉ',
    40525: 'Stav dvere D2/D3 zatvorené',
    40526: 'Reťazca v Q3 ',
    40527: 'Reťazca v Q3 ',
    40528: 'Tesnenie zasunuté',
    40529: 'Tesnenie dverí zasunuté',
    40530: 'Utesnenie rozšírené',
    40531: 'Tesnenie dverí rozšírená',
    40532: 'Q1 vysoká Tlačová',
    40533: 'Pretlak chladiacej komory',
    40534: 'Otvorených dverí',
    40535: 'Žiadosť otvoriť všetky dvere',
    40536: 'Zavrieť dvere',
    40537: 'Požiadavku na zatvorenie všetkých dverí',
    40538: 'Dvere',
    40539: 'Dvere',
    40540: 'SCR1 ',
    40541: 'Výkon na SCR1 (dole) ',
    40542: 'SCR2 ',
    40543: 'Výkon na SCR2 ',
    40544: 'SCR3 ',
    40545: 'Výkon na SCR3 ',
    40546: 'SCR4 ',
    40547: 'Výkon na SCR4 ',
    40548: 'SCR5 ',
    40549: 'Výkon na SCR5 ',
    40550: 'SCR6 ',
    40551: 'Výkon na SCR6 ',
    40552: 'SCR7 ',
    40553: 'Výkon na SCR7 ',
    40554: 'SCR8 ',
    40555: 'Výkon na SCR8 ',
    40556: 'Kúrenie',
    40557: 'Vykurovacie telesá',
    40558: 'EM N2 ',
    40559: 'Núdzové N2 ventil',
    40560: 'N2 ',
    40561: 'Dusík Sol. ventil',
    40562: 'N2-B',
    40563: 'Dusík-B Sol. ventil',
    40564: 'N2-C',
    40565: 'Dusík-C Sol. ventil',
    40566: 'N2-D',
    40567: 'Dusík-D Sol. ventil',
    40568: 'NH3 ',
    40569: 'Čpavok Sol. ventil',
    40570: 'NH3-B',
    40571: 'Čpavok-B Sol. ventil',
    40572: 'NH3-C',
    40573: 'Čpavok-C Sol. ventil',
    40574: 'NH3-D',
    40575: 'Čpavok-D Sol. ventil',
    40576: 'dNH3 ',
    40577: 'Diss.Ammonia Sol. ventil',
    40578: 'dNH3-B',
    40579: 'Diss.Ammonia-B Sol. ventil',
    40580: 'dNH3-C',
    40581: 'Diss.Ammonia-C Sol. ventil',
    40582: 'dNH3-D',
    40583: 'Diss.Ammonia-D Sol. ventil',
    40584: 'CO2 ',
    40585: 'CO2 Elektromagnetický ventil',
    40586: 'CO2-B',
    40587: 'Elektromagnetický ventil CO2-B',
    40588: 'CO2-C',
    40589: 'CO2-C Elektromagnetický ventil',
    40590: 'CO2-D',
    40591: 'CO2-D Elektromagnetický ventil',
    40592: 'Air',
    40593: 'Vzduchu Elektromagnetický ventil',
    40594: 'Vzduch-B',
    40595: 'Elektromagnetický ventil vzduchu-B',
    40596: 'Vzduch-C',
    40597: 'Vzduch-C Elektromagnetický ventil',
    40598: 'Vzduch-D',
    40599: 'Vzduch-D Elektromagnetický ventil',
    40600: 'Endo',
    40601: 'Endo plynu Elektromagnetický ventil',
    40602: 'Endo-B',
    40603: 'Endo-B plynu Elektromagnetický ventil',
    40604: 'Endo-C',
    40605: 'Elektromagnetický ventil plynu endo-C',
    40606: 'Endo-D',
    40607: 'Elektromagnetický ventil plynu endo-D',
    40608: 'Voda',
    40609: 'Elektromagnetický ventil vody',
    40610: 'Voda-B',
    40611: 'Voda-B Elektromagnetický ventil',
    40612: 'Voda-C',
    40613: 'Voda-C Elektromagnetický ventil',
    40614: 'Voda-D',
    40615: 'Voda-D Elektromagnetický ventil',
    40616: 'CO',
    40617: 'CO Elektromagnetický ventil',
    40618: 'CO-B',
    40619: 'CO-B Elektromagnetický ventil',
    40620: 'CO-C',
    40621: 'CO-C Elektromagnetický ventil',
    40622: 'CO-D',
    40623: 'CO-D Elektromagnetický ventil',
    40624: "Hlavné '' Exh",
    40625: 'Hlavné vypúšťací ventil',
    40626: 'AUX výfuku',
    40627: 'Pomocné výfukový ventil',
    40628: 'Vydanie',
    40629: 'Odvzdušňovací ventil',
    40630: 'Furn.IN-VAC',
    40631: 'Pec v - vákuový ventil',
    40632: 'Furn.OUT-VAC',
    40633: 'Pec sa - vákuový ventil',
    40634: 'VAC. ventil',
    40635: 'Hlavné vákuový ventil',
    40636: 'Plyn predradníka',
    40637: 'Plynový ventil predradník - vákuové',
    40638: 'Zapĺňať',
    40639: 'Zapĺňať ventil',
    40640: 'Odber vzoriek',
    40641: 'Odber vzoriek Line Elektromagnetický ventil',
    40642: 'Analyzátor CO CO2',
    40643: 'Ventil - analyzátor CO CO2',
    40644: 'O2 vzoriek',
    40645: 'Vzorkovacie potrubie do analyzátora O2',
    40646: 'Vymazať Diss.',
    40647: 'Očistenie ventil Dissociator',
    40648: 'Ex.OUT-OPEN',
    40649: 'OTVORENÉ turbo ventil výmenné-OUT',
    40650: 'Ex.OUT-CLOSE',
    40651: 'Zavrieť turbo ventil výmenné-OUT',
    40652: 'Pohode ventilátora',
    40653: 'Ventilátor chladenia pece',
    40654: 'Cirkulačný ventilátor',
    40655: 'Pec cirkulujúcej Ventilátor',
    40656: 'Ventilátor Lo.Speed',
    40657: 'Cirkulujúcej Ventilátor - nízkej rýchlosti',
    40658: 'Turbo Motor',
    40659: 'Turbo chladenie motorového',
    40660: 'VAC. Pumpa',
    40661: 'Vákuové pumpy',
    40662: 'Hydraulické',
    40663: 'Hydraulické čerpadlo',
    40664: 'Ventilátor Hi.Speed',
    40665: 'cirkulačný ventilátor - vysokej rýchlosti',
    40666: 'ONC',
    40667: 'NADCHÁ vstrekovania',
    40668: 'Agent čerpadlo',
    40669: 'Agent čerpadlo - aktivácia',
    40670: 'Injekcia 3 ',
    40671: 'Ventil/čerpadlo pre injekciu 3 ',
    40672: 'Chladiaca voda',
    40673: 'Pec chladiaceho okruhu vody',
    40674: 'Exh.Bypass',
    40675: 'Výfukové obchvat',
    40676: 'Rýchly pohode',
    40677: 'Rýchle chladenie',
    40678: 'Na Echanger',
    40679: 'Turbo ventil - výmenník tepla',
    40680: 'Svetlo budík',
    40681: 'Svetlo budík',
    40682: 'Bzučiak',
    40683: 'Bzučiak',
    40684: 'Beh',
    40685: 'Úloha beží',
    40686: 'V pohotovostnom režime',
    40687: 'Pec v pohotovostnom stave',
    40688: 'Exh.Dissoc.',
    40689: 'Výfuk Dissociator',
    40690: 'Neutralizačné',
    40691: 'Neutralizačné',
    40692: 'Restart',
    40693: 'Reštartujte neutralizátorom',
    40694: 'Dissociator',
    40695: 'Proces Dissociator',
    40696: 'Teplo Sledovanie',
    40697: 'Teplo stopové umožniť',
    40698: 'Teplo Sledovanie 1 ',
    40699: 'Teplo sledovanie zóna 1 ',
    40700: 'Teplo Sledovanie 2 ',
    40701: 'Teplo sledovanie zóny 2 ',
    40702: 'Teplo Sledovanie 3 ',
    40703: 'Teplo sledovanie zóna 3 ',
    40704: 'Teplo Sledovanie 4 ',
    40705: 'Teplo sledovanie zóna 4 ',
    40706: 'Kryt umožniť',
    40707: 'Kryt umožniť',
    40708: 'Teplo odberu',
    40709: 'Kúrenie odberu Box',
    40710: 'VS16 ',
    40711: 'VS16 vyčistí nitrocementovanie komoru',
    40712: 'Ready',
    40713: 'Pripravený na príjem',
    40714: 'Teplo Ex.UP',
    40715: 'Signálu výmenník tepla až',
    40716: 'TEN DOLE',
    40717: 'Signálu výmenník tepla nadol',
    40718: 'VSW3 ',
    40719: 'VSW3 Chladenie vody ventil v Q3 ',
    40720: 'Prenos sa',
    40721: 'Začať prenos',
    40722: 'VS10 ',
    40723: 'VS10-nátlaku na chladenie komory',
    40724: 'VS11-vysoká',
    40725: 'VS11 vysoké vymazať všetky komory ',
    40726: 'VS15-nízka',
    40727: 'VS15-Q2/Q3 nízke vyplachovania',
    40728: 'VS12-Q1/Q2 ',
    40729: 'VS12 - Q1/Q2 pripojenie',
    40730: 'VS13-Q2/Q3 ',
    40731: 'VS13 Q2/Q3 pripojenie',
    40732: 'VS14 ATM',
    40733: 'VS14 výfukových plynov do atmosféry',
    40734: 'N2 zapĺňať',
    40735: 'N2 zapĺňať',
    40736: 'BLÍZKO - výmenné',
    40737: 'Zatvorte ventil - výmenník tepla',
    40738: 'Q1 chladenie zapnutie',
    40739: 'Rýchle chladenie v Q1 o',
    40740: 'VSW1 ',
    40741: 'VSW1 uhasiť Main chladenie vody ventil',
    40742: 'VSW2 ',
    40743: 'VSW2 uhasiť Aux. chladenie vody ventil',
    40744: 'Vymazať Turbo',
    40745: 'Vymazať Turbo žiadosť',
    40746: 'Turbo Cool',
    40747: 'Turbo Cool žiadosť',
    40748: 'OTVORENÉ',
    40749: 'Signál otvorených dverí',
    40750: 'ZAVRIEŤ',
    40751: 'Signál zavrieť dvere',
    40752: 'OTVORENÉ D2/D3 ',
    40753: 'Signál otvorené D2/D3 dvere',
    40754: 'ZAVRIEŤ D2/D3 ',
    40755: 'Signál blízko D2/D3 dvere',
    40756: 'Reťaz Forw',
    40757: 'Vpred dopravný reťazec',
    40758: 'Reťazec zatiahnuť',
    40759: 'Dopravného reťazca zatiahnuť',
    40760: 'Závora zaťaženia',
    40761: 'Reverzibilné závora zaťaženia',
    40762: 'Uvoľniť západku',
    40763: 'Reverzibilné závora vyložiť',
    40764: 'Výparov ventilátor',
    40765: 'Výparov ventilátor',
    40766: 'ONC odpad',
    40767: 'ONC odpadové vody ventil',
    40768: 'Ovzdušia zapĺňať',
    40769: 'Vzduchu zapĺňať - otvorená atmosféra ',
    40770: 'Chladenie brána',
    40771: 'Chladenie brána',
    40772: 'Termočlánok vody otvorený',
    40773: 'Turbo chladiacej vody otvorený',
    40774: 'Úniku NH3',
    40775: 'Úniku NH3 relé',
    40776: 'CH4 úniku',
    40777: 'Relé CH4 úniku',
    40778: 'AUX.3 ',
    40779: 'Aux.Relay 3 ',
    40780: 'Koniec práce',
    40781: 'Úloha môže byť ukončená',
    40782: 'Načítať v',
    40783: 'Zaťaženie v komore',
    40784: 'Vpred',
    40785: 'Preniesť dopredu',
    40786: 'ISO-chladenie',
    40787: 'Žiadosť o Iso-chladenie',
    40788: 'Príručka',
    40789: 'Ručné ovládanie',
    40790: 'Up pomalé',
    40791: 'Výťah hore - pomaly',
    40792: 'Nadol pomaly',
    40793: 'Výťah dole - pomaly',
    40794: 'RÝCHLO',
    40795: 'Výťah rýchlo',
    40796: 'Spojka zapnutá',
    40797: 'Spojka zapnutá',
    40798: 'Spojka ',
    40799: 'Spojka ',
    40800: 'Nízky prietok',
    40801: 'Nízky prietok',
    40802: 'Vysoký prietok',
    40803: 'Vysoký prietok',
    40804: 'Teplota',
    40805: 'Teplota v Peci',
    40806: 'Vykurovacie zariadenie',
    40807: 'Kúrenie',
    40808: 'Dvere C',
    40809: 'Dvere zatvorené',
    40810: 'Dvere O',
    40811: 'Dvere sa otvorili',
    40812: 'Chladič',
    40813: 'Chladič termostat',
    40814: 'TRB Ovld',
    40815: 'Turbína preťaženia',
    40816: 'Hydro Ovld',
    40817: 'Hydraulický Motor preťaženia',
    40818: 'Prehriatie',
    40819: 'Prehriatie',
    40820: 'Hydraulický tlak',
    40821: 'Nízky tlak',
    40822: 'HiFloAl',
    40823: 'Vysoký prietok príliš nízka ',
    40824: 'LoFloAl',
    40825: 'Nízky prietok príliš nízka',
    40826: 'Dvere sk',
    40827: 'Rúra umožniť',
    40828: 'Výkon',
    40829: 'Výkon Pec',
    40830: 'HiFloVl',
    40831: 'Vysoký prietok',
    40832: 'LoFloVl',
    40833: 'Nízky prietok',
    40834: 'Hydro Refr',
    40835: 'Operácia relé dvere',
    40836: 'Termočlánok voda Zavrieť',
    40837: 'Turbo chladiacej vody - zavrieť',
    40838: 'KVAPKA',
    40839: 'Znížiť výťah',
    40840: 'VZNIK',
    40841: 'Vzostup Výťah',
    40842: 'SPRÁVNY',
    40843: 'Správne Výťah',
    40844: 'Zaťažiť',
    40845: 'Zaťaženie pece',
    40846: 'Dvere pomaly',
    40847: 'Dvere pomaly',
    40848: 'Zatiahnuť tesnenie',
    40849: 'Zatiahnuť tesnenie',
    40850: 'Rozšíriť tesnenie',
    40851: 'Rozšíriť tesnenie',
    40852: 'PLC-MANUAL',
    40853: 'PLC v manuálnom režime',
    40854: 'Dvere VSD',
    40855: 'Dvere variabilná rýchlosť jazdy',
    40856: 'Obnoviť',
    40857: 'Obnovenie Počítadlo',
    40858: 'Error in percent',
    40859: 'Logical OR operation',
    40860: 'Logical AND operation',
    40861: 'Logical NOR operation',
    40862: 'Logical NAND operation',
    40900: 'H2 Flow',
    40901: 'MFC9A Hydrogen Flow',
    40902: 'H2-B Flow',
    40903: 'MFC9-B Hydrogen Flow',
    40904: 'H2-C Flow',
    40905: 'MFC9-C Hydrogen Flow',
    40906: 'H2-D Flow',
    40907: 'MFC9-D Hydrogen Flow',
    40908: 'CH4 Flow',
    40909: 'MFC10-A Methane Flow',
    40910: 'CH4-B Flow',
    40911: 'MFC10-B Methane Flow',
    40912: 'CH4-C Flow',
    40913: 'MFC10-C Methane Flow',
    40914: 'CH4-D Flow',
    40915: 'MFC10-D Methane Flow',
    40916: 'C3H8 Flow',
    40917: 'MFC11-A Propane Flow',
    40918: 'C3H8-B Flow',
    40919: 'MFC11-B Propane Flow',
    40920: 'C3H8-C Flow',
    40921: 'MFC11-C Propane Flow',
    40922: 'C3H8-D Flow',
    40923: 'MFC11-D Propane Flow',
    40924: 'N2O Flow',
    40925: 'MFC12-A Nitrous Flow',
    40926: 'N2O-B Flow',
    40927: 'MFC12-B Nitrous Flow',
    40928: 'N2O-C Flow',
    40929: 'MFC12-C Nitrous Flow',
    40930: 'N2O-D Flow',
    40931: 'MFC12-D Nitrous Flow',
    40932: 'CH3OH Flow',
    40933: 'MFC13-A Methanol Flow',
    40934: 'CH3OH-B Flow',
    40935: 'MFC13-B Methanol Flow',
    40936: 'CH3OH-C Flow',
    40937: 'MFC13-C Methanol Flow',
    40938: 'CH3OH-D Flow',
    40939: 'MFC13-D Methanol Flow',
    40940: 'C2H2 Flow',
    40941: 'MFC14-A Acetylene Flow',
    40942: 'C2H2-B Flow',
    40943: 'MFC14-B Acetylene Flow',
    40944: 'C2H2-C Flow',
    40945: 'MFC14-C Acetylene Flow',
    40946: 'C2H2-D Flow',
    40947: 'MFC14-D Acetylene Flow',
    40948: 'C2H6 Flow',
    40949: 'MFC15-A Ethane Flow',
    40950: 'C2H6-B Flow',
    40951: 'MFC15-B Ethane Flow',
    40952: 'C2H6-C Flow',
    40953: 'MFC15-C Ethane Flow',
    40954: 'C2H6-D Flow',
    40955: 'MFC15-D Ethane Flow',
    40956: 'Spare1 Flow',
    40957: 'MFC16-A Flow',
    40958: 'Spare1-B Flow',
    40959: 'MFC16-B Flow',
    40960: 'Spare1-C Flow',
    40961: 'MFC16-C Flow',
    40962: 'Spare1-D Flow',
    40963: 'MFC16-D Flow',
    41000: 'H2',
    41001: 'H2 Cut-off Valve',
    41002: 'H2-B',
    41003: 'H2-B Cut-off Valve',
    41004: 'H2-C',
    41005: 'H2-C Cut-off Valve',
    41006: 'H2-D',
    41007: 'H2-D Cut-off Valve',
    41008: 'CH4',
    41009: 'Methane Cut-off Valve',
    41010: 'CH4-B',
    41011: 'Methane-B Cut-off Valve',
    41012: 'CH4-C',
    41013: 'Methane-C Cut-off Valve',
    41014: 'CH4-D',
    41015: 'Methane-D Cut-off Valve',
    41016: 'C3H8',
    41017: 'Propane Cut-off Valve',
    41018: 'C3H8-B',
    41019: 'Propane-B Cut-off Valve',
    41020: 'C3H8-C',
    41021: 'Propane-C Cut-off Valve',
    41022: 'C3H8-D',
    41023: 'Propane-D Cut-off Valve',
    41024: 'N2O',
    41025: 'Nitrous Cut-off Valve',
    41026: 'N2O-B',
    41027: 'Nitrous-B Cut-off Valve',
    41028: 'N2O-C',
    41029: 'Nitrous-C Cut-off Valve',
    41030: 'N2O-D',
    41031: 'Nitrous-D Cut-off Valve',
    41032: 'CH3OH',
    41033: 'Methanol Cut-off Valve',
    41034: 'CH3OH-B',
    41035: 'Methanol-B Cut-off Valve',
    41036: 'CH3OH-C',
    41037: 'Methanol-C Cut-off Valve',
    41038: 'CH3OH-D',
    41039: 'Methanol-D Cut-off Valve',
    41040: 'C2H2',
    41041: 'Acetylene Cut-off Valve',
    41042: 'C2H2-B',
    41043: 'Acetylene-B Cut-off Valve',
    41044: 'C2H2-C',
    41045: 'Acetylene-C Cut-off Valve',
    41046: 'C2H2-D',
    41047: 'Acetylene-D Cut-off Valve',
    41048: 'C2H6',
    41049: 'Ethane Cut-off Valve',
    41050: 'C2H6-B',
    41051: 'Ethane-B Cut-off Valve',
    41052: 'C2H6-C',
    41053: 'Ethane-C Cut-off Valve',
    41054: 'C2H6-D',
    41055: 'Ethane-D Cut-off Valve',
    41056: 'Spare1',
    41057: 'Spare1 Cut-off Valve',
    41058: 'Spare1-B',
    41059: 'Spare1-B Cut-off Valve',
    41060: 'Spare1-C',
    41061: 'Spare1-C Cut-off Valve',
    41062: 'Spare1-D',
    41063: 'Spare1-D Cut-off Valve',
    41100: 'Furnace H2',
    41101: 'Furnace Atmosphere H2',
    41102: 'Furnace CH4',
    41103: 'Furnace Atmosphere Methane (CH4)',
    41104: 'Furnace C3H8',
    41105: 'Furnace Atmosphere Propane (C3H8)',
    41106: 'Furnace N2O',
    41107: 'Furnace Atmosphere Nitrous (N2O)',
    41108: 'Furnace CH3OH',
    41109: 'Furnace Atmosphere Methanol (CH3OH2)',
    41110: 'Furnace C2H2',
    41111: 'Furnace Atmosphere Acetylene (C2H2)',
    41112: 'Furnace C2H6',
    41113: 'Furnace Atmosphere Ethane (C2H6)',
    41114: 'Furnace Spare1',
    41115: 'Furnace Atmosphere Spare1',
    41120: 'Inlet H2',
    41121: 'Inlet Atmosphere H2',
    41122: 'Inlet CH4',
    41123: 'Inlet Atmosphere Methane CH4',
    41124: 'Inlet C3H8',
    41125: 'Inlet Atmosphere Propane C3H8',
    41126: 'Inlet N2O',
    41127: 'Inlet Atmosphere Nitrous N2O',
    41128: 'Inlet CH3OH',
    41129: 'Inlet Atmosphere Methanol CH3OH',
    41130: 'Inlet C2H2',
    41131: 'Inlet Atmosphere Acetylene C2H2',
    41132: 'Inlet C2H6',
    41133: 'Inlet Atmosphere C2H6',
    41134: 'Inlet Spare1',
    41135: 'Inlet Atmosphere Spare1',
    41600: 'V vykurovanie',
    41601: 'Odveta v Kúrenie umiestnenie',
    41602: 'V chladenie',
    41603: 'Odveta v chladenie umiestnenie',
    41604: 'NH3 zapĺňať',
    41605: 'Zaplniť s Čpavokom',
    41606: 'Údržba',
    41607: 'Komory v režime údržby',
    41608: 'Tr.IN hotovo',
    41609: 'Prenos v hotové',
    41610: 'Tr.OUT hotovo',
    41611: 'Prenos sa skončil',
    41612: 'PLC',
    41613: 'PLC stav',
    41614: 'Chyba/Timeout',
    41615: 'Chyba/Timeout',
    41616: 'Konflikt',
    41617: 'Limit prepínač konflikt',
    41618: 'Init.Error',
    41619: 'Nemožno inicializovať PLC program',
    41620: 'Pretlak',
    41621: 'Pretlak plynu dodávok',
    41622: 'Fľaša prázdna',
    41623: 'Plynové fľaše prázdne',
    41624: 'Zásobovanie stanice',
    41625: 'Zásobovanie stanice Status',
    41626: 'Klimatizácia',
    41627: 'Klimatizácia Status',
    41628: 'Vymazať Inj.',
    41629: 'Vymazať čiara injekcia',
    41630: 'Horľavý plyn',
    41631: 'Možné plyny existujú',
    41632: 'Otvoriť výfuk',
    41633: 'Otvoriť výfuk',
    41634: 'Uzavretý výfuk',
    41635: 'Uzavretý výfuk',
    41636: 'Záťaže Open',
    41637: 'Plyn predradníka ventil otvorený',
    41638: 'Predradník zatvorené',
    41639: 'Predradník ventil uzavretý plyn',
    41640: 'Zapĺňať Open',
    41641: 'Zapĺňať ventil otvorený',
    41642: 'Zapĺňať zatvorené',
    41643: 'Zapĺňať ventil uzavretý',
    41644: 'EM-N2 Open',
    41645: 'Núdzové N2 ventil otvorený',
    41646: 'EM-N2 Clsed',
    41647: 'Núdzové N2 ventil uzavretý',
    41648: 'Hlavné Vac',
    41649: 'Hlavné vákuový ventil/hrubovanie vákuový ventil',
    41650: 'VAC obchvat',
    41651: 'Vákuové obtokový ventil',
    41652: 'Vysoká Vac',
    41653: 'Vysoké vákuum ventil (s diff.pumpa)',
    41654: 'Foreline',
    41655: 'Foreline ventilu (s diff.pumpa)',
    41656: 'Plynový ventil',
    41657: 'Plynový ventil',
    41658: 'N2 PPV ',
    41659: 'N2 parciálneho tlaku ventilu',
    41660: 'Argón PPV',
    41661: 'Argón parciálneho tlaku ventilu',
    41662: 'Ventil ventil',
    41663: 'Ventil ventil',
    41664: 'Chov ventil',
    41665: 'Drží ventilom (s difúznej pumpy)',
    41666: 'Dcmp/Equal',
    41667: 'Ventil dekompresie/vyrovnajte (zamykanie dverí)',
    41668: 'ISO-ventil',
    41669: 'Izolovanie ventil',
    41670: 'Náhradné',
    41671: 'Náhradné',
    41672: 'Drsné',
    41673: 'Mechanické/hrubovanie čerpadlo',
    41674: 'Hrubý GBV',
    41675: 'Mechanické/Roughing čerpadlo plynu predradníka ventil',
    41676: 'Hrubý 2 ',
    41677: 'Mechanické/hrubovanie čerpadlo 2 ',
    41678: 'Hrubý 2 GBV',
    41679: 'Mechanické/Roughing čerpadlo 2 plynový ventil balast',
    41680: 'Root/Boost',
    41681: 'Korene / čerpadlom ',
    41682: 'Čerpadlo diff',
    41683: 'Difúzia čerpadlo ohrievač',
    41684: 'Podržte Pmp',
    41685: 'Drží čerpadlo',
    41686: 'Hydro Pmp',
    41687: 'Hydraulické čerpadlo',
    41688: 'HP vydanie',
    41689: 'Drží čerpadlo plynu predradníka ventil',
    41690: 'DP úspornom',
    41691: 'Difúznej pumpy v právomoc uložiť režim',
    41692: 'Konvekčné ventilátor',
    41693: 'Konvekčné ventilátor',
    41694: 'Dúchadlo vysoká',
    41695: 'Ventilátor - vysokej rýchlosti',
    41696: 'Ventilátora',
    41697: 'Ventilátor - nízkej rýchlosti',
    41698: 'Ventilátora',
    41699: 'Ventilátor - variabilná rýchlosť',
    41700: 'Ventilátora',
    41701: 'Ventilátora',
    41702: 'Zátky',
    41703: 'Bungs OPEN/CLOSE',
    41704: 'Zátka dverí',
    41705: 'Dvere zátka OPEN/CLOSE',
    41706: 'Horná zátka',
    41707: 'Top zátka OPEN/CLOSE',
    41708: 'Zátka dno',
    41709: 'Dno zátka OPEN/CLOSE',
    41710: 'Zadné zátka',
    41711: 'Zadné zátka OPEN/CLOSE ',
    41712: 'Náhradné',
    41713: 'Náhradné',
    41714: 'Náhradné',
    41715: 'Náhradné',
    41716: 'Uhasiť na',
    41717: 'Dopyt po uhasiť',
    41718: 'CWV HXQ',
    41719: 'Chladenie vody ventil - výmenník tepla (krížová)',
    41720: 'H2O Shell',
    41721: 'Chladenie vody ventil - pec Shell',
    41722: 'H2O dvere',
    41723: 'Chladenie vody ventil - dvere pece',
    41724: 'H2O DMD ',
    41725: 'Chladenie vody dopytu (vodovod)',
    41726: 'H20 Qnch Alm',
    41727: 'Signál uhasiť vody Alarm (vodovod)',
    41728: 'Dvere otvoriť',
    41729: 'Príkaz otvoriť dvere',
    41730: 'Dvere CLS',
    41731: 'Dvere zavrieť príkaz',
    41732: 'Otvoriť dvere svorky',
    41733: 'Signál do otvorených dverí svorky',
    41734: 'CLS dvere svorky',
    41735: 'Signál zavrieť dvere svorky',
    41736: 'Odomknúť H.Cyl.',
    41737: 'Signál odomknúť Napínacia - horizontálne interlock',
    41738: 'Zámok H.Cyl.',
    41739: 'Signál uzavrieť Napínacia - horizontálne interlock',
    41740: 'Odomknúť V.Cyl.',
    41741: 'Signál odomknúť Napínacia - vertikálne interlock',
    41742: 'Zámok V.Cyl.',
    41743: 'Signál zamknúť Napínacia - vertikálne interlock',
    41744: '',
    41745: '',
    41746: '',
    41747: '',
    41748: 'Odomknúť Rls.v.',
    41749: 'Dvere odomknúť - otvorené odvzdušňovací ventil',
    41750: 'Dvere Hydro otvoriť',
    41751: 'Dvere hydraulický ventil - otvorenie',
    41752: 'Dvere Hydro Clsing',
    41753: 'Dvere hydraulický ventil - záverečné',
    41754: 'Hydro Pmp',
    41755: 'Hydraulické čerpadlo',
    41756: 'Otváranie dverí',
    41757: 'Signál na otvorenie svetlo dverí',
    41758: 'Zatváraní dverí',
    41759: 'Signál do dverí svetlo',
    41760: 'Dvere zamknuté',
    41761: 'Signál na dvere zamknuté svetlo',
    41762: 'Open',
    41763: 'Plynový ventil otvorený',
    41764: 'Uzavreté',
    41765: 'Plynový ventil uzavretý',
    41766: 'Otvorte prívod',
    41767: 'Prívod plynu Open',
    41768: 'Prívod zatvorené',
    41769: 'Prívod plynu uzavreté',
    41770: 'Odber vzoriek na',
    41771: 'Čerpadlo na odber vzoriek',
    41772: 'Odber vzoriek uzavreté',
    41773: 'Vzorkovacie potrubie zatvorené',
    41774: 'Odber vzoriek otvorené',
    41775: 'Odber vzoriek riadku Open',
    41776: 'Vstrekovanie Alarm',
    41777: 'Systém vstrekovania v Alarm (keď na) ',
    41778: 'náhradné',
    41779: 'náhradné',
    41780: 'Turbo čerpadlo',
    41781: 'Turbo čerpadlo',
    41782: 'Pohode H20 HX ',
    41783: 'Chladiacej vody cez tepelný výmenník',
    41784: 'NA obchvat',
    41785: 'Filter obišiel aktivovaný ',
    41786: 'Obísť OPEN',
    41787: 'Filter obtokový ventil otvorený',
    41788: 'Obchvat zatvorené',
    41789: 'Filter obtokový ventil uzavretý',
    41790: 'Filtre pripravený',
    41791: 'Filtre pripravený',
    41792: 'Štart H2O',
    41793: 'Štart vodný systém',
    41794: 'ACC H2O v',
    41795: 'Zrýchlené chladenie vody v',
    41796: 'ACC H2O prietok',
    41797: 'Zrýchlené chladenie prietok vody',
    41798: 'Vypúšťacie čerpadlo',
    41799: 'Zrýchlené chladenie vypúšťacie čerpadlo',
    41800: 'Vypúšťací ventil',
    41801: 'Zrýchlené chladenie vypúšťací ventil',
    41802: 'ACC čerpadlo',
    41803: 'Zrýchlené chladenie čerpadlo',
    41804: 'Para v prevadzke',
    41805: 'Parný generátor na',
    41806: 'Vzduchu v',
    41807: 'Vzduchu v ventil',
    41808: 'Vzduch von',
    41809: 'Vzduch von ventil',
    41810: 'Lock otvorte vľavo',
    41811: 'Kryt skrinke ľavým otvorené',
    41812: 'Blízko zámok vľavo',
    41813: 'Kryt skrinke ľavým úzkej',
    41814: 'Predné zámok Otvoriť',
    41815: 'Kryt prednej otvoriť skrinku',
    41816: 'Zámok úzka vpredu',
    41817: 'Kryt Locker predné blízko',
    41818: 'Zámok otvorené právo',
    41819: 'Kryt správne otvoriť skrinku',
    41820: 'Zámok blízko práve',
    41821: 'Kryt zatvorte skrinku právo',
    41822: 'Zámok otvorený späť',
    41823: 'Kryt zadný otvoriť skrinku',
    41824: 'Blízko zámok späť',
    41825: 'Kryt Locker späť zavrieť',
    41826: 'Kryt tlakového spínača otvorené',
    41827: 'Kryt dodávky energie otvorené',
    41828: 'Kryt PS zavrieť',
    41829: 'Kryt políčko napájanie blízko',
    41830: 'Kryt PS',
    41831: 'Kryt políčko napájanie',
    41832: 'PS sa vzťahuje na',
    41833: 'Pokrytie políčka napájania na',
    41834: 'PS obrazovky',
    41835: 'Aktívna obrazovka napájanie',
    41836: 'Odber vzoriek Alarm',
    41837: 'Nitrex plyn analyzátora odberu zlyhanie',
    41838: 'Odber vzoriek varovania',
    41839: 'Nitrex plynu analýzou vzoriek tok varovania',
    41840: 'H2O Alarm',
    41841: 'Vodný systém Alarm',
    41842: 'Recirkulácia ventilátora',
    41843: 'Recirkulácia ventilátora',
    41844: 'ACC H2O Min',
    41845: 'Zrýchlené chladenie prietok vody: Min ',
    41846: 'Úroveň Max H2O',
    41847: 'Zrýchlené chladenie vody, úroveň: Max ',
    41848: 'H2O úrovni Min',
    41849: 'Zrýchlené chladenie vody, úroveň: Min ',
    41850: 'RF H20 Min',
    41851: 'Vody toku recirkulácia ventilátor: Min ',
    41852: 'Dvere H2O Min',
    41853: 'Vody toku dvere príruba: Min ',
    41854: 'Skrinky otvorené vľavo',
    41855: 'Kryt Locker ľavej otvorené',
    41856: 'Skrinky otvorené právo',
    41857: 'Pokrytie práve otvoril skrinku',
    41858: 'Skrinky otvorené predné',
    41859: 'Kryt otvoril skrinku recepcii',
    41860: 'Skrinky otvorené späť',
    41861: 'Kryt zadnej skrinky otvorené',
    41862: 'Pec H2O Min',
    41863: 'Vody toku pece príruba Min',
    41864: 'Skrinku uzavretý vľavo',
    41865: 'Kryt Locker vľavo zatvorené',
    41866: 'Skrinku zatvorené práva',
    41867: 'Kryt Locker hneď zatvorené',
    41868: 'Skrinku uzavreté predné',
    41869: 'Kryt Locker predné uzavretá',
    41870: 'Skrinku uzavreté Back',
    41871: 'Kryt Locker späť zatvorené',
    41872: 'Tesnenie Max stlačte',
    41873: 'Tlak kontrolu pečať Max',
    41874: 'Tesnenie Min stlačením',
    41875: 'Tlak kontrolu pečať Min',
    41876: 'Kryt napájania na',
    41877: 'Kryt poľa stav napájania dodávok na',
    41878: 'N2 Min P',
    41879: 'N2 minimálny tlak',
    41880: 'H2O Min stupeň',
    41881: 'H2O krmivo minimálnu úroveň',
    41882: 'Vzduchu v otvorené',
    41883: 'Vzduch v ventil otvorený',
    41884: 'Vzduchu v uzavretom',
    41885: 'Vzduch v ventil uzavretý',
    41886: 'Kryt výkon človek',
    41887: 'Pokrytie políčka zapnutie ponuky manuál',
    41888: 'Vzduch z otvorených',
    41889: 'Vzduch von ventil otvorený',
    41890: 'Vzduch von zatvorené',
    41891: 'Vzduch von ventil uzavretý',
    41892: 'Pokryť výletu',
    41893: 'Pokrytie políčka napájania Suppa výlet',
    41894: 'Kryt Pwr na',
    41895: 'Pokrytie políčka napájania na',
    41896: 'Panel AC',
    41897: 'Panel Klimatizácia',
    41898: 'Napájanie',
    41899: 'Stave dodávky energie',
    41900: 'Vymazať',
    41901: 'Vymazať',
    41902: 'Turbo VSD Fail',
    41903: 'Turbo VSD zlyhanie',
    41904: 'Dúchadlo Status',
    41905: 'Plynové dúchadlo stav',
    41906: 'Diff.Pumpa OH',
    41907: 'Prehriatie difúznej pumpy',
    41908: 'Steam',
    41909: 'Parný ventil',
    41910: 'Porucha ventilátora',
    41911: 'Recirkulácia ventilátor zlyhania',
    41912: 'O2 Teplota',
    41913: 'Teplotné sondy kyslíka',
    41914: 'Retortový H2O Min',
    41915: 'Vody toku retorty príruba',
    41916: 'Späť H2O Min',
    41917: 'Vodné toky späť príruby: Min ',
    41918: 'náhradné',
    41919: 'náhradné',
    41920: 'RV otvoriť',
    41921: 'Main/Roughing ventil - otvoril',
    41922: 'RV zatvorené',
    41923: 'Main/Roughing ventil - zatvorené',
    41924: 'VAC BP otvoriť',
    41925: 'By-pass ventilom na vákuové - otvoril',
    41926: 'VAC BP zatvorené',
    41927: 'By-pass ventilom na vákuové - zatvorené',
    41928: 'HiVac otvoriť',
    41929: 'Vysoká vákuový ventil - otvoril (diff.pumpa)',
    41930: 'HiVac Cls',
    41931: 'Vysoké vákuum ventil - uzavreté (diff.pumpa)',
    41932: 'Foreline otvoriť',
    41933: 'Foreline ventil - otvoril (DRP čerpadlo)',
    41934: 'Foreline Cls',
    41935: 'Foreline ventil - zatvorené (DRP čerpadlo)',
    41936: 'Plynové otvoriť',
    41937: 'Plynový ventil - otvoril',
    41938: 'Plynové zatvorené',
    41939: 'Plynový ventil - zatvorené',
    41940: 'PP otvoriť',
    41941: 'Čiastočný tlak ventil - otvoril',
    41942: 'PP zatvorené',
    41943: 'Čiastočný tlak ventil - zatvorené',
    41944: 'Vent otvoriť',
    41945: 'Ventil ventil - otvoril',
    41946: 'Vent zatvorené',
    41947: 'Ventil ventil - zatvorené',
    41948: 'Držať otvoriť',
    41949: 'Drží ventilom - otvoril (diff.pumpa)',
    41950: 'Držať zatvorené',
    41951: 'Drží ventilom - uzavreté (diff.pumpa)',
    41952: 'Uvoľnenie otvoriť',
    41953: 'Dekompresia/odvzdušňovací ventil otvorený',
    41954: 'Uvoľnenie zatvorené',
    41955: 'Dekompresia/odvzdušňovací ventil uzavretý',
    41956: 'ISO-ventil O',
    41957: 'Izolovanie otvorenom ventile',
    41958: 'ISO-ventil C',
    41959: 'Izolovanie ventil uzavretý',
    41960: 'Argón Open',
    41961: 'Parciálneho tlaku argón ventil otvorený',
    41962: 'Argón zatvorené',
    41963: 'Parciálneho tlaku argón ventil uzavretý',
    41964: 'Drsné. Stav',
    41965: 'Mechanické/Roughing čerpadlo stav',
    41966: 'Drsné. Ovrld',
    41967: 'Mechanické/Roughing čerpadlo tepelné nadprúdové stav',
    41968: 'Rough2 stav',
    41969: 'Mechanické/Roughing čerpadlo 2 stav',
    41970: 'Rough2 Ovrld',
    41971: 'Mechanické/Roughing čerpadlo 2 tepelné nadprúdové stav',
    41972: 'Root na',
    41973: 'Korene/posilňovacie čerpadlo na stav',
    41974: 'Koreň Ovrld',
    41975: 'Korene/posilňovacie čerpadlo tepelné nadprúdové stav',
    41976: 'Ohrievač diff',
    41977: 'Difúzia čerpadlo ohrievač',
    41978: 'Diff Ovrld',
    41979: 'Tepelné nadprúdové stav difúznej pumpy',
    41980: 'Stav zadržania',
    41981: 'Drží čerpadlo stav',
    41982: 'Držať Ovrld',
    41983: 'Drží čerpadlo tepelné nadprúdové stav',
    41984: 'Hydraulika',
    41985: 'Hydraulické čerpadlo stav',
    41986: 'Hydr.Ovrld',
    41987: 'Hydraulické čerpadlo tepelné nadprúdové stav',
    41988: 'Vodné čerpadlo',
    41989: 'Vodné čerpadlo stav',
    41990: 'Voda P.Ovrld',
    41991: 'Vodné čerpadlo preťaženia',
    41992: 'Pumpa2 stav',
    41993: 'Náhradné čerpadlá 2 stav',
    41994: 'Pumpa2 Ovrld',
    41995: 'Náhradné čerpadlá 2 preťaženia',
    41996: 'Konvekčné ventilátor',
    41997: 'Konvekčné Ventilátor stav',
    41998: 'Konvekčné Fan Ventilátor',
    41999: 'Konvekčné ventilátor tepelné nadprúdové stav',
    42000: 'Dúchadlo Ahoj ',
    42001: 'Chladenie vysokej rýchlosti ventilátora stav',
    42002: 'Dúchadlo Lo ',
    42003: 'Chladiaci ventilátor Low Speed stav',
    42004: 'Dúchadlo Var',
    42005: 'Chladenie variabilná rýchlosť ventilátora stav',
    42006: 'Dúchadlo Ovrld',
    42007: 'Chladiaci ventilátor ochrana proti preťaženiu',
    42008: 'Ventilátor poistka',
    42009: 'Chladiaci ventilátor poistka stav',
    42010: 'Dúchadlo Ovrld',
    42011: 'Chladiaci ventilátor tepelné nadprúdové @LS',
    42012: 'Dúchadlo THRM',
    42013: 'Chladiaci ventilátor termistora ochrana @LS/HS',
    42014: 'Dúchadlo VSD',
    42015: 'Chladiaci ventilátor VSD stav @ VS',
    42016: 'Porucha ventilátora',
    42017: 'Chladiaci ventilátor mäkký Štart chyba HS',
    42018: 'Ventilátor1 stav',
    42019: 'Náhradný v entilátor 1 stav',
    42020: 'Ventilátor1 Ovrld',
    42021: 'Náhradný ventilátor 1 preťaženia',
    42022: 'Ventilátor 2 Status',
    42023: 'Náhradný ventilátor 2 stav',
    42024: 'Fan 2 Ovrld',
    42025: 'Náhradný ventilátor 2 preťaženia',
    42026: 'P < MAX ',
    42027: 'Pretlak pece',
    42028: 'P > 1 Bar ',
    42029: 'Tlak > 1 bar',
    42030: 'P > 900 mBar',
    42031: 'Tlak > 900 mbar',
    42032: 'P > 800 mbar',
    42033: 'Tlak > 800 mbar',
    42034: 'dP < 8 mbar',
    42035: 'dPressure < 8 mbar',
    42036: 'P < 0,9 bar',
    42037: 'Tlak < 0,9 bar',
    42038: 'P < 1 bar',
    42039: 'Tlak < 1 bar',
    42040: 'Hydr.PS',
    42041: 'Hydraulický tlak prepínanie stavu',
    42042: 'Tlak vzduchu',
    42043: 'Air tlak prepínanie stavu',
    42044: 'PS',
    42045: 'Tlakový spínač',
    42046: 'Pec ochrana proti prehriatiu',
    42047: 'Pec plavidla-ochrana proti prehriatiu',
    42048: 'Dvere ochrana proti prehriatiu',
    42049: 'Pec dvere-ochrana proti prehriatiu',
    42050: 'VRT ochrana proti prehriatiu',
    42051: 'Ochrana VRT-proti prehriatiu',
    42052: 'Z1 ochrana proti prehriatiu',
    42053: 'Zóna 1-ochrana proti prehriatiu',
    42054: 'Z2 ochrana proti prehriatiu',
    42055: 'Zóna 2-ochrana proti prehriatiu',
    42056: 'Z3 ochrana proti prehriatiu',
    42057: 'Zóna 3-ochrana proti prehriatiu',
    42058: 'Teplota OH',
    42059: 'Proces teploty Prehriatie',
    42060: 'Teplo prerušiť',
    42061: 'Teplo istič stav',
    42062: 'Zátka otvoriť',
    42063: 'Stav zátky otvorený spínač',
    42064: 'Zátka zatvorené',
    42065: 'Stav zátka zatvorený spínač',
    42066: 'F.Bung otvoriť',
    42067: 'Predné zátka otvorený stav',
    42068: 'F.Bung zatvorené',
    42069: 'Predné zátka uzavretý stav',
    42070: 'T.Bung otvoriť',
    42071: 'Top zátka otvorený stav',
    42072: 'T.Bung zatvorené',
    42073: 'Top stav zátka zatvorené',
    42074: 'B.Bung otvoriť',
    42075: 'Dolný zátka otvorený stav',
    42076: 'B.Bung zatvorené',
    42077: 'Dolný zátka uzavretý stav',
    42078: 'R.Bung otvoriť',
    42079: 'R.Bung otvorený stav',
    42080: 'R.Bung zatvorené',
    42081: 'Zadné zátka uzavretý stav',
    42082: 'Hlavné H2O',
    42083: 'Hlavný vody Tlakový spínač',
    42084: 'Dúchadlo H2O',
    42085: 'Prietok vody cez ventilátor',
    42086: 'Ventilátor H2O',
    42087: 'Chladenie prietok vody cez konvekčné ventilátor',
    42088: 'HEx.H2O',
    42089: 'Chladenie prietok vody cez tepelný výmenník',
    42090: 'Výkon1 H2O',
    42091: 'Prietok vody cez Feed prostredníctvom sila 1 ',
    42092: 'Výkon2 H2O',
    42093: 'Prietok vody cez Feed cez silu 2 ',
    42094: 'Výkon3 H2O',
    42095: 'Prietok vody cez Feed cez silu 3 ',
    42096: 'VRT H2O',
    42097: 'Voda prúdi VRT',
    42098: 'Shell H2O',
    42099: 'Voda prúdi Shell pece',
    42100: 'Voda-dvere',
    42101: 'Voda prúdi dvere pece',
    42102: 'HEX H2O otvoriť',
    42103: 'Výmenník tepla voda ventil otvorený',
    42104: 'HX H2O zatvorené',
    42105: 'Výmenník tepla voda ventil uzavretý',
    42106: 'Diff H2O',
    42107: 'Prietok vody cez difúznej pumpy',
    42108: 'Voda-turbína',
    42109: 'Prietok vody cez vnútorné turbíny',
    42110: 'Dvere zatvorené',
    42111: 'Dvere pece uzavreté stav',
    42112: 'Svorka otvoriť',
    42113: 'Dvere pece svorka - otvorený stav',
    42114: 'Svorka zatvorené',
    42115: 'Dvere pece svorka - stavom uzavreté',
    42116: 'H.Unlocked',
    42117: 'Bezpečnosť horizontálne Lock otvorte',
    42118: 'H.Locked',
    42119: 'Bezpečnostné zámky na horizontálne zatvorené',
    42120: 'V.Unlocked',
    42121: 'Bezpečnosť vertikálne Lock otvorte',
    42122: 'V.Locked',
    42123: 'Bezpečnostné zámky na vertikálne zatvorené',
    42124: 'Dvere VSD Fail',
    42125: 'Dvere VSD zlyhanie',
    42126: 'Svorka',
    42127: 'Svorka Alarm',
    42128: '',
    42129: '',
    42130: '',
    42131: '',
    42132: 'Rls.Unlocked',
    42133: 'Uvoľnenie ventilu Open - dvere odomknúť stav',
    42134: 'Rls.Locked',
    42135: 'Uvoľnite ventil uzavretý - dvere zamknuté stav',
    42136: 'Tlačidlo Otvoriť',
    42137: 'OTVORENÝCH dverí tlačidlo stav',
    42138: 'Tlačidlo uzamknutia',
    42139: 'ZAMYKANIE tlačidlom stav',
    42140: 'Tlačidlo Zavrieť',
    42141: 'Stav tlačidla zavrieť dvere',
    42142: 'Uvoľnite tlačidlo',
    42143: 'UVOĽŇOVACÍ tlak tlačidlom stav',
    42144: 'Teplota v peci',
    42145: 'Peci teploty',
    42146: 'Pec VAC',
    42147: 'Vákuum v Furace',
    42148: 'Mstr Ctrl Rel',
    42149: 'Master ovládanie relé',
    42150: 'DC napätia',
    42151: 'Napätie DC stavu',
    42152: 'VAC-stredné',
    42153: 'Vákuové snímače - Piran',
    42154: 'VAC-vysoká',
    42155: 'Vákuové snímače - iónová',
    42156: 'N2 dodávok',
    42157: 'N2 tlaku na zásobovanie',
    42158: 'NH3 dodávok',
    42159: 'NH3 tlaku na zásobovanie',
    42160: 'H2 snímač',
    42161: 'Vodík snímač',
    42162: 'Teplota panelu',
    42163: 'Teplota vo vnútri ovládacieho panela',
    42164: 'Teplo stav',
    42165: 'Kúrenie obvod Status',
    42166: 'Brána uzavretá',
    42167: 'Chladenie Gate zatvorené',
    42168: 'Agent nízka',
    42169: 'Aktiváciu agenta nízka',
    42170: 'Agent úniku',
    42171: 'Aktiváciu agenta úniku snímač',
    42172: 'Diss. Status',
    42173: 'Dissociator Kúrenie obvod stav',
    42174: 'Počítadla',
    42175: 'Počítadla - očistenie dokončená',
    42176: 'Snímač CH4',
    42177: 'Snímač metánu',
    42178: 'Na načítanie 4 ',
    42179: 'Na zaťaženie termočlánok 4 ',
    42180: 'Na zaťaženie 5 ',
    42181: 'Na zaťaženie termočlánok 5 ',
    42182: 'Na zaťaženie 6 ',
    42183: 'Na zaťaženie termočlánok 6 ',
    42184: 'Na načítanie 7 ',
    42185: 'Na zaťaženie termočlánok 7 ',
    42186: 'Na zaťaženie 8 ',
    42187: 'Na zaťaženie termočlánok 8 ',
    42188: 'CS1 P > 80 ',
    42189: 'Pokrytie pečať 1 - P > 80 PSI ',
    42190: 'CS2 P > 80 ',
    42191: 'Pokrytie pečať 2 - P > 80 PSI ',
    42192: 'CS1 P < 45 ',
    42193: 'Pokrytie pečať 1 - P < 45 PSI ',
    42194: 'CS2 P < 45 ',
    42195: 'Pokrytie pečať 2 - P < 45 PSI ',
    42196: 'SK P < 40 ',
    42197: 'Pokrytie tesnenia 1 & 2 - P < 40 PSI ',
    42198: 'Vojnových zajatcov. Prehriatie',
    42199: 'Napájanie Prehriatie',
    42200: 'Nosnosť vyplachovania',
    42201: 'Nosnosť N2 vyplachovania',
    42202: 'Tesnenie 1 Išol.',
    42203: 'Tesnenie 1 uzatváracie ventil',
    42204: 'Tesnenie 1 defl.',
    42205: 'Tesnenie 1 nafukuje defláciu ventil',
    42206: 'Tesnenie 2 Išol.',
    42207: 'Tesnenie 2 uzatváracie ventil',
    42208: 'Tesnenie 2 defl.',
    42209: 'Tesnenie 2 nafukuje defláciu ventil',
    42210: 'Externá voda',
    42211: 'Externé vodné toky',
    42212: 'Vysokorýchlostné',
    42213: 'Interiori turbína - vysoká rýchlosť spätnú väzbu',
    42214: 'Nízka rýchlosť',
    42215: 'Interiér turbína - nízka rýchlosť spätnú väzbu',
    42216: 'Turbo vymazané',
    42217: 'Turbo očistenie dokončená',
    42218: 'Voľný N2 v',
    42219: 'Nezávislé N2 čítanie',
    42220: 'Voľný NH3 v',
    42221: 'Nezávislé NH3 čítanie',
    42222: 'Voľný DISS',
    42223: 'Nezávislé DISS NH3 čítanie',
    42224: 'Voľný CO2 v',
    42225: 'Nezávislé CO2 čítanie',
    42226: 'Voľný vzduchu v',
    42227: 'Nezávislé vzduchu čítanie',
    42228: 'Voľný ENDOIN',
    42229: 'Nezávislé ENDO čítanie',
    42230: 'Voľný GAS7 v',
    42231: 'Nezávislé GAS7 NH3 čítanie',
    42232: 'Voľný CO v',
    42233: 'Nezávislé CO čítanie',
    42234: 'Voľný N2 ',
    42235: 'Nezávislé N2 žiadosť',
    42236: 'Voľný NH3 ',
    42237: 'Nezávislé NH3 žiadosť',
    42238: 'Voľný DIS ',
    42239: 'Nezávislé DISS NH3 žiadosť',
    42240: 'Voľný CO2 sa',
    42241: 'Nezávislé CO2 žiadosť',
    42242: 'Voľný vzduch von',
    42243: 'Nezávislé vzduchu žiadosť',
    42244: 'Voľný ENDO ',
    42245: 'Nezávislé ENDO žiadosť',
    42246: 'Zadarmo 7 ',
    42247: 'Nezávislé GAS7 žiadosť',
    42248: 'Voľný CO OUT',
    42249: 'Nezávislé CO žiadosť',
    42250: 'Bezplatne N2 ',
    42251: 'Nezávislé N2 ventil',
    42252: 'Bezplatne NH3 ',
    42253: 'Nezávislé NH3 ventil',
    42254: 'Voľný DIS',
    42255: 'Nezávislé DISS NH3 ventil',
    42256: 'Voľný CO2 ',
    42257: 'Nezávislé CO2 ventil',
    42258: 'Voľný vzduchu',
    42259: 'Nezávislé vzduchový ventil',
    42260: 'Voľný ENDO',
    42261: 'Nezávislé ENDO ventil',
    42262: 'Zadarmo 7 ',
    42263: 'Nezávislé GAS7 ventil',
    42264: 'Voľný CO',
    42265: 'Nezávislé CO ventil',
    42266: 'Pec odstránené',
    42267: 'Štart chladenie - odstrániť pece',
    42268: 'Pec odomknutý',
    42269: 'Odomknúť pece',
    42270: 'Sed. úroveň',
    42271: 'Sedimentačná nádrž stav úrovne',
    42272: 'ONC odpad',
    42273: 'ONC odpadové vody stav úrovne',
    42274: 'Práca Štart',
    42275: 'Povoliť prácu Štart',
    42276: 'Brána otvorená',
    42277: 'Chladenie brány otvorené',
    42278: 'Banka 1 PS',
    42279: 'Čpavok stanice 1 ',
    42280: 'Banka 2 PS',
    42281: 'Čpavok Stanice 2 ',
    42282: 'Vode NÍZKEJ',
    42283: 'NÍZKA hladina vody',
    42284: 'Voda tepla',
    42285: 'Voda, Kúrenie stav',
    42286: 'Obehové čerpadlo',
    42287: 'Chladiaca voda obehové čerpadlo',
    42288: 'Hore ',
    42289: 'Výťah hore',
    42290: 'DOLE',
    42291: 'Dole výťahom',
    42292: 'Nainštalovaný filter',
    42293: 'Inštalovať filter',
    42296: 'Filtre pripravený',
    42297: 'Filtre pripravený',
    42298: 'Filter. Zablokovaný',
    42299: 'Filtre zablokovaný',
    42300: 'PP N2 ',
    42301: 'N2 parciálneho tlaku ',
    42302: 'PP NH3 ',
    42303: 'Parciálneho tlaku NH3 ',
    42304: 'PP H2 ',
    42305: 'Parciálneho tlaku H2 ',
    42306: 'PP O2 ',
    42307: 'Parciálneho tlaku O2 ',
    42308: 'PP H2O',
    42309: 'Parciálneho tlaku H2O',
    42310: 'PP CO',
    42311: 'Parciálneho tlaku CO',
    42312: 'PP CO2 ',
    42313: 'Parciálneho tlaku CO2 ',
    42314: 'PP CH4 ',
    42315: 'Parciálneho tlaku CH4 ',
    42318: 'N2/W',
    42319: 'Hmotnosti dusíka',
    42320: 'Úspornom sídli v komore',
    42321: 'Komory v pohotovostnom úspornom',
    42322: 'P/O č',
    42323: 'Post-Oxidation kvalifikátor',
    42324: '',
    42325: '',
    42326: 'PRIPRAVENÝ k pohybu retorty',
    42327: 'Potvrdenie: na NASŤAHOVANIE retorty ',
    42328: 'Retorty je pripravený pre chladenie',
    42329: 'Potvrdiť: Reatort je pripravený pre chladenie ',
    42330: 'Uvoľniť povolené',
    42331: 'Prenos, je povolené',
    42332: 'Lineárnou funkciou',
    42333: 'Timer Function',
    42334: 'Error in percent (instead of reading)',
    42335: 'Logical OR operation',
    42336: 'Logical AND operation',
    42337: 'Logical NOR operation',
    42338: 'Logical NAND operation',
    42340: 'Okolitá teplota.',
    42341: 'Teplota okolia',
    42342: 'Blok teplota',
    42343: 'Blokovať teplota',
    42344: 'Surové prietok',
    42345: 'Surové prietok',
    42346: 'Odvod',
    42347: 'Odvod',
    42348: 'CComp',
    42349: 'CComp',
    42350: 'Doba impulzu',
    42351: 'Doba impulzu',
    42352: 'Čerpadlo',
    42353: 'Vzorkovacie čerpadlo',
    42358: 'Odber vzoriek',
    42359: 'Umožniť odber vzoriek',
    42360: 'Y',
    42361: 'Radič výstupného signálu',
    42362: 'Odber vzoriek stav',
    42363: 'Odber vzoriek zapnutý stav',
    42364: 'Čerpadlo Alarm',
    42365: 'Čerpadlo sýtosť poplachový stav',
    42366: 'Prietok poplach',
    42367: 'Tok mimo hranice poplachový stav',
    42368: 'Alarm Termočlánok',
    42369: 'Termočlánok poplachový stav',
    42370: 'Ri Alarm',
    42371: 'Ri Test poplachový stav',
    42372: 'Čerpadlo stav',
    42373: 'Čerpadlo zapnutý stav',
    42374: 'H2S Block Control',
    42375: 'H2S Block Control',
    42400: 'Turbine',
    42401: 'Turbine',
    42402: 'N2O',
    42403: 'N2O Cut-Off Valve',
    42404: 'N2O-B',
    42405: 'N2O-B Cut-Off Valve',
    42406: 'Filter Blocked',
    42407: 'Filter station blocked',
    42408: 'Filter Bypass',
    42409: 'Filter Bypass Open',
    42410: 'Air Gate',
    42411: 'Air Gate Control (hot side)',
    42412: 'WCS',
    42413: 'Water Cooling Request',
    42414: 'Condens. Valve',
    42415: 'Condensate Valve Request',
    42416: 'HT Filter',
    42417: 'Heat Trace Filter SSR',
    42418: 'HT Enable',
    42419: 'Heat Trace Enable',
    42420: 'HT Sampling',
    42421: 'Heat Trace Sampling SSR ',
    42422: 'HT Exhaust',
    42423: 'Heat Trace Exhaust SSR',
    42424: 'HT AUX',
    42425: 'Heat Trace AUX SSR ',
    42426: 'Steam Gen.',
    42427: 'Steam Generator Enable ',
    42428: 'Steam Flow',
    42429: 'Steam Flow Request ',
    42430: 'Reset Injection',
    42431: 'Reset Injection Totalizer',
    42432: 'Injection',
    42433: 'Injection Enable',
    42434: 'Control Voltage ',
    42435: 'Control Voltage Failure',
    42436: 'Cover Closed',
    42437: 'Cover Closed and Locked',
    42438: 'Purge Complete',
    42439: 'Purge Complete',
    42440: 'ACC Status',
    42441: 'ACC Cooling Status',
    42442: 'ACC Alarm',
    42443: 'ACC Cooling Alarm',
    42444: 'Steam Ready',
    42445: 'Steam Ready',
    42446: 'ONC Water Level',
    42447: 'ONC Water Tank Level',
    42448: 'Exhaust Valve',
    42449: 'Exhaust Valve',
    42450: 'ONC Exhaust Open',
    42451: 'ONC Exhaust Open',
    42452: 'Probe Air Status',
    42453: 'Probe Ref Air Status',
    42454: 'HT Filter',
    42455: 'Heat Trace Filter Status',
    42456: 'HT Exhaust',
    42457: 'Heat Trace Exhaust Status',
    42458: 'HT Sampling',
    42459: 'Heat Trace Sampling Status',
    42460: 'HT AUX',
    42461: 'Heat Trace AUX Status',
    42462: 'N2O SP',
    42463: 'N2O SP',
    42464: 'N2O-B SP',
    42465: 'N2O-B SP',
    42466: 'H2 Sniffer',
    42467: 'H2 Sniffer',
    42468: 'CO Sniffer',
    42469: 'CO Sniffer',
    42470: 'Injection Pressure',
    42471: 'Injection Pressure',
    42472: 'Injection Volume',
    42473: 'Injection Volume',
    42474: 'CO Flow',
    42475: 'CO Gas Flow',
    42476: 'CO Flow-B',
    42477: 'CO Gas Flow-B',
    42478: 'NH3 Sniffer',
    42479: 'NH3 Sniffer',
    42480: 'Agent Pump',
    42481: 'Agent Pump Request',
    42482: 'dNH3 Flow',
    42483: 'Dissociated Ammonia',
    42484: 'dNH3 Flow-B',
    42485: 'Dissociated Ammonia-B',
    42486: 'H2 Flow',
    42487: 'H2 Gas Flow',
    42488: 'H2 Flow-B',
    42489: 'H2 Gas Flow-B',
    42490: 'HT Filter',
    42491: 'Heat Tracing Filter',
    42492: 'HT Sampling',
    42493: 'Heat Tracing Sampling Line',
    42494: 'HT Exhaust',
    42495: 'Heat Tracing Exhaust Line',
    42496: 'HT Aux',
    42497: 'Heat Tracing Auxilary',
    48992: 'Relé vody',
    48993: 'Relé vode horúcej zóny',
    48994: 'DP overtemp',
    48995: 'Difúzia čerpadlo overtemperature',
    48996: '-',
    48997: '-',
    48998: 'Netesnosti',
    48999: 'Netesnosti',
    49000: 'IO Panel',
    49001: 'IO Panel Status',
    49002: 'VLP Panel',
    49003: 'VLP Panel Status',
    49004: 'O2 Probe mV',
    49005: 'O2 Probe mV',
    49006: 'O2 Probe Temp',
    49007: 'O2 Probe Temp',
    49008: 'Blower Ramp',
    49009: 'Blower Control Enable',
    49010: 'Flap Contrl',
    49011: 'Blower Flap Control Enable',
    49012: 'Dryer Satus',
    49013: 'Ammonia Dryer Status',
    49014: 'WCS_ACC Status',
    49015: 'ACC Water System Status',
    49016: 'CPU Temp',
    49017: 'CPU Temperature',
    49018: 'Board Temp',
    49019: 'Controller Board Temperature Sensor',
    49020: 'Board Volts',
    49021: 'Controller Board Voltage Sensor',
    49022: 'Board 3.3V',
    49023: 'Controller Board 3.3V',
    49024: 'Board VBat',
    49025: 'Controller Board Battery Voltage',
    49026: 'Board VCC',
    49027: 'Controller Board VCC',
    50000: 'Sonda T',
    50001: 'Sonda teploty',
    50002: 'Teplota v peci',
    50003: 'Peci teploty',
    50004: 'Zhášanie T',
    50005: 'Kalením teplota',
    50006: 'Zóna T',
    50007: 'Zóna teplota',
    50008: 'O2 mV',
    50009: 'Kyslík sondy signál',
    50010: '',
    50011: '',
    50012: '',
    50013: '',
    50014: 'C %',
    50015: 'Uhlíka',
    50016: 'C-ATM',
    50017: 'C-atmosferické',
    50018: 'C-Steel',
    50019: 'C-Steel',
    50020: 'C-CH4 ',
    50021: 'C-CH4 ',
    50022: 'C-nasýtených',
    50023: 'C-nasýtených',
    50024: 'Redox',
    50025: 'Redox',
    50026: 'Karbid',
    50027: 'Karbid Limit',
    50028: 'Redox č',
    50029: 'Redox číslo',
    50030: 'DPT',
    50031: 'Teploty rosného bodu',
    50032: 'Zliatiny F',
    50033: 'Zliatiny faktor',
    50034: 'PF',
    50035: 'Proces faktor',
    50036: 'CH4 F.',
    50037: 'CH4 faktor',
    50038: 'Faktor',
    50039: 'Faktor',
    50040: 'Náhradné',
    50041: 'Náhradné',
    50042: 'H2 snímač',
    50043: 'H2 senzorom',
    50044: 'KN',
    50045: 'Nitridačná potenciál',
    50046: 'NP',
    50047: 'Nitridačná potenciál',
    50048: 'KO',
    50049: 'Kyslík potenciál',
    50050: 'Prihlásiť O2 ',
    50051: 'Prihlásiť O2 ',
    50052: '',
    50053: '',
    50054: '',
    50055: '',
    50056: '',
    50057: '',
    50058: '',
    50059: '',
    50060: '',
    50061: '',
    50062: '',
    50063: '',
    50064: 'CO',
    50065: 'CO',
    50066: 'CO2 ',
    50067: 'CO2 ',
    50068: 'CH4 ',
    50069: 'CH4 ',
    50070: 'H2 ',
    50071: 'H2 ',
    50072: 'O2 ',
    50073: 'O2 ',
    50074: 'N2 ',
    50075: 'N2 ',
    50076: 'NH3 ',
    50077: 'NH3 ',
    50078: 'VZDUCHU',
    50079: 'VZDUCHU',
    50080: 'ENDO',
    50081: 'ENDO',
    50082: '',
    50083: '',
    50084: '',
    50085: '',
    50086: 'Stlačte.',
    50087: 'Tlak',
    50088: 'Prietok',
    50089: 'Prietok',
    50090: 'Zemný plyn',
    50091: 'Zemný plyn',
    50092: 'Prívod',
    50093: 'Prívod',
    50094: 'Pece',
    50095: 'Pece',
    50096: 'Zóna',
    50097: 'Zóna',
    50098: 'Ramp +',
    50099: 'Teplo rampa',
    50100: 'Rampa-',
    50101: 'Chladenie rampa',
    50102: 'Ref #',
    50103: 'Referenčné číslo',
    50104: '',
    50105: '',
    50106: '',
    50107: '',
    50108: 'Vstup',
    50109: 'Vstupná - slučka X ',
    50110: 'Fázy času',
    50111: 'Fázy času',
    50112: 'Čas úlohy',
    50113: 'Čas úlohy',
    50114: 'Etapa',
    50115: 'Etapa číslo',
    50116: 'Núdzové',
    50117: 'Núdzové',
    50118: 'IO karty',
    50119: 'Stav I/O karty',
    50120: 'Slave',
    50121: 'Slave štatút',
    50122: 'Panel',
    50123: 'Panel stavu',
    50124: 'Rack',
    50125: 'Mozog doska stav',
    50240: 'Vonku',
    50241: 'Výstup-Loop',
    50242: 'Vpred',
    50243: 'Dopredu výstup',
    50244: 'Reverse',
    50245: 'Reverzné výstup',
    50246: 'Teplo',
    50247: 'Vykurovací výkon',
    50248: 'Cool',
    50249: 'Chladenie signál',
    50250: 'C % ',
    50251: 'C %-priamy výstup',
    50252: 'C-rev.out',
    50253: 'C-obrátená von',
    50254: 'DP sa',
    50255: 'Rosný bod kontrolu výstupného signálu',
    50256: 'DP sa-',
    50257: 'Rosný bod kontrolu výstupného signálu (reverz)',
    50258: 'O2 ',
    50259: 'O2 kontrolu výstupného signálu',
    50260: 'O2 Out-',
    50261: 'O2 kontrolu výstupného signálu (reverz)',
    50262: 'Redox ',
    50263: 'Redox kontrolu výstupného signálu',
    50264: 'Redox ',
    50265: 'Redox kontrolu výstupného signálu (reverz)',
    50266: 'Uhasiť ',
    50267: 'Krížová Out Ovládanie výstupného signálu',
    50268: 'Uhasiť Out-',
    50269: 'Uhasiť, kontrolu výstupného signálu (Rubová strana)',
    50270: 'H.Breaker',
    50271: 'Kúrenie istič',
    50330: 'Vzdialenej žiadaná',
    50331: 'Vzdialený súbor bod',
    50332: 'Miestne žiadaná',
    50333: 'Miestne žiadaná',
    50334: 'Konať. Hodnota',
    50335: 'Skutočná hodnota',
    50336: '% Produkcie',
    50337: 'Percento produkcie',
    50338: 'Auto/Man',
    50339: 'Auto/Manual',
    50340: 'Miestne/vzdialenej',
    50341: 'Miestne/vzdialenej',
    50342: 'Rem.TimeSP',
    50343: 'Bod nastavenia vzdialenej dobe',
    50344: 'Auto TimeSP',
    50345: 'Auto čas nastaviť bod',
    50346: 'Zostávajúci čas',
    50347: 'Zostávajúci čas',
    50348: 'Stav časovača',
    50349: 'Stav časovača',
    50350: 'Ready',
    50351: 'System Ready',
    50360: '10Pro',
    50362: '10Pro/T',
    50440: '',
    50441: '',
    50442: 'Výkon',
    50443: 'Stav napájania',
    50444: 'Chladenie',
    50445: 'Chladiaca voda',
    50446: 'Dvere',
    50447: 'Dvere stav',
    50448: 'Fáza',
    50449: 'Fázu monitorovania',
    50450: 'Otvorený',
    50451: 'Dvere otvorené Status',
    50452: 'Uzavreté',
    50453: 'Dvere zatvorené stav',
    50454: 'Open',
    50455: 'Kryt otvorený stav',
    50456: 'Uzavreté',
    50457: 'Kryt stavom uzavreté',
    50458: 'Motor',
    50459: 'Motorové snímač otáčania',
    50460: 'Motor',
    50461: 'Motor preťaženia',
    50462: 'Miešač',
    50463: 'Miešač',
    50464: 'PS',
    50465: 'Tlakový spínač',
    50466: 'E-STOP',
    50467: 'Núdzové zastavenie',
    50468: 'Ventilátor',
    50469: 'Ventilátor obehu',
    50470: 'Otvorený',
    50471: 'Ventil otvoriť',
    50472: 'Uzavreté',
    50473: 'Ventil uzavretý',
    50474: 'Práca Štart',
    50475: 'Práca Štart požaduje',
    50476: 'Atmosféra na',
    50477: 'Atmosféra na ručné bezpečnostný ventil',
    50500: 'Miešač',
    50501: 'Uhasiť Tank miešač',
    50502: 'Zemný plyn',
    50503: 'Plynový ventil',
    50680: 'Svetlo',
    50681: 'Svetlo budík',
    50682: 'Siréna',
    50683: 'Zvuková signalizácia',
    50684: 'Beh',
    50685: 'Úloha beží',
    50686: 'Pohotovostný režim',
    50687: 'V pohotovostnom režime',
    50688: 'Skrat Res',
    50689: 'Skrat odpor',
    50690: 'Spáliť',
    50691: 'Spáliť Relay',
    50692: 'Ref. plyn',
    50693: 'Referenčný plyn',
    50900: 'Konfigurácia i/o',
    50901: 'Nedá sa interné vstupno-výstupného portu',
    50902: 'Vnútorné I/O port otvorený prístup',
    50903: 'Nie je možné inicializovať vnútorný vstupno-výstupnom ovládači',
    50904: 'Slot',
    50905: 'Prázdny slot',
    50906: 'DIO_16 ',
    50907: 'DIO_8 ',
    50908: 'AI4_AO4 ',
    50909: 'Digitálne palubný konfiguráciu',
    50910: 'Nepodarilo sa nastaviť v / požadované',
    50911: 'Zmenila sa slot',
    50912: 'Bod #',
    50913: 'Vstup',
    50914: 'Výstup',
    50915: 'Nastaviť na prázdny slot',
    50916: 'Chyba nastavenia výveska typ',
    50917: 'Slot aktualizované',
    50918: 'Digitálne doske Test',
    50919: 'Verzia #',
    50920: 'Revízia #',
    50921: 'Sériového #',
    50922: 'Neznámy výveska typ',
    50923: 'Kalibrácia továrne',
    50924: 'Incompatible Firmware',
    50933: 'Analógové dosky konfigurácia',
    50934: 'None',
    50935: '0 - 20 mA ',
    50936: '4 - 20 mA ',
    50937: '0 - 2 VDC ',
    50938: '0 - 5 VDC ',
    50939: 'Slidewire',
    50940: 'Neznámy',
    50941: 'VTR (100-398.48 Ω)',
    50942: 'Termočlánok typu J',
    50943: 'Termočlánok typu K',
    50944: 'Termočlánok typu N',
    50945: 'Termočlánok typu S',
    50946: 'Termočlánok typu R',
    50947: 'Termočlánok typu T',
    50948: 'Termočlánok typu E',
    50949: 'Termočlánok typu B',
    50950: 'Termočlánok typu C',
    50951: 'Termočlánok typu M',
    50952: '0 - 24 mA ',
    50953: '0 - 10 VDC ',
    50954: 'Test analógové dosky',
    50955: 'Konfigurovať',
    50956: 'Uložiť verziu',
    50957: 'Test',
    50958: 'VTR',
    50959: 'Termočlánok',
    50960: 'AI8 ',
    50961: 'Shunt 10 kΩ',
    50975: 'Kanál',
    50976: 'Analógové vstupy',
    50977: 'Analógové výstupy',
    50978: 'Kalibráciu 0',
    50979: 'Kalibráciu zisk',
    50980: 'Kalibrácia samostatne 0',
    50981: 'Set',
    50982: 'Start Logging',
    50983: 'Stop Logging',
    50984: 'Are you ready to perform Zero Calibration?',
    50985: 'Are you ready to perform Full-Scale Calibration?',
    50986: 'Are you sure you want to reset calibration data?',
    50987: 'Are you sure you want to reset ADC for this channel?',
    50988: 'ADC Reset was successful',
    50989: 'Are you sure you want to reset CJ measuring circuit?',
    50990: 'CJ measuring circuit was reset successfully"\\',
    50991: 'Are you sure you want to load default calibration data?',
    50992: 'Are you sure you want to load calibration data saved in EEPROM?',
    50993: 'Are you sure you want to save the data in EEPROM?',
    50994: 'Are you sure you want to revert changes?',
    50995: 'I2C čítanie/zápis zlyhal',
    50996: 'Počkajte, prosím.',
    50997: 'Controller je inicializovaním.',
    50998: '16 = DC DIO ',
    50999: '8 ~ AC DIO ',
    51000: '4 V 4, AIO',
    51001: '8 V AIO',
    51002: 'Kliknite nižšie a pridajte komentár',
    51003: 'HODNOTY OFFSET',
    51004: 'Predvolená hodnota',
    51005: 'V EEPROM',
    51006: 'ZÍSKAŤ HODNOTY',
    51007: 'REGISTRE',
    51008: 'OFC registrov',
    51009: 'FSC registrov',
    51010: 'Musíte vybrať vstupný najprv na kalibráciu',
    51011: 'Počkajte, kým môžem konfigurovať IO...',
    51012: 'Uložiť kalibračné údaje?',
    51013: 'Počkajte, kým konfigurácia kanála jeho počiatočné nastavenia...',
    51014: 'Nepodarilo sa uložiť kalibračné údaje',
    51015: 'Ukladanie, čakajte prosím...',
    51016: 'Počas ukladania údajov do EEPROM sa vyskytla neočakávaná chyba',
    51017: 'Kalibračné údaje uložené',
    51018: 'Sa nedá obnoviť kalibračné údaje',
    51019: 'Prosím pripojiť zdroj %1 slot # %2 kanál # % 3 ',
    51020: 'Vyberte počet vzoriek',
    51021: 'Počet vzoriek',
    51022: 'Prosím, počkajte na postup kalibrácie dokončiť pre slot # %1 kanál # % 2 ',
    51023: 'Vzorka',
    51024: 'Value(Hex)',
    51025: 'Nepodarilo sa dokončiť postup - príliš veľa pokusov pre slot # %1 kanál # % 2 ',
    51026: 'Slot',
    51027: 'Kanál',
    51028: 'Zero kalibrácia bola úspešne dokončená pre',
    51029: 'NULA',
    51030: 'Hex',
    51031: 'Nepodarilo sa nastaviť registre s novými údajmi kalibrácie nula',
    51032: 'Výsledok',
    51033: 'Nepodarilo sa nastaviť registre s nové plné rozsahu kalibračných údajov',
    51034: 'Kalibrácia bola úspešne dokončená pre zisk',
    51035: 'nula',
    51036: 'zisk',
    51037: 'Nepodarilo sa dokončiť postup - kalibračné údaje mimo rozsah pre slot # %1 kanál # % 2 ',
    51038: 'Resetovanie kalibračné údaje...',
    51039: 'Nepodarilo sa obnoviť údaje',
    51040: 'Kalibrácia reset úspešne',
    51041: 'Počkajte, kým Prekonfigurovanie kanálu...',
    51042: 'Nepodarilo sa nakonfigurovať kanál',
    51043: 'Kalibrácia',
    51044: 'Kanál čítanie',
    51045: 'Termočlánok ciachovacie zariadenie',
    51046: 'Termočlánok typu',
    51047: 'Signál',
    51048: 'Cold Junction',
    51049: 'Surové čítanie',
    51050: 'Kalibrované',
    51051: 'Kalibrácia opravy',
    51052: 'Podľa skúšky',
    51053: 'V EEPROM',
    51054: 'Zadajte ciachovacie zariadenie signál',
    51055: 'CJ kalibrácia',
    51056: 'Nepodarilo sa získať údaje z IO',
    51057: 'Na palube teplota kalibrácie úspešne',
    51058: 'Na palube teplota kalibrácie zlyhala',
    51059: 'Na palube teplota kalibrácie sa nepodarilo kompenzovať mimo povoleného rozsahu. min:% 1, max: % 2, hodnotu: % 3 ',
    51060: 'Neplatný vyvážila hodnota',
    51061: 'Na palube teplota kalibrácie zlyhalo, nedá sa zapisovať do EEPROM posun',
    51062: 'Štart kalibrácia CJ',
    51063: 'Kalibráciu kanál',
    51064: 'Vyberte kanál',
    51065: 'Úpravy okruhu palube teplotu',
    51066: 'Uložiť informácie o verzii?',
    51067: 'Informácie o verzii bol uložený za slot',
    51068: 'Informácie o verzii nebola uložená slot',
    51069: 'Chyba pri zápise verzia informácie do EEPROM. ',
    51080: 'Configure Lease Date',
    51081: 'Lease Date',
    51082: 'Saved Date',
    51083: 'Rollback Counter',
    51084: 'Serial Number',
    52324: '',
    52325: '',
    53000: 'English_French_German_Polish_Russian_Italian_Portuguese_Spanish_Chinese_Arabic_Serbian',
    60080: 'Pripravuje sa kopírovanie súborov...',
    60081: 'Zdrojový adresár sa nenašiel.',
    60082: 'Zdrojovom adresári nie sú čitateľné.',
    60083: 'Cieľový adresár nebol nájdený.',
    60084: 'Cieľový adresár nie je čitateľný',
    60085: 'Prepísať nasledujúci súbor?: ',
    60086: 'Nedá sa otvoriť súbor pre čítanie: ',
    60087: 'Nedá sa otvoriť súbor pre zápis: ',
    60088: 'Nedá sa čítať zo súboru: ',
    60089: 'Kopírovanie súboru',
    60090: 'Nedá sa zapisovať do súboru: ',
    60091: 'Hotové',
    60092: 'Prístroj nie je pripravený.',
    60093: '',
    60144: 'Alarmy',
    60146: 'Alarm',
    60147: 'Uznať',
    60148: 'Obnoviť',
    60150: 'Všetky komory',
    60175: 'Stav pripojenia',
    60192: 'Zobraziť alebo skryť informácie',
    60200: 'Musí byť v režime údržby',
    60201: 'Nastavte hodnotu analógový výstup',
    60204: 'Čísla projektu: ',
    60209: 'Analógový vstup',
    60210: 'Nastaviť hodnotu',
    60211: 'Hodnota',
    60212: 'Analógový výstup',
    60213: 'Digitálny vstup',
    60214: 'Digitálny výstup',
    60215: 'Nové hodnoty: ',
    60216: 'Min: ',
    60217: 'Max: ',
    60219: 'Stop forcing output?',
    60220: 'Hodnota presahuje rozsah.',
    60221: 'Analógové',
    60222: 'Digitálne',
    60223: 'Prístup odmietnutý.',
    60225: 'Nitrex Metal Inc.',
    60226: '3474 Poirier Boulevard',
    60227: 'Saint Laurent, Quebec',
    60228: 'H4R 2J5 Canada',
    60229: 'Tel.: 514-335-7191 ',
    60230: 'Fax.: 514-335-4160 ',
    60231: 'Web: www.nitrex.com ',
    60232: 'E-mail: nitrex@nitrex.com ',
    60233: 'Technická podpora: support@nitrex.com ',
    60240: 'Správy',
    60241: 'Vymaže všetky správy',
    60242: 'Vymazať všetky správy?',
    60255: 'Company:',
    60256: 'Názov systému: ',
    60257: 'Stav: ',
    60258: 'Procesu: ',
    60259: 'Čísla projektu: ',
    60260: 'Etapa meno: ',
    60261: 'Etapa číslo: ',
    60262: 'Etapa čas: ',
    60263: 'Proces čas: ',
    60264: '-',
    60265: 'Pohotovostný režim...',
    60266: 'Proces beží...',
    60267: 'Režim údržby',
    60268: 'Žiadny proces spustený',
    60269: 'Chyba',
    60270: 'Neznámy stav',
    60271: 'Núdzového postupu',
    60272: 'Naložené: ',
    60273: 'Naplánované na: ',
    60274: 'Prerušenie...',
    60275: 'Predhrejte',
    60276: 'Čaká sa na prijatie zaťaženia',
    60277: 'Čaká sa na prenos zaťaženia',
    60278: 'Vymazať',
    60279: 'Komora hotové',
    60368: 'heat',
    60369: 'runtime_cool',
    60370: 'runtime',
    60371: 'press_plus',
    60372: 'press_minus',
    60373: 'vacuum_plus',
    60374: 'vacuum_minus',
    60375: 'timecool',
    60376: 'incharge_heat',
    60377: 'incharge_cool',
    60378: 'oncharge_heat',
    60379: 'oncharge_cool',
    60380: 'furnace_heat',
    60381: 'furnace_cool',
    60382: 'N2_plus',
    60383: 'N2_minus',
    60384: 'NH3_plus',
    60385: 'NH3_minus',
    60386: 'dissNH3_plus',
    60387: 'dissNH3_minus',
    60388: 'CO2_plus',
    60389: 'CO2_minus',
    60390: 'air_plus',
    60391: 'air_minus',
    60392: 'user',
    60393: 'standby',
    60394: 'custom_di',
    60395: 'custom_ai',
    60396: 'time_ai',
    60397: 'safe_to_end',
    60398: '1 Volume',
    60399: '2 Volumes',
    60400: '5 Volumes',
    60401: 'in_on_diff',
    60500: 'Koncová podmienka hodnota',
    60880: 'Matematický Model',
    60881: 'Kliknite tu pre prihlásiť',
    60882: 'Nitrex matematický Model',
    60883: 'Vzor typu',
    60884: 'Ocele typu',
    60885: 'Výpočet Graph',
    60886: 'Zmeniť etapu dvakrát na graf v príslušnej oblasti.',
    60887: 'Gama hlavnú vrstvu',
    60888: 'Bielu vrstvu',
    60889: 'Difúznej vrstvy',
    60890: 'Leszek',
    60891: 'Zobrazenie difúznej vrstvy na samostatné osi.',
    60892: 'Zobrazenie DL na samostatné OS zobrazíte ďalšie vrstvy v podrobné móda. \\x0ADisplay im na tej istej osi presne Zobraziť ich relatívna šírka.',
    60893: 'Vyberte si želáte zobraziť vrstvy.',
    60894: 'Čas vo hodín',
    60895: 'Skryť rozhranie na úpravu',
    60896: 'Zobrazenie procesu kontroly',
    60897: 'Aktualizácia etáp v procese tvorca',
    60898: 'Pozor',
    60899: 'Prepíše aktuálne načítaného procesu v Proces Tvorca!',
    60900: 'WL epsilon gama "[m]',
    60901: 'Hodín',
    60902: 'Minút',
    60903: 'Teplota C',
    60904: 'Teplota F',
    60905: 'Fáza trvania',
    60906: 'Teplota Setpoint',
    60907: 'Potenciálne Setpoint',
    60908: 'Zobrazenie DL (Vikkers)',
    60909: 'Hĺbka [m] ',
    60910: 'Hĺbka ty ',
    60911: 'HV',
    60912: 'Železo',
    60913: 'Armco',
    60914: '1020 ',
    60915: '1050 ',
    60916: 'N135M',
    60917: 'H11 ',
    60918: '18HGT',
    60919: '4140 ',
    60920: '5140 ',
    60921: '20 H',
    60922: '4340 ',
    60923: 'NC11LV',
    60924: 'H13 ',
    60925: '32CDV13 ',
    60928: 'Displej hĺbka akou je dosiahnuté špecifikované tvrdosť. Nie všetky typy ocele majú koeficient spojená tvrdosť. Táto možnosť nie je povolená pre železo. ',
    60944: 'Vlastnosti ocele',
    60945: 'Zobraziť vlastnosti',
    60946: 'Nitplanner Menu',
    60947: 'Vlastnosti',
    60948: 'Nitplanner',
    61280: 'Epsilon',
    61281: 'Gama ',
    61282: 'WL',
    61283: 'DL',
    61284: 'Tvrdosť',
    61285: 'WL epsilon gama "[tie]',
    61286: '[tie]',
    61287: '[m] ',
    61288: 'Jadro tvrdosť',
    61289: 'Metrický',
    61290: 'Referenčné tvrdosť',
    61296: 'Tento model spracúva len NH3 a nepriradený NH3 ',
    61297: 'Došlo k chybe nepredvídateľných',
    61298: 'Nitridačná etapách musí byť dlhšieho trvania',
    61299: 'Musíte predložiť Nitridačná etáp. Váš proces má žiadne Nitridačná etapy.',
    61300: 'Teplota je mimo rozsahu a nie je platná pre tento model.',
    61301: 'Chyba v štádiu číslo: ',
    61302: 'Koeficienty boli nevlo ili pre všetky typy ocele. Kontaktovať Nitrex.',
    61303: 'Potenciál prvej fáze musí byť medzi %s a %s pre materiál % s',
    61304: 'Proces inštalácie',
    61305: 'Simulácia dokončeného projektu',
    61306: 'Neznáme kov',
    61307: 'Tejto fáze nie je možné upraviť',
    61308: 'Jadro tvrdosť v HRC. Tvrdosť 0 bude ignorované a použije sa predvolená hodnota.',
    61309: 'Simulácia dokončené úlohy (kontextového menu)',
    61310: 'Oceľové koeficienty sa nenačítali. Kontaktovať Nitrex.',
    61311: 'Kliknite na tlačidlo "Vypočítať" pred použitím tejto funkcie.',
    61312: 'Vložiť pred',
    61313: 'Vložiť po',
    61314: 'Odstrániť fázy',
    61315: 'Načítať denník',
    61316: 'Načítanie súboru denníka: ',
    61317: 'Etapa meno: ',
    61318: 'Log Filename: ',
    61319: 'Tento záznam nie je kompatibilný s Mathmodel. ',
    61320: 'Jednej alebo viacerých fázach tohto denníka bol interruped to a pokračovala. ',
    61321: 'Zobraziť fáze kontroly',
    61322: 'Nitplanner Menu',
    61323: 'Oceľové konfiguračného súboru sa vyskytla chyba. Prosím, kontaktujte Nitrex.',
    61324: 'Nepodarilo sa otvoriť súbor: ',
    61325: 'Nemáte povolenie na zobrazenie tohto denníka.',
    61326: 'Tento denník neobsahuje žiadne použiteľné Nitridačná údaje.',
    61327: 'Tento záznam nie je platné číslo denníka procesu Nitridačná',
    61328: 'Potenciál je zle hodnoty: ',
    61329: 'Trvanie etapy nemôže byť 0. Nitridačná fázach nemôžu byť menej ako 6 minút. Odstrániť fázy v prípade potreby.',
    61330: 'Tento graf sa nedá zobraziť pre tento materiál',
    61331: 'Potenciálne Gradient',
    61332: 'Teplotný Gradient',
    61333: 'Aktuálny Log Filename',
    61334: 'Aktuálne umeleckým menom',
    61335: 'Tejto fáze nie je možné upraviť',
    61336: 'Nemôžete upravovať etáp, ktoré ukončili. Bude k dispozícii prvá etapa',
    61337: 'Neexistujú žiadne fázy spáchať. Stlačte tlačidlo Pridať štádiu vytvoriť jeden.',
    61394: 'Zobraziť denník',
    61409: 'Neznámy protokol',
    61412: 'Konvertory chybový kód',
    61417: 'Pripojený',
    61418: 'Odpojený',
    61419: 'Unable to access user file.  Using hard coded default user.',
    61420: 'Was able to access user file.',
    61429: 'Host',
    61435: 'The following error occurred while loading gui configuration file:',
    61436: 'is currently not connected',
    62000: 'Výroba',
    62001: 'Konfigurácia',
    62002: 'Správa',
    62003: 'Citácia',
    62004: 'Hodnotenie',
    62005: 'Obchod objednávky',
    62006: 'Lodná preprava',
    62007: 'Fakturácia',
    62008: 'Certifikácia',
    62009: 'Zákazník',
    62010: 'Kontakt',
    62011: 'Typ operácie',
    62012: 'Operácia',
    62013: 'Prietok v Procese',
    62014: 'Zariadenie',
    62015: 'Výroba Status',
    62016: 'Obchod dnes',
    62017: 'Spoločnosť Setup',
    62018: 'Označenie',
    62019: 'Cenník',
    62020: 'Jednotka',
    62021: 'Požiadavka',
    62022: 'Operátor',
    62023: 'Materiál',
    62024: 'Mena',
    62025: 'Krajina',
    62026: 'Jazyk',
    62027: 'Prepravná spoločnosť',
    62028: 'Používanie zariadenia',
    62029: 'Obchod systém riadenia databázy',
    62030: 'Zákaznícky kód',
    62031: 'Tlač informácií pre zákazníkov',
    62032: 'Adresa',
    62033: 'Všeobecný telefón',
    62034: 'Vyberte zákazníka',
    62035: 'Priezvisko',
    62036: 'Bezplatná linka telefón',
    62037: 'Prostredné meno',
    62038: 'Všeobecné informácie',
    62039: 'Detail kontaktu',
    62040: 'Názov',
    62041: 'Zástupca',
    62042: 'Telefón',
    62043: 'Typ podnikania',
    62044: 'Webové stránky',
    62045: 'Vzdialenosť',
    62046: 'Expresná dodávka informácie',
    62047: 'Lodné účet',
    62048: 'Zákazník zľavu',
    62049: 'Fax',
    62050: 'Platobné podmienky',
    62051: 'Príjem',
    62052: 'Nákladné informácie',
    62053: 'Obchodná adresa',
    62054: 'Dodatočné informácie',
    62055: 'Ulica',
    62056: 'Zobraziť všetky povolené zákazníci',
    62057: 'E-Mail',
    62058: 'Město',
    62059: 'Provincia/štátu',
    62060: 'Poštové/PSČ',
    62061: 'Identifikátor',
    62062: 'Pozícia',
    62063: 'Oddelenie',
    62064: 'Odoslať e-mail',
    62065: 'Prístup webové stránky',
    62066: 'Poznámku',
    62067: 'Ext.',
    62068: 'Dodaciu adresu',
    62069: 'Rovnaké ako sídlo',
    62070: 'Fakturačná adresa',
    62071: 'Poštová adresa',
    62072: 'Informácie o spoločnosti',
    62073: 'Citovať Poznámka',
    62075: 'Poznámka aby obchod',
    62076: 'Certifikácia Poznámka',
    62077: 'Prepravná Poznámka',
    62078: 'Fakturácia Poznámka',
    62079: 'Časť',
    62080: 'Všeobecné E-mail',
    62081: 'Všeobecný Fax',
    62082: 'Zákaznícky kód už existuje.',
    62083: 'Krstné meno',
    62084: 'Názov',
    62085: 'Tlačiť cenovú ponuku',
    62086: 'Detail',
    62087: 'Názov zákazníka',
    62088: 'Citovať kód',
    62089: 'Vytvoril',
    62090: 'Platnosť',
    62091: 'Vytvoriť',
    62092: 'Klon',
    62093: 'Poštová meno',
    62094: 'Ponuka tovaru',
    62095: 'Zákazník číslo dielu',
    62096: 'Kontakt už existuje. Skúsiť iný identifikátor.',
    62097: 'Uložiť ponuky',
    62098: 'Dokončiť',
    62099: 'Položka',
    62100: 'Špecifikácia',
    62101: 'Cena tovaru',
    62102: 'Pridať',
    62103: 'Hore',
    62104: 'Dole',
    62105: 'Pridanie alebo úprava',
    62106: 'Klon sa',
    62107: 'Hodnota',
    62108: 'Položka kód',
    62109: 'Materiály',
    62110: 'Kód',
    62111: 'Min. cena',
    62112: 'Uložiť cenník',
    62113: 'Vyberte položku cena',
    62115: 'Začiatočná hodnota',
    62116: 'Koniec hodnoty',
    62117: 'Cena',
    62118: 'Dni',
    62119: 'Mesiacov',
    62120: 'Zľava',
    62121: 'Nedá sa upraviť',
    62122: 'Nie všetky požadované polia sú vyplnené',
    62123: 'Nepodarilo sa vložiť záznam',
    62124: 'Materiál už',
    62125: 'Nepodarilo sa odstrániť záznam',
    62126: 'Odstránenie materiálu?',
    62127: 'Druhy prevádzky',
    62128: 'Typ operácie už',
    62129: 'Odstrániť typ operácie',
    62130: 'Zariadenia už existuje',
    62131: 'Odstránenie zariadenia?',
    62132: 'Po skončení úprav',
    62133: 'Úlohy',
    62134: 'Vybraté typy prevádzky',
    62135: 'Typy dostupných prevádzky',
    62136: 'Operácia skupiny',
    62138: '%',
    62139: 'Ceny',
    62140: 'Kód',
    62141: 'Cenová politika',
    62142: 'Spec.',
    62143: 'Nová položka',
    62144: 'Za-veľa cien',
    62145: 'Cien typu',
    62146: 'Veľa cena',
    62147: 'Dvojitým kliknutím vložíte zákazník',
    62148: 'Dvojitým kliknutím vyberte zákazníka',
    62149: 'Časť tovaru: ',
    62150: 'Táto citácia je na tieto časti čísla',
    62151: 'Táto ponuka je platí nasledujúci proces',
    62152: 'Budeme spracovávať vaše časti nasledujúcej špecifikácie',
    62153: 'Zaslať',
    62154: 'Celková hmotnosť by mala byť väčšia alebo rovná hmotnosti za kus',
    62155: 'Celková hmotnosť by mala byť násobkom hmotnosti jednotky',
    62156: 'Zadajte jednotku hmotnosti alebo celkovej hmotnosti',
    62157: 'Zadajte jednotku hmotnosti alebo celkové kus počítať',
    62158: 'Opravte hodnotu za jednotku hmotnosti',
    62159: 'Táto ponuka už vypršala. Zadajte nový dátum platnosti',
    62162: 'Neexistuje žiadna položka na uložený',
    62163: 'Citovať zmenilo, naozaj chcete zahodiť zmeny?',
    62164: 'Kód cenovej ponuky je potrebné',
    62165: 'Iný citát kód je potrebné',
    62166: 'Naozaj chcete zrušiť?',
    62167: 'Parameter je povinný',
    62168: 'Hodnota1 je potrebné',
    62169: 'Hodnota2 je potrebné',
    62170: 'Prevádzkovateľ je potrebné',
    62171: 'Oprávnení zákazníci',
    62172: 'Schválené zákazníkov; aspoň jedna časť je vytvorená pre vymenovaných zákazníkov.',
    62173: 'Ceny za časť počítať sa',
    62174: 'Ceny za hmotnosť je potrebné',
    62175: 'Ceny v inej mene, je potrebné',
    62176: 'Prosím selct cenník',
    62177: 'Jednotka je potrebné',
    62178: 'Prosím vyberte, čo chcete exportovať: ',
    62179: 'Všetky uvedené zákazníkov',
    62180: 'Všetky kontakty z zobrazené zákazníkov',
    62181: 'Celková cena',
    62182: 'Dôvod vypnutia',
    62183: 'Riešenie typu',
    62184: 'Načítať z ponuky',
    62185: 'Množstvo',
    62187: 'Množstvo nádob',
    62188: 'Kontajner',
    62189: 'Hrubá hmotnosť',
    62190: 'Netto hmotnosť',
    62191: 'Vybrané časti',
    62192: 'Súvisiace citácie',
    62193: 'Pred pridaním nových uložte aktuálne úpravy rolu',
    62194: 'NEPOUŽÍVA',
    62195: 'NEPOUŽÍVA',
    62196: 'NEPOUŽÍVA',
    62197: 'Materiál kód je potrebné',
    62198: 'Odkazuje',
    62199: 'Schválenie sprístupní prijaté položky pre Shop objednávky.',
    62201: 'Inšpekcia nebola dokončená pre nasledovné položky: ',
    62202: 'Certifikácia požadovaná',
    62203: 'Print Shop objednávky',
    62204: 'Zoznam',
    62205: 'Obchod objednávací kód',
    62206: '',
    62207: 'Priorita',
    62208: 'Dátum poslednej kontroly',
    62209: 'Rozdeliť',
    62210: 'Stav',
    62211: 'Zobraziť dostupné položky',
    62212: 'Hrubá hmotnosť musí byť väčšia alebo rovná čistej hmotnosti',
    62213: 'Inšpekčné kritériá',
    62214: 'Prijať',
    62215: 'Odmietnuť',
    62216: 'Odmietnuté množstvo je väčšie ako množstvo získané',
    62217: 'Niektoré položky bez čistá hmotnosť alebo množstvo vyšetril. Prajete si vymazať inšpekčných údajov?',
    62218: 'Balenie sklzu/veľa #',
    62219: 'Zmena nebude trvalé do prijímajúceho záznam uloží. ',
    62220: 'Odstránenie položky',
    62221: 'Naozaj chcete odstrániť túto položku?',
    62222: 'Zvoľte časť',
    62223: 'Vymazať vybratú časť',
    62224: 'Uložiť poradie Shop',
    62225: 'Shop objednávací kód je potrebné',
    62226: 'Rôzne kód Shop objednávky je potrebné',
    62227: 'Shop objednať zmenil. Naozaj chcete zahodiť zmeny?',
    62229: 'Databázu zaneprázdnený, skúste to prosím znovu',
    62230: 'Výstava schránky',
    62231: 'Požiadavka na krok',
    62232: 'Stupeň certifikácie',
    62233: 'Identifikácia operácie',
    62236: 'V nasledujúcich dostal položiek sú počítanie chyby: ',
    62237: 'Menej častí boli prijaté ako boli zamietnuté alebo používané v Shop objednať.',
    62238: 'Počet vzoriek',
    62239: 'Prijaté',
    62240: 'Tento text bude nahradený je vybratá časť.',
    62241: 'Nemôžete použiť túto jednotku, pretože je príliš veľké množstvo!',
    62242: 'Množstvo použité Shop objednať',
    62243: 'Príjem bol zmenený. Naozaj chcete zahodiť zmeny?',
    62244: 'Vybrané časti sa vymaže z položiek Ak zákazník mení.',
    62245: 'Vyberte číslo nákupnej objednávky',
    62246: 'Nedá sa nájsť súčasť tohto zákazníka!',
    62247: 'Nemohol nájsť nákupnú objednávku pre tohto zákazníka!',
    62248: 'Táto položka sa nedá odstrániť, pretože ho používa Shop objednať',
    62249: 'Časť pred musíte vybrať pre túto položku môže ísť do poradia Shop.',
    62250: 'Zamietnuté množstvo',
    62251: 'Odstránili ste prepravná spoločnosť zákazníka.',
    62252: 'Tým sa tiež odstránia lodné účet.',
    62253: 'Vybratá časť sa už používa nasledovné položky: ',
    62254: 'Schválenie nedá vykonať, pretože existuje položka s žiadne vybrané časti!',
    62255: 'Klon na adresu typu?',
    62256: 'Naozaj chcete odstrániť túto adresu?',
    62257: 'Zmena nebude trvalé kým zákazník neuloží.',
    62258: 'Naozaj chcete premiestniť túto adresu?',
    62260: 'Poslať Newsletter',
    62261: 'Poslať Vianočné prianie',
    62262: 'Ostatné',
    62270: 'Shop objednať používa aspoň jednu položku z tento príjem rekord!',
    62271: 'Množstvá dotknutých položiek je úprava obmedzené.',
    62272: 'Odstránenie schválenie bude zostávajúce množstvá k dispozícii pre obchod objednávky.',
    62273: 'Zákazník za príplatok',
    62274: 'Povolené zákazníka za príplatok (%)',
    62275: 'Za príplatok (%)',
    62276: 'Celkom za príplatok',
    62338: 'Kompletný plánovanie',
    62339: 'Max dávkové Množ.',
    62340: 'Dávka Max hmotnosť',
    62341: 'Pozri špecifikácie',
    62342: 'Plánovanie č.',
    62343: 'Úloha Detail',
    62344: 'Dostupnosť',
    62345: 'Štart čas',
    62346: 'Čas ukončenia',
    62347: 'Liečba kód',
    62348: 'Pracovné kód',
    62349: 'Operátor',
    62350: 'Zaťaženie č.',
    62351: 'Krok požiadavka',
    62352: 'Hmotnosť jednotky',
    62353: 'nie. na plánovanie',
    62354: 'Kompletné ošetrenie',
    62356: 'Harmonogram zaťaženia',
    62357: 'Chcete uložiť zmeny aktuálnej úlohy?',
    62358: 'Chcete uložiť zmeny pre aktuálny rozvrh?',
    62359: 'Neexistujú žiadne ďalšie časti vytvoriť nový plán',
    62360: 'Ste si istí, že chcete odstrániť tento plán?',
    62361: 'Liečba',
    62363: 'Zaťaženie No. je potrebné',
    62364: 'Zaťaženie No. je igored',
    62369: 'NEPOUŽÍVA',
    62370: 'NEPOUŽÍVA',
    62371: 'Plánované',
    62372: 'V procese',
    62373: 'Certifikácia dokončená',
    62375: 'Fakturované/zatvorené',
    62376: 'Zrušený',
    62377: 'Plánovanie pre túto časť sa tiež odstránia. Chcete pokračovať?',
    62378: 'Načítať časť',
    62379: 'Číslo časti obchod',
    62380: 'Na',
    62381: 'Naozaj chcete zahodiť zmeny?',
    62382: 'Zoznam zákazníkov',
    62383: 'Zákazník Detail',
    62384: 'Tento zákazník už existuje podľa meno a obchodná adresa',
    62385: 'Ste si istý, že by ste chceli odstrániť záznam?',
    62386: 'Záznam nie je možné uzamknúť, to nie je vybraný',
    62387: 'Záznam nemôže byť upravovaný',
    62388: 'Zoznam kontaktov',
    62389: 'ALT. E-mail',
    62390: 'ALT. Phone',
    62391: 'Zákazník bol zmenený. Naozaj chcete zahodiť zmeny?',
    62392: 'Vybrané časti a procesu',
    62393: 'Operácia už existuje',
    62394: 'Proces toku už',
    62395: 'Citácia zmenil, uložiť zmeny?',
    62396: 'Jeden alebo viac vybraných častí už v tabuľke nie sú vkladajú',
    62397: 'Priradiť proces prietok',
    62398: 'Nasledujúci proces tokov odkazuje a nedá sa odstrániť: ',
    62399: 'Žiadne ďalšie časti dostupné.',
    62400: 'Časti celkové náklady',
    62401: 'Misc celkové náklady',
    62402: 'Časti',
    62403: 'Rôzne.',
    62404: 'Kontakt bol zmenený. Naozaj chcete zahodiť zmeny?',
    62405: 'Bez úvodzoviek dostupné.',
    62406: 'Časti Obchod s rovnaké číslo časti a kód zákazníka musia byť z rovnakého materiálu.',
    62407: 'Vzorky prijaté',
    62408: 'Upraviť tok',
    62409: 'Pridať súčasť',
    62410: 'Odstrániť časť',
    62411: 'Schválením tohto shop objednať bude vyžadovať schválenie povolení pre ďalšie zmeny.',
    62412: 'K dispozícii diely',
    62413: 'Proces tok krokov',
    62414: 'Priradený proces toky',
    62415: 'Pre výber viacerých položiek: stlačte a podržte tlačidlo <Ctrl> kľúč a potom kliknite na každú položku ',
    62416: 'Citácie - časť výberu',
    62417: 'Nepodarilo sa načítať shop objednať.',
    62418: 'Nemôžete zrušiť objednávku Obchod s účinnej dávky.',
    62419: 'Momentálne nie sú žiadne dávky pre tento shop objednať.',
    62420: 'Sledovanie hmotnosti',
    62421: 'Pleaes zadanie hmotnosti alebo zmeňte spôsob sledovania výber',
    62422: 'Zadajte množstvo, alebo zmeňte spôsob sledovania výber',
    62423: 'Dostupné množstvo',
    62424: 'Voľné hmotnosti',
    62425: 'Neexistujú žiadne alternatívne toky sú k dispozícii pre túto časť.',
    62426: 'Neplatné množstvo a hmotnosť',
    62427: 'Krok inštrukcie',
    62428: 'Šarže Podrobnosti',
    62429: 'Upraviť dávky',
    62430: 'Táto akcia odstráni všetky dávky pre vybrané shop objednať. Chcete pokračovať?',
    62431: 'Sa nedá odstrániť. Proces toku sa používa',
    62432: 'Sa nedá odstrániť. Operácia sa používa',
    62433: 'Sa nedá odstrániť. Materiál sa používa',
    62434: 'Sa nedá odstrániť. Diely môžu byť využívané fakturácie, plavbu alebo laboratórne Hodnotenie',
    62435: 'Sa nedá odstrániť. Toto by porušilo množstvá už tvrdil v rovnakej časti v iných purifikovaný.',
    62436: 'Sa nedá odstrániť. Niektoré časti sú použité v ďalších nasledujúcich častí.',
    62437: 'Sa nedá odstrániť. Veľa používajú hodnotiace laboratórium',
    62438: 'Nepodarilo sa odstrániť krok. Niektorých dávok sú používané hodnotiace laboratórium',
    62439: 'Sa nedá odstrániť. Typ operácie sa používa operácia',
    62440: 'Hľadať v stĺpci: ',
    62441: 'Auto kľúčom je povolené',
    62442: 'Názov časti',
    62443: 'Nasledujúce pole musí obsahovať hodnotu',
    62444: 'Zobraziť všetkých častí',
    62445: 'Zobraziť všetkých operácií',
    62446: 'Zobraziť všetky toky proces',
    62447: 'Zobraziť všetky faktúry',
    62448: 'Zobraziť všetky dávky',
    62449: 'Jednotka hmotnosti',
    62450: 'Vytvorte dávku',
    62451: 'Odstrániť dávky',
    62452: 'Pridať časť(i) dávky',
    62453: 'Odstrániť vybratú časť',
    62454: 'Nepodarilo sa jasné. Veľa používajú hodnotiace laboratórium',
    62455: 'Ospravedlňujeme sa, ale nemáte povolenie na uloženie dávok.',
    62456: 'Časť',
    62457: 'od kroku',
    62458: 'nie je nájdený v predchádzajúcom kroku',
    62459: 'Nepodarilo sa odstrániť čas ukončenia. Niektoré časti už boli fakturované alebo dodali.',
    62460: 'Časť množstva pre dávku je nižšie ako množstvo už tvrdil invoiing alebo dopravu.',
    62461: 'Celkové množstvo ošetrené časti je nižšie ako celkové množstvo už tvrdil fakturácie alebo lodné.',
    62462: 'Fakturované množstvo: ',
    62463: 'Dodané množstvo: ',
    62464: 'Zák. Časť',
    62465: 'Sa nedá odstrániť. Časť používa hodnotiace laboratórium.',
    62466: 'Nepodarilo sa uložiť. Všetky časti ukončili liečbu a laboratórne hodnotenie už vykonal jej záverečné hodnotenie týchto častí.',
    62467: 'Archív',
    62468: 'Naozaj chcete archivovať túto časť? Pritom vám zabráni pomocou tejto časti nové budúcej práce.',
    62469: 'Ospravedlňujeme sa, budete potrebovať povolenie na úpravu hodnotiace laboratórium na to.',
    62470: 'Ospravedlňujeme sa, budete potrebovať povolenie na úpravu certifikácie na to.',
    62471: 'Percentá všetkých priradených kategórií by súčet do 100%.',
    62472: 'Opakované Kategória má priradený. Odstráňte ho a znova vykonajte uloženie.',
    62473: 'Žiadna kategória je k dispozícii. Prosím, choďte na spoločnosť Info Panel pre konfiguráciu.',
    62474: 'Aspoň jeden kategóriu má priradené k procesu toku.',
    62475: 'Kategória',
    62476: 'Skontrolujte, či pole kategórie toku procesu. Máte tej istej kategórie (case-insensitive) vstúpil.',
    62477: 'Súbor úspešne odstránený.',
    62495: 'Viacnásobný výber',
    62496: 'Verzia Nr.',
    62497: 'Uzamknutý pre úpravy',
    62498: 'Riadok: ',
    62499: 'Stĺpec: ',
    62500: 'Transakcia zlyhala',
    62501: 'Prevádzka popis',
    62502: 'Cena zoznam kód',
    62503: 'Ceny komentár',
    62504: 'Jednotkové ceny',
    62505: 'Prevádzka cena',
    62506: 'Neplatný vstup pre začatie hodnota',
    62507: 'Neplatný vstup pre ukončenie hodnotu',
    62508: 'Neplatný vstup pre jednotkovú cenu',
    62509: 'Nemôžete nájsť ceny pre požadovanú operáciu; KÓD OPERÁCIE: ',
    62510: 'Zadajte kód pre cenník',
    62511: 'Zadajte prosím kód operácie',
    62512: 'Vyberte menu',
    62513: 'Vyberte cien jednotky',
    62514: 'Jednotka pre určovanie cien nie je platný',
    62515: 'Minimálna cena nie je nastavený alebo nie je platný',
    62516: 'Nie je vybratý cenník',
    62517: 'Cenník chýba cenové politiky',
    62518: 'Cenová politika má medzery alebo nejasnosť',
    62519: 'Koncová hodnota musí byť väčšia než hodnota začína',
    62520: 'Nemôže nájsť cenník',
    62521: 'Množstve alebo hmotnosti musí byť uvedené',
    62522: 'Menách sa nezhodujú, konverzie uplatniť',
    62523: 'Menách sa nezhodujú, konverzie nie sú podporované',
    62524: 'Ceny jednotky nezodpovedajú - konverzie uplatniť',
    62525: 'Ceny jednotky nezodpovedajú - konverzie nie sú podporované',
    62526: 'Parameter už existuje',
    62527: 'Shop objednávky časť dokončenie',
    62528: 'Menu nie je povolená',
    62529: 'Prosím skontrolujte a odstrániť alebo zrušiť',
    62530: 'Vlastné',
    62531: 'Predvolené cena',
    62532: 'Reálne náklady',
    62533: 'Cena starý/zakázané',
    62534: 'Zvýšenie/zníženie cien',
    62535: 'Zmena ceny [%]: ',
    62536: 'Spôsob určenia ceny',
    62537: 'Táto operácia je archivovaný. Prosím, odstráňte ho z tohto procesu toku.',
    62538: 'Prosím odstrániť alebo nahradiť všetky operácie ARCHIVOVANÉ z tohto procesu toku.',
    62539: 'Zátvorkách',
    62540: 'Stabilné držiaky',
    62541: 'Upravte kód toku, aby odrážali novú revíziu".',
    62542: 'Nemôžete vykonať túto operáciu: tok je archivované alebo modifikovateľné. ',
    62543: 'Tieto časti sú aktualizované s touto novou verziou z procesu toku: ',
    62544: 'Toto vytvorí novú verziu procesu toku a aktualizovať častí (archivované toku sa nahradí Novovytvorenej verzii). Chcete pokračovať? ',
    62550: 'Merné jednotky',
    62551: 'Skupiny opatrenie',
    62552: 'Percento jednotiek',
    62553: 'Dĺžka jednotky',
    62554: 'Hmotnosť jednotky',
    62555: 'Objemové jednotky',
    62556: 'Tvrdosť jednotky',
    62557: 'Povrchové tvrdosť jednotky',
    62558: '',
    62559: '',
    62560: 'Meny',
    62561: 'Kus počítať ',
    62563: 'Jednotky teploty',
    62564: 'Jednotky tlaku',
    62565: 'Jednotky času',
    62566: 'Temperature Ramp Units',
    62589: '°C/h',
    62590: 'deg C/hour',
    62591: '°C/min',
    62592: 'deg C/minute',
    62593: '°C/sec',
    62594: 'deg C/second',
    62595: '°F/h',
    62596: 'deg F/hour',
    62597: '°F/min',
    62598: 'deg F/minute',
    62599: '°F/sec',
    62600: 'deg F/second',
    62601: 'mi',
    62602: 'Mile',
    62603: 'km',
    62604: 'kilometer',
    62605: 'm',
    62606: 'meter',
    62607: 'metrov',
    62608: 'nohy',
    62609: 'v',
    62610: 'palec',
    62611: 'ty',
    62612: '0,001 v',
    62613: 'µm',
    62614: 'mikrometrový',
    62615: 't',
    62616: 'tona',
    62617: 'kg',
    62618: 'kilogram',
    62619: 'g',
    62620: 'gram',
    62621: 'LB',
    62622: 'Libra',
    62623: 'KGF',
    62624: 'kilogram sily',
    62625: 'LBF',
    62626: 'libra sily',
    62627: 'm³',
    62628: 'kubický meter',
    62629: 'barel',
    62630: 'barel',
    62631: 'Gal',
    62632: 'galón',
    62633: 'cu ft',
    62634: 'kubických metrov',
    62635: 'l',
    62636: 'liter',
    62637: 'cu v',
    62638: 'kubický palec',
    62639: 'ml',
    62640: 'Mililitre',
    62641: '% ',
    62642: 'percent',
    62643: '‰ ',
    62644: 'permille',
    62645: 'ppm',
    62646: 'Parts per million ',
    62647: 'PC. ',
    62648: 'kus',
    62649: 'DZ.',
    62650: 'tucet',
    62651: 'x 100',
    62652: 'stovky',
    62653: 'x 1000',
    62654: 'tisíc',
    62655: '° C',
    62656: 'Celzia',
    62657: '° F',
    62658: 'Fahrenheit',
    62659: 'Bar',
    62660: 'Bar',
    62661: 'Psy',
    62662: 'libra sily na štvorcový palec',
    62663: 'Torr',
    62664: 'mmHg',
    62665: 'mbar',
    62666: 'mbar',
    62667: 'mm',
    62668: 'mm',
    62669: '',
    62670: '',
    62671: 'x 1000000 ',
    62672: 'milióny',
    62673: '',
    62674: '',
    62675: '',
    62676: '',
    62677: '',
    62678: '',
    62679: '',
    62680: '',
    62681: 'rok',
    62682: 'rok',
    62683: 'mesiac',
    62684: 'mesiac',
    62685: 'h',
    62686: 'hodinu. ',
    62687: 'min.',
    62688: 'minút',
    62689: 'SEC.',
    62690: 'druhá',
    62691: '',
    62692: '',
    62693: '',
    62694: '',
    62695: '',
    62696: '',
    62697: '',
    62698: '',
    62699: '',
    62700: '',
    62701: 'HV',
    62702: 'Vickersova tvrdosť',
    62703: 'HV/0,1 ',
    62704: 'Vickers tvrdosť HV/0.1 kgf',
    62705: 'HV/0,2 ',
    62706: 'Vickers tvrdosť HV/0,2 kgf',
    62707: 'HV/0,3 ',
    62708: 'Vickers tvrdosť HV/0,3 kgf',
    62709: 'HV/0,4 ',
    62710: 'Vickers tvrdosť HV/0,4 kgf',
    62711: 'HV/0,5 ',
    62712: 'Vickers tvrdosť HV/0,5 kgf',
    62713: 'HV/0.6 ',
    62714: 'Vickers tvrdosť HV/0.6 kgf',
    62715: 'HV/0.7 ',
    62716: 'Vickers tvrdosť HV/0,7 kgf',
    62717: 'HV/0,8 ',
    62718: 'Vickers tvrdosť HV/0,8 kgf',
    62719: 'HV/0,9 ',
    62720: 'Vickers tvrdosť HV/0,9 kgf',
    62721: 'HV/1 ',
    62722: 'Vickers tvrdosť HV/1 kgf',
    62723: 'HV/10 ',
    62724: 'Vickers tvrdosť HV/10 kgf',
    62725: 'HV/20 ',
    62726: 'Vickers tvrdosť HV/20 kgf',
    62727: 'HV/30 ',
    62728: 'Vickers tvrdosť HV/30 kgf',
    62729: 'HV/40 ',
    62730: 'Vickers tvrdosť HV/40 kgf',
    62731: 'HV/50 ',
    62732: 'Vickers tvrdosť HV/50 kgf',
    62733: 'HV/60 ',
    62734: 'Vickers tvrdosť HV/60 kgf',
    62735: 'HV/70 ',
    62736: 'Vickers tvrdosť HV/70 kgf',
    62737: 'HV/80 ',
    62738: 'Vickers tvrdosť HV/80 kgf',
    62739: 'HV/90 ',
    62740: 'Vickers tvrdosť HV/90 kgf',
    62741: 'HV/100 ',
    62742: 'Vickers tvrdosť HV/100 kgf',
    62743: 'HR',
    62744: 'Tvrdosti Rockwell',
    62745: 'HRA',
    62746: 'Rockwell tvrdosť/Diamond kužeľ / 60 kgf ',
    62747: 'HRB',
    62748: 'Tvrdosti Rockwell / 1/16 "oceľové gule 100 kgf',
    62749: 'HRC',
    62750: 'Rockwell tvrdosť/Diamond kužeľ / 150 kgf ',
    62751: 'RLZ',
    62752: 'Rockwell tvrdosť/Diamond kužeľ 100 kgf ',
    62753: 'HRE',
    62754: 'Tvrdosti Rockwell / 1/8 "oceľová gulička 100 kgf',
    62755: 'HRF',
    62756: 'Tvrdosti Rockwell / 1/16 "oceľové gule / 60 kgf',
    62757: 'HRG',
    62758: 'Tvrdosti Rockwell / 1/16 "oceľové gule / 150 kgf',
    62759: 'HRH',
    62760: 'Tvrdosti Rockwell / 1/8 "oceľová gulička / 60 kgf',
    62761: 'HRK',
    62762: 'Tvrdosti Rockwell / 1/8 "oceľová gulička / 150 kgf',
    62763: 'HRL',
    62764: 'Tvrdosti Rockwell / 1/4 "oceľová gulička / 60 kgf',
    62765: 'HRM',
    62766: 'Tvrdosti Rockwell / 1/4 "oceľová gulička 100 kgf',
    62767: 'HRP',
    62768: 'Tvrdosti Rockwell / 1/4 "oceľová gulička / 150 kgf',
    62769: 'HRR',
    62770: 'Tvrdosti Rockwell / 1/2 "oceľové gule / 60 kgf',
    62771: 'HRS',
    62772: 'Tvrdosti Rockwell / 1/2 "oceľové gule 100 kgf',
    62773: 'HRV',
    62774: 'Tvrdosti Rockwell / 1/2 "oceľové gule / 150 kgf',
    62775: 'HR 15 N',
    62776: 'Povrchné tvrdosti Rockwell/Diamond kužeľ/15 kgf',
    62777: 'HR 30 N',
    62778: 'Povrchné tvrdosti Rockwell/Diamond kužeľ/30 kgf',
    62779: 'HR 45 N',
    62780: 'Povrchné tvrdosti Rockwell/Diamond kužeľ/45 kgf',
    62781: 'HR 15 T',
    62782: 'Rockwell Povrchové tvrdosť/1/16"oceľové gule/15 kgf',
    62783: 'HR 30 T',
    62784: 'Rockwell Povrchové tvrdosť/1/16"oceľové gule/30 kgf',
    62785: 'HR 45 T',
    62786: 'Rockwell Povrchové tvrdosť/1/16"oceľové gule/45 kgf',
    62787: 'HR 15 W ',
    62788: 'Rockwell Povrchové tvrdosť/1/8"oceľové gule/15 kgf',
    62789: 'HR 30 W ',
    62790: 'Rockwell Povrchové tvrdosť/1/8"oceľové gule/30 kgf',
    62791: 'HR 45 W ',
    62792: 'Rockwell Povrchové tvrdosť/1/8"oceľové gule/45 kgf',
    62793: 'HR 15 X ',
    62794: 'Oceľová guľa/15 kgf Rockwell Povrchové tvrdosť/1/4',
    62795: 'HR 30 X ',
    62796: 'Oceľová guľa/30 kgf Rockwell Povrchové tvrdosť/1/4',
    62797: 'HR 45 X ',
    62798: 'Oceľová guľa/45 kgf Rockwell Povrchové tvrdosť/1/4',
    62799: 'Y HR 15',
    62800: 'Rockwell Povrchové tvrdosť/1/2"oceľové gule/15 kgf',
    62801: 'Y HR 30',
    62802: 'Rockwell Povrchové tvrdosť/1/2"oceľové gule/30 kgf',
    62803: 'Y HR 45',
    62804: 'Rockwell Povrchové tvrdosť/1/2"oceľové gule/45 kgf',
    62805: 'BHN',
    62806: 'Tvrdosť podľa Brinella číslo',
    62807: 'HB 10/500/15 ',
    62808: 'Tvrdosť podľa Brinella 10 mm oceľové gule/500 kgf / 15 sec ',
    62809: 'HB 10/1500/15 ',
    62810: 'Tvrdosť podľa Brinella 10 mm oceľové gule/1500 kgf / 15 sec ',
    62811: 'HB 10/3000/15 ',
    62812: 'Tvrdosť podľa Brinella 10 mm oceľové gule/3000 kgf / 15 sec ',
    62813: 'HB 10/500/10 ',
    62814: 'Tvrdosť podľa Brinella 10 mm oceľové gule/500 kgf / 10 sec ',
    62815: 'HB 10/1500/10 ',
    62816: 'Tvrdosť podľa Brinella 10 mm oceľové gule/1500 kgf / 10 sec ',
    62817: 'HB 10/3000/10 ',
    62818: 'Tvrdosť podľa Brinella 10 mm oceľové gule/3000 kgf / 10 sec ',
    62819: 'HB 6/500/15 ',
    62820: 'Tvrdosť podľa Brinella 6 mm oceľové gule/500 kgf / 15 sec ',
    62821: 'HB 6/1500/15 ',
    62822: 'Tvrdosť podľa Brinella 6 mm oceľové gule/1500 kgf / 15 sec ',
    62823: 'HB 6/3000/15 ',
    62824: 'Tvrdosť podľa Brinella 6 mm oceľové gule/3000 kgf / 15 sec ',
    62825: 'HB 6/500/10 ',
    62826: 'Tvrdosť podľa Brinella 6 mm oceľové gule/500 kgf / 10 sec ',
    62827: 'HB 6/1500/10 ',
    62828: 'Tvrdosť podľa Brinella 6 mm oceľové gule/1500 kgf / 10 sec ',
    62829: 'HB 6/3000/10 ',
    62830: 'Tvrdosť podľa Brinella 6 mm oceľové gule/3000 kgf / 10 sec ',
    62831: 'HK',
    62832: 'Knoop tvrdosti číslo',
    62833: 'HK 200 ',
    62834: 'Knoop tvrdosti číslo / 200gf / 10 sec ',
    62835: 'HK 500 ',
    62836: 'Knoop tvrdosti číslo / 500gf / 10 sec ',
    62837: 'HK 50 ',
    62838: 'Knoop tvrdosti číslo / 50gf / 10 sec ',
    62839: 'HK 100 ',
    62840: 'Knoop tvrdosti číslo / 100gf / 10 sec ',
    62849: 'PSY',
    62850: 'Pevnosť v ťahu 1 lb/námestie palec',
    62851: 'KPSI',
    62852: 'Pevnosť v ťahu 1000 lb/námestie palec',
    62853: 'MPa',
    62854: 'Pevnosť v ťahu MPa',
    62855: 'N/mm2',
    62856: 'Tensile strength  N/mm2',
    62871: '$ ',
    62872: 'Dolár',
    62873: 'CAD',
    62874: 'Kanadský dolár',
    62875: 'USD',
    62876: 'Spojené štáty dolár',
    62877: '€ ',
    62878: 'EUR',
    62879: 'AUD',
    62880: 'Austrálsky dolár',
    62881: 'BYR',
    62882: 'Bieloruský rubeľ',
    62883: 'INR',
    62884: 'Indická rupia',
    62885: 'BRL',
    62886: 'Brazílsky real',
    62887: 'CLP',
    62888: 'Čílske peso',
    62889: 'CNY',
    62890: 'Čínsky jüan (yuan)',
    62891: 'PKR',
    62892: 'Pakistanská rupia',
    62893: 'ILS',
    62894: 'Izraelský šekel',
    62895: 'JPY',
    62896: 'Japonský jen',
    62897: 'PYG',
    62898: 'Peruánsky Peruvský sol',
    62899: 'zł',
    62900: 'Poľských zlotých',
    62901: 'SAR',
    62902: 'Saudský riál',
    62903: 'RUB',
    62904: 'Ruský rubeľ',
    62905: 'RP',
    62906: 'Indonézska rupia',
    62907: 'IRR',
    62908: 'Iránsky rial',
    62909: '₩ ',
    62910: 'Južná kórejský vyhral',
    62911: 'د.ك ',
    62912: 'Kuvaitský dinár',
    62971: 'FR',
    62972: 'Frank',
    62973: '$',
    62974: 'Peso',
    62975: 'ЛВ',
    62976: 'Bulharský leva nový',
    62977: '',
    62978: '',
    62979: '',
    62980: '',
    62981: 'Vyhľadávanie',
    62982: 'Použitie',
    62983: 'Používanie rozsah',
    62984: 'Od',
    62985: 'Boolovská hodnota',
    62986: 'True',
    62987: 'Falošné',
    62988: 'Neplatné údaje',
    62989: 'Naposledy upravil',
    62990: 'Poslal',
    62991: 'Stránka: ',
    62992: '',
    62993: 'Schválené',
    62994: 'a',
    62995: 'alebo',
    62996: 'Uplynutí',
    62997: 'Záznam sa momentálne upravuje iný používateľ',
    62998: 'Zariadenie sa nevyžaduje',
    62999: 'Zariadenie je vypnuté',
    63000: 'Sú vyplnené všetky povinné polia pre lodné spoločnosti',
    63001: 'Prepravná spoločnosť kód je potrebné',
    63002: 'Záznam sa nedá vložiť. Prepravná spoločnosť kód už existuje',
    63003: 'Doba platnosti je potrebné',
    63004: 'Pridať',
    63005: 'Zmazať',
    63006: 'Obnoviť',
    63007: 'Zaradiť',
    63008: 'Posunúť nadol',
    63009: 'Predchádzajúcu stránku',
    63010: 'Ďalšia stránka',
    63011: 'Pridať',
    63012: 'Odstrániť',
    63013: 'Klon',
    63014: 'Pohyb doľava',
    63015: 'Posunúť doprava',
    63016: 'Export',
    63018: 'Naložiť',
    63019: 'Cena',
    63848: 'Naposledy upravil',
    63849: 'podľa',
    63850: 'Shop Pilot',
    63851: 'Poslal ',
    63852: 'Potvrdí citát bol odoslaný na tento dátum bude zakázať vypustenie alebo akékoľvek zmeny v ponuke v budúcnosti. Ste si istí?',
    63853: 'Vytvoril',
    63854: 'Naposledy upravil',
    63855: 'Operácie',
    63856: 'Toky',
    63857: 'Časti',
    63858: 'Časť číslo',
    63859: 'Opis materiálu',
    63861: 'Materiál',
    63862: 'Popis',
    63863: 'Schváleného',
    63864: 'P/O č.',
    63865: 'Dostal na',
    63866: 'NEPOUŽÍVA',
    63867: 'Poslednom prehodnotení',
    63868: 'Už bola priradená suvenírmi časť kód zadaný pre túto novú časť a časť bol archivovaný',
    63869: 'Nepodarilo sa načítať údaje',
    63870: 'Nie je možné uzamknúť Priceschema',
    63871: 'Časť Detail',
    63872: 'Vyberte materiál',
    63873: 'Záznam nie je možné uzamknúť pre editáciu',
    63874: 'Vybratá časť',
    63875: 'Súčasťou rovnakého procesu toku už vybrali',
    63876: 'Požadované doručenie',
    63877: 'Sľub dátum',
    63878: 'Časť už',
    63879: 'Vybrané toky',
    63880: 'K dispozícii toky',
    63881: 'Primárne',
    63882: 'Stav',
    63883: 'Zlyhala',
    63884: 'Žiadny proces toku nastaviť na primárne',
    63885: 'Zadajte prosím kód časť dielne',
    63886: 'Aktívny',
    63887: 'Testovanie',
    63900: 'Faktúry',
    63901: 'Faktúry',
    63902: 'PO',
    63903: 'Dátum fakturované',
    63904: 'Celkom fakturované',
    63905: 'Platby',
    63906: 'Vytvorené na',
    63907: 'Zmenené na',
    63908: 'Podľa',
    63909: 'Celkové',
    63910: 'Faktúry, ktoré boli odoslané, môžu už upravovať alebo odstraňovať.',
    63911: 'Komentár',
    63912: 'Fakturácia položky',
    63913: 'Invoiceable položky',
    63914: 'Jednotková cena',
    63915: 'Faktúry už',
    63916: 'Nájdených duplicitných rôzne poplatky',
    63917: 'Množstvo',
    63918: 'Dátum prijatia',
    63919: 'Identifikácia platby',
    63920: 'Platba už existuje',
    63921: 'Rôzne Popis chýba',
    63922: 'Rôzne celkom chýba',
    63923: 'Kód fakturačnej je potrebné',
    63924: 'Rozhodli ste sa poslať faktúru. Tým sa zabráni akékoľvek budúce zmeny. Chcete pokračovať?',
    63925: 'Ospravedlňujeme sa, ale nemáte povolenie na uloženie faktúry',
    63926: 'Položka misc.',
    63927: 'Neuhradené faktúry',
    63928: 'Vynikajúci',
    63929: 'Neplatný platba suma',
    63930: 'Create Supplemental Invoice',
    63931: 'musia byť prítomné vo formáte',
    63932: 'Moduly, ktoré sú/boli pomocou',
    63933: 'Modulov, ktoré nie sú pomocou',
    63934: 'Min Counter číslica',
    63935: 'Voľbu vynulovať počítadlo',
    63936: 'Counter Reset / začať od',
    63937: 'Žiadne Reset',
    63938: 'Obnoviť podľa roka',
    63939: 'Obnoviť podľa mesiaca',
    63940: 'Obnovenie deň',
    63941: 'Automatické generovanie kľúčov',
    63942: 'Názov modulu',
    63943: 'Predpona',
    63944: 'Prípona',
    63945: 'Formát',
    63946: 'Oddeľovač',
    63947: 'Počítadlo typu',
    63948: 'Počítadlo',
    63949: 'Funkciu Auto kľúčom už bola povolená v iný užívateľ',
    63950: 'Neplatný formát. Opraviť medzery prosím.',
    63951: 'Prepravná spoločnosť kód',
    63952: 'Prepravná spoločnosť meno',
    63953: 'Kontaktná osoba',
    63954: 'Nové lodné spoločnosti bol úspešne uložený',
    63955: 'Prepravná spoločnosť bol •speÜne aktualizovan²',
    63958: 'Zákonníka',
    63959: 'Poštovné/vyzdvihnutí eurovej dátum',
    63960: 'Sledovacie číslo',
    63961: 'Prepravné náklady hradí',
    63962: 'Služba typu',
    63963: 'Prepravné náklady',
    63964: 'Celkový objem',
    63965: 'Identifikáciu kontajnera',
    63966: 'Vybrané časti',
    63967: 'Uložiť dopravu',
    63968: 'Zákonníka už existuje',
    63969: 'Potvrdené',
    63970: 'Prepravné informácie zákazníka',
    63971: 'WT',
    63972: 'Prijímač',
    63973: 'Dodávka tovaru',
    63974: 'Položku je potrebné',
    63975: 'Novú dodávku bol úspešne uložený',
    63976: 'Dodávka bol •speÜne aktualizovan²',
    63977: 'Už existuje položka',
    63978: 'Množstvo musí byť väčšie ako nula',
    63979: 'Celková GR WT dodávané',
    63980: 'Celková NT WT dodávané',
    63981: 'Prijať sklzu nie.',
    63982: 'Potvrdenie dodávky/vyzdvihnutí toto dňu zakáže vymazaní alebo akejkoľvek zmene. Stlačte tlačidlo Uložiť pokračovať.',
    63983: 'Ošetrené časti',
    63984: 'Neliečené časť',
    63985: 'Ostatné položky',
    63986: 'Táto zásielka už bola potvrdená. Bez odstránenia alebo ďalšie modifikácie je povolené.',
    63987: 'Dávkové ID už existuje.',
    63988: 'Množstve alebo hmotnosti musí byť väčšia ako nula.',
    63989: 'Dávky',
    63990: 'Dodávka bola úspešne odstránená',
    63991: 'Pozbierať',
    63992: 'Všetky zadané údaje stratia výberom iného zákazníka. Vyberte Áno continu.',
    63993: 'Všetky zadané údaje budú stratené výberom Áno jasné zákazníkov',
    63994: 'Clear zákazníka',
    63995: 'Vyberte lodná spoločnosť',
    63996: 'Vyberte objednávku Shop',
    63997: 'Nie je vybratý jednotkovú hmotnosť',
    63998: 'Množstvo nie je vybratá jednotka',
    63999: 'K dispozícii dodacích adries',
    64000: 'Vyberte adresu pre doručenie',
    64001: 'Najprv vyberte zákazníka',
    64002: 'Žiadna adresa dopravu od zákazníka je k dispozícii, by ste chceli nahrať obchodnú adresu?',
    64003: 'Aktuálny záznam už neexistuje.',
    64004: 'PDF pre náhľad alebo e-mailom',
    64005: 'Vyberte šablónu zostavy',
    64006: 'Prosím zostavu uložiť a potom zatvorte program predvolené PDF reader',
    64007: 'Lodná dopravná spoločnosť je už vybratý, ho prepísať predvolené lodná spoločnosť od zákazníka?',
    64008: 'Je k dispozícii žiadna lodné adresa od zákazníka, primárne obchodnej adresy sa nahrá',
    64009: 'Naozaj chcete zahodiť zmeny a skončiť úpravu formulára?',
    64010: 'Zákonníka spoločnosť (použitie "rovnosť" a zanechať prázdne políčko pre Pick-Up)',
    64011: 'Naozaj chcete odstrániť túto položku?',
    64012: 'Je zadaný neplatný počet',
    64013: 'Odstránením časti vybraté, hrubá hmotnosť a kontajner informácie stratia. Pokračovať?',
    64014: 'Hrubá hmotnosť je nižšia ako čistá hmotnosť na zvýraznenú časť, ignorovať? ',
    64015: 'Túto položku nemožno odstrániť',
    64016: 'Databázový stroj nie je podporovaný generátor zostáv',
    64017: 'Mnž poškodené',
    64018: 'Diely z výroby',
    64019: 'Súčet množstiev dodať a odoslané (poškodená) tejto časti musí byť menšia alebo rovná',
    64020: 'By ste chceli mať celkové množstvo a celková hmotnosť prepočítavané a aktualizované? ',
    64021: 'Celková hrubá hmotnosť je menšia než celková hmotnosť netto, by ste chceli pokračovať?',
    64022: 'Celkové množstvo dodané',
    64023: 'Lodné inšpekcie (použitie _ oddeliť medzi kritériá)',
    64024: 'Nie všetky kritéria kontroly boli ukončené',
    64025: 'Receiving Inspection  (Use _ to separate in between criteria)',
    64026: 'List of Countries  (Use _ to separate)',
    64056: 'Meno kontaktu 1 ',
    64057: 'Kontaktné telefónne číslo 1 ',
    64058: 'Kontaktný telefón Ext. 1 ',
    64059: 'Kontakt Fax číslo 1 ',
    64060: 'Kontaktný E-mail 1 ',
    64061: 'Meno kontaktu 2 ',
    64062: 'Kontaktné telefónne číslo 2 ',
    64063: 'Kontaktný telefón Ext. 2 ',
    64064: 'Kontakt Fax č 2 ',
    64065: 'Kontaktný E-mail 2 ',
    64066: 'Meno kontaktu 3 ',
    64067: 'Kontaktné telefónne číslo 3 ',
    64068: 'Kontaktný telefón Ext. 3 ',
    64069: 'Kontakt Fax číslo 3 ',
    64070: 'Kontaktný E-mail 3 ',
    64071: 'Automatické rozpoznávanie čiarového kódu: meno používateľa predpona ',
    64072: 'Auto detect čiarový kód: heslo používateľa predpona ',
    64073: 'Automatické rozpoznávanie čiarového kódu: Predpona Shop objednávky ',
    64074: 'Automatické rozpoznávanie čiarového kódu: Predpona krok číslo objednávky ',
    64075: 'Automatické rozpoznávanie čiarového kódu: Predpona zariadenia ',
    64076: 'Automatické rozpoznávanie čiarového kódu: skener predpona (kód Ascii) ',
    64077: 'Automatické rozpoznávanie čiarového kódu: skener prípona (kód Ascii) ',
    64078: 'Účty pohľadávok číslo pre Peachtree',
    64079: 'Daň typu číslo pre Peachtree',
    64081: 'Názov',
    64082: 'Správa citát: Komentár 1 ',
    64083: 'Správa citát: Komentár 2 ',
    64084: 'Citácia správa: nákup Adresa objednávky ',
    64085: 'Citácia správa: prijímanie adresu ',
    64086: 'Správe: Komentár 1 ',
    64087: 'REŽIM ÚPRAV',
    64088: 'Zmeny boli vykonané úspešne. Chceli by ste skončiť režim úprav?',
    64089: 'Obchod zostava Objednané: Komentár 1 ',
    64090: 'Produkcia správy: Komentár 1 ',
    64091: 'Lab hodnotiaca správa: Komentár 1 ',
    64092: 'Lodné správa: Komentár 1 ',
    64093: 'Fakturácie správa: Komentár 1 ',
    64094: 'Povoliť viacero procesov tokov v obchode objednávky',
    64095: 'Automatické vyplnenie lab Hodnotenie položky',
    64099: 'Schopný automaticky generovať kľúč',
    64100: 'Certifikačný kód',
    64101: 'Vydané dňa',
    64102: 'Vydané',
    64103: 'Mnoho ID',
    64104: 'ID vzorky Označte',
    64105: 'Mount ID',
    64106: 'Chcete odstrániť túto položku z certifikát?',
    64107: 'Chcete pridať túto položku do certifikát?',
    64108: 'Osvedčenia sa zmenila. Naozaj chcete zahodiť zmeny?',
    64109: 'Tam je žiadne hodnotiace laboratórium k dispozícii pre osvedčenia.',
    64110: 'Vyberte laboratórium hodnotenia',
    64111: 'Prosím, vyberte jednu alebo viac častí tohto certifikátu',
    64112: 'Vytvorte certifikát',
    64113: 'Certifikát nie je možné vydať bez výsledkov testu.',
    64114: 'Vydaním tohto certifikátu bude zakázať akékoľvek ďalšie zmeny alebo odstránenia.',
    64115: 'Ak odstránite tento záznam nemožno prístup znova.',
    64116: 'Naozaj chcete pokračovať?',
    64122: 'Certifikačný kód už existuje',
    64123: 'Chcete uložiť zmeny pred obnovením?',
    64124: 'Uložte zmeny',
    64133: 'Dane sa používa daňová politika',
    64134: 'Proces toky',
    64135: 'Nie je možné zmeniť, typ operácie sa v súčasnosti priraďuje ',
    64136: 'Nepodarilo sa odstrániť typ operácie zo zariadenia. Zariadení v súčasnosti používaných v schedualing',
    64137: 'Uložte zmeny pred tlačou',
    64138: 'Vyskytla sa chyba, ktorá vám bráni pokračovať. Okná musia byť zatvorené. Prosím skúste to znova.',
    64139: 'Upraviť úspešné',
    64140: 'Chcete uložiť zmeny pred zatvorením?',
    64141: 'Pridať/upraviť/odstrániť materiály',
    64142: 'Pridať/upraviť/zmazať procesov tokov',
    64143: 'Výška obchod',
    64144: 'Percento',
    64145: 'Fakturovaná čiastka',
    64146: 'Celkom fakturované',
    64147: 'Dane',
    64148: 'Dane meno',
    64149: 'Základná čiastka',
    64150: 'Zápis názvu',
    64151: 'Registračné číslo.',
    64152: 'Percent',
    64153: 'Percenta dane musí byť Strúhadlo nula',
    64154: 'Existuje dane meno',
    64155: 'Daňová politika',
    64156: 'Názov politiky',
    64157: 'Výška dane',
    64158: 'Uplatňovať na úrovni',
    64159: 'Neplatná politika meno',
    64160: 'Manditory pole bolo zistené prázdne',
    64161: 'Daňová politika už',
    64162: 'Medzisúčet',
    64163: 'Schopný vypočítať cenu. Overenie schémy cenu.',
    64164: 'Cena na základe',
    64165: 'Číslo projektu',
    64166: 'Všetky zakázané',
    64167: 'Číslo dávky',
    64168: 'Stav objednávky obchod',
    64169: 'V akej dobe?',
    64170: 'Pridať veľa',
    64171: 'Odstránenie krok',
    64172: 'Odstrániť veľa',
    64173: 'Vložiť krok',
    64174: 'Výrobné kroky',
    64175: 'Veľa kompletný',
    64176: 'Žiadne ďalšie časti dostupné',
    64177: 'Všetky diely boli liečení pre túto dávku. Pokračovanie označí túto dávku nie je možné upravovať. Pokračovať?',
    64178: 'Neplatné množstvo alebo hmotnosť pre nasledujúci krok: ',
    64179: 'Veľa musí mať aspoň jednu časť.',
    64180: 'Veľa',
    64181: 'Neplatný vstup na adrese',
    64182: 'Prosím, zadajte dátum začiatku.',
    64183: 'Neplatný dátum začiatku.',
    64184: 'Zadajte prosím zariadenia.',
    64185: 'Prosím zadať spracovanie.',
    64186: 'Neplatná súčasť množstve alebo hmotnosti pre nasledujúci krok: ',
    64187: 'Zadajte subjekt pre začiatok.',
    64188: 'krok',
    64189: 'Čas ukončenia musí byť väčšia než jej začiatok.',
    64190: 'Množstvo alebo hmotnosť dávky musí byť väčšia ako nula.',
    64191: 'Čas ukončenia nesmie prekročiť aktuálny dátum a čas.',
    64192: 'Nie je možné upraviť. Táto dávka je kompletný.',
    64193: 'Zadajte časť".',
    64194: 'Nepodarilo sa vložiť krok po poslednom kroku, ak obsahuje veľa ošetrené časti.',
    64195: 'Nepodarilo sa odstrániť krok.',
    64196: 'Nepodarilo sa odstrániť veľa.',
    64197: 'Nepodarilo sa vložiť krok pred krok',
    64198: 'To obsahuje veľa.',
    64199: 'Dávka môže obsahovať iba častí pomocou rovnakého procesu toku.',
    64200: 'Nepodarilo sa odstrániť časť z dávky.',
    64201: 'Je potrebné vybavenie, ale nikto sa zdajú byť k dispozícii.',
    64202: 'Pridať súčasť',
    64203: 'Odstrániť časť',
    64204: 'Časť množstva a hmotnosti musí byť väčšia ako nula.',
    64205: 'Nepodarilo sa pridať časť. Veľa je hotová.',
    64206: 'Nepodarilo sa odstrániť veľa. Niektoré časti boli ošetrené.',
    64207: 'Daňové úrovne je prázdne',
    64208: 'Pole Názov dane je prázdne',
    64209: 'Použiť pole je prázdne',
    64210: 'Táto časť presahuje jeho dávku časť max množstve alebo hmotnosti',
    64211: 'Krok',
    64212: 'Časť',
    64213: 'Chýba začiatok',
    64214: 'Musíte vymazať čas ukončenia prvej',
    64215: 'Nastavenie dátumu ukončenia zabráni akékoľvek budúce zmeny tejto dávky. Pokračovať?',
    64216: 'Žiadne diely k dispozícii',
    64217: 'Zvoľte čas spustenia dávky.',
    64218: 'Čas začiatku jasné dávky.',
    64219: 'Vyberte dávky koniec.',
    64220: 'Čas ukončenia jasné dávky.',
    64221: 'Vyberte úroveň prvýkrát.',
    64222: 'Neplatná úroveň.',
    64223: 'Daní v rovnakej úrovni musia byť jedinečné.',
    64224: 'Musí mať aspoň jeden dane.',
    64225: 'Sa nedá odstrániť. Daňová politika používa.',
    64226: 'Musí mať aspoň Štart čas s cieľom schváliť veľa.',
    64227: 'Musí byť neschválených pred zmenou začiatok.',
    64228: 'Zadajte subjekt pre koniec času.',
    64229: 'Automatické dokončovanie',
    64230: 'Shop objednať je už schválený, obnovte údaje',
    64251: 'Požiadavka parametra',
    64252: 'Test typu k dispozícii',
    64253: 'Jednotka k dispozícii',
    64254: 'Jednotková skupina',
    64255: 'Požiadavka nastaviť kód',
    64256: 'Požiadavku smernice',
    64257: 'Parameter',
    64258: 'Test typu',
    64259: 'Požiadavka Parameter je povinný',
    64260: 'Najmenej jeden Parameter požiadavka je povinný',
    64261: 'Požiadavka nastaviť kód je potrebné',
    64262: 'Upozornenie - aspoň jeden Test typu a jednu jednotku doplniť pre vybratý Parameter požiadavka ako bude môcť byť priradená požiadavka sada',
    64300: 'Obraz',
    64301: 'Načítať obrázok zo súboru',
    64302: 'Jasný obraz',
    64303: 'Nedá sa načítať obrázok',
    64304: 'Kliknite na obrázok pre zväčšenie',
    64305: 'Nič vložiť',
    64306: 'Žiadny obraz',
    64307: '',
    64308: 'Číslo revízie.',
    64309: 'Sa nedá odstrániť. Súčasť sa používa.',
    64310: 'Načítať z požiadavka nastaviť šablóny',
    64311: 'Skúška typu je potrebné',
    64312: 'Načítať obrázok zo schránky',
    64313: 'Schopný pochopiť obrázok!',
    64314: 'Tento obraz má príliš veľa pamäte!',
    64315: 'Prosím zmenšiť rozmery alebo komprimovať ho a skúste to znova.',
    64316: 'Maximálna pamäť požiadavka obrázky, v bytoch, je: ',
    64317: 'Požiadavky na pamäť pre tento obraz, v bytoch, je: ',
    64318: 'Som bol schopný znížiť požiadavky na pamäť pre obrázok: ',
    64325: 'Vybrané jednotky',
    64326: 'Dostupné merné jednotky',
    64327: 'Skupina',
    64328: 'Proces toku kategórie',
    64329: 'Kategória percento',
    64330: 'Kategórie nákladov',
    64331: 'Upozornenie, upravujete faktúru, ktorá je založená na procese tok s žiadne náklady kategórie priradené k nemu.',
    64340: 'Predaj',
    64341: 'Správa štatistiky: predaj zákazníkom ',
    64342: 'Správa štatistiky: predaj podľa kategórie ',
    64343: 'Správa štatistiky: predajné vybavenie ',
    64400: 'Čiarový kód',
    64401: 'Shop objednávací kód je prázdne',
    64402: 'Číslo šarže je prázdne',
    64403: 'Číslo pobočky je prázdne',
    64404: 'Číslo kroku je prázdne',
    64405: 'Povolenie na úpravu dávky poprel',
    64406: 'Zariadenie je prázdne',
    64407: 'Viaceré dávky/veľa nie sú podporované čítačky čiarového kódu.',
    64408: 'Tento krok ešte nezačala',
    64409: 'Pobočka musí obsahovať časti',
    64410: 'Neexistujú žiadne množstvá',
    64411: 'Scan úspešné',
    64412: 'Nepodarilo sa aktualizovať údaje',
    64413: 'Krok, už začalo',
    64414: 'Krok už hotové',
    64415: 'Shop objednávky musí schváliť',
    64416: 'Shop objednať neexistuje',
    64417: 'Dávka neexistuje',
    64418: 'Nie je potrebné pre tento krok vybavenie',
    64419: 'Tento krok obsahuje viac častí potom povolené. Použite prosím výroby stav obrazovky',
    64420: 'Pobočka neexistuje',
    64421: 'Toto zariadenie nie je priradený k tomuto typu krok.',
    64422: 'Odbor č.',
    64423: 'Krok č.',
    64424: 'Tlačiť užívateľa karty',
    64450: 'Please select shop order code',
    65000: 'Materiál: zobrazenie ',
    65001: 'Materiál: upraviť ',
    65002: 'Materiál: odstrániť ',
    65003: 'Vybavenie: zobrazenie ',
    65004: 'Vybavenie: upraviť ',
    65005: 'Vybavenie: odstrániť ',
    65006: 'Typ operácie: zobrazenie ',
    65007: 'Typ operácie: Aktualizácia ',
    65008: 'Typ operácie: odstrániť ',
    65009: 'Typ operácie: priradiť k zariadenia ',
    65010: 'Prevádzka: zobrazenie ',
    65011: 'Prevádzka: upraviť ',
    65012: 'Prevádzka: odstrániť ',
    65013: 'Časť: zobrazenie ',
    65014: 'Časť: zmeniť ',
    65015: 'Časť: odstrániť ',
    65050: 'LabTest typy: zobrazenie ',
    65051: 'LabTest typy: upraviť ',
    65052: 'LabTest typy: odstrániť ',
    65060: 'Správa štatistiky: predaj zákazníkom ',
    65061: 'Správa štatistiky: predaj podľa kategórie ',
    65062: 'Správa štatistiky: predajné vybavenie ',
    65290: 'Laboratórne Hodnotenie: zobrazenie ',
    65291: 'Laboratórne Hodnotenie: upraviť ',
    65292: 'Laboratórne Hodnotenie: odstrániť ',
    65293: 'Laboratórne Hodnotenie: schváliť ',
    65296: 'Informácie o spoločnosti: zobrazenie ',
    65297: 'Informácie o spoločnosti: upraviť ',
    65301: 'Zákazník: zobrazenie ',
    65302: 'Zákazník: upraviť ',
    65303: 'Zákazník: odstrániť ',
    65304: 'Zákaznícky kontakt: upraviť ',
    65305: 'Zákaznícky kontakt: odstrániť ',
    65306: 'Príjem: zobrazenie ',
    65307: 'Príjem: upraviť ',
    65308: 'Príjem: odstrániť ',
    65309: 'Príjem: skontrolovať ',
    65310: 'Obchod objednávky: zobrazenie ',
    65311: 'Obchod objednávky: upraviť ',
    65312: 'Obchod objednávky: odstrániť ',
    65313: 'Obchod objednávky: schváliť ',
    65314: 'Proces tok: zobrazenie ',
    65315: 'Proces tok: upraviť ',
    65316: 'Proces tok: odstrániť ',
    65321: 'Certifikácia: zobrazenie ',
    65322: 'Certifikácia: upraviť ',
    65323: 'Certifikácia: odstrániť ',
    65328: 'Požiadavka: zobrazenie ',
    65329: 'Požiadavka: upraviť ',
    65330: 'Požiadavka: odstrániť ',
    65331: 'Automatické generovanie kľúčov: zobrazenie ',
    65332: 'Automatické generovanie kľúčov: upraviť ',
    65333: 'Automatické generovanie kľúčov: odstrániť ',
    65341: 'Prepravná spoločnosť: zobrazenie ',
    65342: 'Prepravná spoločnosť: upraviť ',
    65343: 'Prepravná spoločnosť: odstrániť ',
    65351: 'Dane: zobrazenie ',
    65352: 'Dane: upraviť ',
    65353: 'Dane: odstránenie ',
    65361: 'Doprava: zobrazenie ',
    65362: 'Doprava: upraviť ',
    65363: 'Doprava: odstrániť ',
    65364: 'CITÁCIA: zobrazenie ',
    65365: 'NEPOUŽÍVA',
    65366: 'Panel poradia obchod',
    65367: 'Lodné Panel',
    65368: 'Fakturácia: zobrazenie ',
    65369: 'Ceritification Panel',
    65371: 'Typ operácie a vybavenie',
    65372: 'Prevádzka & procesu toku',
    65374: 'Obchod dnes',
    65375: 'Informácie o spoločnosti',
    65382: 'PL: cenník ',
    65384: 'Prepravná spoločnosť',
    65385: 'Používanie zariadenia',
    65386: 'NEPOUŽÍVA',
    65387: 'Zostava objednané shop',
    65388: 'Prepravná správa',
    65389: 'Fakturácia správa',
    65390: 'Časť správa',
    65391: 'Správa zariadení',
    65392: 'Zostava toku procesu',
    65393: 'Správe',
    65394: 'CITÁCIA: vytvoriť ',
    65395: 'CITÁCIA: odstrániť ',
    65396: 'CITÁCIA: upraviť ',
    65397: 'CITÁCIA: klon ',
    65398: 'CITÁCIA: pridať časť ',
    65399: 'CITÁCIA: odstrániť časť ',
    65400: 'Fakturácia: odstrániť ',
    65401: 'Fakturácia: upraviť ',
    65402: 'Jednotka: zobrazenie ',
    65403: 'Jednotka: upraviť ',
    65411: 'Vzorky',
    65423: 'PL: vytvoriť cenník ',
    65424: 'PL: upraviť cenník ',
    65425: 'PL: odstrániť cenník ',
    65426: 'ID',
    65427: 'Liečba',
    65428: 'Schválené',
    65429: 'Dátum schválenia',
    65430: 'Schválený',
    65431: 'Sledovanie informácií v súčasnosti k dispozícii',
    65432: 'Obnovenie údajov, zmeny sa stratia. Ste si istí?',
    65433: 'Stav výrobnej: upraviť ',
    65434: 'Stav výrobnej: odstrániť ',
    65435: 'Stav výrobnej: zobrazenie ',
    65436: 'Zrušiť objednávku Shop',
    65437: 'Uložte prácu pred pokračovaním',
    65438: 'Tento zákazník bola deaktivovaná',
    65439: 'Stav výrobnej: zadávanie údajov ',
    65440: 'Stav výrobnej: schváliť krokov & veľa ',
    65441: 'Stav výrobnej: prepísať názov operátora ',
    65442: 'Musíte zadať množstvá a/alebo váhy pre všetky vybraté časti.',
    65443: 'NEPOUŽÍVA',
    65444: 'NEPOUŽÍVA',
    65445: 'NEPOUŽÍVA',
    65446: 'Mena pre vybratú časť nezodpovedá aktuálne vybratej meny.',
    65447: 'By ste chceli nahrať a upraviť ceny?',
    65448: 'Zoom',
    65449: 'Boli aktualizované ceny',
    65450: 'NEPOUŽÍVA',
    65451: 'NEPOUŽÍVA',
    65452: 'Dvojitým kliknutím upravte schému',
    65453: 'Dvojitým kliknutím upravte zľava',
    65500: 'Laboratórne Hodnotenie',
    65501: 'Hodnotiace laboratórium zmenilo. Naozaj chcete zahodiť zmeny?',
    65502: 'Vyhodnotenie dátum',
    65503: 'Lab správa kód',
    65504: 'Lab správa už existuje',
    65505: 'Tam je žiadny Shop objednať k dispozícii pre laboratórium hodnotenia.',
    65506: 'Vyberte diely chcete zahrnúť laboratórne hodnotenie.',
    65507: 'Zahrnúť uzavretá shop objednávky',
    65508: 'Výber požiadaviek pridať Lab Hodnotenie',
    65509: 'Záverečná časť požiadavka',
    65510: 'Požiadavky',
    65511: 'Chcete odstrániť túto položku z vyhodnotenia Lab?',
    65512: 'Chcete pridať túto položku do Lab Hodnotenie?',
    65513: 'Vyberte dávky na laboratórne hodnotenie.',
    65514: 'Návod na použitie',
    65515: 'Výsledky',
    65516: 'Počiatočné nameraná hodnota',
    65517: 'Výsledkom hodnota',
    65518: 'Výrobný krok',
    65519: 'Obrázky',
    65520: 'Laborant',
    65521: 'Presunúť obrázok vľavo',
    65522: 'Presunúť obrázok vpravo',
    65523: 'Naozaj chcete odstrániť tento obraz?',
    65524: 'Tento obrázok je už načítaný.',
    65525: 'Vytvoriť graf',
    65526: 'Leptacie gél',
    65527: 'Naozaj chcete premiestniť tento obraz?',
    65528: 'Vyberte jednotku',
    65529: 'Nastavenie jednotky',
    65530: 'Konvertovať',
    65531: 'Hodnota sa nedá konvertovať: ',
    65532: 'Aktualizovať graf',
    65533: 'Odstrániť graf',
    65534: 'Plot riadkov',
    65535: 'Zov grafu',
    65536: 'Vľavo názov osi',
    65537: 'Dolný názov osi',
    65538: 'Plot stĺpce',
    65539: 'Potvrdzuje, že bolo schválené laboratórium hodnotenia bude zakázať akékoľvek ďalšie zmeny alebo odstránenia.',
    65540: '[mernej jednotky]',
    65541: 'Laboratórium hodnotenia nemôžu byť schválené bez akýchkoľvek výsledkov testov.',
    65542: 'Nasledujúce laboratórne testy neboli dokončené: ',
    65543: 'Schválenie bude odstrániť toto laboratórne hodnotenie z priečinka Doručená pošta bez robí tieto testy.',
    65544: 'Ukážka veľkosti',
    65545: 'Deštruktívne #',
    65546: 'Akceptované #',
    65547: 'Odmietnuté #',
    65548: 'Zväčšení (X)',
    65549: 'Umiestnenie',
    65550: 'Položka schválená',
    65551: 'Položka schválená',
    65552: 'Toto laboratórne testovanej položky nebola dokončená.',
    65553: 'Toto laboratórne testovanej položky nemôže byť upravené alebo odstránené po schválení.',
    65554: 'Os x',
    65555: 'Y',
    65556: 'Použitie Count ',
    65557: 'Pozícia legendy',
    65558: 'Počiatočný dátum',
    65559: 'Dátum skončenia',
    65560: 'Nastavte rozsah dátumov',
    65800: 'LabTest typ šablóny',
    65801: 'Táto šablóna sa používa a nedá sa odstrániť',
    65802: 'LabTest opis',
    65803: 'Naozaj chcete odstrániť túto šablónu?',
    65804: 'Stĺpce',
    65805: 'Riadky',
    65806: 'Nastaviť všetky jednotky',
    65807: 'Žiadne jednotky',
    65808: 'Kód LabTest typu',
    65809: 'Test návod',
    65810: 'Popis testovacieho',
    65812: 'Pridanie obrázka tlačidla',
    65813: 'Pridanie tlačidla grafu',
    65814: 'Pridať tlačidlo Konvertovať jednotky',
    65815: 'Použite záhlavie riadka',
    65816: 'Použiť hlavičku stĺpca',
    65817: 'Test názvu',
    65818: 'Upravte riadky',
    65819: 'Upraviť stĺpce',
    65820: 'Kód typu Test je potrebné',
    65821: 'Typu Test Lab bol uložený',
    65822: 'Túto šablónu zmenil, ste naozaj chcete zahodiť zmeny?',
    65823: 'Rev. sľub',
    65824: 'Termín',
    65825: 'Upraviť Spec',
    65826: '',
    65827: 'Tok Spec',
    65828: 'Požiadavka parametra',
    65829: 'Požiadavka operátora',
    65830: 'Prvá požiadavka hodnota',
    65831: 'Druhá požiadavka hodnota',
    65832: 'Požiadavka jednotky',
    65833: 'Odstránenie schválenie',
    65834: 'Shop objednávky nie je možné zmeniť, akonáhle časti sú vo výrobe',
    65835: 'Poradie zobrazenia Shop v kolónke',
    65836: 'Časť je vo výrobe. Odstrániť z výroby na odstránenie časti.',
    65837: 'Minimálne množstvo-',
    65838: 'Minimálna hmotnosť-',
    65839: 'Schválenie nemôže byť odstránené s dielmi vo výrobe',
    65840: 'Archivované',
    65841: 'Zobraziť typy k dispozícii Test',
    65842: 'Zobraziť archivované Test typov',
    65843: 'Tento typ testu sa nepoužíva. Odstrániť to miesto',
    65844: 'Nie sú žiadne typy dostupných testovacích',
    65845: 'Výber typu náhradného testu',
    66000: 'Open',
    66001: 'Kontrolované',
    66002: 'Schválené',
    66003: 'Plánované',
    66004: 'Vo výrobe',
    66005: 'Ošetrené',
    66006: 'Certifikované',
    66007: 'Dodávané',
    66008: 'Fakturované',
    66009: 'Zrušené',
    66010: 'Uzavreté',
    66011: 'Dosiahol sa maximálny počet položiek na demo verzia',
    66012: 'Neexistujú žiadne jednotky vybraných. Prosím aktualizujte jednotka tabuľky.',
    66013: 'Ak sú použité, hrubá hmotnosť musí byť aspoň rovná čistej hmotnosti.',
    66014: 'Množstvo',
    66015: 'Dodacieho listu',
    66016: 'Zadajte množstvo: ',
    66017: 'Celkové',
    66018: 'Žiadne ďalšie balenie pásky sú k dispozícii.',
    66019: 'Skúste upraviť existujúce čiastkové množstvá.',
    66020: 'Zmeny uložiť pred pokračovaním.',
    66021: 'Schránky',
    66022: 'Nepodarilo sa nájsť požadovanú položku.',
    66023: 'Dvojitým kliknutím upravte množstvo.',
    66024: 'Políčko vyberie položku.',
    66150: 'rovná sa',
    66151: 'nerovná sa',
    66152: 'je menej ako ',
    66153: 'je väčší ako',
    66154: 'je menšia alebo rovná',
    66155: 'je väčšie alebo rovné',
    66156: 'je to ako',
    66157: 'je medzi',
    66170: 'Pridať prázdnu položku',
    66171: 'Pridanie položiek z operácií',
    66172: 'Pridanie položiek z procesov tokov',
    66173: 'Klon vybratú položku',
    66174: 'Odstrániť vybraté položky',
    66175: 'Nová položka',
    66176: 'Chýbajúci Popis',
    66177: 'Chýbajúce jednotky',
    66178: 'Chýbajúca čiastka',
    66179: 'Chýba jednotková cena',
    66180: 'Chýba počiatočná hodnota',
    66181: 'Chýba koncová hodnota',
    66182: 'Chýba jednotková cena',
    66183: 'Vlastné',
    66184: 'Povoliť prispôsobenie aktuálnej ceny schémy',
    66185: 'Vyberte exsisting cena schémy',
    66186: 'Pridať novú stupnicu',
    66187: 'Odstrániť vybratý rozsah',
    66188: 'Koncová hodnota musí byť Strúhadlo a potom začať hodnotu',
    66189: 'Neplatnú schému kód',
    66190: 'Neplatný celkom',
    66191: 'Musí mať časti',
    66192: 'Suma musí byť Strúhadlo potom nula',
    66193: 'Časť množstva musí byť Strúhadlo potom nula',
    66195: 'Obchod stav zariadenia: ',
    66196: 'Načítať položky (y) z ponuky',
    66197: 'Citácia',
    66198: 'Žiadne dostupné Kotácie cien položiek boli nájdené pre tento konkrétny zákazník',
    66199: 'Sa môžete pohybovať iba jednu jednotku v čase',
    66200: 'Ospravedlňujeme sa, ale nemáte povolenie na uloženie jednotiek.',
    66201: 'Jednotka, ktorá je súčasťou systému je už k dispozícii a bol odstránený zo zoznamu',
    66202: 'Nepodarilo sa vytvoriť súbor exportu.',
    66203: 'Uložiť ako súbor XML...',
    66204: 'Nie je možné uložiť XML súbor.',
    66205: 'Nič na export.',
    66206: 'Uzamknutý',
    66207: 'Povinné neplatnú jednotku bol nájdený v súbore config.',
    66208: 'Faktúry bez daňové detaily.',
    66209: 'Daňové Detaily fakturácie len.',
    66210: 'Dávky bez Podrobnosti kroku výroby.',
    66211: 'Výroba krok Podrobnosti len.',
    66212: 'Hmotnosť a počet',
    66213: 'Faktúra všetky časti rovnako',
    66214: 'Viacero procesov tokov nie je dovolené v tomto poradí obchod.',
    66215: 'Faktúry s kategóriami toku procesu.',
    66216: 'Časť celkovej',
    66217: 'Peachtree',
    66218: 'Dobropis',
    66219: 'Termín',
    66220: 'Účty pohľadávok účet',
    66221: 'Účty pohľadávok sumu',
    66222: 'GL účet',
    66223: 'Daň typu',
    66224: 'Počet distribúcie',
    70001: 'Obchod Layout',
    70002: 'Zabezpečenie kvality',
    70003: 'Údaje',
    70004: 'Registrácia súčastí',
    70005: 'Konfigurácia rozloženia rastlín',
    70006: 'Ponuka a konfiguráciu panela s nástrojmi',
    70007: 'Boli vykonané zmeny',
    70008: 'Predvolený používateľ sa nenašiel',
    70009: 'Žiadny užívateľ prihlásený',
    70010: 'Pridanie alebo odstránenie pracoviská',
    70501: 'Nedá sa načítať. Konflikt verzií komponentov.',
    70502: 'Identifikátor prostriedku',
    70503: 'Pridať súčasť',
    70504: 'Odstrániť súčasť',
    70505: 'Upraviť súčasť',
    70506: 'Už nie je zaregistrovaná súčasť',
    70508: 'Verzia',
    70509: 'Dostupné súčasti',
    70510: 'Súčasti v prevádzke',
    70511: 'Upraviť',
    70512: 'Ikona',
    70516: 'Načítať obrázok zo súboru',
    70517: 'Použiť predvolený obrázok poskytovaný komponentu',
    70520: 'Zobraziť súčasti registráciu',
    70521: 'Upraviť súčasť registrácie',
    70522: 'Odstrániť súčasť registrácie',
    73001: 'Terminál Manager Plugin',
    73002: 'Spravovanie počítača termminals',
    73201: 'UPC užívateľ',
    73202: 'Používateľa a povolenia skupiny',
    73203: 'UPC užívateľské neumožňuje mať skupinu priradenú s ňou/ním. Odstránia sa všetky skupiny. Ste si istí?',
    73204: 'Skupina pre vybratého používateľa už existuje aj',
    73205: 'Predvolený používateľ je možné klonovať',
    73206: 'UPC používateľ nemôže mať skupinu priradenú k nej. Sa bude ignorovať všetky skupiny, ak existuje, aby sa klonované',
    73207: 'Vyberte skupinu priradiť používateľovi',
    73208: 'Vyberte používateľa priradené k skupine',
    73209: 'Predvolená skupina možno priradiť len predvolený používateľ',
    73210: 'Nie je možné priradiť skupine používateľovi UPC',
    73211: 'Úroveň povolení',
    73212: 'Vytvoriť predvolený užívateľa',
    73213: 'Vytvoriť predvolené skupiny',
    73214: 'Priezvisko: ',
    73215: 'Meno: ',
    73216: 'Aktualizáciu všetkých skupín',
    73217: 'Nemôžete odstrániť predvolené užívateľ',
    73218: 'Nemôžete odstrániť predvolené skupiny',
    73219: 'Predvolená skupina sa nedá odstrániť z predvoleného používateľa',
    73501: 'Zadajte názov',
    73502: 'Upraviť názov rozloženia',
    73503: 'Premenovať',
    73504: 'Žiadne pracovné miesta pridelené toto rozloženie.',
    73505: 'Vybrať rozloženie',
    73506: 'Zmena štýlu',
    73507: 'Zmena orientácie',
    73508: 'Rozvrhnutie ID',
    73509: 'Názov rozloženia',
    73510: 'Riadok pozícia',
    73511: 'Stĺpec pozícia',
    73512: 'Výška (riadky)',
    73513: 'Šírka (stĺpce)',
    73514: 'Pracovisko',
    73515: 'Pracovisko pridané',
    73516: 'Neexistujú žiadne dostupné pracoviská.',
    73517: 'Pracovisko odstránené',
    73518: 'Pracovisko upravený',
    73519: '',
    73520: 'Zmeniť veľkosť písma',
    73521: 'Existujú viaceré pracoviská v rovnakej polohe.',
    74001: 'Zobraziť & Rozloženie panela s nástrojmi',
    74002: 'Upraviť Menu & Rozloženie panela s nástrojmi',
    74003: 'Ponuky & Rozloženie panela s nástrojmi odstrániť',
    74004: 'Menu',
    74005: 'Panel s nástrojmi',
    74006: 'Komponenty',
    74007: 'Vytvoriť hornom Menu položka',
    74008: 'Upraviť horné Menu položku',
    74009: 'Hornom Menu položku odstrániť',
    74010: 'Odstrániť súčasť z Menu',
    74011: 'Odstrániť súčasť panela s nástrojmi',
    80000: 'Užívateľ Manager ',
    80001: 'Vypnite aplikáciu',
    80002: 'Uznať alarmy',
    80003: 'Manuálny režim',
    80004: 'Kalibrácia',
    80005: 'Kompenzuje',
    80006: 'Aktualizácia firmvéru',
    80007: 'Upraviť súčasné zamestnanie',
    80008: 'Upraviť recept',
    80009: 'Konfigurácia alarmov recept',
    80010: 'Konfigurovať recept vlajky',
    80011: 'Konfigurácia systému',
    80012: 'Konfigurovať kontroly',
    80013: 'Konfigurácia komunikačných',
    80014: 'Zobraziť Log súbory',
    80015: 'Konfigurovať Cascade',
    80016: 'Nastaviť digitálne',
    80017: 'Sonda skúšky',
    80018: 'Konfigurovať sonda skúšky',
    80019: 'Konfigurovať recept udalosti',
    80020: 'Konfigurácia externého správcu',
    80021: 'Konfigurovať Proc Cal (FULL)',
    80022: 'Štart/Stop/drží Job',
    80023: 'Zobrazenie ladenia obrazovky',
    80024: 'Konfigurovať Proc Cal (čiastočné)',
    80025: 'Konfiguráciu I/O vnútorného',
    80026: 'Log Maintenance',
    80027: 'Set Date/Time',
    80028: 'NOT USED',
    80029: 'Recipe Maintenance',
    80030: 'Touch Screen Calibration',
    80031: 'Restart Application',
    80032: 'Test Watchdog',
    80033: 'Maintenance mode is an unprotected mode. Are you sure you want to proceed? ',
    80034: 'You are currently editing or adding new data, data will not be saved. Continue?',
    80035: 'NOT USED',
    80036: 'Attempt to set system time returned error',
    80037: 'Attempt to set hardware time returned error',
    80038: 'System and hardware time have been set',
    80039: 'Memory Map',
    80040: 'Backup/Restore',
    80041: 'Halt/Resume',
    80042: 'Start/Stop standby logging',
    80043: 'Configure I/O points',
    80044: 'File/Folder',
    80100: 'Hlavné Menu',
    80101: 'Uloženie úspešné',
    80102: 'Uloženie zlyhalo',
    80103: 'Odstrániť úspešné',
    80104: 'Odstránenie zlyhalo',
    80105: 'Ready',
    80106: 'Rozsah',
    80107: 'Prístup bol odmietnutý',
    80108: 'It is strongly recommended not to perform this action while job is running. Are you sure you want to proceed?',
    80109: "Can't write log",
    80110: 'Can write log',
    80111: "Can't write process memory",
    80112: 'Are you sure you want to erase memory and restart the application?',
    80113: 'Use Gas Input',
    80114: 'Use DPT Input',
    80115: 'Use mV Input',
    80121: 'HIGH',
    80122: 'LOW',
    80200: 'Prihlásiť sa',
    80201: 'Odhlásiť',
    80202: 'Upraviť používateľov',
    80203: 'Vypnúť',
    80204: 'Restart',
    80205: 'Prihláste, prosím',
    80206: 'Regulátor má byť v miestnom režime',
    80207: 'Regulátor má byť manuálny režim',
    80208: 'Regulátor musí byť v režime vzdialenej',
    80209: 'Regulátor má byť v automatickom režime',
    80210: 'This will clear the Set Point, disable the control loop. Do you want to continue?',
    80221: 'Unable to determine what to update. The following file is missing',
    80222: 'Unable to load the following file',
    80223: 'The following file was not found in the software update content',
    80224: 'Invalid checksum value in software update content for the following file',
    80225: 'Invalid software update',
    80226: 'The following files checksum is invalid after copy',
    80227: 'Unable to obtain checksum value from the following file',
    80228: 'A checksum mismatch has been detected during copy of this file',
    80229: 'Software Updates will need to restart application or even the controller, do you want to proceed?',
    80230: 'Unable to perform software updates while job is running',
    80231: 'You will need to insert or connect an external media containing updates. The root of this media must contain the following folder with updates in it',
    80232: 'Nothing to restore',
    80233: 'After restore has completed the application will automatically restart, do you want to proceed?',
    80249: 'Do NOT power off the instrument till procedure is completed.',
    80250: 'Vložte nasledovné externé médium aktualizácie',
    80251: 'Nasledovný priečinok obsahujúci aktualizácií sa nenašla na médiu',
    80252: 'Pri aktualizácii priečinka sa našiel, ale je prázdne',
    80253: 'Aktualizácia firmvéru je kompletný. Reštartujte radič pre zmeny prejavili',
    80254: 'Nepodarilo sa odstrániť priečinok folowing',
    80255: 'Nepodarilo sa vytvoriť nasledovný priečinok',
    80256: 'Nie je možné skopírovať súbor',
    80257: 'Nepodarilo sa odstrániť súbor',
    80258: 'Vonkajšie médium aktualizácie našiel. Bude teraz vykonávať zálohovanie všetkých súborov bude aktualizovaný.',
    80259: 'Zadajte externých médií',
    80260: 'Neplatné externé média',
    80261: 'Chyba pri prístupe k priečinku',
    80262: 'Nie je možné úplné zálohovanie. Aktualizáciu nevykoná',
    80263: 'Aktualizácia zlyhala.',
    80264: 'Zálohovanie je dokončené. Bude teraz vykonať aktualizáciu firmvéru.',
    80265: 'Nemožno premenovať súbor počas firware aktualizácie.',
    80266: 'Copying update files to controller ...',
    80267: 'Preparing to update software ...',
    80268: 'Performing backup and updating software ...',
    80269: 'Software updates complete. Application will now restart',
    80270: 'Control',
    80271: 'Recipe',
    80272: 'Maintenance',
    80273: 'Configuration',
    80274: 'Users',
    80275: 'View Logs',
    80301: 'Nemožno odstrániť používateľa loged na',
    80350: 'Skupina',
    80351: 'Používateľ už existuje aj',
    80352: 'Upraviť používateľa',
    80353: 'Zadajte meno používateľa',
    80354: 'Prosím, zadajte heslo',
    80355: 'Zvoľte prosím skupinu ',
    80356: 'Používateľ',
    80357: 'Užívateľské meno',
    80358: 'Heslo',
    80359: 'CHYBA - Nepodarilo sa načítať súbor údajov používateľom',
    80360: 'Užívateľské Menu',
    80361: 'Width',
    80362: 'Height',
    80500: 'Vybrať recept',
    80501: 'Caps Lock',
    80502: 'OP kód',
    80503: 'Príkaz',
    80504: 'Recept na uložený',
    80505: 'Chyba pri ukladaní receptu',
    80506: 'Chyba otvorenia recept',
    80507: 'Žiadne inštrukcie je možné nastaviť pre NOOP',
    80508: 'Vyberte si recept',
    80509: 'Zvoľte krok pred vložiť alebo vybrať pripojiť',
    80510: 'Zvoľte krok na odstránenie',
    80511: 'Tento recept existuje',
    80512: 'Ste si istí, že chcete nahradiť to?',
    80513: 'Výučba je neplatná alebo chýba pre tento krok.',
    80514: 'Inštrukcie pre tento krok má neplatný formát pre OP kód.',
    80515: 'Branch inštrukcie odkazuje krok, ktorý neexistuje.',
    80516: 'Tento recept sa uložia ale nebude fungovať, ako to je.',
    80517: 'Tento krok je nastaviť NOP a nemôže mať pokyn.',
    80518: 'Čas je nižšia než minimálna povolená pre tento OP kód.',
    80519: 'Čas je väčší ako maximálna povolená pre tento OP kód.',
    80520: 'Príznak alebo udalosť číslo (XXX) je mimo rozsahu (XXX.Y).',
    80521: 'Hodnôt (Y) musí byť 0 alebo 1 (XXX.Y).',
    80522: 'Limit musí nasledovať test alebo čakať OP kódy alebo ignoruje.',
    80523: 'Rampa krok musí nasledovať H (nastavenú teplotu).',
    80524: 'Hodnota pre tento krok je pod Minimálny rozsah.',
    80525: 'Pre tento krok je nad hodnotou maximálneho rozsahu.',
    80526: 'Tento OP kód je neznámy.',
    80527: 'Z Opcode musí nasledovať F (vlajky) OP kód.',
    80528: 'Maximálny počet receptov prekročil.',
    80529: 'Naozaj chcete odstrániť tento recept?',
    80530: 'Recept nie je možné odstrániť.',
    80531: 'Existujú neuložené zmeny.',
    80532: 'Chcete uložiť zmeny tohto receptu?',
    80533: 'Chyba v kroku',
    80534: 'Tento op kód vyžaduje bod, ktorý neexistuje v tejto konfigurácii.',
    80535: 'Nový recept',
    80536: 'Obmedziť po poplachu platná len pre odchýlku alarmy 81,83 a 85 ',
    80537: 'Vlajky má na mysli radiča, ktorý nie je konfigurovaný',
    80538: 'Príznak, ktorý má na mysli Z musia byť nastavené na (xx.1)',
    80539: 'Príznak, ktorý má na mysli Z musí odkazovať na radič',
    80540: 'Príznak, ktorý má na mysli Z musí byť nakonfigurovaný radič',
    80541: 'Beh recept nemožno uložiť chyby.',
    80542: 'To platí nie čakať na tento príznak na.',
    80543: 'To platí nie čakať na tento príznak.',
    80544: 'To nie je platné nastaviť túto vlajku.',
    80545: 'Nie je platný nastaviť túto vlajku na bez toho, aby s bodom set (y alebo Z opcode).',
    80546: 'Skok na krok jeden tento recept',
    80547: 'Recept číslom náplne z Ref číslo',
    80548: 'Nie je nastavený žiadny ovládací C alebo c op kódov. ',
    80549: 'Ste si istí, že chcete zastaviť túto prácu?',
    80550: 'Udalosť alebo pridružených bod neexistuje',
    80551: 'Ste si istý, že chcete zadržať túto prácu?',
    80552: 'RECEPT EDITOR ',
    80553: 'Vlajka je odkazom na pozadí sekvencie, ktorá nie je nakonfigurovaná',
    80554: 'Vlajka je odkazom na pozadí recept súbor neexistuje',
    80555: 'Nemožno otvoriť tento podprogram',
    80556: 'Tento podprogram vyvolá ďalší čiastkový',
    80557: 'Zlé podprogram',
    80558: 'Vlajka je odkazom na pozadí recept, ktorý nie je platný',
    80559: 'Sekúnd',
    80560: 'Stupňov',
    80561: 'Recipe library updated.',
    80562: 'Running recipe updated.',
    80563: 'The deviation set value for this step is below the minimum range.',
    80564: 'The deviation set value for this step is above the maximum range.',
    80565: 'There is no job currently running.',
    80566: 'The current job has been aborted.',
    80567: 'The requested recipe is not running.',
    80568: 'The recipe was modified by a remote user.',
    80569: 'The subroutine was modified by a remote user.',
    80570: 'System is not set in remote mode.',
    80571: 'Abort job failed',
    80572: 'Opcode y must follow F and Z',
    80701: 'Loop',
    80702: 'Podrobnosti',
    80703: 'Čítanie',
    80704: 'Nastaviť bod',
    80705: 'Výstup',
    80706: 'Príručka',
    80707: 'Automatická',
    80708: 'Miestne',
    80709: 'Vzdialené',
    80710: 'Tune',
    80711: 'Main',
    80721: 'Zadajte nový výstupný signál".',
    80722: 'Rozsah',
    80730: 'Are you sure you want to START standby logging?',
    80731: 'Are you sure you want to STOP standby logging?',
    80800: 'Pozadie tvorca recept',
    80801: 'Zakázať alarmy',
    80802: 'Zakázať výpočty',
    80803: 'Zmraziť radiče',
    80804: 'Hlavné akcie',
    80805: 'Max čas (sekundy)',
    80806: 'Maximálna doba prekročená',
    80807: 'DO súboru',
    80808: 'Nastavte ovládače',
    80809: 'Nastaviť Boolovská vlajok',
    80810: 'Nastaviť AO',
    80811: 'Pokračovať recept po reštarte',
    80812: 'Chyba pri načítaní',
    80813: 'Všetky',
    80814: 'None',
    80815: 'Umožniť',
    80816: 'Vyberte číslo recept',
    80817: 'Existuje recept. Chcete ju nahradiť?',
    80818: 'Na',
    80819: 'Off',
    80820: 'Set Alarm',
    80821: 'Výzva',
    80822: 'Prejdite na',
    80823: 'Vyberte akciu',
    80824: 'Popis kroku',
    80825: 'Analógové výstupy',
    80826: 'Nastaviť koncový stav',
    80827: 'Boolovská indikátor',
    80828: 'Nastaviť hlavné akcie',
    80829: 'Radiče',
    80830: 'Krok #',
    80831: 'Nastaviť Max doba prekročená akcia',
    80832: 'Max fázy času',
    80833: '(v sekundách)',
    80844: 'Čakať na konca stav',
    80845: 'Povolené',
    80846: 'Telesne',
    80847: 'Medzipamäte',
    80848: 'Hodnota',
    80849: 'Vyberte',
    80850: 'Výstupné medzipamäte systému',
    80851: 'Zadajte konštantnú hodnotu',
    80852: 'Analógový vstup',
    80853: 'Krok čas',
    80854: 'Hodnota z systém config',
    80855: 'Vybrať funkciu',
    80856: 'Obchod zdrojovú hodnotu v cieľovej medzipamäte',
    80857: 'Pridať zdroj do cieľa a uložiť výsledok cieľ',
    80858: 'Odčítanie zdroj cieľ a uložiť výsledok cieľ',
    80859: 'Vynásobte zdroj podľa cieľa a uložiť výsledok cieľ',
    80860: 'Rozdeliť cieľ zo zdroja a uložiť výsledok cieľ',
    80861: 'Štart v priemere zdroj AI, ukladanie výsledku v cieľovej',
    80862: 'Zdroj',
    80863: 'Priemer pracuje iba s analógových vstupov.',
    80864: 'Krok čas',
    80865: 'Krok číslo',
    80866: 'Hodnota z konfigurácie',
    80867: 'Cieľ',
    80868: 'Vybrať zdroj',
    80869: 'Vyberte medzipamäte',
    80870: 'Medzipamäte, ktoré ešte neboli pridelené',
    80871: 'Hodnota z medzipamäte',
    80872: 'Manuálne zadajte kľúč',
    80873: 'Overenie prvé časové oneskorenie',
    80874: 'Overenie meraním času',
    80875: 'Overenie konečného časové oneskorenie',
    80876: 'Overenie plyn',
    80877: 'Overenie tolerancie',
    80878: 'Kyslík sonda Min teplota',
    80879: 'Burnoff Max teplota',
    80880: 'Burnoff čas',
    80881: 'Burnoff Max doba zotavenie',
    80882: 'Max Impdedance',
    80883: 'Impedancia zotavenie čas',
    80884: 'Hodnota impedancie skrat',
    80885: 'Tam sú chyby v tomto recepte.',
    80886: 'Recept bol uložený.',
    80887: 'Kontrola',
    80888: 'Manuálny režim',
    80889: 'Spustenie úlohy',
    80890: 'Údržba Menu',
    80891: 'Štýl pera a farbu',
    80892: 'Sonda Test Menu',
    80893: 'Sonda Test Params',
    80894: 'Výsledky testov sonda',
    80895: 'Enable/Disable Shunt',
    80896: 'Select Analog Input for Shunt',
    80897: 'Start finding min value of source AI, store result in Target',
    80898: 'Start finding max value of source AI, store result in Target',
    80899: 'Analog Input SP',
    80900: 'Digital Input',
    80901: 'Digital Input SP',
    80902: 'Digital Output SP',
    80903: 'Analog Output SP',
    81045: 'Žiadna operácia',
    81065: 'Alarm',
    81066: 'Vetva',
    81067: 'C Setpoint',
    81069: 'Podujatie',
    81070: 'Vlajka',
    81071: 'Prejsť Sub',
    81072: 'Nastaviť dočasné',
    81074: 'Skok',
    81076: 'Limit',
    81080: 'Nastaviť Proc skutočnosť',
    81083: 'Namočte',
    81084: 'Nastavenie časovača',
    81085: 'Test teplota.Out',
    81087: 'Počkajte',
    81089: 'Vstupný test',
    81090: 'SetPoint',
    81099: 'Test uhlíka',
    81100: 'Pridať odkaz',
    81104: 'Test teplota',
    81105: 'Meškanie',
    81109: 'Test ovaciu T.',
    81110: 'Nastaviť Ref',
    81111: 'Test sonda mv',
    81113: 'Test Ref č',
    81114: 'Rampa',
    81116: 'Test Timer',
    81117: 'Test C ',
    81119: 'Wait < Setpoint',
    81121: 'Test Input <',
    81200: 'VALUE',
    81201: 'IO Port',
    81202: 'SCADA Port',
    81203: 'IP ADRESA',
    81204: 'IP PORT',
    81205: 'COM PORT',
    81206: 'PRENOSOVÚ',
    81207: 'PARITA',
    81208: 'VEĽKOSŤ ÚDAJOV',
    81209: 'STOP BIT',
    81210: 'OTROK ID',
    81211: 'TIMEOUT',
    81212: 'Zmena protokolu obnoví hodnoty parametra na jej predvolené vybratý protokol',
    81213: 'Pokračovať zmeniť?',
    81214: 'Zmena bude vymazať nastavenie parametrov',
    81216: 'KONFIGURÁCIA MENU',
    81217: 'TSP UTILITY CESTA',
    81218: 'PEC OBJEM (L.)',
    81219: 'ZOBRAZIŤ KURZOR',
    81220: 'NÁZOV SYSTÉMU',
    81221: 'NÁZOV SPOLOČNOSTI',
    81222: 'NÁZOV ZARIADENIA',
    81223: 'ZARIADENIA KÓD',
    81224: 'AUTO LOG OFF (V SEKUNDÁCH)',
    81225: 'DENNÍK INTERVAL (V SEKUNDÁCH)',
    81226: 'EXTERNÝ DISK',
    81227: 'HODNOTA MAX GRAPH',
    81228: 'LOG ZAŠIFROVANÉ',
    81229: 'TYP STRÁŽNEHO PSA',
    81230: 'STRÁŽNY PES POVOLENÝ',
    81231: 'SYSTÉM',
    81232: 'VNÚTORNÉ SLUČKY',
    81233: 'OZNÁMENIE',
    81234: 'VLAJKY',
    81235: 'ALARMY',
    81236: 'NASTAVIŤ CASCADE',
    81237: 'ZAPNUTIE/VYPNUTIE',
    81238: 'VONKAJŠIE',
    81239: 'UDALOSTI',
    81240: 'RADIČE',
    81241: 'RECEPT',
    81242: 'VÝPOČTY',
    81243: 'SONDA TEST',
    81244: 'ZAPNUTIE/VYPNUTIE RADIČE',
    81245: 'EXTERNÉ RADIČE',
    81246: 'PROCES VÝPOČTY',
    81247: 'OTROCI',
    81248: 'Slave',
    81249: 'Slave číslo',
    81250: 'Slave s týmto číslom už existuje aj',
    81251: 'ŽIADNE',
    81252: 'NEPÁRNE',
    81253: 'AJ',
    81254: 'CPU TYP',
    81255: 'Naozaj chcete odstrániť vybratú položku?',
    81256: 'OVLÁDANIE SLUČKY',
    81257: 'PID',
    81258: 'MASTER SLUČKY',
    81259: 'OTROK SLUČKY',
    81260: 'EXTERNÝ SPRÁVCA',
    81261: 'OVLÁDANIE NASADENIA',
    81262: 'REŽIMU OVLÁDANIA',
    81263: 'KONTROLNÉ AKCIE',
    81264: 'KONTROLNÉ VLAJKY',
    81265: 'BOD NASTAVENIA ZDROJA',
    81266: 'VÝSTUPNÉHO CYKLU TIME(SEC)',
    81267: 'VSTUPNÉ TYP',
    81268: 'VSTUPNÉ COMP ID',
    81269: 'ZOBRAZIŤ ZÁHLAVIE',
    81270: 'PRVÝ VÝSTUP ID',
    81271: 'DRUHÝ VÝSTUP ID',
    81272: 'PID CYKLU ČAS (SEC)',
    81273: 'DERIVÁT PRÍSTUP (%)',
    81274: 'CUT-BACK-NÍZKA (%)',
    81275: 'CUT-BACK-VYSOKÁ (%)',
    81276: 'MIN VÝSTUP (%)',
    81277: 'MAX VÝSTUP (%)',
    81278: 'MIN VÝSTUP ODCHÝLKA',
    81279: 'MAX VÝKON ODCHÝLKA',
    81280: 'HIERARCHIA',
    81281: 'PROPORCIONÁLNE BAND (%)',
    81282: 'INTEGRÁLNU ČAS (V SEKUNDÁCH)',
    81283: 'DERIVÁT ČAS (V SEKUNDÁCH)',
    81284: 'IDENTIFIKÁTOR',
    81285: 'NORMALIZÁCIA HODNOTY',
    81286: 'IDENT.KOEFICIENT',
    81287: 'IDENT.HYSTERÉZA',
    81288: 'IDENT.INTERVAL ZISK',
    81289: 'UMIESTNENIE',
    81290: 'VNÚTORNÉHO',
    81291: 'VONKAJŠIE',
    81292: 'NASTAVIŤ BOD TYPU',
    81293: 'NÍZKA DEADBAND',
    81294: 'VYSOKÁ DEADBAND',
    81295: 'NA oneskorenie (sek.)',
    81296: 'VYPNÚŤ oneskorenie (sek.)',
    81297: 'VÝSTUP COMP ID',
    81298: 'REGULÁTOR ZOBRAZENÉ',
    81299: "UPRAVIT'",
    81300: 'ŽIADANEJ HODNOTY KOMPENZOVAŤ',
    81301: 'UHLÍKA',
    81302: 'ROSNÝ BOD',
    81303: 'Prietok KN',
    81304: 'KN ATM',
    81305: 'DISS prietok',
    81306: 'DISS ATM',
    81307: 'KYSLÍKA',
    81308: 'DENNÍK O2 ',
    81309: 'LINEÁRNE',
    81310: 'REDOX',
    81311: 'TEPLOTA',
    81312: 'TEPLO RAMPA',
    81313: 'POHODE RAMPA',
    81314: 'SLEDOVANIE',
    81315: 'KALENIE',
    81319: 'ACCUBLENDOR',
    81320: 'PRAVDA-CARB',
    81321: 'ČAS PROPORCIONÁLNE SINGLE',
    81322: 'PROPORCIONÁLNE DUAL TIME',
    81323: 'POZÍCIA DÁVKOVANIE',
    81324: 'NA VYPNUTIE JEDNÉHO',
    81325: 'NA VYPNUTIE DUAL',
    81326: 'JEDNOSMERNÝ PRÚD JEDNÉHO',
    81327: 'JEDNOSMERNÝ PRÚD DUAL',
    81328: 'DUAL PULSED&CURRENT',
    81329: 'DUAL ONOFF&CURRENT',
    81330: 'DUAL ONOFF&TIME PROP.',
    81331: 'PRIAMY',
    81332: 'OBRÁTENÁ',
    81335: 'NEZÁVISLÉHO',
    81336: 'KASKÁDA',
    81337: 'PEVNÁ',
    81338: 'RELATÍVNA',
    81339: 'LIMIT',
    81340: 'DEVIATION',
    81341: 'BAND',
    81351: 'SKUTOČNÉ PV ID',
    81352: 'VÝSTUP ID',
    81353: 'ID MIESTNYCH SP',
    81354: 'PREČÍTAJTE SI VZDIALENEJ SP ID',
    81355: 'NASTAVENIE VZDIALENEJ SP ID',
    81356: 'PREČÍTAJTE SI AUTO/MANUAL ID',
    81357: 'NASTAVIŤ AUTO/MANUAL ID',
    81358: 'ČÍTAJTE MIESTNE/VZDIALENEJ ID',
    81359: 'IDENTIFIKÁCIA MNOŽINY MIESTNE/VZDIALENEJ',
    81366: 'DO:OK TO SAMPLE',
    81367: 'DO: COMPENSATE',
    81368: 'ODOLNOSŤ @800 ° C (Ω)',
    81369: 'AF AI',
    81370: 'AF POUŽÍVATEĽOM DEFINOVANÉ',
    81371: 'TEPLOTA AI',
    81372: 'SONDA mV AI',
    81373: 'PF AI',
    81374: 'ID: ',
    81375: 'REDOX Č',
    81376: 'CO AI',
    81377: 'CO POUŽÍVATEĽOM DEFINOVANÉ',
    81378: 'H2 AI',
    81379: 'H2 POUŽÍVATEĽOM DEFINOVANÉ ',
    81380: 'PF POUŽÍVATEĽOM DEFINOVANÉ',
    81381: 'Vyberte SLUČKA kontroly alebo PID odstrániť',
    81382: 'Každá SLUČKA kontroly vyžaduje aspoň jednu PID',
    81383: 'Počet regulačné slučky presahuje povolený počet',
    81384: 'Počet PIDs pre každý ovládací prvok SLUČKY prekračuje povolený počet',
    81385: 'Vyberte externý ovládač odstrániť',
    81386: 'Počet externé radiče presahuje povolený počet',
    81387: 'Vyberte položku odstrániť',
    81388: 'Povolený počet maximunm dosiahol. Odstráňte jeden pred pridaním ďalšie.',
    81389: 'MMI',
    81390: 'DIN',
    81391: 'To vymaže nastavenie tejto položky, chceli by ste pokračovať?',
    81393: 'TRUSTED %C',
    81394: 'ADJUSTMENT TYPE',
    81395: 'NONE',
    81396: '%C COMPENSATION',
    81397: 'CO COMPENSATION',
    81398: 'ADJUST CO',
    81399: 'MONITOR',
    81401: 'Neplatný Cascade konfigurácie možno nájsť kvôli zmene kontrolu konfigurácie!',
    81402: 'Vyberte celú kaskádu blok alebo Slave slučky odstrániť',
    81403: 'Každý blok Cascade vyžaduje aspoň jeden Slave',
    81404: 'Nedostatočné kontroly slučky zostal s ďalším Slave slučky',
    81405: 'Máte neuložené! Chceli by ste zachrániť pred odchode?',
    81406: 'Niektoré slučky Master má žiadny identifikátor priradenia',
    81407: 'Niektoré slučky Master opakoval úlohu ID',
    81408: 'Niektoré Slave slučka má žiadny identifikátor priradenia',
    81409: 'Niektoré slučky Slave opakoval úlohu ID',
    81410: 'Nedostatočné kontroly slučky zostal po inom bloku Cascade',
    81411: 'Nasledujúci vzorec nie je správne nakonfigurovaný: ',
    81412: 'Príznak hodnota je mimo rozsah',
    81413: 'AI Nenakonfigurované, ID = ',
    81414: 'Chýba PAO drží % hodnotu, ID = ',
    81415: '',
    81416: '1. výstup Nenakonfigurované, ID = ',
    81417: 'Chýba PAO prvý výstup, ID = ',
    81418: '2. výstup Nenakonfigurované, ID = ',
    81419: 'Chýba PAO 2. výstup, ID = ',
    81420: '',
    81421: 'Neplatný výstup obmedzuje Min/Max ',
    81422: 'Neplatný proporcionálne Band',
    81423: 'Neplatný normalizácia hodnoty',
    81424: 'Interval vzorkovania neplatný',
    81425: 'Neplatný neplatný derivát čas',
    81426: 'Neplatný neplatný integrálnu čas',
    81427: 'Neplatný neplatný výbava čas',
    81428: 'Vnútorné slučky konfigurácia zmenila',
    81429: 'Externé radiče konfigurácia zmenila',
    81430: 'Typ zariadenia AO má byť pulzujúce, ID = ',
    81431: 'WARNING: Oxygen Probe not detected - Op-code c/C cannot be used',
    81432: 'Missing Point for Temperature',
    81433: 'Missing Point for mV',
    81434: 'Invalid Configuration for Process Factor',
    81435: 'Invalid Configuration fo CO',
    81436: 'Invalid Configuration for H2',
    81437: 'Invalid Configuration for AF',
    81438: 'Point to hold Redox Number Value is not configured',
    81439: 'Point to hold Decarb@800 Value is not configured',
    81440: 'Process Factor shall be configured as Analog Input',
    81441: 'Reference for %C (AI) shall be configured',
    81442: 'CO shall be configured as Analog Input',
    81443: 'Analog Pont to hold calculated value is not configured',
    81444: 'Point to hold Calculated Value is reused',
    81450: ' 0 - 4/3Al + O2 = 2/3Al2O ',
    81451: ' 1 - 2Ca + O2 = 2CaO ',
    81452: ' 2 - 2Co + O2 = 2CoO ',
    81453: ' 3 - 4/3Cr + O2 = 2/3CrO3 ',
    81454: ' 4 - 4Cu + O2 = 2Cu2O ',
    81455: ' 5 - 2Fe + O2 = FeO ',
    81456: ' 6 - 4Fe3O4 + O2 = Fe2O3 ',
    81457: ' 7 - 6FeO + O2 = 2Fe3O4 ',
    81458: ' 8 - 2 Mg + O2 = 2MgO ',
    81459: ' 9 - 2Mn + O2 = 2MnO ',
    81460: '10 - 2Ni + O2 = 2NiO ',
    81461: '11 - 2Si + O2 = 2SiO ',
    81462: '12 - 2Ti + O2 = 2TiO ',
    81463: '13 - 2V + O2 = 2VO ',
    81464: '14 - 2Zn + O2 = 2ZnO ',
    81500: 'Manuálny režim',
    81501: 'Upgrade Firmware',
    81502: 'Nástroj Kalibrácia dotykovej obrazovky',
    81503: 'Názov súboru',
    81504: 'Size(bytes)',
    81505: 'Dátum vytvorenia',
    81506: 'Musíte reštartovať radič pre zmeny prejavili.',
    81507: 'Log Maintenance',
    81508: 'Recipe Maintenance',
    81509: 'Test Watchdog',
    81510: 'Internal IO Configuration',
    81551: 'Timers',
    81552: 'Timer',
    81553: 'Remaining',
    81554: 'Elapsed',
    81555: 'hh:mm',
    81556: 'mm:ss',
    81557: 'Please enter timer set value',
    81558: 'STANDBY',
    81559: 'RUNNING',
    81560: 'HOLD',
    81561: 'FINISHED',
    81562: 'Switch to manual mode first',
    81563: 'Caution: at least one timer is left in manual mode!',
    81564: 'Time Elapsed',
    81565: 'Timer on Hold',
    81566: 'TIMERS',
    81567: 'Start Rejected-Busy',
    81568: 'This will reset the timer to IDLE state. Do you want to continue?',
    81569: 'ENABLED',
    81570: '[seconds]',
    81571: '[minutes]',
    81572: 'Do you want to set time in MINUTES?',
    82000: 'Recept začal',
    82001: 'Chyba pri kopírovaní súboru recept',
    82002: 'Chyba pri odstraňovaní dočasných recept súbor',
    82003: 'Chyba pri načítaní súboru recept',
    82004: 'Neexistujú žiadne platné opatrenia na tento recept.',
    82005: 'Nepodarilo skok',
    82006: 'Čítanie referenčné číslo chyby.',
    82007: 'Recept chyba',
    82008: 'Udalosť Nenakonfigurované',
    82009: 'Proces Alarm',
    82011: 'Čakanie na',
    82013: 'Chyba pri načítaní recept GoSub príkaz',
    82014: 'Proces Alarm zakopol',
    82015: 'Ísť príliš hlboko Sub',
    82016: 'KAMARÁT',
    82017: 'Pozadie budík',
    82018: 'Prerušiť alebo pokračovať?',
    82119: 'Upravený recept už nie je aktuálne',
    82120: 'Chyba upravujúci recept',
    82121: 'Krok nie je možné odstrániť. Nastavte NOP miesto.',
    82122: 'Krok odkazuje na radiči, ktorý nie je nakonfigurovaný. To sa bude ignorovať.',
    82123: 'Step references a timer that is not configured.  It will be ignored.',
    82500: 'Chyba v kroku',
    82501: 'Neplatný ukladací žiadosť',
    82502: 'Neplatná akcia',
    82503: 'Výstup žiadosť s žiadne medzipamäte umiestnenia',
    82504: 'Žiadosti výstup, ktorý prekračuje maximálnu veľkosť',
    82505: 'Nemôžete rozdeliť 0 ',
    82506: 'Žiadosti neplatné číslo pre budík',
    82507: 'Žiadosti neplatné číslo riadka',
    82508: 'Neplatná hodnota pre GOTO',
    82509: 'Neplatný rozsah GOTO',
    82510: 'Neplatný argument pre prekročenie akcie',
    82511: 'Krok termínu',
    82512: 'Neplatné nastavenie hodnoty pre analógový výstup',
    82513: 'Nastavenie všetkých analógových výstupov na 0 (nula) alebo 1 (rozpätie) nie je povolené',
    82514: 'Analógový výstup neexistuje',
    82515: 'Hodnota je mimo analógový výstup rozsah ',
    82516: 'Vlajka musí byť nastavená na 0 alebo 1 ',
    82517: 'Príznak nie je nakonfigurovaná',
    82518: 'Radič # je neplatný informačný kanál alebo nie je nakonfigurovaný radič ',
    82519: 'Regulátor povoliť alebo zakázať musí byť 0/1 ',
    82520: 'Žiadajúci nastaviť regulátor na neplatnú hodnotu',
    82521: 'Digitálny výstup musí byť nastavená na 0 alebo 1 ',
    82522: 'Digitálny výstup neexistuje',
    82523: 'Koniec stav',
    82524: 'Neplatný koniec stav',
    82525: 'Invaid hodnotu',
    82526: 'Identifikácia súčasti neexistuje',
    82527: 'Umiestnenie vyrovnávacej pamäte prekračuje max index',
    82528: 'Požiadať o čas na krok, že neexistuje',
    82529: 'Žiadosť nastavenie vlajky, ktorá neexistuje alebo nie je nakonfigurované',
    82530: 'Pole v konfigurácii systému neexistuje',
    82531: 'Žiadosti o hodnotu, ktorá nie je možné dekódovať',
    82532: 'Číslo kroku je nesprávna alebo mimo poradia',
    82533: 'Životopis značka musí byť nastavená na 0 alebo 1 ',
    82534: 'Recept číslo nie je v súlade s názvom',
    82535: 'Recept na pozadí',
    82536: 'Zmraziť výpočet žiadosť týka až do bodu, že neexistuje ',
    82537: 'Zmraziť výpočet žiadosť sa vzťahuje výpočet, že neexistuje ',
    82538: 'Žiadosť zmraziť budíka nie je platný',
    82539: 'Žiadosť zmraziť kontrolór nie je platný',
    82540: 'Nemôžete zakázať správcu a nastavte NastaviťHodnotu',
    82541: 'Chýbajúci alebo neplatný príznak recept',
    82542: 'Neplatná hodnota pre analógový vstup',
    82543: "Analog input doesn't exist",
    82544: 'Shunt must be set to ON or OFF',
    82545: 'Shunt must use analog input from internal IO',
    82601: 'INTERNAL/EXTERNAL CONTROLLERS',
    82602: 'Multiple use of Flag',
    82603: 'Cannot use again assignment TEMPERATURE, use different Flag# instead',
    82604: 'Cannot use again assignment Carbon/DewPoint/Oxygen/Redox, use different Flag# instead',
    82605: 'Master Controller used one more time',
    82606: 'Slave Controller used one more time',
    82607: 'Cascade Controller is not used in any cascade chain',
    82608: 'Flag value is out of range',
    82609: 'Analog Input not configured, ID=',
    82610: 'Digital Input not configured, ID=',
    82611: 'Digital Output not configured, ID=',
    82612: 'Missing/Invalid Process Value input',
    82613: 'Missing/Invalid Send Set Point Value output',
    82614: 'Missing Local SP input',
    82615: 'Missing Output Value reading',
    82616: 'Missing Remote SP input',
    82617: 'Missing Remote Status reading',
    82618: 'Missing Set-to-Remote output',
    82619: 'Missing Auto Status reading',
    82620: 'Missing Set-to-Auto output',
    82621: 'No slaves configured for the Master Controller',
    82622: 'Master controller is using a slave that does not exist',
    83001: 'Chyba načítania recept. Náklad bol zrušený.',
    83002: 'Chyba pri spustení úlohy - úloha spustená',
    83003: 'Krok',
    83004: 'Podprogram nakládky',
    83005: 'Prejsť na nový recept',
    83006: 'Chyba obnovenie recept.',
    83007: 'Nepodarilo sa spustiť postup',
    83008: 'Vyberte Budík',
    83009: 'Vyberte Op kód',
    83010: 'Vyberte udalosť',
    83011: 'Vyberte príznak',
    83012: 'Resuming recipe at boot',
    83013: 'Resuming subroutine at boot',
    84100: 'Vyskytla sa chyba',
    84101: 'Neplatný súbor popisovača (port nebol otvorený správne) ',
    84102: 'Nepodarilo sa vyhradiť pamäť tabuliek (POSIX)',
    84103: 'Chytil signál non-blokované (POSIX)',
    84104: 'Operácie vypršal (POSIX)',
    84105: 'Súbor otvorený port nie je znak zariadenie (POSIX)',
    84106: 'Prístav zistený zlom stave',
    84107: 'Port zistil chybu rámovanie (zvyčajne spôsobené nesprávnym prenosovú rýchlosť nastavenia)',
    84108: 'Tam bol vstupno-výstupná chyba pri komunikácii s port',
    84109: 'Character buffer overrun',
    84110: 'Dostávať pretečeniu',
    84111: 'Port zistená chyba parity v prijaté údaje',
    84112: 'Prenášať pretečeniu',
    84113: 'Všeobecné čítať zlyhanie operácie',
    84114: 'Všeobecný zápis zlyhanie operácie',
    84121: 'Nakonfigurovaný PORT COM nie je možné otvoriť',
    84131: 'Neplatný MMI otrok adresa',
    84132: 'Neplatný 10Pro príkaz',
    84133: 'Nemožno odoslať správu 10Pro',
    84134: 'Chyba v správach',
    84135: 'Hodnota mimo rozsahu',
    84136: '10Pro ovládač nebol inicializovaný',
    84137: '10Pro nezodpovedá',
    84200: 'Chyba konverzie údajov MMI recept údajov',
    84201: 'Chyba pri konverzii rercipe dát na MMI údajov',
    84202: 'Súbor sa nedá čítať/písať recept.',
    84203: 'Start job returned an error',
    84250: 'Systém',
    84251: 'Používateľom definované',
    84252: 'Nový bod...',
    84253: 'Popis',
    84254: 'Readonly',
    84255: 'Lepivé',
    84256: 'Zastavenie',
    84257: 'Recept Alarm',
    84258: 'ID',
    84259: 'Alarm s rovnakou Identifikáciou už existuje aj',
    84300: 'Radič',
    84301: 'Sekvencie/postup',
    84302: 'Recept znie vlajkou',
    84303: 'Recept nastaví príznak',
    84304: 'Typ',
    84305: 'Recept indikátor',
    84306: 'Príznak s rovnakou Identifikáciou už existuje aj',
    84310: 'Kliknite nižšie a vyberte',
    84311: 'Telesne',
    84312: 'Povolené',
    84313: 'Vypnúť',
    84314: 'Zapnite',
    84315: 'Zoznam udalostí',
    84316: 'Zoznam vlajok',
    84350: 'Číslo objednávky obchod',
    84351: 'Zaťaženie č.',
    84352: 'Časť č.',
    84400: 'Zobraziť denník',
    84401: 'Zobrazenie grafu',
    84420: 'Zobraziť zvislé značky',
    84421: 'Maximum Points',
    84440: 'Digitálny regulátor indikátor',
    84441: 'Neplatný vstup comp id',
    84442: 'Neplatný výstup comp id',
    84460: 'Prestávka vo výkone skúšky (sek.)',
    84461: 'MIN. TEPLOTA',
    84462: 'MAX. IMPEDANCIA (KΩ)',
    84463: 'ZOTAVENIE čas (sek.)',
    84464: 'SPÁLIŤ čas (sek.)',
    84465: 'MAXIMÁLNE využitie času (sek.)',
    84466: 'MAXIMÁLNA TEPLOTA',
    84467: 'Prvé časové oneskorenie (sek.)',
    84468: 'MERANIE času (sek.)',
    84469: 'KONEČNÝ čas oneskorenia (sek.)',
    84470: 'OVERIŤ PLYN (%)',
    84471: 'SKONTROLUJTE TOLERANCIE (%)',
    84472: 'SKRAT ODPOR (KΩ)',
    84473: 'AUTOMATICKÝ TEST',
    84474: 'Impedancia',
    84475: 'Overenie',
    84476: 'Spáliť',
    84477: 'Oba testy',
    84478: 'Zobraziť posledný Test výsledky',
    84479: 'Všeobecne',
    84480: 'Testovací postup začal',
    84481: 'Sonda nie je nakonfigurovaná',
    84482: 'Chyba v skúšobnom postupe',
    84483: 'Tolerancie',
    84484: 'Sonda',
    84485: 'Zobrazenie sonda alarmy',
    84486: 'Impedancia Test',
    84487: 'Sonda horieť preč',
    84488: 'Sonda overovania',
    84489: 'Pohotovostnom Logging',
    84490: 'Recept bol upravený',
    84491: 'Recept nebol zmenený',
    84492: 'Nedá sa načítať recept',
    84493: 'Chyba pri načítaní pohotovostného',
    84494: 'Počítač watchdog je zakázané',
    84495: 'Počítač watchdog je zakázaný v simulačné režim',
    84496: 'IO Configuration errors detected!',
    84497: 'Please see file:',
    84498: 'Internal IO configuration mismatch!',
    84500: 'Podujatie',
    84501: 'Udalosť s rovnakou Identifikáciou už existuje aj',
    84502: 'Bod už priradená udalosť',
    84503: 'Bod už existuje aj',
    84504: 'To odstráni všetky aktuálne udalosti a priradiť všetky body. Pokračovať?',
    84505: 'Automatické pridelenie',
    84506: 'IDENTIFIKÁCIA SÚČASTI I/O',
    84507: 'TYP SÚČASTI I/O',
    84508: 'UDALOSTI #',
    84509: 'Nasledujúce priradené body už neexistuje: ',
    84510: 'Point can only read',
    84540: 'Impedancia',
    84541: 'Spáliť',
    84542: 'Overenie',
    84543: 'Dátum',
    84544: 'Čas',
    84545: 'Doba zotavenie (sec)',
    84546: 'Sondy signál (mV)',
    84547: 'Teplota',
    84548: 'O2 odkaz (%)',
    84549: 'Impedance(KΩ)',
    84550: 'O2 meria (%)',
    85000: 'Úspešná operácia',
    85001: '<1> Nezákonné Argument Error',
    85002: '<2> Chyba nezákonného stavu',
    85003: '<3> Vyhodnotenie vypršala',
    85004: '<4> Chýba Data tabuľka chyba',
    85005: 'Adresa <5> nelegálne Slave',
    85006: 'Modbus TCP Server začal',
    85007: 'Modbus RTU Server začal',
    85008: 'Neočakávane Modbus Slave',
    85064: '<64> Vstupno-výstupná chyba komunikácie',
    85065: '<65> V / System Error',
    85066: '<66> Port alebo Konvertory nemôžu byť otvoreným',
    85067: '<67> Serial Port je už otvorený',
    85068: '<68> Nemôže nadviazať pripojenie TCP ',
    85069: '<69> TCP spojenie bolo ukončené',
    85070: '<70> Zásuvka knižnice chyba',
    85071: '<71> Zásuvka už viazané ',
    85072: '<72> Počúvať zlyhala',
    85073: '<73> Počet popisovačov použiteľný súbor bol prekročený',
    85074: '<74> Nemáte povolenie na prístup k tomuto portu',
    85075: '<75> TCP port nie je k dispozícii na tomto počítači',
    85128: '<128> Bus protocol error',
    85129: '<129> Kontrolný chyba',
    85130: '<130> Rám neplatné číslo chyba',
    85131: '<131> Neplatná odpoveď chyba',
    85132: '<132> Odpoveď timeout chyba',
    85133: '<133> Chyba časového limitu odoslať',
    85160: '<160> Modbus výnimkou odpoveď',
    85161: '<161> Modbus nelegálne funkciu odpoveď',
    85162: '<162> Modbus nelegálne adresu odpoveď',
    85163: '<163> Modbus Nepovolená hodnota odpoveď',
    85164: '<164> Modbus otrok zlyhanie odpoveď',
    85201: 'Interface',
    85202: 'Use DHCP',
    85204: 'Network Mask',
    85205: 'Gateway',
    85206: 'Error running script ',
    85207: 'Error accessing file ',
    85208: 'Invalid IP Address',
    85209: 'Invalid Network Mask',
    85210: 'Invalid Gateway',
    85211: 'Please enter the interface name.',
    85212: 'Interface already exists.',
    85213: 'Please select the default interface.',
    85214: 'Default Interface',
    85215: 'Ethernet Interfaces',
    85216: 'Domain Name Servers',
    85217: 'Primary Address',
    85218: 'Secondary Address',
    85219: '',
    85220: '',
    85226: 'Export Log Files',
    85227: 'Delete Log Files',
    85228: 'Log Maintenance',
    85229: 'Select file(s)...',
    85246: 'Export Recipe Files',
    85247: 'Import Recipe Files',
    85248: 'Delete Recipe Files',
    86001: 'Automatického ladenia sa nepodarilo spustiť',
    86002: 'Automatického ladenia SLUČKY # ',
    86004: 'Vyberte súbor na automatického ladenia',
    86005: 'Operácia zamietnuté. Autotuned môže byť iba jeden cyklus v čase',
    86006: 'Naozaj chcete zastaviť postup samoladenie?',
    86007: 'Samoladenie zlyhala',
    86008: 'Set #',
    86009: 'Identifikácia #',
    86010: 'Identifikácia hodnotu 2 ',
    86011: 'Identifikácia hodnotu 3 ',
    86012: 'Novú sadu parametrov PID',
    86013: 'Chcete prijať tento súbor parametrov PID?',
    86014: 'Táto operácia sa nedá vykonať, zatiaľ čo úloha je spustená',
    86015: '#',
    86016: 'Popis',
    86100: 'Pohotovostný režim',
    86101: 'Runtime',
    86102: 'Čakať na digitálny výstup',
    86103: 'Čakať na digitálny vstup',
    86104: 'Čakať na vlajku',
    86105: 'Čakať na analógový vstup',
    86106: 'Čakať na analógový výstup',
    86494: 'Sonda teplota príliš nízka',
    86495: 'OFF: rosného odchýlka band poplašné ',
    86496: 'Rosného odchýlka band poplašné',
    86497: 'OFF: O2 odchýlka band poplašné',
    86498: 'O2 odchýlka band poplašné',
    86499: 'OFF: Redox odchýlka band poplašné',
    86500: 'Redox odchýlka band poplašné',
    86501: 'OFF: teplota odchýlka budík',
    86502: 'Teplota odchýlka kapele poplach',
    86503: 'OFF: C % odchýlka band poplašné',
    86504: 'C % odchýlka band poplašné',
    86505: 'OFF: sonda / regulátor teploty odchýlka ',
    86506: 'Sonda/regulátor teploty odchýlka budík',
    86507: 'Sonda impedancia príliš vysoká',
    86508: 'Impedancia zotavenie čas prekročenia',
    86509: 'Spáliť zotavenie čas prekročenia',
    86510: 'Spáliť teplota prekročila',
    86511: 'Overenie prekročenia tolerancie',
    86514: 'LIMIT vyhlásenie timeout',
    86516: 'Nelegálne rampa',
    86517: 'Automatické práci pokračovať',
    86518: 'Podprogram neexistuje',
    86519: 'Nelegálne skok požaduje',
    86531: 'Chyba v podprogram',
    86533: 'GOSUB príliš hlboko',
    86539: 'Bad načítať vracajúcich sa z podprogramu',
    86560: 'Pec zväzku v systéme je potrebné, ak existuje aspoň jeden radič, ktorého typ nasadenia je Kn',
    86561: 'Cesta k externej aplikácie pre Touch Obrazovka kalibrácie nie je nakonfigurované corrently v konfigurácii systému',
    86562: 'Internal IO Configuration was not found.',
    86563: 'The procedure will last for up to 2 minutes. Touch X signs that will show in each corner of the screen. After calibration is complete, system will be updated with new calibration values. Do you want to proceed?',
    86564: 'Failed to launch external application for Internal IO Configuration, this application will now restart',
    86565: 'Failed to launch external application for Touch Screen Calibration, this application will now restart',
    86566: 'Is there a terminal or other application running in the background? If you are not sure click YES - this will abort the procedure. It is very important to answer accurately to this question.',
    86590: 'Backplane PIC',
    86591: 'Backplane PIC Version',
    86592: 'Mainboard PIC',
    86593: 'Mainboard PIC Version',
    86600: 'Názov spoločnosti',
    86601: 'Názov systému',
    86602: 'Názov zariadenia',
    86603: 'Zariadenia kód',
    86604: 'Automatické prihlásenie a odhlásenie meškanie',
    86605: 'Zapisovanie interval',
    86606: 'External(USB) písmeno jednotky',
    86607: 'Graf rekordér: max. hodnoty pre os y',
    86608: 'Šifrované zapisovať do súboru denníka',
    86609: 'Nastavenie radiča watchdog typu',
    86610: 'Povolenie alebo zakázanie radič watchdog',
    86611: 'Zobraziť kurzor',
    86612: 'Pec objem má byť väčšia než 0 Ak existuje aspoň jeden radič, ktorého typ nasadenia je Kn prietok alebo Kn atm',
    86613: 'Nástroj Kalibrácia dotykovej obrazovky Panel (TSP)',
    86614: 'CPU typ zariadenia',
    86615: 'Zobraziť záhlavie',
    86616: '',
    86617: '',
    86618: '',
    86619: '',
    86620: 'IP adresa',
    86621: 'IP Port',
    86622: 'Com Port',
    86623: 'Prenosová rýchlosť',
    86624: 'Parita',
    86625: 'Veľkosť údajov',
    86626: 'Stop Bit',
    86627: 'Otrok ID',
    86628: 'Časový limit (ms)',
    86629: '',
    86630: '',
    86631: '',
    86632: '',
    86633: '',
    86634: '',
    86635: '',
    86636: '',
    86637: '',
    86638: '',
    86639: '',
    86640: 'Žiadané hodnoty s pridelené sadu parametrov PID',
    86641: 'Identifikátor 2 ',
    86642: 'Identifikátor 3 ',
    86643: 'Proporcionálne kapela v % normalizácia hodnoty (Kp = 100/pb) ',
    86644: 'Integrálnu čas v sekundách (Ki = Kp/Ti) ',
    86645: 'Derivát čas v sekundách (Kd = Kp * Td) ',
    86646: 'PID Kryštalizácia - ovládanie interval v sekundách',
    86647: 'Normalizácia hodnoty (rozdeľuje AI čítanie)',
    86648: 'Chyba limit(%) pod SP začať neoddeliteľnou akumulátor',
    86649: 'Chyba limit(%) nad SP zastaviť neoddeliteľnou akumulátor',
    86650: 'Limit začať derivát kontroly (percento Prop.Band)',
    86651: 'Min výstup (%)',
    86652: 'Max výstup (%)',
    86653: 'Kaskády parametra pre otroka SP (%)',
    86654: 'Nastaviť bod odsadenie (%)',
    86655: '',
    86656: '',
    86657: '',
    86658: '',
    86659: '',
    86660: 'Popis ovládanie slučky',
    86661: 'Pridať zariadenie na samostatnej karte',
    86662: 'Jedinečné číslo pridelené kontrolórovi; vyhradené pre T & C % 0',
    86663: 'Ovládanie nasadenia',
    86664: 'Režimu ovládania',
    86665: 'OBRÁTENE: Kedy vstup < SP, stúpa, výstup má ísť nadol ',
    86666: 'Hierarchia: nezávislé alebo Cascade ',
    86667: 'Vstupná identifikácia súčasti',
    86668: '',
    86669: 'Identifikácia súčasti výstup',
    86670: 'Druhý výstup identifikácia súčasti (Duálny režim)',
    86671: 'Doba cyklu pre šírku pulzné modulácie',
    86672: 'Bod nastavenia zdroja',
    86673: 'Automatického ladenia identifikácie koeficient',
    86674: 'Automatického ladenia identifikácie hysteréza',
    86675: 'Automatického ladenia určenie intervalu zisk',
    86676: '',
    86677: '',
    86678: '',
    86679: '',
    86680: 'Radič opis',
    86681: 'Pridať zariadenie na samostatnej karte',
    86682: 'Unikátny kladné číslo pridelené kontrolórovi; vyhradené pre T & C % 0',
    86683: 'Priradenia zariadenia',
    86684: 'Radič hierarchie',
    86685: 'Identifikácia súčasti pre získanie hodnoty proces od kontrolóra',
    86686: 'Identifikácia súčasti pre získanie hodnoty výstupného signálu od kontrolóra',
    86687: 'Identifikácia súčasti pre získanie miestnych bodu od kontrolóra',
    86688: 'Identifikácia súčasti pre získanie bodu vzdialeného od kontrolóra',
    86689: 'Identifikácia súčasti poslať vzdialený bod nastavenia na radič',
    86690: 'Identifikácia súčasti dostať Auto/Manual štatút kontrolóra',
    86691: 'Identifikácia súčasti Nastaviť Auto/Manual stav',
    86692: 'Identifikácia súčasti čítať miestne/vzdialenej stav',
    86693: 'Identifikácia súčasti pre miestne/vzdialenej stav',
    86694: 'Kaskády parametra pre otroka SP (%)',
    86695: 'SetPoint kompenzovať (%)',
    86696: '',
    86697: '',
    86698: '',
    86699: '',
    86700: 'Popis výpočtu',
    86701: 'Sonda teploty identifikácia súčasti',
    86702: 'Sonda identifikácia súčasti mV',
    86703: 'Toto číslo určuje konštantné koeficienty pre vybraný kov.',
    86704: 'Identifikácia súčasti procesu faktor',
    86705: 'Procesu faktor nastavené používateľom. Táto hodnota sa použije Ak vyššie identifikácia súčasti nie je nakonfigurovaný.',
    86706: 'Identifikácia súčasti CO',
    86707: 'CO % nastavené používateľom. Táto hodnota sa použije Ak vyššie identifikácia súčasti nie je nakonfigurovaný.',
    86708: 'Identifikácia súčasti H2',
    86709: 'H2% nastavené používateľom.Táto hodnota sa použije Ak vyššie identifikácia súčasti nie je nakonfigurovaný.',
    86710: 'Identifikácia súčasti zliatiny faktor',
    86711: 'Zliatiny faktor nastavené používateľom. Táto hodnota sa použije Ak vyššie identifikácia súčasti nie je nakonfigurovaný.',
    86712: 'Odolnosť chýb drôt @ 800 ° C (Ω)',
    86713: 'Identifikácia súčasti držať výsledok (vypočítaná hodnota)',
    86714: '',
    86715: '',
    86716: '',
    86717: '',
    86718: '',
    86719: '',
    86720: 'Radič opis',
    86721: 'Unikátny kladné číslo pridelené kontrolórovi',
    86722: 'Kontrolné akcie',
    86723: 'Urobiť deadband hodnoty predstavujú odchýlku od SP, alebo absolútne hodnoty.',
    86724: 'Digitálny regulátor nízka Deadband',
    86725: 'Digitálny regulátor vysoké Deadband',
    86726: 'Digitálny regulátor na meškanie',
    86727: 'Digitálny regulátor vypnúť oneskorenie',
    86728: 'Digitálny regulátor vstupné typu',
    86729: 'Digitálny regulátor Vstupná identifikácia súčasti',
    86730: 'Digitálny regulátor výstup identifikácia súčasti',
    86731: '',
    86732: '',
    86733: '',
    86734: '',
    86735: '',
    86736: '',
    86737: '',
    86738: '',
    86739: '',
    86740: 'Recept Alarm opis',
    86741: 'Jedinečný recept Alarm ID (1-79)',
    86742: 'Sticky alarmy nezmizne po potvrdení',
    86743: 'Zastavenie alarmy neumožňujú systém postúpiť na ďalší krok.',
    86744: '',
    86745: '',
    86746: '',
    86747: '',
    86748: '',
    86749: '',
    86750: '',
    86751: '',
    86752: '',
    86753: '',
    86754: '',
    86755: '',
    86756: '',
    86757: '',
    86758: '',
    86759: '',
    86760: 'Príznak Descriptoin',
    86761: 'Jedinečné číslo priradené k vlajke. Povolený rozsah je závislá na vybratý typ vlajky.',
    86762: 'Označenie typu: vstupné / výstupné a špeciálny recept ',
    86763: '',
    86764: '',
    86765: '',
    86766: '',
    86767: '',
    86768: '',
    86769: '',
    86770: '',
    86771: '',
    86772: '',
    86773: '',
    86774: '',
    86775: '',
    86776: '',
    86777: '',
    86778: '',
    86779: '',
    86780: 'Jedinečné číslo ID udalosti (0-79)',
    86781: 'Typ udalosti: vstup alebo výstup ',
    86782: 'Real ID komponentu pre túto udalosť',
    86783: '',
    86784: '',
    86785: '',
    86786: '',
    86787: '',
    86788: '',
    86789: '',
    86790: '',
    86791: '',
    86792: '',
    86793: '',
    86794: '',
    86795: '',
    86796: '',
    86797: '',
    86798: '',
    86799: '',
    86800: 'Naplánované prestávka vo výkone skúšky sondy; Nastavte na 0 pre vypnutie automatického sonda skúšky',
    86801: 'Sada ktorá test(y) sonda spúšťať automaticky',
    86802: 'Minimálne sonda teploty požadované na spustenie testu',
    86803: '',
    86804: '',
    86805: '',
    86806: '',
    86807: '',
    86808: '',
    86809: '',
    86810: 'Maximálna sonda impedanciou, ktorá nestanovuje IMPEDANCIA VINA ALARM',
    86811: 'Čas, ktorý umožní sonde dosiahnuť 99% počiatočnej mV čítanie alebo prekročení IMPEDANCIA zotavenie čas budenia je spustená',
    86812: 'Skrat odpor. Predvolená hodnota je 10 KΩ',
    86813: '',
    86814: '',
    86815: '',
    86816: '',
    86817: '',
    86818: '',
    86819: '',
    86820: 'Doba trvania napaľovanie Off krok.',
    86821: 'Čas, ktorý umožní sonde dosiahnuť 99% pre-burn z mV čítanie alebo prekročení zotavenie čas budenia je spustená',
    86822: 'Limit pre sondu teploty počas spáliť testu; Ak sa prekročí, teplota PREKROČILA poplachu.',
    86823: '',
    86824: '',
    86825: '',
    86826: '',
    86827: '',
    86828: '',
    86829: '',
    86830: 'Čas očistiť sonda s referenčný plyn',
    86831: 'Čas vzorky & priemerná teplota a mV',
    86832: 'Konečný čas oneskorenia pre sondy prispôsobiť proces atmosféru',
    86833: 'Obsah O2 referenčný plyn',
    86834: 'Dovolené chyby / odchýlky medzi sondou čítanie a odkaz plyn hodnotu ',
    86835: '',
    86836: '',
    86837: '',
    86838: '',
    86839: '',
    86840: 'MEMORY MAP',
    86841: 'I/O MAPPING',
    86842: 'CURRENT JOB MAPPING',
    86843: 'MISCELLANEOUS',
    86844: 'MMI MULTIPLIER',
    86845: 'PROBE TEST MAPPING',
    86846: 'CONTROLLER MAPPING',
    86847: 'I/O ALARMS MAPPING',
    86848: 'GENERAL',
    86849: 'NETWORK SETTINGS',
    86850: 'SET DATE/TIME',
    86851: 'I/Os',
    86852: 'Node Guarding',
    86853: 'Receive by RTR',
    86854: 'TCP CONNECTIONS',
    86855: 'TCP PORT NUMBER',
    86856: 'DISK SPACE ALARM (MB)',
    86857: 'Comp ID for OpCode Y',
    86858: 'Select Comp ID for input used in Y test',
    86859: 'The following communication ports are configured to use the same serial port:',
    86881: 'DISABLE ALL WDGS',
    86882: 'All backplane watchdogs will be disabled',
    86883: 'AI FILTERING',
    86884: 'Filter algorithm to be applied to internal AIs',
    86885: 'Moving Average',
    86886: 'Purified Average',
    86900: 'Point not found',
    86901: 'REGISTER',
    86902: 'POINT TYPE',
    86903: 'Analog Input',
    86904: 'Analog Output',
    86905: 'Digital Input',
    86906: 'Digital Output',
    86907: 'Actual Value',
    86908: 'Set Value',
    86909: 'VALUE TYPE',
    86910: 'ACCESS LEVEL',
    86911: 'Read',
    86912: 'Write',
    86913: 'Read/Write',
    86914: 'MULTIPLIER',
    86915: 'Unable save change to configuration file',
    86916: 'Must select a component',
    86917: 'This point can only be set to read',
    86918: 'Point no longer exists',
    86919: 'Wrong access level',
    86920: 'Point is already mapped',
    86921: 'NOT USED',
    86922: 'Invalid multiplier value',
    86923: 'Invalid register value',
    86924: 'Invalid access level',
    86925: 'Invalid value type',
    86926: 'Invalid point type',
    86927: 'Invalid component id',
    86928: 'IO Mapping Error(s)',
    86929: "Point can't have WRITE access",
    86930: 'Duplicate addressing',
    86931: 'Unable to read IO mapping data from configuration file',
    87000: 'NOT USED',
    87001: 'Date of last probe test',
    87002: 'Time of last probe test',
    87003: 'Probe maintenance interval',
    87004: 'Probe impedance max recovery time',
    87005: 'Probe burn off time',
    87006: 'Probe burn off max recovery time',
    87007: 'Probe impedance',
    87008: 'Probe impedance recovery time',
    87009: 'Probe burn off millivolts',
    87010: 'Probe burn off temperature',
    87011: 'Probe burn off recovery time',
    87012: 'Remaining time to next probe test',
    87013: 'Probe maintenance control',
    87014: 'Probe maintenance sequence indicator',
    87015: 'Start probe test only',
    87016: 'Start burn off only',
    87017: 'Start full maintenance',
    87018: 'Abort probe test',
    87021: 'REGISTER',
    87022: 'Address <%1> is already mapped in <%2>',
    87023: 'Invalid register value',
    87024: 'This address is already mapped to <%1>',
    87025: 'Address <%1> from <%2> is already mapped in <%3>',
    87026: 'Unable to read probe test mapping data from configuration file',
    87100: 'Invalid register value',
    87101: 'REGISTER',
    87200: 'Job is running',
    87201: 'Job is on hold',
    87202: 'Job number',
    87203: 'Recipe number',
    87204: 'Background recipe number',
    87205: 'Background recipe step number',
    87206: 'Recipe remaining soak time (sec.)',
    87207: 'Master timer',
    87208: 'Invalid multiplier value',
    87209: 'Invalid register value',
    87210: 'Invalid access level',
    87211: 'Current Program Alarm',
    87212: 'PARAMETER',
    87213: 'REGISTER',
    87214: 'MULTIPLIER',
    87215: 'Job parameter already used',
    87216: 'Register is reserved',
    87217: 'Foreground recipe step number',
    87218: 'Start Job',
    87219: 'Stop Job',
    87220: 'Hold Job',
    87221: 'Start/Stop Job',
    87222: 'Pause Job',
    87300: 'Invalid multiplier value',
    87301: 'Invalid register value',
    87302: 'Invalid access level',
    87303: 'PARAMETER',
    87304: 'REGISTER',
    87306: 'NOT USED',
    87307: 'Register is reserved',
    87308: 'MULTIPLIER',
    87400: 'Remote Mode Status',
    87401: 'Auto Mode Status',
    87402: 'Invalid control flag',
    87403: 'Invalid parameter',
    87404: 'Controller not found',
    87405: 'PARAMETER',
    87406: 'Controller parameter already mapped',
    87407: 'Unable to load controller mapping from configuration file.',
    87420: 'TRIM DEFAULT VAL.',
    87421: 'Value when reading is not available',
    87422: 'GET TRIM FROM',
    87423: 'Select point type (input/output) for trim',
    87424: 'SELECT TRIM CHANNEL',
    87425: 'Select channel that reads trim value',
    87426: 'TRIM AV/SP',
    87427: 'Value comes from Actual Value or the Set Point?',
    87428: 'MAX TRIM',
    87429: 'Set max offset for ratio (+/-)',
    87430: 'AIR DEFAULT FLOW',
    87431: 'Air flow when reading is not available',
    87432: 'SELECT AIR CHANNEL',
    87433: 'Select channel that reads air flow',
    87434: 'AIR AV/SP',
    87435: 'Value comes from Actual Value or the Set Point?',
    87436: 'BASE RATIO',
    87437: 'Base ratio constant AIR/GAS',
    87438: 'GAS CHANNEL',
    87439: 'Select channel to set GAS flow',
    87440: 'FINAL RATIO',
    87441: 'Compensated ratio AIR/GAS',
    87442: 'TEMP. USER DEFINED',
    87443: 'Value set by user when reading is not available',
    87444: 'REACTION COEFF.',
    87445: 'Chemical Reaction Coefficient',
    87446: 'TOTAL FLOW ID.',
    87447: 'Point that holds calculated total flow',
    87450: 'ACTUAL VALUE',
    87451: 'SET POINT',
    87500: 'Backup/Restore',
    87501: 'Folder not found',
    87502: 'Unable to create folder',
    87503: 'If a custom backup already exists on the target device, it will be overwritten. Continue?',
    87504: 'Unable to clear backup folder',
    87505: 'Backup',
    87506: 'No files were selected',
    87507: 'Unable to copy file',
    87508: 'Backup completed successfully',
    87509: 'Unable to calculate checksum value for the following file',
    87510: 'Unable to write',
    87511: 'No backup folder found',
    87512: 'Restore will overwrite any files that already exist and when finished will restart controller. Continue?',
    87513: 'Restore will overwrite any files that already exist and when finished will restart application. Continue?',
    87514: 'Restore will overwrite any files that already exist. Continue?',
    87515: 'File not found',
    87516: 'Invalid checksum value',
    87517: 'Unable to overwrite file during restore',
    87518: 'Unable to create folder',
    87519: "Checksum values don't match between the following two files",
    87520: 'Restore completed successfully',
    87521: 'Destination folder not found and was unable to create it.',
    87522: 'Unable to access external media.',
    87523: 'No external drive has been defined on this system. Please verify system configuration or environment variable',
    87524: 'Backup/restore has processed all files but the following error(s) have occurred',
    87525: 'Backup/restore stop processing files after to many errors. Below are some of the errors that have occurred',
    87526: 'Please wait while files are copied ...',
    87527: 'The following file has changed after it was copied',
    87528: 'No permission to read file',
    87529: 'No files to import',
    87530: 'The following folder containing files to import was not found',
    87531: 'The following folder containing files to export was not found',
    87532: 'No files to export',
    87533: 'The following folder containing files to delete was not found',
    87534: 'No files to delete',
    87535: 'File not found',
    87536: 'Unable to write the following file',
    87537: 'Verify if there is enough space.',
    87538: 'Backup failed',
    87539: 'Restore failed',
    87542: 'Application will now restart',
    87543: "The checksum value of the following file does not match it's checksum value when it was first backed up.",
    87544: 'Controller will now restart',
    87545: 'Unable to create temp backup folder prior to restore',
    87546: 'Unable to rename file',
    87547: 'Unable to rename folder',
    87548: 'Unable to remove folder',
    87549: 'Creating persistent backup (TC Backup)',
    87550: 'Unable to open file',
    87551: 'Unable to write to file',
    87552: 'Unable to sync file',
    87553: 'No write access permission for file',
    87554: 'Unable to read from file',
    87555: 'Device not found',
    87556: 'No read access permission for file',
    87557: 'Unable to read to file',
    87558: 'List of backup files is empty',
    87559: 'Invalid file format',
    87560: 'Many more files where not found. To many of them to display',
    87561: 'Failed to disable internal I/O watchdog. Operation aborted',
    87562: 'Environment variable not defined',
    87563: 'Full Backup',
    87564: 'Full Restore',
    87565: 'Custom Backup',
    87566: 'Custom Restore',
    87567: 'FULL BACKUP/RESTORE',
    87568: 'CUSTOM BACKUP/RESTORE',
    87569: 'Restore from - Select One',
    87570: 'Select files/folders to backup',
    87571: 'Select files/folders to restore',
    87572: 'Following message(s) are generated',
    87573: 'WARNING: Restore is partialy completed!',
    87574: 'Failed to make persistent backup!',
    87575: 'There are no files to restore',
    87576: 'No files where backed up',
    87577: 'A time out occurred while trying to copy file',
    87578: 'Bypass checksum validation',
    87600: 'Component <%1> is already mapped in <%2>',
    87601: 'This will remove all alarm mappings permanently. Continue?',
    87602: 'This will add all missing alarm mappings. Continue?',
    87603: 'Error trying to read data from configuration file for alarm mapped points.',
    87604: 'I/O Alarms Mapping Error',
    87700: 'TIMERS',
    87701: 'FLAG ID',
    87702: 'Range',
    87703: 'DESCRIPTION',
    87704: 'Description',
    87705: 'COUNT OPTION',
    87706: 'Count up or down',
    87707: 'Count Up',
    87708: 'Count Down',
    87709: 'Basic',
    87710: 'Guaranteed Soak',
    87711: 'Guaranteed Start',
    87712: 'Guatanteed Speed',
    87713: 'Unknown',
    87714: 'Type',
    87715: 'Select type of timer',
    87716: 'RESET DI',
    87717: 'Select DI to reset timer',
    87718: 'START DI',
    87719: 'Select DI to start/resume timer',
    87720: 'HOLD DI',
    87721: 'Select DI to hold timer',
    87722: 'SP AI',
    87723: 'Select AI to hold SP value',
    87724: 'PV AI',
    87725: 'Select AI to monitor for guaranteed timer functions',
    87726: 'TIME EXCEEDS DO',
    87727: 'DO to activate when time elapses',
    87728: 'HIGH LIMIT',
    87729: 'In units of process value AI',
    87730: 'LOW LIMIT',
    87731: 'Timer already exists',
    87732: 'Invalid flag number',
    87733: 'Invalid type',
    87734: 'Reset DI point does not exist',
    87735: 'Start DI point does not exist',
    87736: 'Hold DI point does not exist',
    87737: 'Invalid time SP AI',
    87738: 'Invalid process value AI',
    87739: 'Time exceeds DO point does not exist',
    87740: 'Invalid high limit',
    87741: 'Invalid low limit',
    87742: 'The following AI point does not exist',
    87743: 'Either high or low limit must have a value but not both',
    87744: 'Unable to load timer data from configuration file',
    87745: 'Unable to remove timer data from configuration file',
    87746: 'Unable to add timer data to configuration file',
    87747: 'Must select a process value',
    87748: 'High limit must be grater then low limit',
    87749: 'REFERENCE NUMBER',
    87750: 'Reference No.',
    88000: 'ANALOG INPUTS',
    88001: 'ANALOG OUTPUTS',
    88002: 'DIGITAL I/Os',
    88003: '',
    88004: 'EXTERNAL AIs',
    88005: 'EXTERNAL AOs',
    88006: 'EXT.DIGITAL I/Os',
    88007: 'ALARMS',
    88008: 'ADDRESS 1',
    88009: 'ADDRESS 2',
    88010: 'ADDRESS 3',
    88011: 'COLD JUNCTION',
    88012: 'Invalid description',
    88013: 'Invalid unit',
    88014: 'Invalid address 1',
    88015: 'Invalid address 2',
    88016: 'Invalid address 3',
    88017: 'Invalid driver',
    88018: 'Invalid device type',
    88019: 'Invalid min',
    88020: 'Invalid max',
    88021: 'Invalid number of decimals',
    88022: 'Delay to turn ON DO',
    88023: 'Retransmit point',
    88024: 'Retransmit Value Type',
    88025: 'Retransmit Time(sec)',
    88026: 'Retransmit Error',
    88027: 'Value',
    88028: 'Set Value',
    88029: 'CONFIGURE CJ COMPENSATION',
    88030: 'Default (on-board measurement)',
    88031: 'External - temperature measurement',
    88032: 'External - mV source',
    88033: 'Internal AI channel',
    88034: 'CJ compensation add. 1',
    88035: 'CJ compensation add. 2',
    88036: 'CJ compensation add. 3',
    88037: 'Invalid CJC add. 1',
    88038: 'Invalid CJC add. 2',
    88039: 'Invalid CJC add. 3',
    88040: 'Disabled',
    88041: 'Delay to turn off DO',
    88042: 'Invalid cycle time',
    88043: 'Cycle Time must be less than or equal to the the control update time value.',
    88044: 'Switches need to be repositioned. Continue?',
    88100: 'Time Zone',
    88101: 'Set Time Zone',
    88102: 'Time zone data folder not found',
    88103: 'Time zone data file not found',
    88104: 'Unable to set time zone',
    88105: 'Unable to save time zone',
    88106: 'Unable to load time zone data file',
    88107: 'Saving date/time configuration, please wait ...',
    88108: 'Must select a time zone',
    88109: 'Invalid year',
    88110: 'Invalid month',
    88111: 'Invalid day',
    88112: 'Invalid hour',
    88113: 'Invalid minute',
    88114: 'Get time from network',
    88115: 'Pools',
    88116: 'Servers',
    88117: 'SUCCESS',
    88118: 'UPDATING',
    88119: 'SOURCE OFFLINE',
    88120: 'ADDRESS UNKNOWN',
    88121: 'FAIL',
    90000: 'Typ zariadenia',
    90001: 'Popisuje základné úlohy zariadenia',
    90002: 'Stručne povedané, všetky druhy predpokladať pece okrem posledného typu (ostatné). Zariadenia typu: NITRIDÁCIA, NITROCEMENTOVANIE a NITRIDAČNÁ s VÁKUUM, vyžadujú existenciu prívod plyny, atmosféra pece, H2 analyzer(s), Kn – to má preddefinované ID komponentu pre štandardné generovaných. Zariadenia typu VÁKUUM nevyžaduje atmosféru, má pre štandardné generovaných preddefinované ID komponentu. Zariadenie typu "Ostatné" je možné úplne prispôsobiť užívateľovi, je to čierna skrinka s generovaných čítanie/napísal a radiče ovládať niečo. ',
    90003: 'Id zariadenia',
    90004: 'Jedinečný kód pre zariadenia vnútri závodu',
    90005: 'Unikátny kód je potrebné aby zariadenia môže byť identifikovaný v sieti NPM alebo PT9800, alebo pri sledovaní LOG súbory s stand-alone nástroj. Kód sa objaví na obrazovke používateľské rozhranie a log súbory/grafy.',
    90006: 'Názov spoločnosti',
    90007: 'Názov spoločnosti alebo oddelenie',
    90008: 'Názov spoločnosti sa zobrazí na obrazovke používateľské rozhranie a log súbory/rebríčky.',
    90009: 'Názov zariadenia',
    90010: 'Jedinečný názov zariadenia',
    90011: 'Názov zariadenia sa objaví na obrazovke používateľské rozhranie a log súbory/grafy.',
    90012: 'Menová jednotka',
    90013: 'Menová jednotka opis',
    90014: 'Vyberte jednotku z drop-dole zoznam, alebo ak nie našiel, zadajte názov menovej jednotky alebo symboly. Toto pole sa používa, keď zobrazovanie výrobných nákladov.',
    90015: 'Pec objem (l)',
    90016: 'Použiteľné pre atmosferické kotly',
    90017: 'Objemu pece je veľmi dôležitým parametrom pre pece s atmosférou. Ak je zadaná hodnota menšia ako skutočný objem, to povedie k zlý výpočet atmosféru v peci a ohrozí bezpečnosť systému. Tiež, nesprávna hodnota spôsobí chyby vo výpočte KN.',
    90018: 'Časový limit pre odhlásenia (min)',
    90019: 'Oneskorenie pre automatické odhlásenie (minút)',
    90020: 'Ak neexistuje žiadna myš/klávesnica činnosť preddefinované obdobie, automatické log-off sa stane a načíta predvolený používateľ povolenie.',
    90021: 'Čas obnoviť prácu po poruche napájania (min)',
    90022: 'Maximálny čas v minútach na obnovenie po zlyhaní napájania.',
    90023: 'Najdlhšia oneskorenie prijateľné práce budú pokračovať po zlyhaní napájania. Ak je systém vypnutý dlhšie než preddefinovaného časového, nitridom softvér automaticky prerušíte prácu. Nastavená na 0 vypnúť automatické prerušenie. ',
    90024: 'Konfigurácia cesta',
    90025: 'Zložku, kde sú uložené konfiguračné súbory',
    90026: 'Zložku, kde sú uložené konfiguračné súbory. Cesta je relatívna umiestnenie kde nitridom konfigurácie systému súborov.CFG súboru býva.',
    90027: 'Denník cesta',
    90028: 'Zložku, kde sú uložené súbory denníka',
    90029: 'Zadajte úplnú cestu, ako C:\\nitrex\\MyFolder, alebo relatívnu cestu. Pre relatívnu cestu, predchádzajúci znak $ požaduje, ako $Myfolder. Relatívna cesta je relatívna miesto bydliska spustiteľný súbor aplikácie.',
    90030: 'Zdroj cesta',
    90031: 'Zložku, kde sú uložené jazykové súbory prostriedkov',
    90032: 'Zadajte úplnú cestu, ako C:\\nitrex\\MyFolder, alebo relatívnu cestu. Pre relatívnu cestu, predchádzajúci znak $ požaduje, ako $Myfolder. Relatívna cesta je relatívna miesto bydliska spustiteľný súbor aplikácie.',
    90033: 'Watchdog typu',
    90034: 'Typ počítača Watchdog',
    90035: 'Vyberte typ z drop-down menu. Nesprávny výber ohrozí správnu funkčnosť systému a môže poškodiť zaťaženia pece',
    90036: 'Validácia Analyzer čítanie',
    90037: 'Zapína/vypína nejaké potvrdenie H2 analyzátor čítania',
    90038: 'Ak je zakázaná, nitridom softvér akceptuje ako platná H2 čítanie, kedy je nižšie (vypočítaná) obsah oddeliť čpavok v peci. ',
    90039: 'Tabuľa Font',
    90040: 'Rodina nastaviť písmo a veľkosť pre tabule',
    90041: 'Zmeniť písmo tabuľa, použite túto syntax: FontFamilyName_size. Príklad: system_9 alebo arial_12 alebo courier_10 ',
    90042: 'Disk Space Alarm (MB)',
    90043: 'Horný limit voľného miesta na disku alarm',
    90044: 'Keď voľné miesto na disku je menšia ako táto hodnota, spustí alarm na nedostatok miesta na disku. Disk Space Alarm hodnota by mala byť nižšia než hodnota Disk Space upozornenie.',
    90045: 'Upozornenie na disku (MB)',
    90046: 'Horný limit zadarmo disk space upozornenie',
    90047: 'Keď voľné miesto na disku je menšia ako táto hodnota, spustí upozornenie na nedostatok miesta na disku. Disk Space upozornenie hodnota by mala byť vyššia ako hodnota Disk Space poplach.',
    90048: 'Povoliť počítaču Watchdog',
    90049: 'Zapína/vypína počítač watchdog.',
    90050: 'Tento atribút je vyhradená pre vývojárov použitie. Mala by nikdy byť nastavená na hodnotu false.',
    90051: 'Zapnúť plán Štart',
    90052: 'Zapína/vypína oneskorený Štart práce.',
    90053: 'Zrušte začiarknutie políčka pre zákazníkov, ktorí si ani kúpiť túto možnosť. ',
    90054: 'Štart neutralizátorom',
    90055: 'Turn ON neutralizátorom v prvej fáze.',
    90056: 'Ak je toto políčko začiarknuté, neutralizačné začína, keď práca začína inak (nekontrolovaná políčko), neutralizačné začne vo fáze, ktorá žiada čpavok alebo oddeliť čpavok',
    90057: 'Vymazať pracovných údajov na Štart',
    90058: 'Udržuje alebo odstráni údaje zadané pri práce bolo naložené.',
    90059: 'Zákazníci, ktorý vždy spustiť rovnaký recept, pre toho istého zákazníka, môžu využiť prácu načítať dáta sa uloží a naložený znova zakaždým, keď začína novú prácu. ',
    90060: 'Krok prietok (l/min)',
    90061: 'Prietok nábeh krok v l/min',
    90062: 'Aby sa zabránilo veľké výkyvy tlaku pri dramaticky zmena toku, prietok sa zvyšuje/znižuje v krokoch. Ak krok je nastavený na 0, tam je žiadne ramping v toku',
    90063: 'Kód účinnosť procesu na veľké',
    90064: 'Zmení kód recept na veľké',
    90065: 'Keď sa od práce SCADA systémov, že ignorovať prípade kódexu recept.',
    90066: 'Horúce pohotovostnom recepty',
    90067: 'Zoznam všetkých nakonfigurovaný pohotovostnom recept súbory.',
    90068: 'Tento riadok obsahuje názvy všetkých nakonfigurovaných hot-pohotovostný recepty. Zoznam je ohranièený | charakter. Príklad: SB1.pro|Sb2.Pro|SB3.Pro',
    90069: 'Životopis Standby',
    90070: 'Pokračovať alebo reštartovať Standby recept ',
    90071: 'Pri kontrole pohotovostnom recept bude pokračovať po výpadku prúdu alebo keď nitridom aplikácie reštartuje. Keď nekontrolovaná, pohotovostný recept začína od nuly každý uplatnenie nitridom reštartuje. Nitrex predvolené nie je pokračovať v pohotovostnom recept.',
    90072: 'Šifrovať súbory denníka',
    90073: 'Nastavenie šifrovania súborov denníka.',
    90074: 'Log súbory by mali vždy byť šifrovaná.',
    90075: 'Max čas (dni) ',
    90076: 'Max oneskorenie spustenia plánovanej úlohy.',
    90077: 'Táto vlastnosť určuje, či naplánovanej úlohy by mala začať akonáhle žiadosť a plánovaný čas už uplynul. Nastavenie hodnoty na kladné číslo, umožňuje nitridom aplikácie na spustenie úlohy, keď aktuálny čas je menšia ako plánovaný čas plus max. odstávky. Príklad: Nitridom aplikácia bola nadol pre viac ako 30 hodín. Nitridom aplikácia je späť v novembri 10th 2010 @ 8:15 AM; Úlohou bolo naplánované na November 9th 2010 @ 6:00 AM. Ak je to max. odstávok bol stanovený na 1 deň, bude zrušená naplánovaná úloha. Avšak, ak je to max. odstávok bol stanovený na 2 dni, naplánovaná úloha spustí na November 10th 2010 @ 8:15 AM. ',
    90078: 'Hodnota Max Graph',
    90079: 'Max. Y hodnota pre graf. ',
    90080: 'Tento parameter je použitý filter extrémne vysoké hodnoty pre Kn, keď sú nízke teploty a obsah čpavok v peci.',
    90081: 'Skryť panel úloh',
    90082: 'Skryť panel úloh a zakáže Ctrl-Alt-Del',
    90083: 'Skryť panel úloh by mala byť vždy zapnutá. Táto vlastnosť je spojený s používateľovi. Keď skryť panel úloh je povolená, to bude platiť pre používateľov, ktorí nemajú prístup k Ukončite aplikáciu. Vlastnosť tiež zakáže Task Manager a vypnutie po stlačení kombinácie klávesov Ctrl-Alt-Del. ',
    90084: 'Sériový Port číslo',
    90085: 'Sériový Port číslo',
    90086: 'Vlastnosť slúži pre vstupno-výstupných ovládačov, ktoré komunikujú s generovaných cez sériový port (Opto).',
    90087: 'Prenosová rýchlosť',
    90088: 'Oznámenie Baud Rate',
    90089: 'Vlastnosť slúži pre vstupno-výstupných ovládačov, ktoré komunikujú s generovaných cez sériový port (Opto). Všetky zariadenia na sériovej siete potrebné nastaviť na rovnakú prenosovú rýchlosť.',
    90090: 'Obrat Timeout (sec)',
    90091: 'Nastaviť zdržanie (sec)',
    90092: 'Vlastnosť slúži pre Opto vstupno-výstupnom ovládači. To predstavuje max. odklad uplatňovania nitridom čakať na odpoveď od slave. Ak neexistuje žiadna odpoveď v stanovenom termíne, sa vygeneruje chybu /alarm. ',
    90093: 'Počet opakovaní',
    90094: 'Nastaviť maximálny počet opakovaní komunikácie.',
    90095: 'Nastaviť počet opakovaní ovládač pokúsi odoslať príkaz pred vráti chybové hlásenie.',
    90096: 'Strážca času',
    90097: 'Nastaviť Watchdog meškanie na generovaných',
    90098: 'Watchdog časovač býva v mozgu dosky I/O. Každý čas dosky v mozgu dostane žiadosť od hlavného (ovládanie aplikácie), strážca časovač na palube mozgu je reset. Ak neexistujú žiadne požiadavky z predlohy (ovládanie aplikácie) dlhšie ako zadaný čas, dosky v mozgu sa nastaví všetky výstupné kanály, analógové a digitálne, nulové signál.',
    90099: 'Zapĺňať Gradient (torr/min)',
    90100: 'Tlak svahu v štádiu zapĺňať',
    90101: 'Priemerný tlak svahu v štádiu zapĺňať. Vždy kladné číslo.',
    90102: 'Pohode Gradient (° C/min)',
    90103: 'Chladenie svahu',
    90104: 'Priemerná teplota svahu (vždy pozitívne), meraná tým hlavného termočlánok. Vzťahuje sa na fázach, ktoré majú koniec podmienka cool alebo pec v pohode.',
    90105: 'Výplne prechodu (torr/min)',
    90106: 'Tlak svahu',
    90107: 'Priemerný tlak svahu v etapách, ktoré nátlaku pece (koniec podmienka je tlak). Vždy kladné číslo.',
    90108: 'Teplo Gradient (° C/min)',
    90109: 'Kúrenie svahu',
    90110: 'Priemerná teplota svahu, meraná tým hlavného termočlánok. Vždy kladné číslo. Vzťahuje sa na fázach s podmienkou ukončenia teplo alebo teplo pece.',
    90111: 'Potenciál prechodu/min.',
    90112: 'Priemerný pokles Kn v prvej fáze Kúrenie.',
    90113: 'Parameter sa používa iba v systémoch s včlenené Kn simulačný model.',
    90114: 'Vákuové Gradient (torr/min)',
    90115: 'Vákuové rýchlosť vo vákuovej etapy.',
    90116: 'Priemerná vákuové svahu vákuové fázach.',
    90117: 'Pohode Limit (° C)',
    90118: 'Minimálna teplota koncom-štádiu',
    90119: 'Minimálna hodnota teploty koniec stave. Platí pre štádiá s konečnými podmienkami pece COOL alebo čas COOL. Zvyčajne je to číslo medzi 80 a 100 (okrem nízkoteplotné kotly). Hodnoty, ktoré sú príliš nízke, môže viesť k nekonečné pohode fáze, ako štandardný hardvér zvyčajne nemôže ochladiť pod 60 ° C. ',
    90120: 'Teplo Limit (° C)',
    90121: 'Maximálne koncom etapy teplota.',
    90122: 'Maximálna hodnota teploty pri fáze koniec podmienka je TEPLOM z vysokej pece. Tento parameter sa používa na ochranu hardware (pec). By mali byť nižšie nastavenie ochrany prehriať. Obyčajne je nastavená na 600 ° C',
    90123: 'Max. Teplota NH3 (° C) ',
    90124: 'Teplotu, pri ktorej miešania NH3 vzduchom bezpečné.',
    90125: 'Max. teplota pri ktorej NH3 plynu môžu byť zavedené v peci s akýmkoľvek obsahom vzduchu. Pre maximálnu bezpečnosť a systémy s dissociator na výfuku nastavená na 20 ° C. Predvolená hodnota je 400 ° C. Riadenie je potrebné povolenie prepísať predvolenú hodnotu.',
    90126: 'Max. Vzduchu pre NH3 (%) ',
    90127: 'Max. povolený obsah vzduchu, bezpečné mix s NH3 pri akejkoľvek teplote. ',
    90128: 'Maximálny povolený obsah vzduchu do pece, ktoré uľahčuje bezpečné zaviesť NH3 plynu, pri akejkoľvek teplote. Nitrex predvolená hodnota je 14%. Riadenie je potrebné povolenie prepísať predvolenú hodnotu.',
    90129: 'Max. Vzduchu pre Diss. NH3 (%) ',
    90130: 'Max. povolený obsah vzduchu, bezpečné mix s DNH3 pri akejkoľvek teplote. ',
    90131: ' Maximálny povolený obsah vzduchu do pece, ktoré uľahčuje bezpečné zaviesť dNH3 plynu, pri akejkoľvek teplote. Nitrex predvolená hodnota je 1%. Riadenie je potrebné povolenie prepísať predvolenú hodnotu.',
    90132: 'Max. Posledná etapa teplota.(°C)',
    90133: 'Bezpečnú teplotu pre otvorenie pece.',
    90134: 'Maximálna povolená teplota pod ktorou je bezpečné otvoriť pece. Nitrex predvolená hodnota je 100 ° C.',
    90135: 'Max. Posledná etapa NH3 (%) ',
    90136: 'Bezpečné NH3 obsah pre otvorenie pece',
    90137: 'Maximálny povolený obsah NH3 v peci, ktoré uľahčuje bezpečné otvoriť pece. Nitrex predvolená hodnota je 1%. Riadenie je potrebné povolenie prepísať predvolenú hodnotu.',
    90138: 'Max. Posledná etapa DNH3 (%) ',
    90139: 'Bezpečné DNH3 obsah pre otvorenie pece',
    90140: 'Maximálny povolený obsah diss. NH3 v peci, ktoré uľahčuje bezpečné otvoriť pece. Nitrex predvolená hodnota je 1%. Riadenie je potrebné povolenie prepísať predvolenú hodnotu.',
    90141: 'Zapĺňať teplota Limit (° C)',
    90142: 'Max teploty vo vákuu/zapĺňať. ',
    90143: 'Teplota pod ktorou je bezpečné vákuové/zapĺňať (hardware ochrana). Nitrex predvolená hodnota je 350 ° C.',
    90144: 'Predvolené vákuové Setpoint (torrov)',
    90145: 'Predvolené vákuové Setpoint (torrov)',
    90146: 'Predvolené vákuové Setpoint (torrov)',
    90147: 'Min. vákuum úrovni (torrov)',
    90148: 'Limit pre vákuový set bod a koniec stave.',
    90149: 'Limit na overenie vákuové etáp. Etapy s vákuové koncová hodnota pod hranicou vynesie chybné a recept sa neuložia. Hodnota závisí od schopnosti vákuovej pumpy. Predvolená hodnota je 5 torr. Uvedenie hodnoty príliš nízke môže viesť k nekonečnej fáze.',
    90150: 'Max. Požadovanej hodnoty tlakového rozdielu (torrov)',
    90151: 'Horný limit pre tlak SP a tlak PLUS koniec stav. ',
    90152: 'Hodnota slúži na overenie recepty a chrániť pece proti pretlak.',
    90153: 'Min. tlak Setpoint (torrov)',
    90154: 'Nižší limit pre tlak SP a tlak mínus stav konca.',
    90155: 'Hodnota slúži na overenie recepty a zabrániť nekonečné fáz (etáp, ktoré nemôže splniť účel stav)',
    90156: 'Atmosferický tlak čítanie (torrov)',
    90157: 'Atmosferický tlak čítanie tlakového snímača comp ID 18 ',
    90158: 'Obvykle hlavné tlakovým snímačom je snímaču diferenciálneho tlaku a atmosferický tlak 0 torr. Používa sa niekedy absolútna tlakovým snímačom. V tomto prípade atmosférického tlaku závisí od nadmorskej výšky, počasia (vlhkosť). Poveternostné podmienky sa líšia, je očakávať priemernú hodnotu. Nitrex štandardne 760 torr. Dôrazne odporúča nastavenie tejto hodnoty na miesto kde je nasadený systém.',
    90159: 'Atmosferický tlak čítanie vákuové snímača (torrov)',
    90160: 'Atmosferický tlak čítanie vákuové snímača – comp ID 20 ',
    90161: 'Atmosferický tlak závisí od nadmorskej výšky, počasia (vlhkosť). Poveternostné podmienky sa líšia, je očakávať priemernú hodnotu. Táto hodnota sa používa na výpočet bodu (a generovať alarmy/núdze) na absolútna tlakovým snímačom v etapách, ktoré neriadia vákuum. Napríklad ak je priemerná atmosférický tlak 740 torr a ak fáze má 3 torr žiadané na hlavnej - diferenciálnemu tlakovému prevodníku, nastaviť bod na absolútna tlakovým snímačom sa vypočíta ako 740 + 3 = 743 torr. Absolútna tlakovým snímačom je získanie žiadanej 743 torr a teraz je schopný generovať alarmy a mimoriadnych udalostí na základe stanovenia bodu.',
    90162: 'Min. Poslednej fáze vákua (torrov)',
    90163: 'Obmedzenia pre úroveň podtlaku na konci recept.',
    90164: 'Parameter slúži na overenie recept. Posledná etapa recept by v blízkosti atmosférický tlak umožňuje ľahké otvorenie pece. Táto hodnota predstavuje hranicu pre úroveň podtlaku. Ak recept končí vákuové úroveň vyššiu ako je limit, recept nebude platné.',
    90165: 'Zapnutie siete Štart',
    90166: 'Nastaviť prístup k vzdialene spustiť úlohu.',
    90167: 'V predvolenom nastavení vypnutá vzdialený Štart. V osobitných prípadoch, keď Nitrex kontrolný systém je spojený s PT9800 Automat, vzdialený Štart práce musí byť povolená.',
    90168: 'Zapnúť vzdialenej manuálny režim',
    90169: 'Nastaviť prístup do manuálneho režimu zo vzdialeného počítača. ',
    90170: 'Nitrex politiky je vypnúť manuálna prevádzka pece zo vzdialeného počítača. Prepísať predvolené nastavenie je potrebné povolenie správy. ',
    90171: 'Číslo portu termočlánokP',
    90172: 'Číslo portu určené pre komunikáciu s NPM. ',
    90173: 'Číslo portu, ktorý otvorí ovládanie počítača na prijímanie žiadostí od vzdialeného počítača (NPM). Port číslo potrieb zodpovedali jednej nastaviť v konfiguračnom súbore NPM.',
    90174: 'Počet pripojení Socket',
    90175: 'Max. možnosť pripojenia zásuvky.',
    90176: 'Nastavte hodnotu na 0, ak nie je žiadny NPM v systéme. Nastavte hodnotu 10 ak NPM je nainštalovaný.',
    90177: 'Na čas (sekundy)',
    90178: 'Šírka impulzu (sec)',
    90179: 'Sa vzťahuje na nitridáciu systémov s Turbo chladenie a butterfly ventil ovládaný dvoma DOs. Jeden robiť sa používa na otvorenie a dá robiť sa používa pre uzatvorenie ventilu. Otvorenie prebieha pomaly s impulzy, aby sa zabránilo poklesu tlaku v peci. Tentoraz predstavuje šírka impulzu je signál, že otvára ventil',
    90180: 'Off Time (sec)',
    90181: 'Oneskorenie medzi dvoch impulzov (sec)',
    90182: 'Sa vzťahuje na nitridáciu systémov s Turbo chladenie a butterfly ventil ovládaný dvoma DOs. Jeden robiť sa používa na otvorenie a dá robiť sa používa pre uzatvorenie ventilu. Otvorenie prebieha pomaly s impulzy, aby sa zabránilo poklesu tlaku v peci. Tentoraz predstavuje oneskorenie medzi dvoma impulzov. ',
    90183: 'Turbo chladenie objem (l)',
    90184: 'Turbo chladiaci výmenník tepla objem (l)',
    90185: 'Turbo chladenie objem je dôležitým parametrom. Ak je zadaná hodnota menšia ako skutočný objem, to bude mať za následok nesprávny výpočet atmosféru v peci a ohrozí bezpečnosť systému.',
    90186: 'Cesta k súboru procesu',
    90187: 'Zložku, kde sú uložené súbory recept',
    90188: 'Zadajte úplnú cestu, ako C:\\nitrex\\MyFolder, alebo relatívnu cestu. Na relatívnu cestu, predchádzajúci znak $ požaduje, ako $Myfolder. Relatívna cesta je relatívna miesto bydliska spustiteľný súbor aplikácie.',
    90189: 'Núdzové cesty',
    90190: 'Priečinok, kde sú uložené súbory núdzové recept',
    90191: 'Zadajte úplnú cestu, ako C:\\nitrex\\MyFolder, alebo relatívnu cestu. Na relatívnu cestu, predchádzajúci znak $ požaduje, ako $Myfolder. Relatívna cesta je relatívna miesto bydliska spustiteľný súbor aplikácie.',
    90192: 'Povoliť zapisovanie do denníka počas pohotovostného',
    90193: '',
    90194: '',
    90195: 'Povoliť panel ikony',
    90196: '',
    90197: '',
    90600: 'Všeobecne',
    90601: 'Bezpečnosť',
    90602: 'Spotreba',
    90603: 'Opto',
    90604: 'NPM',
    90605: 'Hodnota',
    90606: 'Uložiť ako',
    90607: 'Konfigurácia systému',
    90608: 'Vyberte parametre konfigurácie systému pridať',
    90609: 'Untitled',
    90610: 'Nastavenie',
    90611: 'Staré Turbo',
    90612: 'Nové Turbo',
    90613: 'Turbo štýl',
    90614: 'Typ komunikácie IO',
    90615: 'Optomux',
    90616: 'DPN',
    90617: 'Hilscher',
    90618: 'KBus',
    90619: 'Simmux',
    90620: 'VLP',
    90621: 'MMI 10Pro',
    90622: 'Modbus TCP',
    90623: 'Musíte vybrať typ IO',
    90624: 'Niektoré polia v kontrolovaných riadkov mať žiadne hodnoty',
    90625: 'Názov značky sa používa už.',
    90626: 'Tag názvu musí byť písmeno od A po Z.',
    90627: 'Tag',
    90628: 'Popis ID',
    90629: 'Formulár bol zmenený. Chcete zahodiť zmeny?',
    90630: 'Systém špecifické',
    90631: 'Konfigurácia cesty',
    90632: 'Konfigurácia bol úspešne uložený. Avšak niektoré parametre sú nesprávne nakonfigurované',
    90633: 'Tieto parametre sú povinné a musí mať hodnotu: ',
    90634: 'Tieto parametre nie sú správne nakonfigurované: ',
    90635: 'Tieto parametre boli chýbajúce a boli pridané: ',
    90636: 'Nie sú potrebné nasledovné parametre: ',
    90637: 'Konfigurovať spotreby',
    90638: 'Konfigurovať koeficient',
    90639: 'Zistilo sa neplatné koeficient',
    90640: 'Pomoc na spotrebu vytvoriť a upraviť: ',
    90641: 'Pomôcť vytvoriť alebo zmeniť koeficient: ',
    90642: 'Spotreba sekcia nie je povinná časť a nemá existovať. To je koncový užívateľ možnosť voľby sledovať spotrebu plynov, elektriny alebo akéhokoľvek meranej premennej v systéme. Spotreba sekcia je zoskupené v segmentoch. Segmenty, ktoré predstavujú tovary, že užívateľ chce sledovať a segmentmi, ktoré predstavujú koeficienty sa použijú na konverziu skutočné namerané hodnoty na konečnej podobe alebo jednotku. Upraviť spotrebu parametre kliknite na tlačidlo KONFIGUROVAŤ spotreby alebo KONFIGUROVAŤ koeficienty',
    90643: 'Spotreba sekcia nie je povinná časť a nemá existovať. To je koncový užívateľ možnosť voľby sledovať spotrebu plynov, elektriny alebo akéhokoľvek meranej premennej v systéme. Spotreba sekcia je zoskupené v segmentoch. Segmenty, ktoré predstavujú tovary, že užívateľ chce sledovať a segmentmi, ktoré predstavujú koeficienty sa použijú na konverziu skutočné namerané hodnoty na konečnej podobe alebo jednotku. Upraviť spotrebu parametre kliknite na tlačidlo KONFIGUROVAŤ spotreby alebo KONFIGUROVAŤ koeficienty',
    90644: 'Parametre podľa tejto skupiny nerozpoznal túto verziu nástroja Konfigurácia. To znamená, že tieto parametre sú buď zastarané, alebo zavedené po tento nástroj bol prepustený. Po uložení konfigurácie, tieto parametre zostane nedotknutý.',
    90645: 'Multiplikátor: ',
    90646: 'Neznámy',
    90647: 'Nakonfigurovať protokol Modbus TCP',
    90648: 'Modbus TCP',
    90649: 'Modbus RTU',
    90650: 'Turbo',
    90651: 'Nitridačná pec',
    90652: 'Nitro-Cementačná oceľ',
    90653: 'Vákuové pece',
    90654: 'Zomrieť pece',
    90655: 'Nitridačná s vákuové',
    90656: 'Iné zariadenia',
    90657: 'Konfigurovať Modbus RTU',
    90658: 'Host adresu Slave',
    90659: 'Toto je adresa pre túto otroka. Môžete upravovať viac paramters kliknutím na tlačidlo "Konfigurovať Modbus TCP".',
    90660: 'Pomocník pre vytvorenie upraviť Modbus TCP: ',
    90661: 'Slave',
    90662: 'Host',
    90663: 'Port',
    90664: 'Delay(MS)',
    90665: 'Int poradie bajtov',
    90666: 'Float poradie bajtov',
    90667: 'Žiadne prázdne polia povolený',
    90668: 'Duplicitné otrok nie je dovolené',
    90669: 'Duplicitné hostiteľa nie je dovolené',
    90670: 'Názov portu',
    90671: 'Toto je názov portu. Môžete upravovať viac paramters kliknutím na tlačidlo "Konfigurovať Modbus RTU".',
    90672: 'Prenosová rýchlosť',
    90673: 'Bitov',
    90674: 'Parita',
    90675: 'Stop Bit',
    90676: 'Čas Out(ms)',
    90677: 'Pokusy',
    90678: 'Prístavov',
    90679: 'Otroci',
    90680: 'Port s duplicitné otrok nie je dovolené',
    90681: 'Názov portu prázdne.',
    90682: 'PT455 ',
    90683: 'RTS Delay(ms)',
    90684: 'Konzumovať Echo',
    90685: 'Žiadne func. 16 ',
    90686: 'Unit ID',
    90687: 'CANopen',
    90688: 'Invalid slave address',
    90690: 'Bias',
    90691: 'Koeficient',
    90693: 'Signál povolené',
    90694: 'Max má väčšie ako Min',
    90695: 'Typ výpočtu',
    90696: 'Výpočet parametrov',
    90697: 'Určenia',
    90698: 'Hodnota',
    90699: 'Pomôcť',
    90700: 'Nepodarilo sa uložiť súbor',
    90701: 'Bez správne nakonfigurovaný proces výpočtu',
    90702: 'PAI/AO Comp ID pre výpočtu výsledku procesu je potrebné, ale nie je nakonfigurovaný',
    90703: 'Rovnakú identifikáciu Comp nakonfigurovaný pre výpočtu výsledku procesu by objaví len jedenkrát v konfigurácii',
    90704: 'Nasledujúce pole je potrebné, ale nie je nakonfigurovaný: ',
    90705: 'Proces kontroly výpočtu konfigurácia',
    90710: 'Kľúč',
    90711: 'Kontrolné akcie',
    90712: 'Nastaviť bod typu',
    90714: 'Nízka Deadband',
    90715: 'Vysoká Deadband',
    90716: 'Vypnúť oneskorenie (sec)',
    90717: 'Na oneskorenie (sec)',
    90718: 'Vstupné typ',
    90719: 'Vstupné Comp ID',
    90720: 'Výstup Comp ID',
    90721: 'obrátená',
    90722: 'priamy',
    90723: 'relatívna',
    90724: 'absolútna',
    90725: 'Zap-Vyp regulátory nastavenia',
    90726: 'Niektoré kľúčové je prázdne',
    90727: 'Kľúčom je, musí byť jedinečný',
    90728: 'Chýbajú hodnoty pre niektoré nízka/vysoká Deadband',
    90729: 'Upozornenie: ani popis, ani identifikácia prostriedku východy v niektorých konfigurácia radiča-Off! ',
    90730: 'Popis identifikátor prostriedku',
    90731: 'Chýbajú hodnoty pre niektoré Off/On meškanie',
    90732: 'Vysoká Deadband musí byť väčšia ako Low Deadband',
    90733: 'Nasledujúci Parameter je povinný: ',
    90749: 'Vlastná...',
    90750: 'Analógový regulátor',
    90751: 'Názov súboru na fuzzy',
    90752: 'Interval kontroly (s)',
    90753: 'Max výkon',
    90754: 'Max odchýlka výstup',
    90755: 'Min výstup',
    90756: 'Min odchýlka výstup',
    90757: 'Unsupported Function 16',
    90758: 'Unit ID',
    90759: 'Timeout',
    90760: 'SP Offset',
    90791: 'Fuzzy názov súboru musíte mať.FUZ ako prípona súboru',
    90792: 'Max výstup musí byť väčšie ako Min výstup',
    90793: 'Max odchýlka výstup musí byť väčšie ako Min odchýlka výstup',
    90794: 'Min/Max výstupu by mali byť ohraničené nasledujúcom rozsahu: ',
    90795: 'Min/Max odchýlka výstupu by mali byť ohraničené nasledujúcom rozsahu: ',
    90796: 'Obe Min/Max odchýlka výstup má byť väčšia než 0 ',
    90800: 'Analyzátor pomoc: PAI pre výpočtu výsledku ',
    90801: 'Analyzátor pomoc: Kn - Nitridačná potenciál ',
    90802: 'Analyzátor pomoc: Kn - disociácia pece ',
    90803: 'Analyzátor pomoc: Kn - vzorkovanie Line Elektromagnetický ventil ',
    90804: 'Analyzátor pomoc: Kc - uhlíka potenciál ',
    90805: 'Analyzátor pomoc: Kc - parciálneho tlaku CO ',
    90806: 'Analyzátor pomoc: Kc - parciálneho tlaku CO2 ',
    90807: 'Analyzátor pomoc: Kc - odber vzoriek Line Elektromagnetický ventil (voliteľný) ',
    90808: 'Analyzátor pomoc: Ko - kyslík potenciál ',
    90809: 'Analyzátor pomoc: Ko - kyslík sonda mV ',
    90810: 'Analyzátor pomoc: Ko - kyslík sonda teploty (voliteľný) ',
    90811: 'Analyzátor pomoc: Ko - odber vzoriek Line Elektromagnetický ventil (voliteľný) ',
    90812: 'Analyzátor pomoc: Nf - Nitridačná faktor ',
    90813: 'Analyzátor pomoc: Nf - disociácia pece ',
    90814: 'Analyzátor pomoc: Nf - Nitridačná potenciál ',
    90815: 'Analyzátor pomoc: Nf - odber vzoriek Line Elektromagnetický ventil (voliteľný) ',
    90816: 'Analyzátor pomoc: Kn1 - PE na nitridáciu potenciál ',
    90817: 'Analyzátor pomoc: Kn1 - disociácia pece ',
    90818: 'Analyzátor pomoc: Kn1 - parciálneho tlaku NH3 ',
    90819: 'Analyzátor pomoc: Kn1 - odber vzoriek Line Elektromagnetický ventil ',
    90820: 'Analyzátor pomoc: NW - dusík hmotnosť ',
    90821: 'Analyzátor pomoc: NW - Nitridačná potenciál ',
    90822: 'Analyzátor pomoc: NW - peci teploty ',
    90823: 'Analyzátor pomoc: NW - odber vzoriek Line Elektromagnetický ventil (voliteľný) ',
    90824: 'Analyzátor pomoc: LogO2 - Post-Oxidation kvantifikátor ',
    90825: 'Analyzátor pomoc: LogO2 - kyslík sonda mV ',
    90826: 'Analyzátor pomoc: LogO2 - kyslík sonda teploty (voliteľný) ',
    90827: 'Analyzátor pomoc: LogO2 - odber vzoriek Line Elektromagnetický ventil (voliteľný) ',
    90828: 'Analyzátor pomoc: LinearFunc - lineárnou funkciou ',
    90829: 'Analyzátor pomoc: LinearFunc - analógový vstup ',
    90830: 'Analyzátor pomoc: LinearFunc - signál povolené (nepovinné) ',
    90831: 'Analyzátor pomoc: LinearFunc - Bias ',
    90832: 'Analyzátor pomoc: LinearFunc - koeficient ',
    90833: 'Analyzátor pomoc: LinearFunc - Min (nepovinné) ',
    90834: 'Analyzátor pomoc: LinearFunc - Max (nepovinné) ',
    90835: 'Analyzer Help: Timer Function',
    90836: 'Analyzer Help: Error in percent',
    90837: 'Analyzer Help: Point Type',
    90840: 'Zap-Vyp regulátor pomoc: kľúč ',
    90841: 'Zap-Vyp regulátor pomoc: opis ',
    90842: 'Zap-Vyp regulátor pomoc: kontrolné akcie ',
    90843: 'Zap-Vyp regulátor pomoc: Nastavte bodového, typ ',
    90844: 'Zap-Vyp regulátor pomoc: nízka Deadband ',
    90845: 'Zap-Vyp regulátor pomoc: vysoká Deadband ',
    90846: 'Zap-Vyp regulátor pomoc: vypnúť oneskorenie ',
    90847: 'Zap-Vyp regulátor pomoc: na meškanie ',
    90848: 'Zap-Vyp regulátor pomoc: vstup typu ',
    90849: 'Zap-Vyp regulátor pomoc: vstup Comp ID ',
    90850: 'Zap-Vyp regulátor pomoc: výstup Comp ID ',
    90851: 'Zap-Vyp regulátor pomoc: Popis identifikátor prostriedku ',
    90870: 'Analógový regulátor pomoc: kľúč ',
    90871: 'Analógový regulátor pomoc: opis ',
    90872: 'Analógový regulátor pomoc: názov súboru na Fuzzy ',
    90873: 'Analógový regulátor pomoc: ovládanie Interval ',
    90874: 'Analógový regulátor pomoc: Max výstup ',
    90875: 'Analógový regulátor pomoc: Max odchýlka výstup ',
    90876: 'Analógový regulátor pomoc: min. výstup ',
    90877: 'Analógový regulátor pomoc: Min odchýlka výstup ',
    90878: 'Analógový regulátor pomoc: vstup Comp ID ',
    90879: 'Analógový regulátor pomoc: výstup Comp ID ',
    90880: 'Analógový regulátor pomoc: Popis identifikátor prostriedku ',
    90881: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 1 ',
    90882: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 2 ',
    90883: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpce 3 ',
    90884: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 4 ',
    90885: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 5 ',
    90886: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 6 ',
    90887: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 7 ',
    90888: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 8 ',
    90889: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 9 ',
    90890: 'Analyzátor pomoc pre typ Nedefinovaný výpočtu: Stĺpec 10 ',
    90891: 'Analyzer Help: Logical OR operation',
    90892: 'Analyzer Help: Logical AND operation',
    90893: 'Analyzer Help: Logical NOT OR operation',
    90894: 'Analyzer Help: Logical NOT AND operation',
    90900: 'Vyberte systém konfiguračný súbor.',
    90901: 'IO konfiguračný súbor neexistuje',
    90902: 'IO konfiguračný súbor našiel. Celkový počet bodov = ',
    90903: 'Prosím zaťaženie systému.CFG prvý ',
    90904: 'Už ste pripojení na server. Pripojenie k inému?',
    90905: 'IO chýb zistených!',
    90906: 'Chýbajúce povinné body',
    90907: 'Plyn konfigurácie chýb zistených!',
    90908: 'Nastaviť nový názov priečinka a umiestnenie',
    90909: 'System loaded',
    91000: 'Zero',
    91001: 'Rozpätie',
    91002: 'Slave',
    91003: 'IO bod konfiguračné Utility',
    91004: 'Append',
    91005: 'Vložiť',
    91006: 'Zaradiť',
    91007: 'Posunúť nadol',
    91008: 'Pseudo',
    91009: 'Popisovač',
    91010: 'Vodič',
    91011: 'Predvolený ovládač',
    91012: 'Chceli by ste aj zmeny všetky body využiť tejto novo vybratý ovládač.',
    91013: 'Upraviť bod IO Config',
    91014: 'Chránené',
    91015: 'Zobraziť',
    91016: 'Totalizer',
    91017: 'Alarm',
    91018: 'Adresa',
    91019: 'Rozsah',
    91020: 'Akcia',
    91021: 'Pridať.',
    91022: 'Chladenie s dusíkom',
    91023: 'Počkajte',
    91024: 'Cool s NH3 ',
    91025: 'Zlyhanie napájania',
    91026: 'Zapĺňať',
    91027: 'Res ID',
    91028: 'Pridať reťazec',
    91029: 'SEC.: ',
    91030: 'Max. Počíta: ',
    91031: 'Min. sa počíta: ',
    91032: 'Vstupné: ',
    91033: 'Vždy',
    91034: 'NA požiadanie',
    91035: 'Pri OFF',
    91036: 'Prepojené vstup',
    91037: 'Nastaviť na nulu',
    91038: 'Set na min',
    91039: 'Set Max',
    91040: 'Na',
    91041: 'Off',
    91042: 'IO Config Šablóna súbor nebol nájdený',
    91043: 'Úplné povolenie',
    91044: 'Nitrex užívateľ len',
    91045: 'Žiadne logovanie',
    91046: 'Prenášať',
    91047: 'Správa bod',
    91048: 'Unable to create software updates folder',
    91049: 'Unable to access media or folder. Try again?',
    91050: 'The current content of the software updates folder will be cleared. Continue?',
    91051: 'Unable to clear software updates folder',
    91052: 'Unable to copy file, operation aborted',
    91053: 'Unable to calculate checksum value. Operation aborted',
    91054: "Checksum values don't match. Operation aborted.",
    91055: 'Unable to write. Operation aborted',
    91056: 'Completed successfully',
    91057: 'Calculated Point',
    91058: 'Stage End Condition',
    91059: 'Alarm Levels',
    91060: 'End Condition & SP',
    91061: 'End Condition & Alarm',
    91062: 'End Condition & SP & Alarm',
    91063: '',
    91064: 'Misc',
    91200: 'Identifikácia súčasti',
    91201: 'Jedinečný identifikátor za I/O typu',
    91202: 'V rámci zložky I/O skupiny (AI, AO, DI DO) ID musí byť jedinečná. Niektoré súčasti identifikátory sú vyhradené pre konkrétne merania/zariadenia. Príklad: AI 9 = Hlavná termočlánok merania; AI 18 = Hlavná tlakový prevodník; DI 1 = pece kryt; DI 2 = energia, atď... Pomocou špecializované zložky ID pre náhodné merania/zariadenia môže viesť k poruche systému. Ako orientačné pravidlo, použite väčšie než 250 comp ID pre zariadenia, ktoré sa nenašli v zozname šablón. ',
    91203: 'Bod typu',
    91204: '',
    91205: '',
    91206: 'Kľúč',
    91207: '',
    91208: '',
    91209: 'Triedenie',
    91210: '',
    91211: '',
    91212: 'Počet desatinných miest',
    91213: 'Zadajte hodnotu medzi 0 a 9 ',
    91214: 'Bod bude zaznamenané a zobrazené s počtom desatinných miest ustanovené v tejto oblasti. ',
    91215: 'Je k dispozícii v procese tvorca',
    91216: 'Pridá bod Zostavovača recept',
    91217: 'Pri výbere miesta môžu byť použité v recept tvorca. Ak bod typu AI alebo DI, možno v Zostavovači recept na určenie stavu konca etapy. Ak bod typu AO alebo robiť, požadovaná výstupná hodnota je možné nastaviť v Zostavovači recept.',
    91218: 'Bodu povolenie na čítanie',
    91219: 'Vyberte zo zoznamu',
    91220: 'Definuje viditeľnosť bodu na všetkých nitridom obrazovky rovnako ako či sa zapisovali bodu čítanie. V predvolenom nastavení bod je viditeľné, ale nie prihlásený. Ďalšie dve možnosti povoliť zapisovanie do denníka, ale môžete urobiť bod viditeľné iba pre užívateľov, Nitrex. ',
    91221: 'Bod povolenie pre súbor bod',
    91222: 'Vyberte zo zoznamu',
    91223: 'Definuje viditeľnosť žiadané na všetkých nitridom obrazovky rovnako ako či sa zapisovali príslušného bodu. Predvolene nastaviť bod je viditeľné, ale nie prihlásený. Ďalšie dve možnosti povoliť zapisovanie do denníka, ale môžete urobiť bod viditeľná len pre používateľov, Nitrex',
    91225: 'Značka totalizer koeficient',
    91226: 'Vyberte zo zoznamu',
    91227: 'Tag list je spojená s číselný koeficient definovaný v konfiguračnom súbore systému. Koeficient vynásobí čítanie pred pridaním do akumulátora.',
    91228: 'Predvolené nastavenie hodnoty',
    91229: 'Vyberte zo zoznamu',
    91230: 'Toto pole je voliteľné. Ak je povolené, bod bude mať vždy nastaviť bod, a možnosť, že alarmy/varovania. Poznámka: Pre alarmy/varovania diať, oneskorenie poplachu a aspoň jedna z úrovní upozornenia budíka/musí sa zapnúť aj. ',
    91231: 'Slave',
    91232: 'Otrok adresa',
    91233: 'Rôzne IO zariadenia vyžadujú rôzne spôsoby adresovania. Ak je záporná hodnota tohto bodu sa budú ignorovať. Príklad: K-bus & Optomux ovládača zadajte 1; Hilscher profibus ovládača zadajte hodnotu 0 126; Siemens profibus zadajte hodnotu od 3 až 126.',
    91234: 'Adresa 1 ',
    91235: 'Adresa 1 ',
    91236: 'Rôzne IO zariadenia vyžadujú rôzne spôsoby adresovania. Ak je záporná hodnota tohto bodu sa budú ignorovať. Pre analógové body, zvyčajne obsahuje adresu prvého bajtu (počnúc 0). Pre digitálne bodov obsahuje bitová pozícia (od 1). Optomux ovládača, predstavuje rack číslo.',
    91237: 'Adresa 2 ',
    91238: 'Adresa 2 ',
    91239: 'Rôzne IO zariadenia vyžadujú rôzne spôsoby adresovania. Ak je záporná hodnota tohto bodu sa budú ignorovať. Pre analógové body, zvyčajne obsahuje adresu druhého bajtu (počnúc 0). Pre digitálne bodov obsahuje bajtovú adresu (od 0). Optomux ovládača, predstavuje modul pozície v stojane, počínajúc 0.',
    91240: 'Typ zariadenia',
    91241: 'Definuje osobitné správanie zariadenia',
    91242: 'Toto pole je voliteľné, ponechajte prázdne, ak žiadne špeciálne funkcie sú potrebné. Optomux ovládač vyžaduje okrem typov vhodným zariadením pre termočlánky. Vyberte typ PULZUJÚCE analógové výstupy napodobniť analógové hodnoty s digitálnych výstupov pomocou PWM (pulse šírka modulácie). Ostatné typy sú spoločné pre všetky ovládače. Pre viac informácií, nájdete súbor Pomocníka na serveri \\\\United\\group\\NMI\\Software\\_INSTRUCTIONS_MANUALS \\IOPOINT_Description.doc.',
    91243: 'Popisovač ID',
    91244: 'Identifikátor popisovača',
    91245: 'Značka, ktorá upozorňuje na reťazec v súbore zdrojov (English.cfg /French.cfg, atď....). Vždy PÁRNE číslo. ',
    91246: 'Nula počíta',
    91247: 'Spočítať hodnoty zodpovedajúce Min',
    91248: 'Minimálny počet hodnoty v rozsahu modulu zariadenia.',
    91249: 'Rozpätie počíta',
    91250: 'Spočítať hodnoty zodpovedajúce Max',
    91251: 'Maximálny počet hodnôt v rozsahu modulu zariadenia.',
    91252: 'Min',
    91253: 'Minimálne čítanie v aplikovanej meracích jednotkách',
    91254: 'Minimálne čítanie v aplikovanej meracích jednotkách',
    91255: 'Max',
    91256: 'Maximálne čítanie v aplikovanej meracích jednotkách',
    91257: 'Maximálne čítanie v aplikovanej meracích jednotkách',
    91258: 'Meracia jednotka',
    91259: 'Vyberte mernú jednotku',
    91260: 'Jednotky sú preddefinované. Pridať novú jednotku nie je možné bez zmeny softvéru.',
    91261: 'Kalibračný súbor',
    91262: 'Vyberte kalibráciu súbor',
    91263: 'Súbor sa používa pre kalibráciu alebo linearizace čítania. Súbor je voliteľné. Ak pole ponecháte prázdne, použije sa bez kalibrácie/linearizace súboru. Kalibračný súbor prepíše rozsahoch vymedzených v oblasti počíta Min počíta/Max a Min jednotiek/Max jednotiek.',
    91264: 'Riešenie',
    91265: 'Budík kompenzovať keď SP = 0',
    91266: 'Hodnota je vyjadrená v merných jednotkách. Ak budíka hladiny stanovené percento z príslušného bodu Táto hodnota je povinná a musí byť väčšia ako nula. Keď sa požaduje bod nula (0) súbor predstavuje povolené offset (chyba). Všetky mfc-s nenastavujte hodnotu pod 1% rozpätie. Totalizer nebude hromadiť hodnotu ak bod číta pod jeho rozlíšenie. ',
    91267: 'Nízke upozornenie',
    91268: 'Posun pre nízky Limit',
    91269: 'Ak je pole prázdne alebo nastavený na 0, nízke upozornenie je zakázaný. Hodnota môže byť vyjadrené v merných jednotkách, alebo v percentách. Ak zadaná v percentách, limit sa mení hodnota bodu. Nízky Limit je vypočítaný ako: Set bodovú hodnotu - nízke upozornenie kompenzovať. Pri čítaní nižšie Low Limit, meškanie dlhšie než Alarm oneskorenie, bod pôjde do stavu Low upozornenie. Pri každom bode siaha od varovania štátu do normálu, časovača budíka reštartuje od 0. Hodnota musí byť menšia ako hodnota Low Alarm. Poznámka: Ak bod nemá žiadané, všetky alarmy & upozornenia deaktivujú. ',
    91270: 'Vysoká varovania',
    91271: 'Vyrovnanie vysoký Limit',
    91272: 'Ak je pole prázdne alebo nastavený na 0, vysoká upozornenie je zakázaný. Hodnota môže byť vyjadrené v jednotkách opatrenie, alebo ako percento. Ak zadaná ako percento, limit sa mení hodnota bodu. Vysoký Limit je vypočítaný ako: žiadané hodnoty + vysoká upozornenie kompenzovať. Pri čítaní vyššie High Limit, meškanie dlhšie než Alarm oneskorenie, bod pôjde do stavu High upozornenie. Pri každom bode siaha od varovania štátu do normálu, časovača budíka reštartuje od 0. Hodnota musí byť menšia ako hodnota vysoká Alarm. Poznámka: Ak bod nemá žiadané, všetky alarmy & upozornenia deaktivujú. ',
    91273: 'Nízke Alarm',
    91274: 'Posun pre nízky Limit',
    91275: 'Ak je pole prázdne alebo nastavený na 0, alarmu nízkej vypnutá. Hodnota môže byť vyjadrené v jednotkách opatrenie, alebo ako percento. Ak zadaná ako percento, limit sa mení hodnota bodu. Nízky Limit je vypočítaný ako: Set bodovú hodnotu - Low Alarm kompenzovať. Pri čítaní nižšie Low Limit, meškanie dlhšie než Alarm oneskorenie, bod pôjde do stavu Low Alarm. Zakaždým, keď bod siaha od poplachový stav do normálneho, časovača budíka reštartuje od 0. Hodnota musí byť väčšia ako hodnota Low upozornenia. Poznámka: Ak bod nemá žiadané, všetky alarmy & upozornenia deaktivujú. ',
    91276: 'Vysoká Alarm',
    91277: 'Vyrovnanie vysoký Limit',
    91278: ' Ak je pole prázdne alebo nastavený na 0, vysoká alarm je zakázaný. Hodnota môže byť vyjadrené v jednotkách opatrenie, alebo ako percento. Ak zadaná ako percento, limit sa mení hodnota bodu. Vysoký Limit je vypočítaný ako: žiadané hodnoty + vysoká Alarm kompenzovať. Pri čítaní vyššie High Limit, meškanie dlhšie než Alarm oneskorenie, bod pôjde do stavu High Alarm. Zakaždým, keď bod siaha od poplachový stav do normálneho, časovača budíka reštartuje od 0. Hodnota musí byť väčšia ako hodnota vysoká upozornenia. Poznámka: Ak bod nemá žiadané, všetky alarmy & upozornenia deaktivujú. ',
    91279: 'Alarm oneskorenie (sec)',
    91280: ' Oneskorenie, ktorá spustí poplach, alebo upozornenie',
    91281: 'Oneskorenie, ktoré spúšťa všetky nakonfigurované alarmov a upozornení. Ak je pole prázdne alebo nastavený na 0, všetky alarmy/upozornenia sú vypnuté. Kladná hodnota predstavuje max čas (v sekundách), ktorý bod môže byť mimo jeho hraníc, bez spustenia alarmy/varovania. Zakaždým, keď bod siaha od poplachový stav do normálneho, časovača budíka reštartuje od 0. ',
    91282: 'Núdzové typu',
    91283: 'Vyberte vhodné špeciálny recept',
    91284: 'Definuje postup, ktorý bude možné uplatniť, keď bod ide do núdzového stavu. Núdzové typy sú preddefinované. Každému typu špeciálny recept je spojená. Prečítajte si prosím recept priradené bod, uistite sa, že správny postup sa uplatniť.',
    91285: 'Núdzové meškanie (sec)',
    91286: 'Oneskorenie, ktoré spúšťa núdzového postupu',
    91287: 'Núdzové meškanie určuje či núdzového postupu je zapnuté alebo vypnuté. Ak je pole prázdne alebo nastavený na 0, núdzového postupu je zakázaný. Kladná hodnota predstavuje max čas (v sekundách), ktorý bod môže byť v alarm bez spustenia núdzového režimu. Každý časový bod siaha od poplachového stavu reštartuje normálne, núdzové časovač od 0. ',
    91288: 'Zrkadlo',
    91289: 'Vyberte Comp. identifikáciu referenčného bodu',
    91290: 'Keď chceme bod sledovať - mať rovnaký čítanie ako ďalší (Master) bod, uvedieme identifikácia súčasti bodu Master v tejto oblasti. Majster bodu čítanie sa stáva bodom SET pre naše miesto. Tolerancia medzi dvomi je definovaný podľa nízka/vysoká alarmy/varovania. Budík je generovaný, keď čítanie bodu zrkadlo prekročí tolerancia. Alarm je generovaný na mieste zrkadlo, nie na hlavný bod. ',
    91291: 'Popis',
    91292: 'Popis v anglickom jazyku',
    91293: 'Tento text sa nikde grafického používateľského rozhrania. Používa sa opísať miesto, keď je manuálne upravovať súbor.',
    91294: 'Akcia',
    91295: 'Vyberte zo zoznamu',
    91296: 'Pri výklade bodu čítania alebo nastavenie hodnoty do bodu, nitridom softvér používa dve vrstvy: 1) rovno čítanie/nastavenie bodu 2) softvér interpretáciu signál. Keď akciu je definovaná ako priama, minimálna hodnota z vrstvy 1 predstavuje minimálnu hodnotu vo vrstve 2; Maximálna hodnota z vrstvy 1 predstavuje maximálnu hodnotu vo vrstve 2. Keď akciu je definovaná ako reverzné, minimálna hodnota z vrstvy 1 predstavuje maximálnu hodnotu vo vrstve 2; Maximálna hodnota z vrstvy 1 predstavuje minimálnu hodnotu vo vrstve 2. V predvolenom nastavení bod akcie je priama. ',
    91297: 'Ovplyvnené DI bodov',
    91298: 'Vyberte zo zoznamu – výber viacerých položiek je možné',
    91299: ' Toto pole je voliteľné. Jeden digitálny výstup môže mať viacero kontrolovaných podľa digitálnych vstupov. Všetky kontrolované podľa digitálnych vstupov by mali nasledovať výstup, t. j. majú rovnaký čítanie ako výstupný signál. Príklad: Predstavuje signál vody na chladenie; Môžeme mať niekoľko vody prepínače, ktoré monitorujú prietoku vody v rôznych častiach nášho zariadenia; Keď voda je prikázané byť ON, Všetky prepínače mali vidieť prietok chladiacej vody. Tam je rozdiel medzi bodu spätnú väzbu a Controlled-By bodov. Keď jeden z kontrolovaných podľa bodu nezodpovedá žiadosť, to neznamená, že táto žiadosť nie je vykonaný správne.',
    91300: 'Zapnúť Alarm',
    91301: 'Nastavenie budíka pravidlá',
    91302: 'Použiť pre digitálne vstupy. Ak toto pole nastavená na vždy (predvolený) existujú dva prípady, keď digitálny vstup môže ísť do budíka: 1), keď to požaduje, aby sa ON a jeho stav je OFF a 2) keď sa požaduje byť OFF a jeho stav je zapnutý. Ak toto pole je nastavená na Ak-na-požadované, bod pôjde poplach iba vtedy, ak to požaduje, aby sa ON a jeho štát nie je na. Ak toto pole nastavená na požadované keď-OFF, bod pôjde poplach iba vtedy, ak to požaduje byť OFF a jeho stav je nie OFF. ',
    91303: 'Značka pre totalizer skupinu',
    91304: 'Vyberte zo zoznamu',
    91305: 'Toto pole je voliteľné. Totalizer skupiny sú definované pomocou konfigurácie systému. Ak potrebujete upraviť skupiny, vytvoriť alebo odstrániť jeden, choďte prosím do menu Konfigurácia systému. Totalizer skupina je tag pre kontajner obsahujúci akumulovanú spotrebu pre všetky body, ktoré používajú rovnakú značku.',
    91306: 'Pridať reťazec',
    91307: 'Popisovač pripojí reťazec',
    91308: 'Voliteľné pole. Používané na prispôsobenie opisu bodu. Zadaná hodnota sa pripojí k popisu definovaný identifikátor prostriedku ',
    91309: 'Ovládač typu',
    91310: 'Vyberte zo zoznamu',
    91311: 'Uvedené sú ovládače, ktoré sú podporované NITRIDOM softvér.',
    91312: 'Je Pseudo',
    91313: 'To je bod, Pseudo',
    91314: 'V predvolenom nastavení, body sú skutočné body. Pseudo body nie sú čítať pomocou akéhokoľvek vstupno-výstupnom ovládači. Namiesto toho sú kontajnery, mäkké body, ktoré pridať flexibility systému funkčnosť. Väčšina pseudo body sú vyhradené pre nitridom softvér spustiť správne. Používateľ môže vytvoriť vlastné pseudo bodov, typickým príkladom je výpočet proces.',
    91315: 'Spätná väzba bod',
    91316: 'Vyberte zo zoznamu',
    91317: ' Toto pole je voliteľné. Spätná väzba je digitálny vstup, ktorý prečíta stav zariadenia, ktoré umožňujú systému overiť, ak príkaz je vykonaný správne. Ak spätnú väzbu bodu čítanie nezodpovedá žiadosť, môžu byť generované alarm na čítanie (spätná väzba bod potrebuje mať alarmy zapnuté). ',
    91318: 'Min. počet Alarm',
    91319: 'Min platné počíta pre analógový vstup',
    91320: 'Toto pole je voliteľné, v predvolenom nastavení je hodnota nie je nastavená. Ak je zadaný, predstavujú nízky limit pre čítaní (počty). Pri každom čítaní prekročí limit, bod pôjde do č-reakcia-Alarm. ',
    91321: 'Max počet Alarm',
    91322: 'Max platné počíta pre analógový vstup',
    91323: 'Toto pole je voliteľné, v predvolenom nastavení je hodnota nie je nastavená. Ak je zadaný, predstavujú vysoký limit čítaní (počty). Pri každom čítaní prekročí limit, bod pôjde do č-reakcia-Alarm.',
    91324: 'Zakázať odozvu v pohotovostnom režime',
    91325: 'Vypnutie alarmu žiadnu odpoveď v pohotovostnom fáze',
    91326: 'Toto pole je voliteľné. Podľa predvoleného nastavenia všetky alarmy sú povolené v pohotovostnom fáze. Niekedy, systém je navrhnutý tak, odpojte niektoré zariadenia pri dokončení úlohy. Použite toto políčko pre takýto prípad. ',
    91327: 'Na oneskorenie (sec)',
    91328: 'Meškanie na zapnutie zariadenia',
    91329: 'Toto pole je zapnutá, keď zariadenie je nakonfigurovaný ako o meškanie typu a v tomto prípade je povinné pole. ',
    91330: 'Vypnúť oneskorenie (sec)',
    91331: 'Oneskorenie vypnutia zariadenia',
    91332: 'Toto pole je zapnutá, keď zariadenie je nakonfigurovaný ako Off-Delay typu a v tomto prípade je povinné pole. ',
    91333: 'Spätná väzba bod',
    91334: 'Vyberte zo zoznamu',
    91335: 'Toto pole je voliteľné. Spätná väzba je analógový vstup, ktorý prečíta stav zariadenia, umožňujúce systém skontrolovať, ak príkaz je vykonaný správne. Ak spätnú väzbu bodu čítanie nezodpovedá žiadosť, môžu byť generované alarm na čítanie (spätná väzba bod potrebuje mať alarmy zapnuté). ',
    91336: 'Obrátený spätnú väzbu',
    91337: 'Vyberte zo zoznamu',
    91338: 'Toto pole je zapnutá, keď zariadenie je nakonfigurovaný ako Duálny vstup typu a v tomto prípade je povinné pole. Bod je spojený s digitálnym výstupom a mali vždy čítať opak od požadovaný signál na digitálny výstup. Príklad: To je signál k otvoreniu dverí. Obrátený DI je signál: dvere zatvorené; Takže keď žiadame 1 na výstup otvoriť dvere, obrátený spätnú väzbu dvere zatvorené stav by mal byť nepravdivé. Ak čítanie bodu obrátený spätnú väzbu zodpovedalo požiadavke, môžu byť generované alarm na čítanie (obrátený spätnú väzbu bod potrebuje mať alarmy zapnuté). ',
    91339: 'Riadený DI',
    91340: 'Vyberte zo zoznamu',
    91341: ' Toto pole je zapnutá, keď zariadenie je nakonfigurovaný ako o-keď-na na-keď-Off-Off-keď-On / / Off-keď-Off. Dlhý popis typov týchto zariadení sú: zase výstup na kedy vstupný stav je na / zapnúť výstup na keď vstupného štátu je vypnuté / zapnúť výstup Off keď vstupný stav je na / zapnúť výstup Off keď vstupného štátu je vypnuté. Vyberte digitálny vstupné zariadenie, ktoré ukončí činnosť prístroj digitálny výstup. Príklad: máme digitálny výstup typu Off-keď-On. Tento výstup je riadená digitálne vstupné-otvorené dvere. Ak nastavíme tento výstup na (otvorené dvere) signál sa automaticky nastaví späť na 0 potom otvorenými dverami signál dosiahne 1 (dvierka otvorené). ',
    91342: 'Viditeľné',
    91343: 'Zviditeľnite bod v obrazovka detailu',
    91344: 'Začiarknete toto políčko zviditeľňuje miesto v detaile obrazovky.',
    91345: 'Bod',
    91346: '',
    91347: '',
    91348: 'Nastavená hodnota/hodnota',
    91349: '',
    91350: '',
    91351: 'Prenášať Time(sec.)',
    91352: '',
    91353: '',
    91354: 'Chybové hodnoty',
    91355: '',
    91356: '',
    91357: 'Správa bod',
    91358: 'Označí tento bod ako bod správy',
    91359: '',
    91360: 'Decision points',
    91361: 'Marks this point as a decision point',
    91362: 'Decision point is a pseudo point. It holds calculated value based on real readings of several ianalog input points. The first point (on the top) is a dominant point – takes precedence. ',
    91363: 'Decision type',
    91364: 'Select the decision algorithm',
    91365: 'Decision algorithms are:  Avoid Error,  Highest Value,  Lowest Value,  Mean Value and  Threshold Highest. All of these types except Threshold take only source points as arguments. Threshold point  also requires a  Threshold Value argument.  Avoid Error point gives the value of the higher priority (first-specified) point as long as the point is not in error state (no-response state)  ',
    91366: 'Threshold value',
    91367: 'Please set the value for the threshold',
    91368: 'Threshold Highest is the algorithm applied  for the probe on the PT455.  It requires exactly two source points (where the other types have N).  It gives the value of the higher priority (first-specified) point as long as the difference between the values of the source points is less than or equal to the Threshold Value (“TV” argument).  If the difference is greater than TV, then the higher of the two values is returned.',
    91369: 'Follow SP',
    91370: 'Follow set point',
    91371: 'The pseudo point will hold value equal to its set point.',
    91372: 'Disable no-response (real I/Os)',
    91373: 'Real Points - Disable no-response alarm',
    91374: 'Applicable to real points only. By default no-response alarms for real points are always enabled.This filed allows us to change the default and completely disable no-response alarms, for any real point. ',
    91375: 'No-Response Alarm Delay',
    91376: 'Alarm Delay for no-response alarms, applicable to pseudo inputs',
    91377: 'Applicable to pseudo points only. If NO-RESPONSE alarm for pseudo point is enabled, this field allows user to specify alarm delay. If NO-RESPONSE alarm for pseudo point is enabled and this field is left empty, default NO-RESPONSE alarm delay is 60 seconds.',
    91378: 'Enable no-response (PAIs/PDIs)',
    91379: 'Pseudo Inputs - Enable no-response alarm',
    91380: 'Applicable to pseudo inputs only. By default pseudo points have no NO-RESPONSE alarms. When the box is not checked, the PAI cannot have no-response alarm. When no-response alarm is enabled, default alarm delay is 60 seconds. User can overwrite the default alarm delay by specifying the desired alarm delay in seconds.',
    91381: 'Enable serial number',
    91382: 'Enable serial number',
    91383: 'Enable serial number',
    91384: 'Enforce defeat',
    91385: 'Enforce defeat',
    91386: 'Enforce defeat',
    91499: '',
    92000: 'Hodnotu kalibrácie',
    92001: 'Kalibrácia Count ',
    92002: 'Hodnotu kompenzácie',
    92003: 'Všetky upraviteľné pole v tabuľke kalibrácie nemôže byť prázdna.',
    92004: 'Kalibrácia konfigurácia',
    92005: 'Kalibrácia opis',
    92006: 'Zapnutie kalibrácie',
    92007: 'Umožniť posun',
    92008: 'Kalibračné hodnoty v tabuľke musia byť v rastúcom poradí.',
    92009: 'Kalibrácia počíta v tabuľke musia byť buď v klesajúcim alebo rastúcim.',
    92010: 'Viac než dva riadky sú povinné pre kalibračné hodnoty/počíta.',
    92011: 'Hodnota Max kalibrácie musí byť väčšia než hodnota kalibrácie Min',
    92012: 'Max počet kalibračných musí byť väčšia než hodnota min. počet',
    92013: 'Rovnomerne distribuovať body založené na Min/Max',
    92014: 'Počet bodov medzi Min/Max',
    92015: 'Kliešťa na zostupnom poradí',
    92016: 'Niektoré polia majú chýbajúce údaje',
    92017: '1. Riadok je minimálna hodnota a druhý riadok predstavuje hodnotu Max. Max musí byť väčšia ako Min',
    92018: 'Voltov',
    92019: 'Vymažú sa všetky údaje na GUI. Naozaj chcete prepnúť na iný typ kalibrácie? ',
    92101: 'GUI konfiguračné Utility',
    92102: 'Vlastnosť',
    92103: 'Konfigurácia bol úspešne uložený. Avšak, niektoré body sú nesprávne nakonfigurovaný',
    92104: 'Multi systém nepodporuje tento gui config util',
    92105: 'Nasledujúce značky nie je podporovaný týmto gui config util',
    92106: 'Horúce škvrny nie sú podporované v tomto gui config util',
    92107: '',
    92108: '',
    92109: '',
    92110: '',
    92111: '',
    92112: '',
    92113: '',
    92114: '',
    92115: '',
    92116: '',
    92117: '',
    92118: '',
    92119: '',
    92120: '',
    93000: 'Nástroj Správca používateľov vývoz užívateľov',
    93001: 'Neplatné heslo, skúste znova?',
    93002: 'Prosím, zadajte svoje heslo',
    93003: 'Vyberte súbor s údajmi používateľa <QUsers.dat> ',
    93004: 'Úplné meno používateľa',
    93005: 'Užívateľské meno',
    93006: 'Je Nitrex užívateľa',
    93007: 'Povolenia používateľa',
    93008: 'Povolenie',
    93009: 'Prístup',
    93010: 'Užívatelia údajový súbor bol uložený',
    93011: 'Nepodarilo sa uložiť',
    93030: 'Preferencie',
    93031: 'Šifrovanie systému konfiguračný súbor',
    93032: 'Šifrovať io konfiguračný súbor',
    93033: 'Vyberte používateľov',
    94001: '',
    94002: '',
    94003: '',
    94004: '',
    94005: '',
    94006: '',
    94007: 'Časové pásmo',
    94008: 'Nastaviť rôzne časové pásmo pre PT9800 ',
    94009: 'Ak chcete udržať váš počítač je nastavený na rovnakom časovom pásme, ponechajte toto pole prázdne. Ak klientsky softvér potrebuje používať iné časové pásmo ako je nainštalovaný v počítači, vyberte časové pásmo zo zoznamu. Vybraté časové pásmo bude viditeľné vnútri PT9800 aplikácie len.',
    94010: 'Čiastočné zálohovanie',
    94011: 'Zálohovanie záznamy vytvorené po zadanom dátume.',
    94012: 'Táto funkcia sa používa pre zálohy, ktoré trvať príliš dlho. Ak aplikácia, ktorý extrahuje databázy do súboru (dbunload) trvá príliš veľa času, môžeme urobiť zálohu selektívne; sme môžete určiť dátum & čas zálohovania na filtrovanie údajov. Pred nastavením tento dátum, používateľ musí premenovať VYLOŽIŤ priečinok (C:/users/dbtool/VYLOŽIŤ) "UNLOAD_BEFORE_DateTime" a to, používateľ sa znovu nový priečinok VYLOŽIŤ (typicky (C:/users/dbtool/VYLOŽIŤ). Premenovaný priečinok obsahuje úplnú zálohu. Po tom, nastavte parameter. Akonáhle aplikácie "dbunload" sa vyvolá to selektívne extrahovať údaje z tabuľky Archív (a_value, a_msg, a_any...), ktoré sú novšie ako zadaný dátum a čas. S opatrnosťou používať túto funkciu, musíte mať plné pochopenie toho postupu. Počas odpočítavania každé 2 roky.',
    94013: 'Číslo verzie DB',
    94014: 'PT9800 databáza číslo verzie',
    94015: 'PT9800 tabuľky v databáze vyvíjať. Každá nová verzia je označená s radom unikátnu verziu. Rôzne verzie majú rôzny počet tabuliek, rôzne polia v tabuľke. Nemeňte Toto pole pokiaľ dostanete pokyny a schválenie od dodávateľa (SW).',
    94016: 'Číslo platiteľa',
    94017: 'Číselný kód pre zákazníka',
    94018: 'Každý zákazník má jedinečný kód (číslo). Po priradení, tento počet sa nemení. Pre nových zákazníkov získať číslo zodpovednej osoby, nikdy vymýšľať alebo použiť náhodné číslo!',
    94019: 'Názov zákazníka',
    94020: 'Názov zákazníka',
    94021: 'Toto pole obsahuje názov zákazníka.',
    94022: 'Ladenie úroveň',
    94023: 'Nastavte Ladiace informácie na zápis',
    94024: 'Debug úroveň pozadia programy. Zakázať písanie ladiť onfo, toto pole nastavená na 0. Navrhol hodnota je 1. Keď budeme potrebovať viac ladenie info, nastavte vyššie číslo. Konzultovať s dodávateľom (oddelenie softvér prvá). Ďalšie možnosti sú: 6,48,64,8208,1040... Tieto možnosti sú užitočné pri začínajúcich a kedykoľvek problémov s ovládačmi.',
    94025: 'Preklad',
    94026: 'Povolenie alebo zakázanie prekladu',
    94027: 'Povolí alebo zakáže Prekladací modul. Mali by byť povolené po celú dobu. Možnosť zakázaná slúži iba pre nemeckých vývojárov.',
    94028: '° C alebo ºF',
    94029: 'Vyberte jednotku pre teplotu',
    94030: 'Definuje, ktoré mernú použiteľný pre teploty. Dve možnosti k dispozícii ºC a ºF. ',
    94031: 'mm alebo thsd',
    94032: 'Vyberte jednotku pre spevnenie vrstvy',
    94033: 'Definuje, ktoré mernej jednotky pre spevnenie vrstvy (nauhličovanie hĺbku hĺbky tvrdosť, biele vrstvy atď.). Sú dve možnosti: mm alebo ty. ',
    94034: 'mm alebo palec',
    94035: 'Nastaviť jednotku pre dĺžku a priemer',
    94036: 'Definuje, ktoré mernej jednotky pre dĺžku/priemery.',
    94037: 'PE Logo',
    94038: 'Nastaví logo na paneli s nástrojmi',
    94039: 'Definuje ak PE Logo sa zobrazí na každej nástrojovej lište v pravom hornom rohu. ',
    94040: 'Graf Demo',
    94041: 'Graf demo mode',
    94042: 'Zapína / vypína demo režim pre historické grafy. V predvolenom nastavení je zakázané demo režime. Táto funkcia je užitočná pre výstavy, prezentácie...',
    94043: 'Kontinuálne grafy',
    94044: 'Ignorovať prerušenie v príjem dát',
    94045: 'Toto pole definuje správanie grafu pri prerušení prenosu dát (oneskorenie medzi dvoma susednými miestami presahuje maximálnu hodnotu). V predvolenom nastavení toto oneskorenie nie je ignorovaný. Pri prerušení prenosu údajov grafu by mali zobrazovať prestávku /gap. Avšak pre radiče, že nie odoslať údaje, pokiaľ dáta, bol zmenený tento príznak je veľmi užitočné. Nastaviť túto vlajku pre staršie verzie PT500 povolené.',
    94046: 'Prerušenie oneskorenia',
    94047: 'Oneskorenie vyhlásiť prerušenia prenosu údajov',
    94048: 'Toto pole definuje, keď vyhlásil, že prenos dát je prerušený. To predstavuje maximálne prijateľné čas (v minútach) medzi dvoch po sebe idúcich signály. Ak údaje nie je prijatá v rámci tohto intervalu, graf zobrazí medzeru. Pre novšie zariadenia (2010 a neskôr), maximálna vzdialenosť medzi dvoma bodmi je definovaný v správcovi grafu. Ak sa používa staršiu verziu PT500 radič, zadajte 999. Pre novšie zariadenia navrhované hodnotu 7 (minút).',
    94049: 'Potvrdiť odstránenie',
    94050: 'Potvrdenie odstránenia v slovníku',
    94051: 'Toto pole definuje potreby potvrdenie pred odstránením položky zo slovníka. Ak veľké množstvo textu je potrebné vypustiť zo slovníka vyberte zakázať potvrdenie. Starostlivo použiť túto možnosť, ak neviete rozhranie "od srdca" zanechať dôležitý text, aby ste uložiť, zatvoriť, prechádzať rozhranie. V predvolenom nastavení, potvrdenie sa požaduje pred každý vypustenie.',
    94052: 'Max logy',
    94053: 'Max záznamy v lodnom denníku produkcie',
    94054: 'Nastaví maximálny počet pracovných miest v výrobu záznamy obrazovky zobrazí. V predvolenom nastavení je 10.000.',
    94055: 'Výroba prihlási Offset',
    94056: 'Interval na zobrazenie posledných logy',
    94057: 'Nastaviť interval (v dňoch) pre výrobu Log modulu na zobrazenie posledných denníky. Tento interval Nastaví predvolený začiatok výroby záznamy vyhľadávania. Hľadať interval je nastavený od súčasnej dobe mínus hodnota. Zobrazia sa len pracovných miest vytvorených v rámci tohto intervalu. Predvolená hodnota je 1 deň. Všimnite si, desatinné hodnoty sú akceptované - je možné požiadať o 0,5 (posledných 12 hodín) alebo 0,25 (posledných 6 hodín) atď... ',
    94058: 'Predvolený jazyk',
    94059: 'Nastaviť predvolený jazyk',
    94060: 'Nastaví jazyk, ktorý sa použije v užívateľ prihlasovacie obrazovky. Stanoviť do jazyka krajiny, kde je nainštalovaný softvér. Po prihlásení používateľa rozhranie berie v jazyku používateľa.',
    94061: 'Štýl & Farba',
    94062: 'Vybrať štýl a farbu pozadia',
    94063: 'Nastavuje štýl a farbu pozadia používateľského rozhrania - klientskej aplikácie. ',
    94064: 'Zvýraznenie tlačidla',
    94065: 'Zvýraznite tlačidlá s odtieňom oranžovej',
    94066: 'Tlačidlo môže byť automaticky zvýraznený keď používateľ umiestni kurzor nad ním. Tento parameter zapne alebo vypne automatickú zmenu stavu tlačidlo zvýraznenie. Pri použití čistých vyzerať štýl, vypnutie tejto funkcie (predvolené elektroinštalácií PT9800 po 2010)',
    94067: 'Alarm meškanie',
    94068: 'Oneskoriť odoslanie alarmu oznámenie',
    94069: 'Oneskorenie v sekundách až alarmu oznámenie je zaslaná prostredníctvom GSM modemu, e-mail... Predvolená hodnota je 30 (sec). Ak alarm stav trvá kratšie ako oneskorenie alarmu určené týmto parametrom, alarmu oznámenie nebude odoslaná. ',
    94070: 'Databáza alarmy',
    94071: 'VYPNÚŤ databázy alarmy',
    94072: 'Definuje ak databázy chyby sa majú zobraziť, alebo nie. V predvolenom nastavení databázy závad sú zobrazené. Vypnúť databázy alarm oznámenia len v osobitných prípadoch, dočasne, kým problémy sú vyriešené.',
    94073: 'Splash obrazovky',
    94074: 'Začnite s splash obrazovky',
    94075: 'Definuje ak splash obrazovky sa použije pred otvorením tri základné rozhrania. Užívateľ by mal vybrať kombináciu, ktorá vyhovuje inštalácie najlepšie. Splash obrazovky nie sú potrebné vysoko výkonné počítače.',
    94076: 'Sledovanie služby',
    94077: 'Monitor PT9800 služby',
    94078: 'Vyhradené len pre správcov. Príznak na povolenie alebo zakázanie monitorovanie PT9800 (p9start) služba. To by malo byť vždy povolená. Klientsky softvér monitory, ak je služba spustená. Keď zistí, že služba nie je spustená, ale objaví správa informovať používateľa ako dlho služba nie je spustená.',
    94079: 'Pripojiť a_ld_ext',
    94080: 'Rozšírená načítať dáta / externých údajov ',
    94081: 'To je chránený parameter, len pre správcov. Definuje ako dotaz výrobné záznamy pri externej databáze neexistuje.',
    94082: 'Tlačné obrazovky',
    94083: 'Kreslenie tlačných obrazovky v niekoľkých krokoch',
    94084: 'Definuje spôsob tlačné obrazovky je vypracovaný. Tento parameter musí byť povolené na pomalých počítačoch alebo pomalé databázy. Zapnuté, užívateľské rozhranie je utopiť v krokoch, takže konečný užívateľ vidí činnosti na obrazovke. Zvyčajne tento parameter by mal povolené.',
    94085: 'Pracovisko typu',
    94086: 'Pracovisko: posunovač, pás alebo žiadne ',
    94087: 'Definuje typ inštalácie v súvislosti, aké typy pracovísk sú používané. Tlačné remorkéry a pásom pece alebo bez. Voľbu vhodných k inštalácii.',
    94088: 'Odstrániť veľa',
    94089: 'Povolenie odstrániť denníky produkcie',
    94090: 'Zapína/vypína odstránenie zaťaženie od výroby protokoly. Všimnite si, užívateľ je schopný odstrániť zaťaženie od výroby protokoly, ak tento parameter je nastavený a ak má povolenie na upravovanie polí.',
    94091: 'Časové osi jednotky',
    94092: 'Formát času na OS X',
    94093: 'Definuje formát času na grafe. Čas môže byť vyjadrený ako uplynutý čas (v minútach), alebo môže byť v čase formát dátumu. Tento parameter sa vzťahuje na výrobné záznamy iba (za-histogram zaťaženia). Pracovisku histogram je vždy vo formáte dátumu a času.',
    94094: 'Pohotovostnom hodnoty',
    94095: 'Nastavenia pohotovostného režimu',
    94096: 'Toto pole sa používa na povolenie alebo zakázanie kartu "Standby hodnoty" vnútri obrazovky pracovisku alebo vyberte špeciálne vykonávania pohotovostného režimu. Keď je zapnuté nastavenie pohotovostného hodnoty používateľa môžete definovať hodnoty pre proces premenné, ktoré bude aktívna pri nečinnosti - nie beh práce pracovisku. Existujú dva špeciálne implementácií, jeden je pre zákazníka 1016 len, druhý je určený pre olejovom kúpeli. Keď je vybratá voľba oleja kúpeľ, stránka nová karta je vytvorený v okne pracovisku umožňuje používateľovi upravovať ďalšie hodnoty.',
    94097: 'PT500 tlačidlá',
    94098: 'Povoliť PT500 tlačidlá',
    94099: 'Platí pre pracoviská PT500 len. Toto pole povoľuje alebo zakazuje PT500 tlačidiel na strane klienta GUI. Neodporúča sa remotly príkaz generovaných z pracoviska SCADA GUI. Mohlo by to byť nebezpečné, kliknite na jedno tlačidlo môže ohroziť bezpečnosť na pracovisku (ako je otvorenie dverí pecí, alebo zapnutím niektoré zariadenia...)',
    94100: 'Zarovnanie pre PT600 ',
    94101: 'Korekcia označenie tlačidla/allignment',
    94102: 'Toto pole sa vzťahuje len na PT600 pracoviskách, povolí alebo zakáže zosúladenie tlačidlá a menovky. Pre PT600 sa môže stať, že tlačidlá a menovky nie sú v rovnakej výške. V tomto prípade vyrovnanie musí byť povolené.',
    94103: 'Nástroje nasadenia',
    94104: 'Modul, z ktorej je priradený náradie',
    94105: 'V predvolenom nastavení nástroja je priradený formulár časť modulu. Typicky pre automaty nαstroje priradený za náklad. Ostatné možnosti sú priradiť náradie z práce Úvodná obrazovka, alebo auto príkaz. Možnosť auto príkaz nemožno použiť pre všetkých zákazníkov',
    94106: 'Oneskorenie pre ux_dcr',
    94107: 'Zbytočného odkladu ukončiť ux_dcr',
    94108: 'Zastaraného parametra. Nepoužívajú ako konfigurovateľné parameter, ale použitá aplikácia.',
    94109: 'Časť & Spec',
    94110: 'Priradenie parametrov secification časť',
    94111: 'Tento parameter určuje, ako parametre v špecifikáciách sú pripojené na časť. Existujú dve možnosti. Každú časť môžete mať rovnaké kolekcia špecifikácia parametrov definovaných v dokumente operácie -> PE-STANDARD, alebo časť môže Zdediť špecifikácia parametrov od typu operácie. Koncový používateľ musí priradiť typ operácie pre každú časť. Príklad druhov prevádzky: nitridácia nauhličovanie... ',
    94112: 'Č/kreslenie číslo platiteľa',
    94113: 'Atribút pre prvé pole v časti rozhrania',
    94114: 'Časť tabuľky & časť GUI majú dve polia, ktoré majú rôzne významy podľa nastavenia dvoch rôznych parametrov. Existujú 4 atribúty spojené s časťou: výkres číslo, číslo revízie, platiteľa a číslo objednávky Existujú iba dve polia na GUI. Tento parameter nastavenie určuje, ktoré parameter sa používa v prvom poli. K dispozícii sú dve možnosti: výkres č alebo číslo zákazníka. Keď číslo výkresu. je vybraný ako prvého poľa, druhé pole vždy obsahuje číslo revízie. kresby. Ak číslo zákazníka. je vybraný pre prvé pole, potom druhé pole môže mať jednu z dvoch hodnôt: číslo objednávky alebo výkres č. Ktorý z nich bude použité ako druhé pole je stanovená s ďalší Konfiguračný parameter "Atribút pre druhé pole v časti rozhranie',
    94115: 'Výkres číslo/číslo objednávky ',
    94116: 'Atribút pre pole druhej časti rozhrania',
    94117: 'Časť tabuľky & časť GUI majú dve polia, ktoré majú rôzne významy založené na stanovenie týchto parametrov. Existujú 4 atribúty spojené s časťou: výkres číslo, číslo revízie, platiteľa a číslo objednávky Existujú iba dve polia na GUI. Tento parameter nastavenie určuje možnosti pre druhý parameter, keď prvý parameter nastavený na platiteľa Toto pole je aktívne iba ak parameter "Atribút pre prvé pole v časti rozhranie" nastavené číslo zákazníka Vybrať medzi číslo objednávky a číslo výkresu. Konečný výsledok bude, že časť obrazovky zobrazí buď číslo Customerer & Číslo objednávky alebo číslo zákazníka. & Kreslenie číslo Predvolené číslo zákazníka. & Zobrazenia výkresu č. ',
    94118: 'Preložiť alarmy',
    94119: 'Zastaraného parametra',
    94120: 'Zastarané Parameter.Parameter nepoužíva od verzie z roku 2010. Vzťahuje na non-externalized verzie. Definuje rozsah alarmy preložené alebo neprekladajú.',
    94121: 'Stĺpce v výtlačok',
    94122: 'Štýl & počet parametrov vo výrobe prihlásiť výtlačok',
    94123: 'Definuje vzhľad zostavu denníka výroby a počet parametrov recept na vytlačenie. Keď starý štýl výtlačky sú vybrané, užívateľ mať možnosť pridať (alebo nie) tolerancia k výtlačku. Nového štýlu výtlačkoch užívateľ si môže vybrať medzi 2 a 20 parametre, ktoré sa zahrnú do vytlačeného výstupu. Typicky, nauhličovanie liečby, 2 parametre sú dosť - teplota a uhlíka potenciál.',
    94124: 'Počet kópií',
    94125: 'Pracovisko správa: počet kópií na vytlačenie ',
    94126: 'Platí to pre automaty iba. Sa vzťahuje na tlačenie zostáv pracovisku. Určuje počet kópií na vytlačenie. Nastavte ju na 0 pre vypnutie tlače.',
    94127: 'Majte na pamäti, alebo Release',
    94128: 'UIs, majte na pamäti, alebo uvoľnite pamäť pri zatvorení UI',
    94129: 'Tri typy používateľské rozhranie windows je možné nastaviť nie po zatvorení užívateľ požaduje zavrieť: pracovisko GUI, Shop rozloženia a výrobné záznamy. Keď blízko je požadované, týchto okien zostať načítaný v pamäti, ale sa stal neviditeľným. Všetky tieto okná sú v predvolenom nastavení zostane v pamäti zavedený celú dobu. Iné kombinácie sú k dispozícii tiež, môžeme napríklad vyberte položku zachovať iba Shop rozloženia nahrá ale uvoľnenie zdrojov pre ostatné okná keď sú zatvorené. Nastaviť tento parameter správne potrebujeme poznať hardvérovú konfiguráciu (RAM) počítače, kde je klientska aplikácia spustená. Toto je kompromis medzi rýchle vyvolanie obrazovky používateľa rozhranie a celkový výkon počítača (Nechceme systém spustiť nízky obsah pamäte). Keď počítač nemá dostatok zdrojov (RAM), vedenie niekoľko okien pamäti (počet načítaných okien závisí koľko pracoviská sú nakonfigurované) bude tieto okná "zaťaženie" rýchlo a to nie podstatne zhorší výkon počítača. Pre ystems nie je bohatý na pamiatku, lepším riešením je uvoľniť pamäť, okna, ktorá je uzavretá.',
    94130: 'Dátum vytvorenia QM',
    94131: 'Dátum vytvorenia QM stránka',
    94132: 'Dátum vytvorenia vo výtlačkoch QM',
    94133: 'QM zmeniť dátum',
    94134: 'QM stránku zmeniť dátum',
    94135: 'Zmeniť dátum v QM výtlačkoch',
    94136: 'QM autor',
    94137: 'QM stránky autora',
    94138: 'Meno autora QM výtlačkoch',
    94139: 'Časť v denníkoch produkcie',
    94140: 'Zahrnutie alebo vylúčenie časti z výroby záznamy hľadania',
    94141: 'Definuje, či časť objednávky informácie bude vnútri kritéria vyhľadávania v denníkoch produkcie. Normálne časť je súčasťou kritérium vyhľadávania. Pre pomalý server alebo pomalé databázy zakázať načítanie časti-objednávka informácií.',
    94142: 'Win Update cesta',
    94143: 'Aktualizovať cestu pre klientov so systémom Windows OS',
    94144: 'Cesta kde aktualizácie windows verzie PT9800 pobyt (pe_9800.jar, preklad...)',
    94145: 'Linux aktualizácia cesta',
    94146: 'Aktualizovať cestu pre klientov so systémom Linux OS',
    94147: 'Cestu, kde Linux verziu aktualizácie PT9800 býva (pe_9800.jar, preklad...)',
    94148: 'Spustiť archiváciu',
    94149: 'Uplynutý čas (počet dní) začať archiváciu ',
    94150: 'Najrýchlejšie rastúce stoly, stoly, ktoré obsahujú historické údaje: a_value a a_any musia byť archivované. Staré záznamy sú presunuté do určené tabuľky. Toto pole určuje, Kedy by sme mali začať archiváciu. Hodnota predstavuje počet dní. 720 je predvolená hodnota (~ 2 roky). Vždy, keď je hodnota väčšia než 0, archivácia zapnutá a musíme aktivovať proces ux_jahr pozadie aby archivačné funkcie pracovať správne.',
    94151: 'Špeciálny náklad',
    94152: 'Zaťaženie Marker',
    94153: 'Označuje ak zaťaženie vyžaduje ďalšiu pozornosť. Zvyčajne sa používa pre veľké zaťaženie, ktorých rozmery presahujú limit (príliš ťažké, príliš dlhé, vysoké...), alebo pre zaťaženie, ktoré je potrebné overiť. ',
    94154: 'Zoznam tlače zaťaženia',
    94155: 'Povolí alebo zakáže tlač zoznamu nákladu',
    94156: 'To umožňuje tlač zoznamu nákladu. Zapnuté, ďalšie tlačidlo Ukážka pred tlačou zobrazí Automat-miesto-informácie alebo denníky produkcie (časť/poradí)',
    94157: 'Hlavička výtlačok',
    94158: 'Výtlačok hlavičky zoznamu nákladu',
    94159: 'Definuje hlavičky zoznamu nákladu na vytlačenie.',
    94160: 'Formát papiera',
    94161: 'Nastavenie formátu papiera',
    94162: 'Platí pri tlači zoznamu nákladu alebo pracovisko informácie. Ak používatelia aleays použiť rovnaký formát pre tlač, oni by mal vybrať jeden oni používajú. Inak, používateľ by mal vybrať dialógové okno tlačiť a spýtala na výber formátu zakaždým ona vytlačí.',
    94163: 'Aktivujete režim',
    94164: 'Umožňuje od zakáže toner save mode',
    94165: 'Definuje ako poslať informácie tlačiareň pri tlači pece obrazovky. Odporúča sa použiť toner save mód, keď čierna farba pozadia nahrádza bledosivá.',
    94166: 'SAP cesta',
    94167: 'SAP cestu pre tlačné',
    94168: 'Uplatniteľné pre tlačné pece. Predstavuje cestu pre čítanie súborov SAP (SAP súbory obsahujú časť/objednávky-informácie pre tlačné remorkéry). Prosím vložte znak lomka (späť) na konci dráhy.',
    94169: 'Odkaz na časť',
    94170: 'Pri spustení úlohy vyberte časť',
    94171: 'Určuje, ako sa odkazovať na časť: ako voľného poľa kde koncový používateľ zadá časti názov a popis, alebo tým, že poukáže na záznam v tabuľke súčasť. V predvolenom nastavení je požadované, žiadne prepojenie s tabuľkou časť ktorá je preferovanou voľbou pre väčšinu tepla treaters. Ak používateľ vyberie možnosť použiť časti z tabuľky časť, byť si vedomý, že časť má existovať v databáze pred vytvorením zaťaženie.',
    94172: 'Celková hmotnosť',
    94173: 'Zobrazenie celkovej hmotnosti v časti formulára',
    94174: 'Obsolite Parameter.Determines, ak celková hmotnosť sa zobrazí alebo nie, v časti upraviť formulár. V predvolenom nastavení, táto hodnota je zobrazená. Zastarané, dnes každý časť má celkovú hmotnosť.',
    94175: 'Vypnúť čítanie alarmy',
    94176: 'Alarmy komunikáciu s radičmi zapnúť/vypnúť',
    94177: 'Normálne komunikácie alarmy by mala byť vždy povolená. Pre zákazníkov, ktorí veľmi často vypnúť ich radiče, vypnutie alarmy považovať.',
    94178: 'Varchar alebo BLOB',
    94179: 'BLOB nahradiť Varchar',
    94180: 'Pre jazyky, ktoré nemožno použiť ASCII znaky (ako čínština), musíme nahradiť guličky s varchars. V predvolenom nastavení aplikácia aby guličky',
    94181: 'Formát času',
    94182: 'Zadajte formát času',
    94183: 'Určuje formát èasu. Ak chcete zachovať rovnakého formátu času počítač je nastavený, ponechajte toto pole prázdne. Ak klientsky softvér potrebuje používať iný časový formát ako je nainštalovaný v počítači, vyberte formát času zo zoznamu. Vybratý časový formát bude viditeľné vnútri PT9800 aplikácie len.',
    94184: 'Formát dátumu',
    94185: 'Špecifikovať formát dátumu',
    94186: 'Určuje formát dátumu. Ak chcete ponechať rovnaký dátum formát počítač nastavený na, ponechajte toto pole prázdne. Ak klientsky softvér potrebuje používať iný formát ako je nainštalovaný v počítači, vyberte formát dátumu zo zoznamu. Vybraný formát dátumu budú viditeľné vnútri PT9800 aplikácie len.',
    94187: 'Výroba časovač',
    94188: 'Výroba minútu proti',
    94189: 'Uplatniteľné na automaty iba. Zvyčajne je zakázaná výroba časovač (non-automaty). Pre automaty, vyberte zdroj pre počítadlo čas: vonkajšie PLC alebo internej databázy (tabuľka ux-btrb). ',
    94190: 'Max zaťaženie',
    94191: 'Maximálny počet náklad v bunku',
    94192: 'Uplatniteľné na automaty iba. Počet bremenami by mala byť obmedzená; to musí byť vždy menšie potom počet časopisov (skladovanie staníc). Napríklad, ak máme 10 časopisov a 6 pecí a chceme obmedziť zaťaženie v začiarkli políčko automat aby určite máme vždy jeden časopis zadarmo, by sme mali dať 9 v tejto oblasti. Bez obmedzenia môžeme naplniť začiarkli políčko Automat a začať výrobu uviazol.',
    94193: 'PT9000 zaťaženie osvedčenie',
    94194: 'Zapína/vypína PT9000 štýl správy',
    94195: 'Ak je povolené v denníkoch produkcie Zobraziť a vytlačiť zostavy sa zobrazí tlačidlo. Rozloženie zostavy musia byť uvedené pod "8001 - definícia tepelného spracovania certifikátu".',
    94196: 'Obrázok cesta',
    94197: 'Nastaviť počiatočné cestu pre obrázky',
    94198: 'Uplatniteľné, keď je aktivovaná voľba "Obrázky". To je počiatočné cestu pre dialógové okno Otvoriť obrázok.',
    94199: 'Počet miest',
    94200: 'Maximálny povolený počet miest na sedenie / klientsky softvér ',
    94201: ' Ak licencia ochrana nie je nainštalovaný, zadajte číslo kódované, podľa nasledujúceho postupu. Najprv vynásobiť číslo zákazníka s maximálnych povolených miest. Po každej číslice výrobku, počnúc zľava, vložte čísla 1,2,3 atď.; význam prvej číslice vľavo, vložte 1, po druhej číslice od ľavého okraja vložte 2 atď... Príklad: Zákazník číslo = 1016, počet miest na sedenie = 3. Súčin týchto dvoch čísel je 3048. Po vložení 1,2,3 a 4 po každej číslice od číslo vľavo, kódované uviesť je 31024384 ',
    94202: 'Tlačné ID',
    94203: 'Tlačné ID pre simulácie',
    94204: '',
    94205: 'Číslo verzie',
    94206: 'Číslo verzie aplikácie Navision',
    94207: 'Zadajte číslo softvéru produkt Navision. Ak neexistuje žiadna súvislosť s Navision systému, zadajte hodnotu 0. Aplikácia Navision podporuje podnikových zdrojov projektovací softvér od spoločnosti Microsoft.',
    94208: 'Sekvenčný režim poplatku',
    94209: '',
    94210: '',
    94211: 'Graf Mode',
    94212: 'Používanie moderného štýlu',
    94213: '',
    94214: 'Plánovanie graf pre normálne 9800 ',
    94215: 'Vypnúť/zapnúť plánovanie graf pre normálne 9800 ',
    94216: '',
    94217: 'WBN Export tlačidla',
    94218: '',
    94219: '',
    94220: 'Recept runtime',
    94221: '',
    94222: '',
    94223: 'Serverová licencia',
    94224: 'Používanie licencií pre servery',
    94225: '',
    94226: 'Pozrite sa a cítiť',
    94227: 'Použiť nový vzhľad & cítiť',
    94228: 'Vyberte štýl grafické užívateľské rozhranie, založené na vaše preferencie.',
    94229: 'Väčšie ikony',
    94230: 'Použite vyššie rozlíšenie ikony',
    94231: 'Ak je povolené, ikony sú 24 x 24 bodov, Ostatné 16 x 16. Vyberte veľkosť ikon, založené na vaše preferencie rovnako rozlíšenie monitora.',
    94232: 'Hospodárenie s energiou',
    94233: 'Zakázať/povoliť energetický manažment',
    94234: 'V predvolenom nastavení by mala byť zakázaná. Funkciu, ak je povolené, bude pracovať len pre jedného konkrétneho zákazníka',
    94235: 'NADCAP kompatibilný s',
    94236: 'Ochranu údajov pred úpravy.',
    94237: 'Ak dáta sú chránené – systém spĺňa normu NADCAP. Keď je toto políčko začiarknuté, oznámiť zmeny v údajoch sa pridáva kód chyby-detekcia (crc). ',
    94238: 'Pridať stĺpce do a_cont_pos',
    94239: 'Vytvoriť/používať nové polia v tabuľke a_cont_pos',
    94240: 'Táto funkcia sa týka iba automaty. Užívateľ má tri možnosti: nie je vytvárať a používať nové polia; Vytvoriť nové polia a používať už pridané polia. Ak používateľ vyberie vytvoriť nové polia, polia sa vytvoria a po osviežujúci obrazovke rozbaľovacieho zoznamu sa nastaví na "Použitie pridané polia". Po vytvorení polí sú nie skúste ich znova vytvoriť.',
    94241: 'Načítať zoznam',
    94242: 'Naplánované načítať zoznam',
    94243: 'Keď je táto funkcia zapnutá "Zobraziť zaťaženie zoznam" tlačidla sa objaví pece kartu recept zaťaženia zoznamu možno získať z PT9800 zaťaženie sekvencer alebo z externej aplikácie, ako je TTC ASM softvér',
    94244: 'Demo dátum',
    94245: 'Dátum vypršania platnosti demo',
    94246: 'Dátum pri demo verzia PT9800 klientsky softvér prestane fungovať.',
    94247: 'Zámok terminál',
    94248: 'Zámok termináli dovtedy, kým tieto',
    94249: 'Dátum dokedy bude zamčené terminál',
    94250: 'AMS Automat',
    94251: 'Povoliť pripojenie na AMS',
    94252: 'AMS je komerčný softvér TTC, heat-treating. Ak je táto funkcia zapnutá, PT9800 môžete vymieňať údaje s TTC je AMS softvér',
    94253: 'Klient Auto Print',
    94254: 'Povoliť automatickú tlač pre konkrétneho klienta',
    94255: '',
    94256: 'Zaťaženie Auto Print',
    94257: 'Povoliť automatickú tlač pre konkrétne zaťaženie',
    94258: '',
    94259: 'Auto tlače spánok čas',
    94260: 'Čakať čas int sekúnd medzi dvoma tlače žiadosť',
    94261: '',
    94262: 'Minimálne pracovisku id pre auto tlače',
    94263: '',
    94264: '',
    94265: 'Maximálna pracovisku id pre auto tlače',
    94266: '',
    94267: '',
    94268: 'Výber výr denník',
    94269: 'Zakázať/povoliť používanie conbo políčko hlavička',
    94270: '',
    94271: 'Pohotovostnom aktívny ak zmenil',
    94272: '',
    94273: '',
    94274: 'AMS IP adresu',
    94275: ' AMS Server IP adresu',
    94276: ' Toto pole vyplniť len vtedy, ak je povolená komunikácia s AMS softvér. Zadajte adresu IP servera, AMS. AMS je komerčný softvér TTC, heat-treating. PT9800 si môžu vymieňať údaje s TTC je AMS softvér. ',
    94277: 'Číslo portu AMS',
    94278: ' Číslo portu servera AMS',
    94279: ' Toto pole vyplniť len vtedy, ak je povolená komunikácia s AMS softvér. Zadajte číslo portu na serveri AMS, zodpovedný za komunikáciu s PT9800 serverom. AMS je komerčný softvér TTC, heat-treating. PT9800 môžete vymieňať údaje s TTC"s AMS softvér. ',
    94280: 'Číslo portu PE',
    94281: ' Číslo portu PE AMS',
    94282: 'Toto pole vyplniť len vtedy, ak je povolená komunikácia s AMS softvér. Zadajte číslo portu na PT9800 serveri, zodpovedný za komunikáciu so serverom AMS. AMS je komerčný softvér TTC, heat-treating. PT9800 si môžu vymieňať údaje s TTC je AMS softvér. ',
    94283: 'AMS Time Out',
    94284: 'AMS komunikácie Timeout',
    94285: ' Toto pole vyplniť len vtedy, ak je povolená komunikácia s AMS softvér. Zadajte čas oneskorenia pre komunikáciu so serverom AMS. AMS je komerčný softvér TTC, heat-treating. PT9800 si môžu vymieňať údaje s TTC je AMS softvér. ',
    94286: 'Informácie o ladení',
    94287: 'Vypnúť/zapnúť ladenie informácií',
    94288: 'Ak je povolené, ladenie kartu sa zobrazia v obchode rozloženie GUI, obsahujúce debug správy. ',
    94289: 'Obrázok procesu toku',
    94290: '',
    94291: '',
    94292: 'Obrázok cesta',
    94293: 'Proces toku obrázok cestu',
    94294: '',
    94295: 'Pohotovostnom úspornom režime v ect/hosts',
    94296: 'Zakázať/povoliť úspornom v etc/hosts',
    94297: 'Ak je pripojený k Siemens PLC a Linux: v etc/hosts malo alias pre pe_server ',
    94298: 'Bunka s IVA',
    94299: '',
    94300: '',
    94301: 'Výroba log tlačiť tlačidlo',
    94302: 'Zobraziť/Skryť výroba log tlačiť tlačidlo',
    94303: 'Vytlačí zoznam vyhľadávania',
    94304: 'Automaticky vytvoriť PDF súbor.',
    94305: 'Číslo klienta pre automatické vytváranie súborov PDF',
    94306: '',
    94307: 'Automaticky vytvárať PDF súboru priečinka.',
    94308: 'Určuje priečinok, kde je automaticky generuje PDF súbory sú uložené ',
    94309: '',
    94310: 'Automatické vytváranie PDF voľby',
    94311: 'Možnosti pre automatické vytváranie súborov PDF',
    94312: 'Určuje možnosti automaticky generuje súbory PDF-A v okamihu, keď je možné nastaviť, ktoré stránky sú vytlačené',
    94313: 'Mierka osi grafu',
    94314: 'Zakázať/povoliť Mierka grafu',
    94315: '',
    94316: 'Auto log out',
    94317: 'Klient bude automaticky odhlásiť po každých n minút',
    94318: 'Zadajte číslo klienta, ktoré budú mať auto log out povolené ',
    94319: 'Aplikácia Navision výrobnej bunky',
    94320: '',
    94321: '',
    94322: 'Názov spoločnosti Navision',
    94323: '',
    94324: '',
    94325: 'Externalizácia',
    94326: 'Externalizácia reťazcov',
    94327: '',
    94328: 'Pondelok hodíny',
    94329: 'Max. Pracovná doba pondelok',
    94330: 'Zadajte počet dostupných výrobných hodín (0-24), pre konkrétny deň. Toto číslo sa používa na výpočet využitia zariadenia. Napríklad ak rastlina pôsobí 16 hodín na konkrétny deň a zariadenia bola použitá na 10 hodín ten deň, jeho využitie pre tento deň je 10/16 = 62,5% ',
    94331: 'Utorok hodíny',
    94332: 'Max. pracovných hodín v utorok',
    94333: ' Zadajte počet dostupných výrobných hodín (0-24), pre konkrétny deň. Toto číslo sa používa na výpočet využitia zariadenia. Napríklad ak rastlina pôsobí 16 hodín na konkrétny deň a zariadenia bola použitá na 10 hodín ten deň, jeho využitie pre tento deň je 10/16 = 62,5% ',
    94334: 'Streda hodíny',
    94335: 'Max. pracovných hodín v stredu',
    94336: ' Zadajte počet dostupných výrobných hodín (0-24), pre konkrétny deň. Toto číslo sa používa na výpočet využitia zariadenia. Napríklad ak rastlina pôsobí 16 hodín na konkrétny deň a zariadenia bola použitá na 10 hodín ten deň, jeho využitie pre tento deň je 10/16 = 62,5% ',
    94337: 'Štvrtok hodíny',
    94338: 'Max. pracovných hodín vo štvrtok',
    94339: ' Zadajte počet dostupných výrobných hodín (0-24), pre konkrétny deň. Toto číslo sa používa na výpočet využitia zariadenia. Napríklad ak rastlina pôsobí 16 hodín na konkrétny deň a zariadenia bola použitá na 10 hodín ten deň, jeho využitie pre tento deň je 10/16 = 62,5% ',
    94340: 'Piatok hodíny',
    94341: 'Max. pracovných hodín v piatok',
    94342: ' Zadajte počet dostupných výrobných hodín (0-24), pre konkrétny deň. Toto číslo sa používa na výpočet využitia zariadenia. Napríklad ak rastlina pôsobí 16 hodín na konkrétny deň a zariadenia bola použitá na 10 hodín ten deň, jeho využitie pre tento deň je 10/16 = 62,5% ',
    94343: 'Sobota hodíny',
    94344: 'Max. pracovných hodín v sobotu',
    94345: ' Zadajte počet dostupných výrobných hodín (0-24), pre konkrétny deň. Toto číslo sa používa na výpočet využitia zariadenia. Napríklad ak rastlina pôsobí 16 hodín na konkrétny deň a zariadenia bola použitá na 10 hodín ten deň, jeho využitie pre tento deň je 10/16 = 62,5% ',
    94346: 'Nedeľa hodíny',
    94347: 'Max. pracovných hodín v nedeľu',
    94348: ' Zadajte počet dostupných výrobných hodín (0-24), pre konkrétny deň. Toto číslo sa používa na výpočet využitia zariadenia. Napríklad ak rastlina pôsobí 16 hodín na konkrétny deň a zariadenia bola použitá na 10 hodín ten deň, jeho využitie pre tento deň je 10/16 = 62,5% ',
    94349: 'Dostupnosť(%)',
    94350: 'Dostupnosť čas v percentách',
    94351: ' Predstavuje percento plánovaný čas, že vybavenie je k dispozícii na prevádzku. Dostupnosť (%) = 100 * dostupný čas / plánovaný čas ',
    94352: 'Cieľový čas časti??94352 ',
    94353: '',
    94354: '',
    94355: 'Bar v grafe oddelené v prevádzke',
    94356: '',
    94357: '',
    94358: 'Miesto držiak pre "0" hodnota',
    94359: '',
    94360: '',
    94361: 'MDE produkcie hodín',
    94362: '',
    94363: '',
    94364: 'QM režim vyhľadávania',
    94365: 'Vyhľadávanie lab hodnotenia',
    94366: '',
    94367: 'Tlač identifikátor <piston> ',
    94368: '',
    94369: '',
    94370: 'Tlač identifikátor < Mi-Za >',
    94371: '',
    94372: '',
    94373: 'Názov zákazníka odd.',
    94374: '',
    94375: '',
    94376: 'FTE/nákladové stredisko',
    94377: '',
    94378: '',
    94379: 'FTE/nákladové stredisko právo',
    94380: '',
    94381: '',
    94382: 'Počet vzťahov SpecSetMaterialPlan',
    94383: '',
    94384: '',
    94385: 'FTE122 (oddelenie 1) ',
    94386: '',
    94387: '',
    94388: 'QME1 (2 odd.) ',
    94389: '',
    94390: '',
    94391: 'QME2 (oddelenie 3) ',
    94392: '',
    94393: '',
    94394: 'Tlač certifikátu QM s',
    94395: '',
    94396: '',
    94397: 'Spoločnosť No.',
    94398: '',
    94399: '',
    94400: 'Malé QM režim',
    94401: '',
    94402: '',
    94403: 'Automat typ',
    94404: '',
    94405: '',
    94406: 'Zaťaženie planning(cell)',
    94407: '',
    94408: '',
    94409: 'Počet miest v rotačné časopise',
    94410: '',
    94411: '',
    94412: 'Zaťaženie farebný režim',
    94413: '',
    94414: '',
    94415: 'Proces toku histórie',
    94416: 'Vypnúť/zapnúť proces toku histórie',
    94417: 'Ak je povolená je možné zobraziť verzie výroby denníka len pre archivované údaje atm. hobľované základne údaje',
    94418: 'Posledné číslo rack prázdnu bunku',
    94419: '',
    94420: '',
    94421: 'Poslednej bunky podržte číslo',
    94422: '',
    94423: '',
    94424: 'Vedúci znak pre mobil zaťaženia',
    94425: '',
    94426: '',
    94427: 'Číslo poslednej obsahu',
    94428: '',
    94429: '',
    94430: 'Vedúci charakter obsahu číslo',
    94431: '',
    94432: '',
    94433: 'Názov archívu kritérií 1 ',
    94434: '',
    94435: '',
    94436: 'Názov archívu kritériá 2 ',
    94437: '',
    94438: '',
    94439: 'Názov archívu kritérií 3 ',
    94440: '',
    94441: '',
    94442: 'Objednávka číslo názov poľa',
    94443: 'Názov poľa pre číslo objednávky v časti Zoznam',
    94444: '',
    94445: 'Poradové číslo súbor názov',
    94446: 'Názov poľa sériové číslo v časti Zoznam',
    94447: '',
    94448: 'Ropných uhasiť ID',
    94449: '',
    94450: '',
    94451: 'Ropných uhasiť miesto nie.',
    94452: '',
    94453: '',
    94454: 'N2 uhasiť ID',
    94455: '',
    94456: '',
    94457: 'N2 zhášania miesto č.',
    94458: '',
    94459: '',
    94460: 'Bezplatne auto ID',
    94461: '',
    94462: '',
    94463: 'Automatické načítanie miesto ID',
    94464: '',
    94465: '',
    94466: 'Automatické načítanie miesto nie',
    94467: '',
    94468: '',
    94469: 'Základná B_WP_ID mobilný',
    94470: '',
    94471: '',
    94472: 'Časť výberu',
    94473: 'Zakázať/povoliť výber častí s zodpovedajúce procesov tokov',
    94474: 'Časť výberu nájde náhradné diely rovnakej procesu toku',
    94475: 'Názov poľa č. ',
    94476: '',
    94477: '',
    94478: '',
    94479: '',
    94480: '',
    94481: 'Názov poľa 3 parts(CustomerOrderNo)',
    94482: '',
    94483: '',
    94484: 'Názov poľa 4 parts(Remark)',
    94485: '',
    94486: '',
    94487: 'Recept História',
    94488: 'Zakázať/povoliť recept História',
    94489: '',
    94490: 'Naposledy zaťaženie č.',
    94491: '',
    94492: '',
    94493: 'Načítať č. popredný znak',
    94494: '',
    94495: '',
    94496: 'Bez PT500 ',
    94497: '',
    94498: '',
    94499: 'Možnosť zaťaženia sekvencia',
    94500: '',
    94501: '',
    94502: 'Výroba log zaťaženie nasadenia',
    94503: 'Zakázať/povoliť obsah zaťaženia priradiť výrobné záznamy',
    94504: '',
    94505: 'GetNewid prostredníctvom SQL procedúry alebo funkcie',
    94506: '',
    94507: '',
    94508: 'Vytlačiť recept info',
    94509: 'Zakázať/povoliť recept info o výtlačok',
    94510: '',
    94511: '',
    94512: '',
    94513: '',
    96999: '',
    97000: 'Všeobecne',
    97001: 'Spoločné parametre',
    97002: 'Kontrola kvality',
    97003: 'Utilitzation',
    97004: 'Recept',
    97005: 'Automat',
    97006: 'Pripojenie',
    97007: 'Systém',
    97008: 'Jazyk',
    97009: 'Pozrite sa a cítiť',
    97010: 'Jednotka',
    97011: 'Čas',
    97012: 'Výkon',
    97013: 'Cesta',
    97014: 'Alarm',
    97015: 'Časť',
    97016: 'Výroba Log',
    97017: 'Výtlačok',
    97018: 'Graf',
    97019: 'Kontrola',
    97020: 'Údržba',
    97021: 'Zastaraný',
    97022: 'AMS',
    97023: 'Navision',
    97024: 'SAP',
    97025: 'Bunka 1 ',
    97026: 'Bunky 2 ',
    97027: 'Automat',
    97028: 'Dávky',
    97029: 'Svetlo modrá',
    97030: 'Štýl Windows',
    97031: 'Čistý štýl',
    97032: 'Žiadna tlačná/pás pece',
    97033: 'Vyhradené pre 1016 ',
    97034: 'Tlačné',
    97035: 'Pás',
    97036: 'Dátum & čas',
    97037: 'Uplynutý čas',
    97038: 'Nie',
    97039: 'Vyhradené pre 1016 ',
    97040: 'Áno',
    97041: 'PT500 ',
    97042: 'V časti',
    97043: 'Za náklad',
    97044: 'Recept Štart',
    97045: 'V auto príkaz',
    97046: 'Rovnaké pre všetky diely',
    97047: 'Rovnaké pre všetky diely',
    97048: 'Výkres č & revízia č. ',
    97049: 'Zákazník č & objednávka/výkres č ',
    97050: 'Výkres č. zobrazí sa',
    97051: 'Číslo objednávky zobrazí sa',
    97052: 'Signalizácie v rozsahu 1 až 1024 ',
    97053: 'Poplach v rozsahu 1 až 1024 a alarmy väčšie 512 ',
    97054: 'Nikto bude preložený',
    97055: 'None',
    97056: 'Pece len',
    97057: 'Shop "len rozloženie',
    97058: 'Pece a rozloženie Shop',
    97059: 'Výrobné záznamy iba',
    97060: 'Pece a výrobu logy',
    97061: 'Obchod rozloženie a výrobné záznamy',
    97062: 'Pec & Shop rozloženia a výrobné záznamy',
    97063: 'Aktuálne nastavenie na PC',
    97064: 'DIN A4 ',
    97065: 'Dialógové okno tlač',
    97066: 'Aktuálne nastavenie na PC',
    97067: '12 hodín (AM, PM)',
    97068: '24 hodín',
    97069: 'Aktuálne nastavenie na PC',
    97070: 'RR-MM-DD',
    97071: 'MM-DD-RR',
    97072: 'DD-MM-RR',
    97073: 'Využiť čas (hodiny) dostal od pece PLC',
    97074: 'Použité čas (hodiny) z tabuľky ux_btrb (pt9800) ',
    97075: 'Default',
    97076: 'Najskorší čas spustenia',
    97077: 'Výroba log',
    97078: 'ASCII',
    97079: 'XML',
    97080: 'Všetky',
    97081: 'HH',
    97082: 'min',
    97083: 'Off',
    97084: 'Na',
    97085: 'Len na čítanie',
    97086: 'DR',
    97087: 'Bursa/Bosch',
    97088: 'Časť',
    97089: 'Prevádzka/materiál',
    97090: 'Vzorka',
    97091: 'None',
    97092: 'Zapisovač',
    97093: 'Profil',
    97094: 'Info nižšie',
    97095: 'Legenda nižšie',
    97096: 'Pole číslo',
    97097: 'Číslo platiteľa',
    97098: 'Staré',
    97099: 'Nový',
    97100: 'Mini',
    97101: 'Amerike',
    97102: 'Elgin',
    97103: 'Passau',
    97104: 'Nie',
    97105: 'Áno',
    97106: 'H & S',
    97107: 'Žiadne plánovanie',
    97108: 'Len auto príkaz',
    97109: 'Triedenie',
    97110: 'Teplo',
    97111: 'Zvyšok',
    97112: 'Hydro',
    97113: 'None',
    97114: 'MSSql',
    97115: 'MySql/PostGreSQL',
    97116: 'Oracle',
    97117: 'None',
    97118: 'Navision',
    97119: 'Tlačné',
    97120: 'Nie',
    97121: 'Áno',
    97122: 'Zaťaženie sekvencer',
    97123: 'TTC',
    97124: 'Nie',
    97125: 'Áno',
    97126: 'Trvať od časti',
    97127: 'Trvať od ako dlho zaťaženie bolo pece ',
    97128: 'Nie',
    97129: 'Áno',
    97130: 'Tlačné',
    97131: 'Neplatný názov hostiteľa',
    97132: 'Neplatnej databáze typu',
    97133: 'Testovacie pripojenie',
    97134: 'Neplatný sluţby',
    97135: 'Host name',
    97136: 'Názov databázy',
    97137: 'Databáza typu',
    97138: 'Port číslo',
    97139: 'Užívateľské meno',
    97140: 'Heslo',
    97141: 'Číslo klienta',
    97142: 'Typ klienta',
    97143: 'Verbose',
    97144: 'Prihláste sa do konzoly',
    97145: 'Databáza',
    97146: 'Rôzne.',
    97147: 'Pripojenie k databáze úspešné',
    97148: 'Vyberte otvoriť súbor',
    97149: 'Číslo zákazníka nebol nájdený',
    97150: 'Zákazník priečinok nebol nájdený',
    97151: 'Nastaviť nový názov priečinka a umiestnenie',
    97152: 'PT 9800 konfiguračné Utility',
    97153: 'Pripojenie na server pomocou klient konfiguračného súboru...',
    97154: 'Vytvorenie nového klienta konfiguračného súboru...',
    97155: 'Parametre konfigurácie',
    97156: 'Klon systém',
    97157: 'Nastavenie',
    97158: 'Pracoviská',
    97159: 'License',
    97160: 'Obchod Layout',
    97161: 'Sprievodca inštaláciou servera',
    97162: 'Systém',
    97163: 'Nástroje',
    97164: 'Výrobca',
    97165: 'Developer',
    97166: 'Nahrá',
    97167: 'Neplatná hodnota pre tento parameter',
    97168: 'Úprava údajov',
    97169: 'Upraviť',
    97170: 'Odstrániť aktuálne rozloženie obchod',
    97171: 'Už názov rozloženia shop',
    97172: 'Pracoviská',
    97173: 'Rôzne.',
    97174: 'Obdĺžnikový',
    97175: 'Označenie',
    97176: 'Nákupný košík',
    97177: 'Späť. Obraz',
    97178: 'Vyberte rozloženie...',
    97179: 'Vyberte priečinok, pracovisko...',
    97180: 'Shop rozloženia podporuje iba 1 obrázok na pozadí',
    97181: 'Neznáma značka [%1]. Nepodarilo sa vytvoriť zložku.',
    97182: 'Kopírovať vybratý súbor: %1? ',
    97183: 'Súbor už existuje. Chcete pokračovať a prepísať?',
    97184: 'Nepodarilo sa skopírovať súbor',
    97185: 'Rôzne.',
    97186: 'Používateľom definované',
    97187: 'Shop rozloženia meno nemôže byť prázdne',
    97188: 'Pripojiť k serveru pomocou databázy paramters...',
    97189: 'Parametre pripojenia databázy',
    97190: 'Pripojený k databáze',
    97191: 'Priečinok vyberte zákazníka',
    97192: 'Zákazník priečinok je neznámy. Budete musieť vybrať umiestnenie priečinka zákazník',
    97193: 'PT9800 konfiguračné Utility',
    97194: 'Parametre úspešne uložený',
    97195: 'Nastavenie',
    97196: 'Nie je možné uložiť zmeny, zatiaľ čo tam sú iné databázové pripojenia.',
    97197: 'Prosím, zatvorte všetky okná.',
    97198: 'Neplatný názov databázy',
    97199: 'Neplatný port číslo',
    97200: 'Licencovanie: ',
    97201: 'Server licencií: ',
    97202: 'Niektoré záznamy DB nebol nájdený',
    97203: 'Neplatný aktivačný kód',
    97204: 'Karta overenie zlyhanie siete',
    97205: 'Demo verzia Dátum uplynul!',
    97206: 'Porušenie prístupu!',
    97207: 'Žiadna licencia politika je nastavená. Všetky parametre sú otvorené na úpravy.',
    97251: 'Krok 1 - Inštalácia databázový stroj',
    97252: 'Krok 2 - overiť závislostí',
    97253: 'Krok 3 - Skopírujte 9800 DB-náradie do Server',
    97254: 'Krok 4 - Vyberte metódu',
    97255: 'Krok 5 - vytvoriť prázdnu databázu',
    97256: 'Krok 6 - Vytvorenie databázových tabuliek',
    97257: 'Krok 7 - vytvoriť prepojenia medzi tabuľkami',
    97258: 'Krok 8 - načítať dáta',
    97259: '',
    97260: '',
    97261: '',
    97262: '',
    97263: '',
    97264: '',
    97265: '',
    97266: '',
    97267: '',
    97268: '',
    97269: '',
    97270: '',
    97271: '',
    97272: '',
    97273: '',
    97274: '',
    97275: '',
    97276: '',
    97277: '',
    97278: '',
    97279: '',
    97280: '',
    97281: 'By ste chceli odstrániť databázy vytvorené v databáze?',
    97282: 'Nepodarí odstrániť databázu, chyba: ',
    97283: 'Prosím vyplňte všetky polia a skúste to znova!',
    97284: 'Pripojenie Test prejde",',
    97285: 'Test pripojenia neprejde',
    97286: 'Krok 1 - Test pripojenia neprejde',
    97287: 'Krok 1 - úspech',
    97288: 'Potrebné závislosti overenie úspešné',
    97289: 'Krok 2 - potrebné závislosti overenie nie je vykonané alebo overenie zlyhá ',
    97290: 'Krok 2 - úspech',
    97351: 'Štandardné',
    97352: 'Odhlásený',
    97353: 'Prosím, zatvorte všetky okná pred odhlásením',
    97354: 'Nepodarilo sa odhlásiť',
    97355: 'Posledné súbory',
    97401: 'Licenčný server Manager',
    98000: 'Nasledujúci konfiguračný súbor nebol nájdený',
    98001: 'PT455 konfiguračný nástroj',
    98002: 'Výrobca',
    98003: 'Developer',
    98004: 'Nahrá',
    98005: 'Posledné súbory',
    98006: 'Načítanie systému...',
    98007: 'Zatvorte systém',
    98008: 'Výjazd',
    98009: 'Prosím, zatvorte všetky okná pred',
    98010: 'Tam je v súčasnosti otvorený systém. Bude musieť zavrieť pred načítaním iného jeden, pokračovať?',
    98011: 'Musíte zavrieť "IO bod konfiguračný nástroj" pouzit "Pozadie recept tvorca',
    98012: 'Musíte zavrieť "Pozadie recept tvorca" pouzit "IO bod konfiguračný nástroj',
    98013: 'Prihlásiť',
    98014: 'Ukázať užívateľovi Editor',
    98015: 'Ak chcete použiť "Recept tvorca" musíte zavrieť "IO bod konfiguračný nástroj',
    98016: 'Musíte zavrieť "Recept tvorca" pouzit "IO bod konfiguračný nástroj',
    98017: 'Nepodarilo sa načítať tieto externý nástroj',
    98018: 'IO bod konfigurácia',
    98019: 'Konfigurácia systému',
    98020: 'Create update package',
    98021: 'Tools',
    98022: 'Regenerate "files.lst',
    98023: "'files.lst' not found",
    98024: 'Unable to calculate checksum value for the following file',
    98025: 'Unable to write the following file',
    98026: 'Completed successfully',
    98027: 'Not a valid backup',
    98500: 'Firmware Update',
    98501: 'The following firmware update folder was not found',
    98502: 'The following firmware update file was not found',
    98503: 'Firmware update as been copied. Unit needs to be restarted for effects to take place. Restart unit now?',
    98504: 'Please wait while copying firmware update ...',
    98505: 'The following checksum file for the firmware update was not found',
    98506: 'Unable to read the following checksum file',
    98507: 'A checksum file was found but does not appear to be for the firmware update file',
    98508: 'The checksum value obtained from the firmware update file does not match the value stored in the checksum file',
    98509: 'After copying firmware update file a checksum mismatch has been found',
    98510: 'You will need to insert or connect an external media containing the firmware update. The root of this media must contain the folder',
    98511: 'with the firmware update file',
    98512: 'After update has completed the unit will have to be restarted for changes to take effect. Do you want to proceed?',
    98513: 'The checksum command did not end normally and returned with an error',
    98514: 'Invalid checksum',
    98515: 'The checksum command returned with error',
    98550: 'Load Profibus Configuration',
    98551: 'You will need to insert or connect an external media containing the profibus configuration created with sycon.net. The root of this media must contain the folder',
    98552: 'with the configuration file',
    98553: 'After update has completed the unit will have to be restarted for changes to take effect. Do you want to proceed?',
    98554: 'Please wait while copying profibus configuration.',
    98555: 'The profibus configuration folder was not found',
    98556: 'The profibus configuration file was not found',
    100000: 'heat ramp',
    100001: 'cool ramp',
    100002: 'heat',
    100003: 'cool',
    100004: 'hold',
    100005: 'Min',
    100006: 'Max',
    100007: 'Search in column: ',
    100008: 'Created with',
    100009: 'version',
    100029: 'Invalid Value',
    100030: 'off',
    100031: 'on %C',
    100032: 'soot limit%',
    100033: 'Auto(100-x)%',
    100034: 'Surf.C%',
    100040: 'off',
    100041: 'on %N',
    100042: 'Nitride(100-x)%',
    100043: 'Surf. N%',
    100050: 'off',
    100051: 'on',
    100052: 'auto',
    100059: '°C/min ',
    100060: '°F/min ',
    100061: 'Minutes',
    100062: '%CD',
    100063: 'Stage Inserted',
    100064: 'Stage Added',
    100065: 'Please select a stage to be deleted.',
    100066: 'Stage Deleted',
    100067: 'Name',
    100068: 'Carrier Gas',
    100069: 'Fixed',
    100070: 'Stages',
    100071: 'Recipe',
    100072: 'Temp-Control',
    100073: 'Temp.Set Point',
    100074: 'Unit',
    100075: 'CP-Control',
    100076: 'Target End Value',
    100077: 'Stage[min]',
    100078: 'Total[h:min]',
    100079: 'Entry out of range',
    100080: 'Setting entry to ',
    100081: 'Are you sure that you want to delete this recipe?',
    100082: 'Please load the recipe for deletion',
    100083: 'Recipe deleted',
    100084: 'Error deleting recipe',
    100085: 'Recipe saved',
    100086: 'Error saving recipe',
    100087: 'Error opening recipe database ',
    100088: 'CP-Set Point [%]',
    100089: 'Gas Carburizing',
    100090: 'HT-Tools Pro',
    100091: 'Fixed',
    100092: 'Variable',
    100093: 'ß Control',
    100094: 'Ratio',
    100095: 'End Condition',
    100096: 'Case Depth',
    100097: 'Time',
    100098: "Can't load template",
    100099: 'You may not delete or modify this recipe.',
    100100: 'Use "Save as" to make a copy.',
    100101: 'N Pot Type',
    100102: 'N Pot Value [%]',
    100103: 'Carbonitriding',
    100104: 'Low Pressure Carborizing',
    100105: 'Volumetric Flow',
    100106: 'Vol Flow [nl/m^2/h]',
    100107: 'Average',
    100108: 'Comp',
    100109: 'User',
    100110: 'Minimum',
    100111: 'Maximum',
    100112: 'Preprocessed',
    100118: 'Pre-processed Values',
    100119: 'Edit/Set',
    100120: 'Simulation Value',
    100121: 'Surface C',
    100122: 'Carbon Pot.',
    100123: 'Use',
    100124: 'Kn',
    100125: 'Kc Use',
    100126: 'Kc',
    100127: 'N2 Flow[%]',
    100128: 'Compound',
    100129: 'Diff./Prec.',
    100130: 'Layer',
    100131: "Iron AG'",
    100132: "Steel AG'",
    100133: "Iron G'E",
    100134: "Steel G'E",
    100135: 'CO+CO2[%]',
    100136: 'CO fl[%]',
    100137: 'CO2 fl[%]',
    100138: 'Phase',
    100139: 'NiCarm',
    100140: 'Diagram',
    100141: 'Temp. °F',
    100142: 'Temp. °C',
    100143: 'Nitralloy 135M',
    100144: 'Nitralloy EZ',
    100145: 'Nitralloy N',
    100146: '4140,4340',
    100147: 'DC,D6AC',
    100148: 'H11',
    100149: 'Stainless',
    100150: 'Carbon',
    100151: 'Group 1_HLSA Plain Carbon_5.1 to 21 [microns]',
    100152: 'Group 2_4140,4340_Nitralloy 135M_Low alloy 5.1 to 25_Tool Steels 2.5 to 15',
    100153: 'Group 3_Cast Iron 5.1 to 25 [microns]',
    100154: 'Class 0 No(Cl)',
    100155: 'Class 1 (0-13)',
    100156: 'Class 2 (13-25)',
    100157: 'Class 1_(Porosity <= 15%)',
    100158: 'Class 2_(10% - 40%)',
    100159: 'Kc Control',
    100160: 'Kn',
    100161: ' ',
    100162: 'Iron',
    100163: 'DC',
    100164: 'Nitralloy',
    100165: 'D6AC',
    100166: 'Carbon Steel',
    100167: 'Tool Steel',
    100168: 'H11 H13',
    100169: 'Low Alloy Steel',
    100170: '4140 4340',
    100171: 'High Alloy Steel',
    100172: 'Stainless Steel',
    100173: 'Steel Grade Estimation',
    100174: 'Use Recommended',
    100175: 'Steel',
    100176: 'Class',
    100200: 'Kn Eff',
    100201: 'Kc Eff',
    100202: 'AMS Helper',
    100203: 'Hide AMS',
    100204: 'E-Phase',
    100205: 'E-Phase-Steel',
    100206: 'Lehrer Diagram',
    100207: 'AMS Recommendation',
    100208: 'Diagrams',
    100209: 'Error in step ',
    100210: 'Not in epsilon.',
    100211: 'Stage time shorter than nucleation time.',
    100212: 'Kn too low for nucleation.',
    100213: "Kn too low.  Calculate with γ' steel.",
    100214: 'Temperature outside of specification.',
    100215: 'Surface hardness cannot be reached.',
    100216: 'Tempering temperature is too low, set to 500 deg C',
    100300: 'Process Values',
    100301: 'Profile Chart',
    100302: 'C/N2 Weight[%]',
    100303: 'Mass Flow',
    100304: 'C Potential',
    100305: 'N Potential',
    100306: 'Surface C',
    100307: 'Surface N',
    100308: 'Surface Carbide',
    100309: 'C/N Content [wt%]',
    100310: 'C/N Potential [wt%]',
    100311: 'C-Profile',
    100312: 'N-Profile',
    100313: 'Actual Nitride Limit',
    100314: 'Carb.Profile',
    100315: 'Carburizing Depth',
    100316: 'Actual Carbide Limit',
    100317: 'Retained Austenite',
    100318: 'Required Hardness at Case Depth',
    100319: 'Required Carbon at Carb. Depth',
    100320: 'Modify Selection',
    100321: 'Required Surface Hardness',
    100322: 'Nitride Profile',
    100323: 'Please select the items you want to display.',
    100324: 'No.',
    100325: 'Compound Layer',
    100326: 'Diffusion Layer',
    100327: 'Nitrided Case',
    100328: 'Distance to Surface',
    100329: 'Kn/Kc Potential',
    100330: 'Visual Case Depth',
    100331: 'Setpoint',
    100332: 'NHD',
    100333: 'C/C-Fe3C Content [wt%]',
    100400: 'Diffusion',
    100401: 'Part and Material',
    100402: 'Recipe',
    100403: 'Process Values Chart',
    100404: 'Profile Table',
    100405: 'Print Selection',
    100406: 'Analysis',
    100407: 'Page',
    100408: 'Carbon Profile Table',
    100409: 'Carbon/Nitrogen Profile Table',
    100410: '(continued)',
    100411: 'Simulation Errors',
    100415: 'Austenite',
    100416: 'Time [hh:mm:ss]',
    100417: 'Temp',
    100418: 'Atm.',
    100419: '%C',
    100420: '%N',
    100421: '%flow',
    100422: 'cd',
    100423: 'Ferrite',
    100424: 'Diff./Prec. Layer',
    100425: 'Carbide',
    100999: 'Are you sure you want to delete this item?',
    101000: 'Part',
    101001: 'Quench Condition',
    101002: 'Quenching Media',
    101003: 'Quenching Intensity',
    101004: 'Temperature',
    101005: 'Material Data',
    101006: 'Grain Size',
    101007: 'Shape',
    101008: 'Diameter',
    101009: 'Carburizing Requirements',
    101010: 'Surface Hardness',
    101011: 'Case Depth [tsd]  NOT USED',
    101012: 'Reg. Hardness at cd [HV] NOT USED',
    101013: 'Content needed NOT USED',
    101014: 'Hardness[wt%]',
    101015: 'For Hardness at cd[wt%]',
    101016: 'Please enter the Part Name',
    101017: 'Please select the Quenching Media',
    101018: 'Please enter the Quenching Intensity',
    101019: 'Please enter the End Temperature',
    101020: 'Please enter Grain Size',
    101021: 'Please select the Shape',
    101022: 'Please enter Diameter',
    101023: 'Please enter Surface Hardness',
    101024: 'Please enter Case Depth',
    101025: 'Please enter Reg. Hardness',
    101026: 'Please select a treatment type',
    101027: 'Diameter',
    101028: 'Span betw. parallel sides',
    101029: 'Min. critical dimension',
    101030: 'Wall thickness',
    101031: 'Round Bar',
    101032: 'Hexagonal or Octagonal Bar',
    101033: 'Block/Plate/Sheet',
    101034: 'Disc inner diammeter < 200 mm',
    101035: 'Ring inner diammeter > 200 mm',
    101036: 'Tubing inner diameter < 80 mm',
    101037: 'Tubing inner diameter < 200 mm',
    101038: 'Tubing inner diameter > 200 mm',
    101039: 'Partially Closed Hollow Body',
    101044: 'Disc inner diammeter < 8 inch',
    101045: 'Ring inner diammeter > 8 inch',
    101046: 'Tubing inner diameter < 3 inch',
    101047: 'Tubing inner diameter < 8 inch',
    101048: 'Tubing inner diameter > 8 inch',
    101049: 'Rows',
    101050: 'Preprocessed Profile Data',
    101051: 'Sample',
    101052: 'Calculated Values (Carburizing)',
    101053: 'C-content @ core',
    101054: 'C-content @ CD',
    101055: 'Accept',
    101056: 'Select an equipment',
    101057: 'User Defined Values',
    101058: 'Profile',
    101059: 'Load From File',
    101060: 'Manual',
    101061: 'PartData',
    101062: 'Requirements',
    101063: 'Through Hardening',
    101064: 'Hardness @ CHD',
    101065: 'Equipment',
    101066: 'Total Case Depth',
    101067: 'Effective Case Depth',
    101068: 'Salt',
    101069: 'Oil',
    101070: 'Water',
    101071: 'Profile',
    101072: 'Properties',
    101073: 'End Temperature',
    101074: 'Heat Treatment Type',
    101075: 'C-content @ Surface',
    101076: 'Select a material',
    101077: 'End temperature is used for the calculation of the retained austenite',
    101078: 'Surface carbon[%]',
    101079: 'Reference carbon[%]',
    101100: 'Range',
    101101: 'Please select a material',
    101102: 'Select Units',
    101103: 'Change Units',
    101104: 'Depth',
    101105: 'C-Content',
    101106: 'Hardness',
    101107: 'CORE',
    101108: 'Conversion between Vickers and Rockwell failed...',
    101109: 'Please select a material',
    101110: 'Some fields are incomplete',
    101111: 'N2-Content',
    101112: 'C in Fe3C',
    101113: 'C-CORE',
    101114: 'N-CORE',
    101115: 'Initial Condition (Nitriding)',
    101116: 'Normalized',
    101117: 'As Quenched',
    101118: 'Tempered',
    101119: 'Estimated Tempering Conditions',
    101120: 'Temperature',
    101121: 'Time',
    101122: 'Carburizing Requirements',
    101130: 'PE C - Diff',
    101131: 'Newmann',
    101132: 'AWT',
    101133: 'Gunnarson',
    101134: 'Grabke',
    101135: 'User Defined',
    101136: 'PE C[+N] - Diff',
    101140: 'Chemical Composition',
    101141: 'Heat Treatment Properties',
    101142: 'General Properties',
    101143: 'Carburizing Properties',
    101144: 'Nitriding Properties',
    101145: 'Untreated Core Hardness',
    101146: 'Alloy Factor',
    101147: 'Carbide Limit',
    101148: 'Max. Carbon in Carbides',
    101149: 'Max. Nitrogen in Nitrides',
    101150: 'Calculation Method',
    101151: 'CH4 Factor',
    101152: '[min,max]',
    101153: 'wt %',
    101154: 'Carbon',
    101158: 'Please load the item for deletion',
    101159: 'No Change has been made',
    101160: 'Save Successful',
    101161: 'Save Failed',
    101162: 'Copy Successful',
    101163: 'Copy Failed',
    101164: 'Delete Successful',
    101165: 'Delete Failed',
    101166: 'Open Successful',
    101167: 'Open Failed',
    101168: 'Ready',
    101169: 'Please open one to copy',
    101170: 'Please verify Min/Max values.',
    101201: 'Gas carburizing',
    101202: 'Gas carbonitriding',
    101203: 'Low pressure (vacuum) carburizing',
    101204: 'Nitriding',
    101205: 'Nitrocarburizing',
    101206: 'Neutral hardening (vacuum)',
    101221: 'Distance from Surface',
    101222: 'Conversion Failed!',
    101223: 'Error',
    101224: 'Failed to get the list of all materials',
    101225: 'Alloy factor[Carbon]',
    101226: 'Carbide limit[%aC=1]',
    101227: 'Alloy factor[Nitrogen]',
    101228: 'Nitride limit[FexNy]',
    101229: 'Core Hardness untreated',
    101230: 'Undefined',
    101231: 'Core Hardness',
    101232: 'Quenched Hardness',
    101233: 'Hardness',
    101235: 'Tempering Curve',
    101236: 'Temperature',
    101237: 'Schaeffler Diagram',
    101238: 'NI-Equivalent [%]',
    101239: 'Cr-Equivalent [%]',
    101240: 'Jominy Curve',
    101241: 'Material',
    101242: 'Material Compare',
    101243: 'Tempering',
    101301: 'General',
    101302: 'Heating Capacity',
    101303: 'Cooling Capacity',
    101304: 'Carbon Potential - max. increase',
    101305: 'Carbon Potential - max. decrease',
    101306: 'Displaying result please wait ...',
    101310: 'Gas',
    101311: 'Salt&Oil',
    101312: 'Water',
    101313: 'Brine',
    101320: 'Depth unit',
    101321: 'Temp',
    101322: 'Time [hh:mm:ss]',
    101323: 'Atm. [%C]',
    101324: 'Atm. [%N]',
    101325: 'Atm. [%flow]',
    101326: 'Save As',
    101327: 'Simulation in progress, result will be displayed when simulation is finished...',
    101328: 'Save table to file',
    101329: 'Save profile result',
    101330: 'Configuration',
    101331: 'Configuration of carbon table',
    101332: 'Configuration of nitriding table',
    101333: 'Configuration of nitro carburizing table',
    101350: 'Options',
    101351: 'Set as Default',
    101352: 'Measuring Units',
    101353: 'Temperature',
    101354: 'Stage Duration',
    101355: 'Heat/Cool Ramp',
    101356: 'Part/Sample Dimension',
    101357: 'Simulation Speed',
    101358: 'Calculation Interval [ms]',
    101359: 'Corresponding Time [sec]',
    101360: 'Requirements',
    101361: 'Core Hardness (Untreated)',
    101362: 'Surface Hardness',
    101363: 'Effective Case Depth',
    101364: 'Required Hardness@Case Depth',
    101365: 'Total Case Depth',
    101366: 'White Layer',
    101367: 'User Interface',
    101368: 'Show Full Screen',
    101369: 'ShowLegend',
    101370: 'Select Title Color',
    101371: 'C-Beta',
    101372: 'C-Diff',
    101373: 'N-Beta',
    101374: 'N-Diff',
    101375: 'Use Part Shape in Simulation',
    101376: 'Low Pressure Carburizing Only',
    101377: 'Max.C in cementite [%C]',
    101378: 'C Below Carbide Limit[%C]',
    101400: 'Atmospheric carburizing is based on J. Wünning. Atmospheric Carbonitriding is based on K.-M. Winter. Low pressure carburizing is based on M. Steinbacher.',
    101401: 'Hardness calculation is valid for direct hardening only and is  based on U. Wyss and K. H. Weissohn.',
    101402: 'Atmospheric nitriding and nitrocarburizing is based on K.-M. Winter using: Hardenability (Just), Tempering (Grange et al.), Phase boundaries in Lehrer-Diagram (Maldzinski et al.), Iron-nitrogen-carbon ε-phase boundaries (Naumann and Langenscheidt), Iso-concentration lines for nitrogen and carbon in ε-phase (Kunze), Activity coefficients for nitrogen and carbon in ferrite (Fromm and Gebhardt), Nucleation (Sun and Bell), Compound layer growth (Hosseini et al.), Precipitation layer growth (Kunze), Softening (applying Hollomon-Jaffe equation on literature data). Simulator also provides recommendations for recipe design according to AMS 5759.',
    101403: 'Please, select a valid recipe.',
    101404: "Fe αγ'",
    101405: "Fe γ'ξ",
    101406: "St αγ'",
    101407: "St γ'ξ",
    101408: 'AMS',
    101409: 'Wrong recipe type from Simulation',
    101410: "Can't close form when simulation is running",
    101411: "Can't load recipe",
    101412: 'You do not have access to this type of recipe.',
    101413: 'Preprocessed values form is not open.',
    101414: 'Load the data from a file.',
    101415: 'Select file',
    101416: 'Result',
    101417: 'Update file was not found',
    101418: 'This feature is disabled',
    101419: 'Failed to set recipe parameters',
    101420: 'Some of recipe parameters are not valid',
    101421: 'Cross-section',
    101422: 'Plate from two sides',
    101423: 'Calculation from one side',
    101500: 'Yes',
    101501: 'No',
    101502: 'Ok',
    101503: 'Cancel',
    101504: 'Exit',
    101505: 'Close',
    101506: 'Save',
    101507: 'Save As',
    101508: 'Clear',
    101509: 'New',
    101510: 'New Recipe',
    101511: 'Delete',
    101512: 'Print',
    101513: 'Append',
    101514: 'Insert',
    101515: 'Open',
    101516: 'Duplicate',
    101517: 'Furnace',
    101518: 'Material',
    101519: 'Part',
    101520: 'Recipe Type',
    101521: 'Option',
    101522: 'Run Simulation',
    101523: 'Abort Simulation',
    101524: 'Pause',
    101525: 'Next Hour',
    101526: 'Next Stage',
    101527: 'Add Comment',
    101528: 'Process Calculator',
    101529: 'Export',
    101530: 'Go to End',
    101531: 'Switch Units',
    101532: 'Process Values',
    101533: 'Profile Table',
    101534: 'Profile Chart',
    101535: 'Configure',
    101536: 'Select Recipe',
    101537: 'Settings',
    101538: 'About',
    101539: 'Save to PDF',
    101540: 'Modify',
    101541: 'Nitriding',
    101542: 'Nitrocarburizing',
    101543: 'Surface Content',
    101544: 'Core Content',
    101545: 'Core Depth',
    101599: ' ',
  },
};
